import { openBlock, createBlock, Transition, withCtx, createElementBlock, normalizeClass, renderSlot, createCommentVNode, createElementVNode, resolveComponent, Fragment, createVNode, renderList, resolveDynamicComponent, createTextVNode, toDisplayString, normalizeStyle, resolveDirective, createSlots, normalizeProps, guardReactiveProps, withModifiers, withDirectives, mergeProps, vShow, inject, withKeys, computed, TransitionGroup, defineCustomElement } from "vue";
import { getImageUrlLimitWidth, Env, addEventListener as addEventListener$1, removeEventListener, dispatchEvent } from "@voghion/fe-util";
import { Database } from "emoji-picker-element";
import { customBack, customKeyboardEvent } from "@voghion/native-api";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$y = {
  name: "AppLoader",
  props: {
    show: { type: Boolean, default: false },
    infinite: { type: Boolean, default: false },
    type: { type: String, required: true },
    messageId: { type: String, default: "" }
  }
};
const _hoisted_1$v = /* @__PURE__ */ createElementVNode("div", { id: "vac-circle" }, null, -1);
const _hoisted_2$s = /* @__PURE__ */ createElementVNode("div", { id: "vac-circle" }, null, -1);
const _hoisted_3$m = /* @__PURE__ */ createElementVNode("div", { id: "vac-circle" }, null, -1);
const _hoisted_4$h = /* @__PURE__ */ createElementVNode("div", { id: "vac-circle" }, null, -1);
const _hoisted_5$g = /* @__PURE__ */ createElementVNode("div", { id: "vac-circle" }, null, -1);
const _hoisted_6$a = /* @__PURE__ */ createElementVNode("div", { id: "vac-circle" }, null, -1);
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: "vac-fade-spinner",
    appear: ""
  }, {
    default: withCtx(() => [
      $props.show ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["vac-loader-wrapper", {
          "vac-container-center": !$props.infinite,
          "vac-container-top": $props.infinite
        }])
      }, [
        $props.type === "rooms" ? renderSlot(_ctx.$slots, "spinner-icon-rooms", { key: 0 }, () => [
          _hoisted_1$v
        ]) : createCommentVNode("", true),
        $props.type === "infinite-rooms" ? renderSlot(_ctx.$slots, "spinner-icon-infinite-rooms", { key: 1 }, () => [
          _hoisted_2$s
        ]) : createCommentVNode("", true),
        $props.type === "message-file" ? renderSlot(_ctx.$slots, "spinner-icon-message-file_" + $props.messageId, { key: 2 }, () => [
          _hoisted_3$m
        ]) : createCommentVNode("", true),
        $props.type === "room-file" ? renderSlot(_ctx.$slots, "spinner-icon-room-file", { key: 3 }, () => [
          _hoisted_4$h
        ]) : createCommentVNode("", true),
        $props.type === "messages" ? renderSlot(_ctx.$slots, "spinner-icon-messages", { key: 4 }, () => [
          _hoisted_5$g
        ]) : createCommentVNode("", true),
        $props.type === "infinite-messages" ? renderSlot(_ctx.$slots, "spinner-icon-infinite-messages", { key: 5 }, () => [
          _hoisted_6$a
        ]) : createCommentVNode("", true)
      ], 2)) : createCommentVNode("", true)
    ]),
    _: 3
  });
}
var Loader = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$x]]);
const _sfc_main$x = {
  name: "SvgIcon",
  props: {
    name: { type: String, default: null },
    param: { type: String, default: null }
  },
  data() {
    return {
      svgItem: {
        search: {
          path: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
        },
        add: {
          path: "M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
        },
        toggle: {
          path: "M5,13L9,17L7.6,18.42L1.18,12L7.6,5.58L9,7L5,11H21V13H5M21,6V8H11V6H21M21,16V18H11V16H21Z"
        },
        menu: {
          path: "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"
        },
        close: {
          path: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
        },
        file: {
          path: "M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
        },
        paperclip: {
          path: "M16.5,6V17.5A4,4 0 0,1 12.5,21.5A4,4 0 0,1 8.5,17.5V5A2.5,2.5 0 0,1 11,2.5A2.5,2.5 0 0,1 13.5,5V15.5A1,1 0 0,1 12.5,16.5A1,1 0 0,1 11.5,15.5V6H10V15.5A2.5,2.5 0 0,0 12.5,18A2.5,2.5 0 0,0 15,15.5V5A4,4 0 0,0 11,1A4,4 0 0,0 7,5V17.5A5.5,5.5 0 0,0 12.5,23A5.5,5.5 0 0,0 18,17.5V6H16.5Z"
        },
        "close-outline": {
          path: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
        },
        send: {
          path: "M2,21L23,12L2,3V10L17,12L2,14V21Z"
        },
        emoji: {
          path: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
        },
        document: {
          path: "M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
        },
        pencil: {
          path: "M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"
        },
        checkmark: {
          path: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
        },
        "double-checkmark": {
          path: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
        },
        eye: {
          path: "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
        },
        dropdown: {
          path: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
        },
        deleted: {
          path: "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20A8,8 0 0,0 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z"
        },
        microphone: {
          size: "large",
          path: "M432.8,216.4v39.2c0,45.2-15.3,84.3-45.2,118.4c-29.8,33.2-67.3,52.8-111.6,57.9v40.9h78.4c5.1,0,10.2,1.7,13.6,6c4.3,4.3,6,8.5,6,13.6c0,5.1-1.7,10.2-6,13.6c-4.3,4.3-8.5,6-13.6,6H157.6c-5.1,0-10.2-1.7-13.6-6c-4.3-4.3-6-8.5-6-13.6c0-5.1,1.7-10.2,6-13.6c4.3-4.3,8.5-6,13.6-6H236v-40.9c-44.3-5.1-81.8-23.9-111.6-57.9s-45.2-73.3-45.2-118.4v-39.2c0-5.1,1.7-10.2,6-13.6c4.3-4.3,8.5-6,13.6-6s10.2,1.7,13.6,6c4.3,4.3,6,8.5,6,13.6v39.2c0,37.5,13.6,70.7,40,97.1s59.6,40,97.1,40s70.7-13.6,97.1-40c26.4-26.4,40-59.6,40-97.1v-39.2c0-5.1,1.7-10.2,6-13.6c4.3-4.3,8.5-6,13.6-6c5.1,0,10.2,1.7,13.6,6C430.2,206.2,432.8,211.3,432.8,216.4z M353.5,98v157.6c0,27.3-9.4,50.3-29,69c-19.6,19.6-42.6,29-69,29s-50.3-9.4-69-29c-19.6-19.6-29-42.6-29-69V98c0-27.3,9.4-50.3,29-69c19.6-19.6,42.6-29,69-29s50.3,9.4,69,29C344.2,47.7,353.5,71.6,353.5,98z"
        },
        "audio-play": {
          size: "medium",
          path: "M43.331,21.237L7.233,0.397c-0.917-0.529-2.044-0.529-2.96,0c-0.916,0.528-1.48,1.505-1.48,2.563v41.684   c0,1.058,0.564,2.035,1.48,2.563c0.458,0.268,0.969,0.397,1.48,0.397c0.511,0,1.022-0.133,1.48-0.397l36.098-20.84   c0.918-0.529,1.479-1.506,1.479-2.564S44.247,21.767,43.331,21.237z"
        },
        "audio-pause": {
          size: "medium",
          path: "M17.991,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C4.729,2.969,7.698,0,11.36,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z",
          path2: "M42.877,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C29.616,2.969,32.585,0,36.246,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z"
        },
        flag: {
          path: "M3.26738636e-13,0.2 C3.26807674e-13,0.08954305 0.08954305,0 0.2,0 L0.2,0 L1.64530581,0 C1.75576276,0 1.84530581,0.08954305 1.84530581,0.2 L1.84530581,0.2 L1.845,1 L18.6986209,1 C19.9157379,1.00088514 20.9145061,1.93061729 20.994794,3.10228086 L21,3.2564221 C20.9996849,3.72654852 20.8528218,4.17712482 20.5746626,4.56027632 L20.5746626,4.56027632 L20.4119182,4.76224288 C20.411132,4.76332044 20.4103458,4.76424407 20.4095596,4.76501376 L20.4095596,4.76501376 L15.7330568,9.91500702 C15.7119865,9.93809771 15.7119865,9.97304162 15.7330568,9.99613231 L15.7330568,9.99613231 L20.4199375,15.157517 C21.1404155,15.9515288 21.1940347,17.143932 20.5487179,17.9965941 L20.5487179,17.9965941 L20.3983955,18.1765476 C20.3969803,18.1782409 20.3954079,18.1799342 20.3938355,18.1814736 L20.3938355,18.1814736 L20.2218139,18.346649 L20.2218139,18.346649 C19.8600025,18.6572957 19.4219293,18.8460236 18.9487913,18.8962074 L18.9487913,18.8962074 L18.8060165,18.9043661 L18.8119917,18.9112933 L1.89380989,18.9112933 C1.85937412,18.9112933 1.83138524,18.9385403 1.83138524,18.9722527 L1.83138524,18.9722527 L1.83138524,24.7851027 C1.83138524,24.9036349 1.73310965,25 1.61187688,25 L1.61187688,25 L0.376749294,25 C0.168719529,25 0,24.8348246 0,24.6311647 L0,24.6311647 Z",
          fill: "#F54E36",
          width: 16,
          height: 20
        },
        plus: {
          path: "M4.22697775,2.5291075 L8.05378074,6.35606922 L11.8803688,2.5291075 C12.3857532,2.02372312 13.2051431,2.02372312 13.7105275,2.5291075 C14.2159119,3.03449188 14.2159119,3.85388185 13.7105275,4.35926623 L9.88378074,8.18606922 L13.7105275,12.0126573 C14.2159119,12.5180416 14.2159119,13.3374316 13.7105275,13.842816 C13.2051431,14.3482004 12.3857532,14.3482004 11.8803688,13.842816 L8.05378074,10.0160692 L4.22697775,13.842816 C3.72159337,14.3482004 2.9022034,14.3482004 2.39681902,13.842816 C1.89143464,13.3374316 1.89143464,12.5180416 2.39681902,12.0126573 L6.22378074,8.18606922 L2.39681902,4.35926623 C1.89143464,3.85388185 1.89143464,3.03449188 2.39681902,2.5291075 C2.9022034,2.02372312 3.72159337,2.02372312 4.22697775,2.5291075 Z",
          fill: "#fff"
        },
        filter: {
          path: "M8.5,32 C10.9852814,32 13,34.0147186 13,36.5 C13,38.9852814 10.9852814,41 8.5,41 C6.01471863,41 4,38.9852814 4,36.5 C4,34.0147186 6.01471863,32 8.5,32 Z M8.5,35 C7.67157288,35 7,35.6715729 7,36.5 C7,37.3284271 7.67157288,38 8.5,38 C9.32842712,38 10,37.3284271 10,36.5 C10,35.6715729 9.32842712,35 8.5,35 Z M43.6,35 C43.8209139,35 44,35.1790861 44,35.4 L44,37.6 C44,37.8209139 43.8209139,38 43.6,38 L16.4,38 C16.1790861,38 16,37.8209139 16,37.6 L16,35.4 C16,35.1790861 16.1790861,35 16.4,35 L43.6,35 Z M8.5,19 C10.9852814,19 13,21.0147186 13,23.5 C13,25.9852814 10.9852814,28 8.5,28 C6.01471863,28 4,25.9852814 4,23.5 C4,21.0147186 6.01471863,19 8.5,19 Z M8.5,22 C7.67157288,22 7,22.6715729 7,23.5 C7,24.3284271 7.67157288,25 8.5,25 C9.32842712,25 10,24.3284271 10,23.5 C10,22.6715729 9.32842712,22 8.5,22 Z M43.6,22 C43.8209139,22 44,22.1790861 44,22.4 L44,24.6 C44,24.8209139 43.8209139,25 43.6,25 L16.4,25 C16.1790861,25 16,24.8209139 16,24.6 L16,22.4 C16,22.1790861 16.1790861,22 16.4,22 L43.6,22 Z M8.5,6 C10.9852814,6 13,8.01471863 13,10.5 C13,12.9852814 10.9852814,15 8.5,15 C6.01471863,15 4,12.9852814 4,10.5 C4,8.01471863 6.01471863,6 8.5,6 Z M8.5,9 C7.67157288,9 7,9.67157288 7,10.5 C7,11.3284271 7.67157288,12 8.5,12 C9.32842712,12 10,11.3284271 10,10.5 C10,9.67157288 9.32842712,9 8.5,9 Z M43.6,9 C43.8209139,9 44,9.1790861 44,9.4 L44,11.6 C44,11.8209139 43.8209139,12 43.6,12 L16.4,12 C16.1790861,12 16,11.8209139 16,11.6 L16,9.4 C16,9.1790861 16.1790861,9 16.4,9 L43.6,9 Z",
          width: 20,
          height: 20
        }
      }
    };
  },
  computed: {
    svgId() {
      const param = this.param ? "-" + this.param : "";
      return `vac-icon-${this.name}${param}`;
    },
    size() {
      const item = this.svgItem[this.name];
      if (item.size === "large")
        return 512;
      else if (item.size === "medium")
        return 48;
      else
        return 24;
    }
  }
};
const _hoisted_1$u = ["width", "height", "viewBox"];
const _hoisted_2$r = ["id", "d", "fill"];
const _hoisted_3$l = ["id", "d"];
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    version: "1.1",
    width: $data.svgItem[$props.name].width ? $data.svgItem[$props.name].width : "24",
    height: $data.svgItem[$props.name].width ? $data.svgItem[$props.name].height : "24",
    viewBox: `0 0 ${$options.size} ${$options.size}`
  }, [
    createElementVNode("path", {
      id: $options.svgId,
      d: $data.svgItem[$props.name].path,
      fill: $data.svgItem[$props.name].fill
    }, null, 8, _hoisted_2$r),
    $data.svgItem[$props.name].path2 ? (openBlock(), createElementBlock("path", {
      key: 0,
      id: $options.svgId,
      d: $data.svgItem[$props.name].path2
    }, null, 8, _hoisted_3$l)) : createCommentVNode("", true)
  ], 8, _hoisted_1$u);
}
var SvgIcon = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$w]]);
const _sfc_main$w = {
  name: "RoomsSearch",
  components: { SvgIcon },
  props: {
    textMessages: { type: Object, required: true },
    showSearch: { type: Boolean, required: true },
    showAddRoom: { type: Boolean, required: true },
    rooms: { type: Array, required: true },
    loadingRooms: { type: Boolean, required: true }
  },
  emits: ["search-room", "add-room"],
  computed: {
    showSearchBar() {
      return this.showSearch || this.showAddRoom;
    }
  }
};
const _hoisted_1$t = {
  key: 0,
  class: "vac-icon-search"
};
const _hoisted_2$q = ["placeholder"];
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = resolveComponent("svg-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({
      "vac-box-search": $options.showSearchBar,
      "vac-box-empty": !$options.showSearchBar
    })
  }, [
    $props.showSearch ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      !$props.loadingRooms && $props.rooms.length ? (openBlock(), createElementBlock("div", _hoisted_1$t, [
        renderSlot(_ctx.$slots, "search-icon", {}, () => [
          createVNode(_component_svg_icon, { name: "search" })
        ])
      ])) : createCommentVNode("", true),
      !$props.loadingRooms && $props.rooms.length ? (openBlock(), createElementBlock("input", {
        key: 1,
        type: "search",
        placeholder: $props.textMessages.SEARCH,
        autocomplete: "off",
        class: "vac-input",
        onInput: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("search-room", $event))
      }, null, 40, _hoisted_2$q)) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true),
    $props.showAddRoom ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "vac-svg-button vac-add-icon",
      onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("add-room"))
    }, [
      renderSlot(_ctx.$slots, "add-icon", {}, () => [
        createVNode(_component_svg_icon, { name: "add" })
      ])
    ])) : createCommentVNode("", true)
  ], 2);
}
var RoomsSearch = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$v]]);
const element = document.createElement("i");
function decodeNamedCharacterReference(value) {
  const characterReference2 = "&" + value + ";";
  element.innerHTML = characterReference2;
  const char = element.textContent;
  if (char.charCodeAt(char.length - 1) === 59 && value !== "semi") {
    return false;
  }
  return char === characterReference2 ? false : char;
}
function splice(list2, start, remove, items) {
  const end = list2.length;
  let chunkStart = 0;
  let parameters;
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove = remove > 0 ? remove : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start, remove);
    list2.splice(...parameters);
  } else {
    if (remove)
      list2.splice(start, remove);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start, 0);
      list2.splice(...parameters);
      chunkStart += 1e4;
      start += 1e4;
    }
  }
}
function push(list2, items) {
  if (list2.length > 0) {
    splice(list2, list2.length, 0, items);
    return list2;
  }
  return items;
}
const hasOwnProperty$2 = {}.hasOwnProperty;
function combineExtensions(extensions) {
  const all = {};
  let index = -1;
  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index]);
  }
  return all;
}
function syntaxExtension(all, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$2.call(all, hook) ? all[hook] : void 0;
    const left = maybe || (all[hook] = {});
    const right = extension[hook];
    let code2;
    if (right) {
      for (code2 in right) {
        if (!hasOwnProperty$2.call(left, code2))
          left[code2] = [];
        const value = right[code2];
        constructs(
          left[code2],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}
function constructs(existing, list2) {
  let index = -1;
  const before = [];
  while (++index < list2.length) {
    (list2[index].add === "after" ? existing : before).push(list2[index]);
  }
  splice(existing, 0, 0, before);
}
function combineHtmlExtensions(htmlExtensions) {
  const handlers = {};
  let index = -1;
  while (++index < htmlExtensions.length) {
    htmlExtension(handlers, htmlExtensions[index]);
  }
  return handlers;
}
function htmlExtension(all, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$2.call(all, hook) ? all[hook] : void 0;
    const left = maybe || (all[hook] = {});
    const right = extension[hook];
    let type;
    if (right) {
      for (type in right) {
        left[type] = right[type];
      }
    }
  }
}
function decodeNumericCharacterReference(value, base) {
  const code2 = Number.parseInt(value, base);
  if (code2 < 9 || code2 === 11 || code2 > 13 && code2 < 32 || code2 > 126 && code2 < 160 || code2 > 55295 && code2 < 57344 || code2 > 64975 && code2 < 65008 || (code2 & 65535) === 65535 || (code2 & 65535) === 65534 || code2 > 1114111) {
    return "\uFFFD";
  }
  return String.fromCharCode(code2);
}
const characterReferences = { '"': "quot", "&": "amp", "<": "lt", ">": "gt" };
function encode(value) {
  return value.replace(/["&<>]/g, replace2);
  function replace2(value2) {
    return "&" + characterReferences[value2] + ";";
  }
}
function normalizeIdentifier(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const unicodePunctuationRegex = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
const asciiAlpha = regexCheck(/[A-Za-z]/);
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(code2) {
  return code2 !== null && (code2 < 32 || code2 === 127);
}
const asciiDigit = regexCheck(/\d/);
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(code2) {
  return code2 !== null && code2 < -2;
}
function markdownLineEndingOrSpace(code2) {
  return code2 !== null && (code2 < 0 || code2 === 32);
}
function markdownSpace(code2) {
  return code2 === -2 || code2 === -1 || code2 === 32;
}
const unicodePunctuation = regexCheck(unicodePunctuationRegex);
const unicodeWhitespace = regexCheck(/\s/);
function regexCheck(regex) {
  return check;
  function check(code2) {
    return code2 !== null && regex.test(String.fromCharCode(code2));
  }
}
function sanitizeUri(url, protocol) {
  const value = encode(normalizeUri(url || ""));
  if (!protocol) {
    return value;
  }
  const colon = value.indexOf(":");
  const questionMark = value.indexOf("?");
  const numberSign = value.indexOf("#");
  const slash = value.indexOf("/");
  if (colon < 0 || slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || protocol.test(value.slice(0, colon))) {
    return value;
  }
  return "";
}
function normalizeUri(value) {
  const result = [];
  let index = -1;
  let start = 0;
  let skip = 0;
  while (++index < value.length) {
    const code2 = value.charCodeAt(index);
    let replace2 = "";
    if (code2 === 37 && asciiAlphanumeric(value.charCodeAt(index + 1)) && asciiAlphanumeric(value.charCodeAt(index + 2))) {
      skip = 2;
    } else if (code2 < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code2))) {
        replace2 = String.fromCharCode(code2);
      }
    } else if (code2 > 55295 && code2 < 57344) {
      const next = value.charCodeAt(index + 1);
      if (code2 < 56320 && next > 56319 && next < 57344) {
        replace2 = String.fromCharCode(code2, next);
        skip = 1;
      } else {
        replace2 = "\uFFFD";
      }
    } else {
      replace2 = String.fromCharCode(code2);
    }
    if (replace2) {
      result.push(value.slice(start, index), encodeURIComponent(replace2));
      start = index + skip + 1;
      replace2 = "";
    }
    if (skip) {
      index += skip;
      skip = 0;
    }
  }
  return result.join("") + value.slice(start);
}
const hasOwnProperty$1 = {}.hasOwnProperty;
const protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const protocolSrc = /^https?$/i;
function compile(options) {
  const settings = options || {};
  let tags = true;
  const definitions = {};
  const buffers = [[]];
  const mediaStack = [];
  const tightStack = [];
  const defaultHandlers = {
    enter: {
      blockQuote: onenterblockquote,
      codeFenced: onentercodefenced,
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: onentercodeindented,
      codeText: onentercodetext,
      content: onentercontent,
      definition: onenterdefinition,
      definitionDestinationString: onenterdefinitiondestinationstring,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: onenteremphasis,
      htmlFlow: onenterhtmlflow,
      htmlText: onenterhtml,
      image: onenterimage,
      label: buffer,
      link: onenterlink,
      listItemMarker: onenterlistitemmarker,
      listItemValue: onenterlistitemvalue,
      listOrdered: onenterlistordered,
      listUnordered: onenterlistunordered,
      paragraph: onenterparagraph,
      reference: buffer,
      resource: onenterresource,
      resourceDestinationString: onenterresourcedestinationstring,
      resourceTitleString: buffer,
      setextHeading: onentersetextheading,
      strong: onenterstrong
    },
    exit: {
      atxHeading: onexitatxheading,
      atxHeadingSequence: onexitatxheadingsequence,
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: onexitblockquote,
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: onexitflowcode,
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: resume,
      codeFlowValue: onexitcodeflowvalue,
      codeIndented: onexitflowcode,
      codeText: onexitcodetext,
      codeTextData: onexitdata,
      data: onexitdata,
      definition: onexitdefinition,
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: onexitemphasis,
      hardBreakEscape: onexithardbreak,
      hardBreakTrailing: onexithardbreak,
      htmlFlow: onexithtml,
      htmlFlowData: onexitdata,
      htmlText: onexithtml,
      htmlTextData: onexitdata,
      image: onexitmedia,
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: onexitmedia,
      listOrdered: onexitlistordered,
      listUnordered: onexitlistunordered,
      paragraph: onexitparagraph,
      reference: resume,
      referenceString: onexitreferencestring,
      resource: resume,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      setextHeading: onexitsetextheading,
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: onexitstrong,
      thematicBreak: onexitthematicbreak
    }
  };
  const handlers = combineHtmlExtensions(
    [defaultHandlers].concat(settings.htmlExtensions || [])
  );
  const data = {
    tightStack,
    definitions
  };
  const context = {
    lineEndingIfNeeded,
    options: settings,
    encode: encode$1,
    raw,
    tag,
    buffer,
    resume,
    setData,
    getData
  };
  let lineEndingStyle = settings.defaultLineEnding;
  return compile2;
  function compile2(events) {
    let index = -1;
    let start = 0;
    const listStack = [];
    let head = [];
    let body = [];
    while (++index < events.length) {
      if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) {
        lineEndingStyle = events[index][2].sliceSerialize(events[index][1]);
      }
      if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
        if (events[index][0] === "enter") {
          listStack.push(index);
        } else {
          prepareList(events.slice(listStack.pop(), index));
        }
      }
      if (events[index][1].type === "definition") {
        if (events[index][0] === "enter") {
          body = push(body, events.slice(start, index));
          start = index;
        } else {
          head = push(head, events.slice(start, index + 1));
          start = index + 1;
        }
      }
    }
    head = push(head, body);
    head = push(head, events.slice(start));
    index = -1;
    const result = head;
    if (handlers.enter.null) {
      handlers.enter.null.call(context);
    }
    while (++index < events.length) {
      const handles = handlers[result[index][0]];
      const kind = result[index][1].type;
      const handle = handles[kind];
      if (hasOwnProperty$1.call(handles, kind) && handle) {
        handle.call(
          Object.assign(
            {
              sliceSerialize: result[index][2].sliceSerialize
            },
            context
          ),
          result[index][1]
        );
      }
    }
    if (handlers.exit.null) {
      handlers.exit.null.call(context);
    }
    return buffers[0].join("");
  }
  function prepareList(slice) {
    const length = slice.length;
    let index = 0;
    let containerBalance = 0;
    let loose = false;
    let atMarker;
    while (++index < length) {
      const event = slice[index];
      if (event[1]._container) {
        atMarker = void 0;
        if (event[0] === "enter") {
          containerBalance++;
        } else {
          containerBalance--;
        }
      } else
        switch (event[1].type) {
          case "listItemPrefix": {
            if (event[0] === "exit") {
              atMarker = true;
            }
            break;
          }
          case "linePrefix": {
            break;
          }
          case "lineEndingBlank": {
            if (event[0] === "enter" && !containerBalance) {
              if (atMarker) {
                atMarker = void 0;
              } else {
                loose = true;
              }
            }
            break;
          }
          default: {
            atMarker = void 0;
          }
        }
    }
    slice[0][1]._loose = loose;
  }
  function setData(key, value) {
    data[key] = value;
  }
  function getData(key) {
    return data[key];
  }
  function buffer() {
    buffers.push([]);
  }
  function resume() {
    const buf = buffers.pop();
    return buf.join("");
  }
  function tag(value) {
    if (!tags)
      return;
    setData("lastWasTag", true);
    buffers[buffers.length - 1].push(value);
  }
  function raw(value) {
    setData("lastWasTag");
    buffers[buffers.length - 1].push(value);
  }
  function lineEnding2() {
    raw(lineEndingStyle || "\n");
  }
  function lineEndingIfNeeded() {
    const buffer2 = buffers[buffers.length - 1];
    const slice = buffer2[buffer2.length - 1];
    const previous2 = slice ? slice.charCodeAt(slice.length - 1) : null;
    if (previous2 === 10 || previous2 === 13 || previous2 === null) {
      return;
    }
    lineEnding2();
  }
  function encode$1(value) {
    return getData("ignoreEncode") ? value : encode(value);
  }
  function onenterlistordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag("<ol");
    setData("expectFirstItem", true);
  }
  function onenterlistunordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag("<ul");
    setData("expectFirstItem", true);
  }
  function onenterlistitemvalue(token) {
    if (getData("expectFirstItem")) {
      const value = Number.parseInt(this.sliceSerialize(token), 10);
      if (value !== 1) {
        tag(' start="' + encode$1(String(value)) + '"');
      }
    }
  }
  function onenterlistitemmarker() {
    if (getData("expectFirstItem")) {
      tag(">");
    } else {
      onexitlistitem();
    }
    lineEndingIfNeeded();
    tag("<li>");
    setData("expectFirstItem");
    setData("lastWasTag");
  }
  function onexitlistordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag("</ol>");
  }
  function onexitlistunordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag("</ul>");
  }
  function onexitlistitem() {
    if (getData("lastWasTag") && !getData("slurpAllLineEndings")) {
      lineEndingIfNeeded();
    }
    tag("</li>");
    setData("slurpAllLineEndings");
  }
  function onenterblockquote() {
    tightStack.push(false);
    lineEndingIfNeeded();
    tag("<blockquote>");
  }
  function onexitblockquote() {
    tightStack.pop();
    lineEndingIfNeeded();
    tag("</blockquote>");
    setData("slurpAllLineEndings");
  }
  function onenterparagraph() {
    if (!tightStack[tightStack.length - 1]) {
      lineEndingIfNeeded();
      tag("<p>");
    }
    setData("slurpAllLineEndings");
  }
  function onexitparagraph() {
    if (tightStack[tightStack.length - 1]) {
      setData("slurpAllLineEndings", true);
    } else {
      tag("</p>");
    }
  }
  function onentercodefenced() {
    lineEndingIfNeeded();
    tag("<pre><code");
    setData("fencesCount", 0);
  }
  function onexitcodefencedfenceinfo() {
    const value = resume();
    tag(' class="language-' + value + '"');
  }
  function onexitcodefencedfence() {
    const count = getData("fencesCount") || 0;
    if (!count) {
      tag(">");
      setData("slurpOneLineEnding", true);
    }
    setData("fencesCount", count + 1);
  }
  function onentercodeindented() {
    lineEndingIfNeeded();
    tag("<pre><code>");
  }
  function onexitflowcode() {
    const count = getData("fencesCount");
    if (count !== void 0 && count < 2 && data.tightStack.length > 0 && !getData("lastWasTag")) {
      lineEnding2();
    }
    if (getData("flowCodeSeenData")) {
      lineEndingIfNeeded();
    }
    tag("</code></pre>");
    if (count !== void 0 && count < 2)
      lineEndingIfNeeded();
    setData("flowCodeSeenData");
    setData("fencesCount");
    setData("slurpOneLineEnding");
  }
  function onenterimage() {
    mediaStack.push({
      image: true
    });
    tags = void 0;
  }
  function onenterlink() {
    mediaStack.push({});
  }
  function onexitlabeltext(token) {
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onexitlabel() {
    mediaStack[mediaStack.length - 1].label = resume();
  }
  function onexitreferencestring(token) {
    mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
  }
  function onenterresource() {
    buffer();
    mediaStack[mediaStack.length - 1].destination = "";
  }
  function onenterresourcedestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitresourcedestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitresourcetitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitmedia() {
    let index = mediaStack.length - 1;
    const media = mediaStack[index];
    const id = media.referenceId || media.labelId;
    const context2 = media.destination === void 0 ? definitions[normalizeIdentifier(id)] : media;
    tags = true;
    while (index--) {
      if (mediaStack[index].image) {
        tags = void 0;
        break;
      }
    }
    if (media.image) {
      tag(
        '<img src="' + sanitizeUri(
          context2.destination,
          settings.allowDangerousProtocol ? void 0 : protocolSrc
        ) + '" alt="'
      );
      raw(media.label);
      tag('"');
    } else {
      tag(
        '<a href="' + sanitizeUri(
          context2.destination,
          settings.allowDangerousProtocol ? void 0 : protocolHref
        ) + '"'
      );
    }
    tag(context2.title ? ' title="' + context2.title + '"' : "");
    if (media.image) {
      tag(" />");
    } else {
      tag(">");
      raw(media.label);
      tag("</a>");
    }
    mediaStack.pop();
  }
  function onenterdefinition() {
    buffer();
    mediaStack.push({});
  }
  function onexitdefinitionlabelstring(token) {
    resume();
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onenterdefinitiondestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitdefinitiondestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitdefinitiontitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitdefinition() {
    const media = mediaStack[mediaStack.length - 1];
    const id = normalizeIdentifier(media.labelId);
    resume();
    if (!hasOwnProperty$1.call(definitions, id)) {
      definitions[id] = mediaStack[mediaStack.length - 1];
    }
    mediaStack.pop();
  }
  function onentercontent() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheadingsequence(token) {
    if (getData("headingRank"))
      return;
    setData("headingRank", this.sliceSerialize(token).length);
    lineEndingIfNeeded();
    tag("<h" + getData("headingRank") + ">");
  }
  function onentersetextheading() {
    buffer();
    setData("slurpAllLineEndings");
  }
  function onexitsetextheadingtext() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheading() {
    tag("</h" + getData("headingRank") + ">");
    setData("headingRank");
  }
  function onexitsetextheadinglinesequence(token) {
    setData(
      "headingRank",
      this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2
    );
  }
  function onexitsetextheading() {
    const value = resume();
    lineEndingIfNeeded();
    tag("<h" + getData("headingRank") + ">");
    raw(value);
    tag("</h" + getData("headingRank") + ">");
    setData("slurpAllLineEndings");
    setData("headingRank");
  }
  function onexitdata(token) {
    raw(encode$1(this.sliceSerialize(token)));
  }
  function onexitlineending(token) {
    if (getData("slurpAllLineEndings")) {
      return;
    }
    if (getData("slurpOneLineEnding")) {
      setData("slurpOneLineEnding");
      return;
    }
    if (getData("inCodeText")) {
      raw(" ");
      return;
    }
    raw(encode$1(this.sliceSerialize(token)));
  }
  function onexitcodeflowvalue(token) {
    raw(encode$1(this.sliceSerialize(token)));
    setData("flowCodeSeenData", true);
  }
  function onexithardbreak() {
    tag("<br />");
  }
  function onenterhtmlflow() {
    lineEndingIfNeeded();
    onenterhtml();
  }
  function onexithtml() {
    setData("ignoreEncode");
  }
  function onenterhtml() {
    if (settings.allowDangerousHtml) {
      setData("ignoreEncode", true);
    }
  }
  function onenteremphasis() {
    tag("<em>");
  }
  function onenterstrong() {
    tag("<strong>");
  }
  function onentercodetext() {
    setData("inCodeText", true);
    tag("<code>");
  }
  function onexitcodetext() {
    setData("inCodeText");
    tag("</code>");
  }
  function onexitemphasis() {
    tag("</em>");
  }
  function onexitstrong() {
    tag("</strong>");
  }
  function onexitthematicbreak() {
    lineEndingIfNeeded();
    tag("<hr />");
  }
  function onexitcharacterreferencemarker(token) {
    setData("characterReferenceType", token.type);
  }
  function onexitcharacterreferencevalue(token) {
    let value = this.sliceSerialize(token);
    value = getData("characterReferenceType") ? decodeNumericCharacterReference(
      value,
      getData("characterReferenceType") === "characterReferenceMarkerNumeric" ? 10 : 16
    ) : decodeNamedCharacterReference(value);
    raw(encode$1(value));
    setData("characterReferenceType");
  }
  function onexitautolinkprotocol(token) {
    const uri = this.sliceSerialize(token);
    tag(
      '<a href="' + sanitizeUri(
        uri,
        settings.allowDangerousProtocol ? void 0 : protocolHref
      ) + '">'
    );
    raw(encode$1(uri));
    tag("</a>");
  }
  function onexitautolinkemail(token) {
    const uri = this.sliceSerialize(token);
    tag('<a href="' + sanitizeUri("mailto:" + uri) + '">');
    raw(encode$1(uri));
    tag("</a>");
  }
}
function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
  let size = 0;
  return start;
  function start(code2) {
    if (markdownSpace(code2)) {
      effects.enter(type);
      return prefix(code2);
    }
    return ok(code2);
  }
  function prefix(code2) {
    if (markdownSpace(code2) && size++ < limit) {
      effects.consume(code2);
      return prefix;
    }
    effects.exit(type);
    return ok(code2);
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  );
  let previous2;
  return contentStart;
  function afterContentStartConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, contentStart, "linePrefix");
  }
  function paragraphInitial(code2) {
    effects.enter("paragraph");
    return lineStart(code2);
  }
  function lineStart(code2) {
    const token = effects.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    if (previous2) {
      previous2.next = token;
    }
    previous2 = token;
    return data(code2);
  }
  function data(code2) {
    if (code2 === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      effects.exit("chunkText");
      return lineStart;
    }
    effects.consume(code2);
    return data;
  }
}
const document$2 = {
  tokenize: initializeDocument
};
const containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(effects) {
  const self2 = this;
  const stack = [];
  let continued = 0;
  let childFlow;
  let childToken;
  let lineStartOffset;
  return start;
  function start(code2) {
    if (continued < stack.length) {
      const item = stack[continued];
      self2.containerState = item[1];
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code2);
    }
    return checkNewContainers(code2);
  }
  function documentContinue(code2) {
    continued++;
    if (self2.containerState._closeFlow) {
      self2.containerState._closeFlow = void 0;
      if (childFlow) {
        closeFlow();
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let point;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          point = self2.events[indexBeforeFlow][1].end;
          break;
        }
      }
      exitContainers(continued);
      let index = indexBeforeExits;
      while (index < self2.events.length) {
        self2.events[index][1].end = Object.assign({}, point);
        index++;
      }
      splice(
        self2.events,
        indexBeforeFlow + 1,
        0,
        self2.events.slice(indexBeforeExits)
      );
      self2.events.length = index;
      return checkNewContainers(code2);
    }
    return start(code2);
  }
  function checkNewContainers(code2) {
    if (continued === stack.length) {
      if (!childFlow) {
        return documentContinued(code2);
      }
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code2);
      }
      self2.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      );
    }
    self2.containerState = {};
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code2);
  }
  function thereIsANewContainer(code2) {
    if (childFlow)
      closeFlow();
    exitContainers(continued);
    return documentContinued(code2);
  }
  function thereIsNoNewContainer(code2) {
    self2.parser.lazy[self2.now().line] = continued !== stack.length;
    lineStartOffset = self2.now().offset;
    return flowStart(code2);
  }
  function documentContinued(code2) {
    self2.containerState = {};
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code2);
  }
  function containerContinue(code2) {
    continued++;
    stack.push([self2.currentConstruct, self2.containerState]);
    return documentContinued(code2);
  }
  function flowStart(code2) {
    if (code2 === null) {
      if (childFlow)
        closeFlow();
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    childFlow = childFlow || self2.parser.flow(self2.now());
    effects.enter("chunkFlow", {
      contentType: "flow",
      previous: childToken,
      _tokenizer: childFlow
    });
    return flowContinue(code2);
  }
  function flowContinue(code2) {
    if (code2 === null) {
      writeToChild(effects.exit("chunkFlow"), true);
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      writeToChild(effects.exit("chunkFlow"));
      continued = 0;
      self2.interrupt = void 0;
      return start;
    }
    effects.consume(code2);
    return flowContinue;
  }
  function writeToChild(token, eof) {
    const stream = self2.sliceStream(token);
    if (eof)
      stream.push(null);
    token.previous = childToken;
    if (childToken)
      childToken.next = token;
    childToken = token;
    childFlow.defineSkip(token.start);
    childFlow.write(stream);
    if (self2.parser.lazy[token.start.line]) {
      let index = childFlow.events.length;
      while (index--) {
        if (childFlow.events[index][1].start.offset < lineStartOffset && (!childFlow.events[index][1].end || childFlow.events[index][1].end.offset > lineStartOffset)) {
          return;
        }
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let seen;
      let point;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point = self2.events[indexBeforeFlow][1].end;
            break;
          }
          seen = true;
        }
      }
      exitContainers(continued);
      index = indexBeforeExits;
      while (index < self2.events.length) {
        self2.events[index][1].end = Object.assign({}, point);
        index++;
      }
      splice(
        self2.events,
        indexBeforeFlow + 1,
        0,
        self2.events.slice(indexBeforeExits)
      );
      self2.events.length = index;
    }
  }
  function exitContainers(size) {
    let index = stack.length;
    while (index-- > size) {
      const entry = stack[index];
      self2.containerState = entry[1];
      entry[0].exit.call(self2, effects);
    }
    stack.length = size;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = void 0;
    childFlow = void 0;
    self2.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function classifyCharacter(code2) {
  if (code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2)) {
    return 1;
  }
  if (unicodePunctuation(code2)) {
    return 2;
  }
}
function resolveAll(constructs2, events, context) {
  const called = [];
  let index = -1;
  while (++index < constructs2.length) {
    const resolve = constructs2[index].resolveAll;
    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }
  return events;
}
const attention = {
  name: "attention",
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
};
function resolveAllAttention(events, context) {
  let index = -1;
  let open;
  let group;
  let text2;
  let openingSequence;
  let closingSequence;
  let use;
  let nextEvents;
  let offset;
  while (++index < events.length) {
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
      open = index;
      while (open--) {
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
          if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) {
            continue;
          }
          use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
          const start = Object.assign({}, events[open][1].end);
          const end = Object.assign({}, events[index][1].start);
          movePoint(start, -use);
          movePoint(end, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: Object.assign({}, events[open][1].end)
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, events[index][1].start),
            end
          };
          text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          };
          group = {
            type: use > 1 ? "strong" : "emphasis",
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          };
          events[open][1].end = Object.assign({}, openingSequence.start);
          events[index][1].start = Object.assign({}, closingSequence.end);
          nextEvents = [];
          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ["enter", events[open][1], context],
              ["exit", events[open][1], context]
            ]);
          }
          nextEvents = push(nextEvents, [
            ["enter", group, context],
            ["enter", openingSequence, context],
            ["exit", openingSequence, context],
            ["enter", text2, context]
          ]);
          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index),
              context
            )
          );
          nextEvents = push(nextEvents, [
            ["exit", text2, context],
            ["enter", closingSequence, context],
            ["exit", closingSequence, context],
            ["exit", group, context]
          ]);
          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2;
            nextEvents = push(nextEvents, [
              ["enter", events[index][1], context],
              ["exit", events[index][1], context]
            ]);
          } else {
            offset = 0;
          }
          splice(events, open - 1, index - open + 3, nextEvents);
          index = open + nextEvents.length - offset - 2;
          break;
        }
      }
    }
  }
  index = -1;
  while (++index < events.length) {
    if (events[index][1].type === "attentionSequence") {
      events[index][1].type = "data";
    }
  }
  return events;
}
function tokenizeAttention(effects, ok) {
  const attentionMarkers2 = this.parser.constructs.attentionMarkers.null;
  const previous2 = this.previous;
  const before = classifyCharacter(previous2);
  let marker;
  return start;
  function start(code2) {
    marker = code2;
    effects.enter("attentionSequence");
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside;
    }
    const token = effects.exit("attentionSequence");
    const after = classifyCharacter(code2);
    const open = !after || after === 2 && before || attentionMarkers2.includes(code2);
    const close = !before || before === 2 && after || attentionMarkers2.includes(previous2);
    token._open = Boolean(marker === 42 ? open : open && (before || !close));
    token._close = Boolean(marker === 42 ? close : close && (after || !open));
    return ok(code2);
  }
}
function movePoint(point, offset) {
  point.column += offset;
  point.offset += offset;
  point._bufferIndex += offset;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok, nok) {
  let size = 0;
  return start;
  function start(code2) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code2);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }
  function open(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return schemeOrEmailAtext;
    }
    return emailAtext(code2);
  }
  function schemeOrEmailAtext(code2) {
    if (code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) {
      size = 1;
      return schemeInsideOrEmailAtext(code2);
    }
    return emailAtext(code2);
  }
  function schemeInsideOrEmailAtext(code2) {
    if (code2 === 58) {
      effects.consume(code2);
      size = 0;
      return urlInside;
    }
    if ((code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) && size++ < 32) {
      effects.consume(code2);
      return schemeInsideOrEmailAtext;
    }
    size = 0;
    return emailAtext(code2);
  }
  function urlInside(code2) {
    if (code2 === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }
    if (code2 === null || code2 === 32 || code2 === 60 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return urlInside;
  }
  function emailAtext(code2) {
    if (code2 === 64) {
      effects.consume(code2);
      return emailAtSignOrDot;
    }
    if (asciiAtext(code2)) {
      effects.consume(code2);
      return emailAtext;
    }
    return nok(code2);
  }
  function emailAtSignOrDot(code2) {
    return asciiAlphanumeric(code2) ? emailLabel(code2) : nok(code2);
  }
  function emailLabel(code2) {
    if (code2 === 46) {
      effects.consume(code2);
      size = 0;
      return emailAtSignOrDot;
    }
    if (code2 === 62) {
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }
    return emailValue(code2);
  }
  function emailValue(code2) {
    if ((code2 === 45 || asciiAlphanumeric(code2)) && size++ < 63) {
      const next = code2 === 45 ? emailValue : emailLabel;
      effects.consume(code2);
      return next;
    }
    return nok(code2);
  }
}
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
};
function tokenizeBlankLine(effects, ok, nok) {
  return start;
  function start(code2) {
    return markdownSpace(code2) ? factorySpace(effects, after, "linePrefix")(code2) : after(code2);
  }
  function after(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok(code2) : nok(code2);
  }
}
const blockQuote = {
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
};
function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === 62) {
      const state = self2.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code2);
      effects.exit("blockQuoteMarker");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    if (markdownSpace(code2)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code2);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok;
    }
    effects.exit("blockQuotePrefix");
    return ok(code2);
  }
}
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  const self2 = this;
  return contStart;
  function contStart(code2) {
    if (markdownSpace(code2)) {
      return factorySpace(
        effects,
        contBefore,
        "linePrefix",
        self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(code2);
    }
    return contBefore(code2);
  }
  function contBefore(code2) {
    return effects.attempt(blockQuote, ok, nok)(code2);
  }
}
function exit(effects) {
  effects.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok, nok) {
  return start;
  function start(code2) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code2);
    effects.exit("escapeMarker");
    return inside;
  }
  function inside(code2) {
    if (asciiPunctuation(code2)) {
      effects.enter("characterEscapeValue");
      effects.consume(code2);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok;
    }
    return nok(code2);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok, nok) {
  const self2 = this;
  let size = 0;
  let max;
  let test;
  return start;
  function start(code2) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code2);
    effects.exit("characterReferenceMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric;
    }
    effects.enter("characterReferenceValue");
    max = 31;
    test = asciiAlphanumeric;
    return value(code2);
  }
  function numeric(code2) {
    if (code2 === 88 || code2 === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max = 7;
    test = asciiDigit;
    return value(code2);
  }
  function value(code2) {
    if (code2 === 59 && size) {
      const token = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self2.sliceSerialize(token))) {
        return nok(code2);
      }
      effects.enter("characterReferenceMarker");
      effects.consume(code2);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok;
    }
    if (test(code2) && size++ < max) {
      effects.consume(code2);
      return value;
    }
    return nok(code2);
  }
}
const nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: true
};
const codeFenced = {
  name: "codeFenced",
  tokenize: tokenizeCodeFenced,
  concrete: true
};
function tokenizeCodeFenced(effects, ok, nok) {
  const self2 = this;
  const closeStart = {
    tokenize: tokenizeCloseStart,
    partial: true
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  let marker;
  return start;
  function start(code2) {
    return beforeSequenceOpen(code2);
  }
  function beforeSequenceOpen(code2) {
    const tail = self2.events[self2.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code2;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === marker) {
      sizeOpen++;
      effects.consume(code2);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code2);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace(code2) ? factorySpace(effects, infoBefore, "whitespace")(code2) : infoBefore(code2);
  }
  function infoBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFencedFence");
      return self2.interrupt ? ok(code2) : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code2);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code2);
  }
  function info(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace(effects, metaBefore, "whitespace")(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return info;
  }
  function metaBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return infoBefore(code2);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta(code2);
  }
  function meta(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return meta;
  }
  function atNonLazyBreak(code2) {
    return effects.attempt(closeStart, after, contentBefore)(code2);
  }
  function contentBefore(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return contentStart;
  }
  function contentStart(code2) {
    return initialPrefix > 0 && markdownSpace(code2) ? factorySpace(
      effects,
      beforeContentChunk,
      "linePrefix",
      initialPrefix + 1
    )(code2) : beforeContentChunk(code2);
  }
  function beforeContentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code2);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code2);
  }
  function contentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code2);
    }
    effects.consume(code2);
    return contentChunk;
  }
  function after(code2) {
    effects.exit("codeFenced");
    return ok(code2);
  }
  function tokenizeCloseStart(effects2, ok2, nok2) {
    let size = 0;
    return startBefore;
    function startBefore(code2) {
      effects2.enter("lineEnding");
      effects2.consume(code2);
      effects2.exit("lineEnding");
      return start2;
    }
    function start2(code2) {
      effects2.enter("codeFencedFence");
      return markdownSpace(code2) ? factorySpace(
        effects2,
        beforeSequenceClose,
        "linePrefix",
        self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(code2) : beforeSequenceClose(code2);
    }
    function beforeSequenceClose(code2) {
      if (code2 === marker) {
        effects2.enter("codeFencedFenceSequence");
        return sequenceClose(code2);
      }
      return nok2(code2);
    }
    function sequenceClose(code2) {
      if (code2 === marker) {
        size++;
        effects2.consume(code2);
        return sequenceClose;
      }
      if (size >= sizeOpen) {
        effects2.exit("codeFencedFenceSequence");
        return markdownSpace(code2) ? factorySpace(effects2, sequenceCloseAfter, "whitespace")(code2) : sequenceCloseAfter(code2);
      }
      return nok2(code2);
    }
    function sequenceCloseAfter(code2) {
      if (code2 === null || markdownLineEnding(code2)) {
        effects2.exit("codeFencedFence");
        return ok2(code2);
      }
      return nok2(code2);
    }
  }
}
function tokenizeNonLazyContinuation(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineStart;
  }
  function lineStart(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok(code2);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
};
const furtherStart = {
  tokenize: tokenizeFurtherStart,
  partial: true
};
function tokenizeCodeIndented(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("codeIndented");
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code2) : nok(code2);
  }
  function atBreak(code2) {
    if (code2 === null) {
      return after(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.attempt(furtherStart, atBreak, after)(code2);
    }
    effects.enter("codeFlowValue");
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return atBreak(code2);
    }
    effects.consume(code2);
    return inside;
  }
  function after(code2) {
    effects.exit("codeIndented");
    return ok(code2);
  }
}
function tokenizeFurtherStart(effects, ok, nok) {
  const self2 = this;
  return furtherStart2;
  function furtherStart2(code2) {
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return furtherStart2;
    }
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code2) : markdownLineEnding(code2) ? furtherStart2(code2) : nok(code2);
  }
}
const codeText = {
  name: "codeText",
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
};
function resolveCodeText(events) {
  let tailExitIndex = events.length - 4;
  let headEnterIndex = 3;
  let index;
  let enter;
  if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
    index = headEnterIndex;
    while (++index < tailExitIndex) {
      if (events[index][1].type === "codeTextData") {
        events[headEnterIndex][1].type = "codeTextPadding";
        events[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }
  index = headEnterIndex - 1;
  tailExitIndex++;
  while (++index <= tailExitIndex) {
    if (enter === void 0) {
      if (index !== tailExitIndex && events[index][1].type !== "lineEnding") {
        enter = index;
      }
    } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
      events[enter][1].type = "codeTextData";
      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end;
        events.splice(enter + 2, index - enter - 2);
        tailExitIndex -= index - enter - 2;
        index = enter + 2;
      }
      enter = void 0;
    }
  }
  return events;
}
function previous(code2) {
  return code2 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(effects, ok, nok) {
  let sizeOpen = 0;
  let size;
  let token;
  return start;
  function start(code2) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between(code2);
  }
  function between(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 32) {
      effects.enter("space");
      effects.consume(code2);
      effects.exit("space");
      return between;
    }
    if (code2 === 96) {
      token = effects.enter("codeTextSequence");
      size = 0;
      return sequenceClose(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return between;
    }
    effects.enter("codeTextData");
    return data(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 32 || code2 === 96 || markdownLineEnding(code2)) {
      effects.exit("codeTextData");
      return between(code2);
    }
    effects.consume(code2);
    return data;
  }
  function sequenceClose(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      size++;
      return sequenceClose;
    }
    if (size === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok(code2);
    }
    token.type = "codeTextData";
    return data(code2);
  }
}
function subtokenize(events) {
  const jumps = {};
  let index = -1;
  let event;
  let lineIndex;
  let otherIndex;
  let otherEvent;
  let parameters;
  let subevents;
  let more;
  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index];
    }
    event = events[index];
    if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }
    if (event[0] === "enter") {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index));
        index = jumps[index];
        more = true;
      }
    } else if (event[1]._container) {
      otherIndex = index;
      lineIndex = void 0;
      while (otherIndex--) {
        otherEvent = events[otherIndex];
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === "enter") {
            if (lineIndex) {
              events[lineIndex][1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else {
          break;
        }
      }
      if (lineIndex) {
        event[1].end = Object.assign({}, events[lineIndex][1].start);
        parameters = events.slice(lineIndex, index);
        parameters.unshift(event);
        splice(events, lineIndex, index - lineIndex + 1, parameters);
      }
    }
  }
  return !more;
}
function subcontent(events, eventIndex) {
  const token = events[eventIndex][1];
  const context = events[eventIndex][2];
  let startPosition = eventIndex - 1;
  const startPositions = [];
  const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
  const childEvents = tokenizer.events;
  const jumps = [];
  const gaps = {};
  let stream;
  let previous2;
  let index = -1;
  let current = token;
  let adjust = 0;
  let start = 0;
  const breaks = [start];
  while (current) {
    while (events[++startPosition][1] !== current) {
    }
    startPositions.push(startPosition);
    if (!current._tokenizer) {
      stream = context.sliceStream(current);
      if (!current.next) {
        stream.push(null);
      }
      if (previous2) {
        tokenizer.defineSkip(current.start);
      }
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = void 0;
      }
    }
    previous2 = current;
    current = current.next;
  }
  current = token;
  while (++index < childEvents.length) {
    if (childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
      start = index + 1;
      breaks.push(start);
      current._tokenizer = void 0;
      current.previous = void 0;
      current = current.next;
    }
  }
  tokenizer.events = [];
  if (current) {
    current._tokenizer = void 0;
    current.previous = void 0;
  } else {
    breaks.pop();
  }
  index = breaks.length;
  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1]);
    const start2 = startPositions.pop();
    jumps.unshift([start2, start2 + slice.length - 1]);
    splice(events, start2, 2, slice);
  }
  index = -1;
  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
    adjust += jumps[index][1] - jumps[index][0] - 1;
  }
  return gaps;
}
const content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
};
const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
};
function resolveContent(events) {
  subtokenize(events);
  return events;
}
function tokenizeContent(effects, ok) {
  let previous2;
  return chunkStart;
  function chunkStart(code2) {
    effects.enter("content");
    previous2 = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code2);
  }
  function chunkInside(code2) {
    if (code2 === null) {
      return contentEnd(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code2);
    }
    effects.consume(code2);
    return chunkInside;
  }
  function contentEnd(code2) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok(code2);
  }
  function contentContinue(code2) {
    effects.consume(code2);
    effects.exit("chunkContent");
    previous2.next = effects.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    });
    previous2 = previous2.next;
    return chunkInside;
  }
}
function tokenizeContinuation(effects, ok, nok) {
  const self2 = this;
  return startLookahead;
  function startLookahead(code2) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, prefixed, "linePrefix");
  }
  function prefixed(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    const tail = self2.events[self2.events.length - 1];
    if (!self2.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok(code2);
    }
    return effects.interrupt(self2.parser.constructs.flow, nok, ok)(code2);
  }
}
function factoryDestination(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
  const limit = max || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start;
  function start(code2) {
    if (code2 === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      return enclosedBefore;
    }
    if (code2 === null || code2 === 32 || code2 === 41 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return raw(code2);
  }
  function enclosedBefore(code2) {
    if (code2 === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return enclosed(code2);
  }
  function enclosed(code2) {
    if (code2 === 62) {
      effects.exit("chunkString");
      effects.exit(stringType);
      return enclosedBefore(code2);
    }
    if (code2 === null || code2 === 60 || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? enclosedEscape : enclosed;
  }
  function enclosedEscape(code2) {
    if (code2 === 60 || code2 === 62 || code2 === 92) {
      effects.consume(code2);
      return enclosed;
    }
    return enclosed(code2);
  }
  function raw(code2) {
    if (!balance && (code2 === null || code2 === 41 || markdownLineEndingOrSpace(code2))) {
      effects.exit("chunkString");
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok(code2);
    }
    if (balance < limit && code2 === 40) {
      effects.consume(code2);
      balance++;
      return raw;
    }
    if (code2 === 41) {
      effects.consume(code2);
      balance--;
      return raw;
    }
    if (code2 === null || code2 === 32 || code2 === 40 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? rawEscape : raw;
  }
  function rawEscape(code2) {
    if (code2 === 40 || code2 === 41 || code2 === 92) {
      effects.consume(code2);
      return raw;
    }
    return raw(code2);
  }
}
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self2 = this;
  let size = 0;
  let seen;
  return start;
  function start(code2) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code2);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }
  function atBreak(code2) {
    if (size > 999 || code2 === null || code2 === 91 || code2 === 93 && !seen || code2 === 94 && !size && "_hiddenFootnoteSupport" in self2.parser.constructs) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return labelInside(code2);
  }
  function labelInside(code2) {
    if (code2 === null || code2 === 91 || code2 === 93 || markdownLineEnding(code2) || size++ > 999) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    if (!seen)
      seen = !markdownSpace(code2);
    return code2 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size++;
      return labelInside;
    }
    return labelInside(code2);
  }
}
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  let marker;
  return start;
  function start(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      marker = code2 === 40 ? 41 : code2;
      return begin;
    }
    return nok(code2);
  }
  function begin(code2) {
    if (code2 === marker) {
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.exit(stringType);
      return begin(marker);
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return factorySpace(effects, atBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === marker || code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? escape : inside;
  }
  function escape(code2) {
    if (code2 === marker || code2 === 92) {
      effects.consume(code2);
      return inside;
    }
    return inside(code2);
  }
}
function factoryWhitespace(effects, ok) {
  let seen;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      seen = true;
      return start;
    }
    if (markdownSpace(code2)) {
      return factorySpace(
        effects,
        start,
        seen ? "linePrefix" : "lineSuffix"
      )(code2);
    }
    return ok(code2);
  }
}
const definition = {
  name: "definition",
  tokenize: tokenizeDefinition
};
const titleBefore = {
  tokenize: tokenizeTitleBefore,
  partial: true
};
function tokenizeDefinition(effects, ok, nok) {
  const self2 = this;
  let identifier;
  return start;
  function start(code2) {
    effects.enter("definition");
    return before(code2);
  }
  function before(code2) {
    return factoryLabel.call(
      self2,
      effects,
      labelAfter,
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code2);
  }
  function labelAfter(code2) {
    identifier = normalizeIdentifier(
      self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1)
    );
    if (code2 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code2);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code2);
  }
  function markerAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, destinationBefore)(code2) : destinationBefore(code2);
  }
  function destinationBefore(code2) {
    return factoryDestination(
      effects,
      destinationAfter,
      nok,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(code2);
  }
  function destinationAfter(code2) {
    return effects.attempt(titleBefore, after, after)(code2);
  }
  function after(code2) {
    return markdownSpace(code2) ? factorySpace(effects, afterWhitespace, "whitespace")(code2) : afterWhitespace(code2);
  }
  function afterWhitespace(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("definition");
      self2.parser.defined.push(identifier);
      return ok(code2);
    }
    return nok(code2);
  }
}
function tokenizeTitleBefore(effects, ok, nok) {
  return titleBefore2;
  function titleBefore2(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, beforeMarker)(code2) : nok(code2);
  }
  function beforeMarker(code2) {
    return factoryTitle(
      effects,
      titleAfter,
      nok,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(code2);
  }
  function titleAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code2) : titleAfterOptionalWhitespace(code2);
  }
  function titleAfterOptionalWhitespace(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok(code2) : nok(code2);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok, nok) {
  return start;
  function start(code2) {
    effects.enter("hardBreakEscape");
    effects.consume(code2);
    return after;
  }
  function after(code2) {
    if (markdownLineEnding(code2)) {
      effects.exit("hardBreakEscape");
      return ok(code2);
    }
    return nok(code2);
  }
}
const headingAtx = {
  name: "headingAtx",
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
};
function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2;
  let contentStart = 3;
  let content2;
  let text2;
  if (events[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }
  if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content2 = {
      type: "atxHeadingText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    };
    text2 = {
      type: "chunkText",
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: "text"
    };
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ["enter", content2, context],
      ["enter", text2, context],
      ["exit", text2, context],
      ["exit", content2, context]
    ]);
  }
  return events;
}
function tokenizeHeadingAtx(effects, ok, nok) {
  let size = 0;
  return start;
  function start(code2) {
    effects.enter("atxHeading");
    return before(code2);
  }
  function before(code2) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 35 && size++ < 6) {
      effects.consume(code2);
      return sequenceOpen;
    }
    if (code2 === null || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code2);
    }
    return nok(code2);
  }
  function atBreak(code2) {
    if (code2 === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("atxHeading");
      return ok(code2);
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, atBreak, "whitespace")(code2);
    }
    effects.enter("atxHeadingText");
    return data(code2);
  }
  function sequenceFurther(code2) {
    if (code2 === 35) {
      effects.consume(code2);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 35 || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingText");
      return atBreak(code2);
    }
    effects.consume(code2);
    return data;
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
const htmlRawNames = ["pre", "script", "style", "textarea"];
const htmlFlow = {
  name: "htmlFlow",
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
};
const blankLineBefore = {
  tokenize: tokenizeBlankLineBefore,
  partial: true
};
const nonLazyContinuationStart = {
  tokenize: tokenizeNonLazyContinuationStart,
  partial: true
};
function resolveToHtmlFlow(events) {
  let index = events.length;
  while (index--) {
    if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") {
      break;
    }
  }
  if (index > 1 && events[index - 2][1].type === "linePrefix") {
    events[index][1].start = events[index - 2][1].start;
    events[index + 1][1].start = events[index - 2][1].start;
    events.splice(index - 2, 2);
  }
  return events;
}
function tokenizeHtmlFlow(effects, ok, nok) {
  const self2 = this;
  let marker;
  let closingTag;
  let buffer;
  let index;
  let markerB;
  return start;
  function start(code2) {
    return before(code2);
  }
  function before(code2) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      closingTag = true;
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      marker = 3;
      return self2.interrupt ? ok : continuationDeclarationInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      marker = 2;
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      marker = 5;
      index = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      marker = 4;
      return self2.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return self2.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index++)) {
      effects.consume(code2);
      if (index === value.length) {
        return self2.interrupt ? ok : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function tagName(code2) {
    if (code2 === null || code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      const slash = code2 === 47;
      const name = buffer.toLowerCase();
      if (!slash && !closingTag && htmlRawNames.includes(name)) {
        marker = 1;
        return self2.interrupt ? ok(code2) : continuation(code2);
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code2);
          return basicSelfClosing;
        }
        return self2.interrupt ? ok(code2) : continuation(code2);
      }
      marker = 7;
      return self2.interrupt && !self2.parser.lazy[self2.now().line] ? nok(code2) : closingTag ? completeClosingTagAfter(code2) : completeAttributeNameBefore(code2);
    }
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function basicSelfClosing(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return self2.interrupt ? ok : continuation;
    }
    return nok(code2);
  }
  function completeClosingTagAfter(code2) {
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeClosingTagAfter;
    }
    return completeEnd(code2);
  }
  function completeAttributeNameBefore(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return completeEnd;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameBefore;
    }
    return completeEnd(code2);
  }
  function completeAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code2);
  }
  function completeAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code2);
  }
  function completeAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      markerB = code2;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code2);
  }
  function completeAttributeValueQuoted(code2) {
    if (code2 === markerB) {
      effects.consume(code2);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 47 || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 || markdownLineEndingOrSpace(code2)) {
      return completeAttributeNameAfter(code2);
    }
    effects.consume(code2);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownSpace(code2)) {
      return completeAttributeNameBefore(code2);
    }
    return nok(code2);
  }
  function completeEnd(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function completeAfter(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuation(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function continuation(code2) {
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationCommentInside;
    }
    if (code2 === 60 && marker === 1) {
      effects.consume(code2);
      return continuationRawTagOpen;
    }
    if (code2 === 62 && marker === 4) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 63 && marker === 3) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    if (code2 === 93 && marker === 5) {
      effects.consume(code2);
      return continuationCdataInside;
    }
    if (markdownLineEnding(code2) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(
        blankLineBefore,
        continuationAfter,
        continuationStart
      )(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationStart(code2);
    }
    effects.consume(code2);
    return continuation;
  }
  function continuationStart(code2) {
    return effects.check(
      nonLazyContinuationStart,
      continuationStartNonLazy,
      continuationAfter
    )(code2);
  }
  function continuationStartNonLazy(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return continuationBefore;
  }
  function continuationBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuationStart(code2);
    }
    effects.enter("htmlFlowData");
    return continuation(code2);
  }
  function continuationCommentInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationRawTagOpen(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      buffer = "";
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationRawEndTag(code2) {
    if (code2 === 62) {
      const name = buffer.toLowerCase();
      if (htmlRawNames.includes(name)) {
        effects.consume(code2);
        return continuationClose;
      }
      return continuation(code2);
    }
    if (asciiAlpha(code2) && buffer.length < 8) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationCdataInside(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationDeclarationInside(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationClose(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code2);
    }
    effects.consume(code2);
    return continuationClose;
  }
  function continuationAfter(code2) {
    effects.exit("htmlFlow");
    return ok(code2);
  }
}
function tokenizeNonLazyContinuationStart(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok(code2);
  }
}
function tokenizeBlankLineBefore(effects, ok, nok) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return effects.attempt(blankLine, ok, nok);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok, nok) {
  const self2 = this;
  let marker;
  let index;
  let returnState;
  return start;
  function start(code2) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instruction;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      index = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return declaration;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return nok(code2);
  }
  function comment(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 45) {
      effects.consume(code2);
      return commentClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = comment;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return comment;
  }
  function commentClose(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return comment(code2);
  }
  function commentEnd(code2) {
    return code2 === 62 ? end(code2) : code2 === 45 ? commentClose(code2) : comment(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index++)) {
      effects.consume(code2);
      return index === value.length ? cdata : cdataOpenInside;
    }
    return nok(code2);
  }
  function cdata(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = cdata;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return cdata;
  }
  function cdataClose(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function cdataEnd(code2) {
    if (code2 === 62) {
      return end(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function declaration(code2) {
    if (code2 === null || code2 === 62) {
      return end(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = declaration;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return declaration;
  }
  function instruction(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instructionClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = instruction;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return instruction;
  }
  function instructionClose(code2) {
    return code2 === 62 ? end(code2) : instruction(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return nok(code2);
  }
  function tagClose(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return tagCloseBetween(code2);
  }
  function tagCloseBetween(code2) {
    if (markdownLineEnding(code2)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagCloseBetween;
    }
    return end(code2);
  }
  function tagOpen(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function tagOpenBetween(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return end;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenBetween;
    }
    return end(code2);
  }
  function tagOpenAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code2);
  }
  function tagOpenAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code2);
  }
  function tagOpenAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      marker = code2;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      marker = void 0;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function end(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok;
    }
    return nok(code2);
  }
  function lineEndingBefore(code2) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }
  function lineEndingAfter(code2) {
    return markdownSpace(code2) ? factorySpace(
      effects,
      lineEndingAfterPrefix,
      "linePrefix",
      self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(code2) : lineEndingAfterPrefix(code2);
  }
  function lineEndingAfterPrefix(code2) {
    effects.enter("htmlTextData");
    return returnState(code2);
  }
}
const labelEnd = {
  name: "labelEnd",
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
};
const resourceConstruct = {
  tokenize: tokenizeResource
};
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
};
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(events) {
  let index = -1;
  while (++index < events.length) {
    const token = events[index][1];
    if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
      events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
      token.type = "data";
      index++;
    }
  }
  return events;
}
function resolveToLabelEnd(events, context) {
  let index = events.length;
  let offset = 0;
  let token;
  let open;
  let close;
  let media;
  while (index--) {
    token = events[index][1];
    if (open) {
      if (token.type === "link" || token.type === "labelLink" && token._inactive) {
        break;
      }
      if (events[index][0] === "enter" && token.type === "labelLink") {
        token._inactive = true;
      }
    } else if (close) {
      if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
        open = index;
        if (token.type !== "labelLink") {
          offset = 2;
          break;
        }
      }
    } else if (token.type === "labelEnd") {
      close = index;
    }
  }
  const group = {
    type: events[open][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  const label = {
    type: "label",
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  };
  const text2 = {
    type: "labelText",
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  };
  media = [
    ["enter", group, context],
    ["enter", label, context]
  ];
  media = push(media, events.slice(open + 1, open + offset + 3));
  media = push(media, [["enter", text2, context]]);
  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset + 4, close - 3),
      context
    )
  );
  media = push(media, [
    ["exit", text2, context],
    events[close - 2],
    events[close - 1],
    ["exit", label, context]
  ]);
  media = push(media, events.slice(close + 1));
  media = push(media, [["exit", group, context]]);
  splice(events, open, events.length, media);
  return events;
}
function tokenizeLabelEnd(effects, ok, nok) {
  const self2 = this;
  let index = self2.events.length;
  let labelStart;
  let defined;
  while (index--) {
    if ((self2.events[index][1].type === "labelImage" || self2.events[index][1].type === "labelLink") && !self2.events[index][1]._balanced) {
      labelStart = self2.events[index][1];
      break;
    }
  }
  return start;
  function start(code2) {
    if (!labelStart) {
      return nok(code2);
    }
    if (labelStart._inactive) {
      return labelEndNok(code2);
    }
    defined = self2.parser.defined.includes(
      normalizeIdentifier(
        self2.sliceSerialize({
          start: labelStart.end,
          end: self2.now()
        })
      )
    );
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after;
  }
  function after(code2) {
    if (code2 === 40) {
      return effects.attempt(
        resourceConstruct,
        labelEndOk,
        defined ? labelEndOk : labelEndNok
      )(code2);
    }
    if (code2 === 91) {
      return effects.attempt(
        referenceFullConstruct,
        labelEndOk,
        defined ? referenceNotFull : labelEndNok
      )(code2);
    }
    return defined ? labelEndOk(code2) : labelEndNok(code2);
  }
  function referenceNotFull(code2) {
    return effects.attempt(
      referenceCollapsedConstruct,
      labelEndOk,
      labelEndNok
    )(code2);
  }
  function labelEndOk(code2) {
    return ok(code2);
  }
  function labelEndNok(code2) {
    labelStart._balanced = true;
    return nok(code2);
  }
}
function tokenizeResource(effects, ok, nok) {
  return resourceStart;
  function resourceStart(code2) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code2);
    effects.exit("resourceMarker");
    return resourceBefore;
  }
  function resourceBefore(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceOpen)(code2) : resourceOpen(code2);
  }
  function resourceOpen(code2) {
    if (code2 === 41) {
      return resourceEnd(code2);
    }
    return factoryDestination(
      effects,
      resourceDestinationAfter,
      resourceDestinationMissing,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(code2);
  }
  function resourceDestinationAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceBetween)(code2) : resourceEnd(code2);
  }
  function resourceDestinationMissing(code2) {
    return nok(code2);
  }
  function resourceBetween(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      return factoryTitle(
        effects,
        resourceTitleAfter,
        nok,
        "resourceTitle",
        "resourceTitleMarker",
        "resourceTitleString"
      )(code2);
    }
    return resourceEnd(code2);
  }
  function resourceTitleAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceEnd)(code2) : resourceEnd(code2);
  }
  function resourceEnd(code2) {
    if (code2 === 41) {
      effects.enter("resourceMarker");
      effects.consume(code2);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok;
    }
    return nok(code2);
  }
}
function tokenizeReferenceFull(effects, ok, nok) {
  const self2 = this;
  return referenceFull;
  function referenceFull(code2) {
    return factoryLabel.call(
      self2,
      effects,
      referenceFullAfter,
      referenceFullMissing,
      "reference",
      "referenceMarker",
      "referenceString"
    )(code2);
  }
  function referenceFullAfter(code2) {
    return self2.parser.defined.includes(
      normalizeIdentifier(
        self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1)
      )
    ) ? ok(code2) : nok(code2);
  }
  function referenceFullMissing(code2) {
    return nok(code2);
  }
}
function tokenizeReferenceCollapsed(effects, ok, nok) {
  return referenceCollapsedStart;
  function referenceCollapsedStart(code2) {
    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code2);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }
  function referenceCollapsedOpen(code2) {
    if (code2 === 93) {
      effects.enter("referenceMarker");
      effects.consume(code2);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok;
    }
    return nok(code2);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartImage(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code2);
    effects.exit("labelImageMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 91) {
      effects.enter("labelMarker");
      effects.consume(code2);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok(code2);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
};
function tokenizeLabelStartLink(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after;
  }
  function after(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok(code2);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, ok, "linePrefix");
  }
}
const thematicBreak = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0;
  let marker;
  return start;
  function start(code2) {
    effects.enter("thematicBreak");
    return before(code2);
  }
  function before(code2) {
    marker = code2;
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code2);
    }
    if (size >= 3 && (code2 === null || markdownLineEnding(code2))) {
      effects.exit("thematicBreak");
      return ok(code2);
    }
    return nok(code2);
  }
  function sequence(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      size++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace(code2) ? factorySpace(effects, atBreak, "whitespace")(code2) : atBreak(code2);
  }
}
const list = {
  name: "list",
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
};
const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
};
const indentConstruct = {
  tokenize: tokenizeIndent$1,
  partial: true
};
function tokenizeListStart(effects, ok, nok) {
  const self2 = this;
  const tail = self2.events[self2.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size = 0;
  return start;
  function start(code2) {
    const kind = self2.containerState.type || (code2 === 42 || code2 === 43 || code2 === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code2 === self2.containerState.marker : asciiDigit(code2)) {
      if (!self2.containerState.type) {
        self2.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code2 === 42 || code2 === 45 ? effects.check(thematicBreak, nok, atMarker)(code2) : atMarker(code2);
      }
      if (!self2.interrupt || code2 === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside(code2);
      }
    }
    return nok(code2);
  }
  function inside(code2) {
    if (asciiDigit(code2) && ++size < 10) {
      effects.consume(code2);
      return inside;
    }
    if ((!self2.interrupt || size < 2) && (self2.containerState.marker ? code2 === self2.containerState.marker : code2 === 41 || code2 === 46)) {
      effects.exit("listItemValue");
      return atMarker(code2);
    }
    return nok(code2);
  }
  function atMarker(code2) {
    effects.enter("listItemMarker");
    effects.consume(code2);
    effects.exit("listItemMarker");
    self2.containerState.marker = self2.containerState.marker || code2;
    return effects.check(
      blankLine,
      self2.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    );
  }
  function onBlank(code2) {
    self2.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code2);
  }
  function otherPrefix(code2) {
    if (markdownSpace(code2)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code2);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code2);
  }
  function endOfPrefix(code2) {
    self2.containerState.size = initialSize + self2.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok(code2);
  }
}
function tokenizeListContinuation(effects, ok, nok) {
  const self2 = this;
  self2.containerState._closeFlow = void 0;
  return effects.check(blankLine, onBlank, notBlank);
  function onBlank(code2) {
    self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine;
    return factorySpace(
      effects,
      ok,
      "listItemIndent",
      self2.containerState.size + 1
    )(code2);
  }
  function notBlank(code2) {
    if (self2.containerState.furtherBlankLines || !markdownSpace(code2)) {
      self2.containerState.furtherBlankLines = void 0;
      self2.containerState.initialBlankLine = void 0;
      return notInCurrentItem(code2);
    }
    self2.containerState.furtherBlankLines = void 0;
    self2.containerState.initialBlankLine = void 0;
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code2);
  }
  function notInCurrentItem(code2) {
    self2.containerState._closeFlow = true;
    self2.interrupt = void 0;
    return factorySpace(
      effects,
      effects.attempt(list, ok, nok),
      "linePrefix",
      self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(code2);
  }
}
function tokenizeIndent$1(effects, ok, nok) {
  const self2 = this;
  return factorySpace(
    effects,
    afterPrefix,
    "listItemIndent",
    self2.containerState.size + 1
  );
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self2.containerState.size ? ok(code2) : nok(code2);
  }
}
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self2 = this;
  return factorySpace(
    effects,
    afterPrefix,
    "listItemPrefixWhitespace",
    self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return !markdownSpace(code2) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code2) : nok(code2);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
};
function resolveToSetextUnderline(events, context) {
  let index = events.length;
  let content2;
  let text2;
  let definition2;
  while (index--) {
    if (events[index][0] === "enter") {
      if (events[index][1].type === "content") {
        content2 = index;
        break;
      }
      if (events[index][1].type === "paragraph") {
        text2 = index;
      }
    } else {
      if (events[index][1].type === "content") {
        events.splice(index, 1);
      }
      if (!definition2 && events[index][1].type === "definition") {
        definition2 = index;
      }
    }
  }
  const heading = {
    type: "setextHeading",
    start: Object.assign({}, events[text2][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  events[text2][1].type = "setextHeadingText";
  if (definition2) {
    events.splice(text2, 0, ["enter", heading, context]);
    events.splice(definition2 + 1, 0, ["exit", events[content2][1], context]);
    events[content2][1].end = Object.assign({}, events[definition2][1].end);
  } else {
    events[content2][1] = heading;
  }
  events.push(["exit", heading, context]);
  return events;
}
function tokenizeSetextUnderline(effects, ok, nok) {
  const self2 = this;
  let marker;
  return start;
  function start(code2) {
    let index = self2.events.length;
    let paragraph;
    while (index--) {
      if (self2.events[index][1].type !== "lineEnding" && self2.events[index][1].type !== "linePrefix" && self2.events[index][1].type !== "content") {
        paragraph = self2.events[index][1].type === "paragraph";
        break;
      }
    }
    if (!self2.parser.lazy[self2.now().line] && (self2.interrupt || paragraph)) {
      effects.enter("setextHeadingLine");
      marker = code2;
      return before(code2);
    }
    return nok(code2);
  }
  function before(code2) {
    effects.enter("setextHeadingLineSequence");
    return inside(code2);
  }
  function inside(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace(code2) ? factorySpace(effects, after, "lineSuffix")(code2) : after(code2);
  }
  function after(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("setextHeadingLine");
      return ok(code2);
    }
    return nok(code2);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(effects) {
  const self2 = this;
  const initial = effects.attempt(
    blankLine,
    atBlankEnding,
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content, afterConstruct)
        ),
        "linePrefix"
      )
    )
  );
  return initial;
  function atBlankEnding(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code2);
    effects.exit("lineEndingBlank");
    self2.currentConstruct = void 0;
    return initial;
  }
  function afterConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    self2.currentConstruct = void 0;
    return initial;
  }
}
const resolver = {
  resolveAll: createResolver()
};
const string$1 = initializeFactory("string");
const text$2 = initializeFactory("text");
function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === "text" ? resolveAllLineSuffixes : void 0
    )
  };
  function initializeText(effects) {
    const self2 = this;
    const constructs2 = this.parser.constructs[field];
    const text2 = effects.attempt(constructs2, start, notText);
    return start;
    function start(code2) {
      return atBreak(code2) ? text2(code2) : notText(code2);
    }
    function notText(code2) {
      if (code2 === null) {
        effects.consume(code2);
        return;
      }
      effects.enter("data");
      effects.consume(code2);
      return data;
    }
    function data(code2) {
      if (atBreak(code2)) {
        effects.exit("data");
        return text2(code2);
      }
      effects.consume(code2);
      return data;
    }
    function atBreak(code2) {
      if (code2 === null) {
        return true;
      }
      const list2 = constructs2[code2];
      let index = -1;
      if (list2) {
        while (++index < list2.length) {
          const item = list2[index];
          if (!item.previous || item.previous.call(self2, self2.previous)) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events, context) {
    let index = -1;
    let enter;
    while (++index <= events.length) {
      if (enter === void 0) {
        if (events[index] && events[index][1].type === "data") {
          enter = index;
          index++;
        }
      } else if (!events[index] || events[index][1].type !== "data") {
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end;
          events.splice(enter + 2, index - enter - 2);
          index = enter + 2;
        }
        enter = void 0;
      }
    }
    return extraResolver ? extraResolver(events, context) : events;
  }
}
function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0;
  while (++eventIndex <= events.length) {
    if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
      const data = events[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index = chunks.length;
      let bufferIndex = -1;
      let size = 0;
      let tabs;
      while (index--) {
        const chunk = chunks[index];
        if (typeof chunk === "string") {
          bufferIndex = chunk.length;
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++;
            bufferIndex--;
          }
          if (bufferIndex)
            break;
          bufferIndex = -1;
        } else if (chunk === -2) {
          tabs = true;
          size++;
        } else if (chunk === -1)
          ;
        else {
          index++;
          break;
        }
      }
      if (size) {
        const token = {
          type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        };
        data.end = Object.assign({}, token.start);
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token);
        } else {
          events.splice(
            eventIndex,
            0,
            ["enter", token, context],
            ["exit", token, context]
          );
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events;
}
function createTokenizer(parser, initialize, from) {
  let point = Object.assign(
    from ? Object.assign({}, from) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const columnStart = {};
  const resolveAllConstructs = [];
  let chunks = [];
  let stack = [];
  const effects = {
    consume,
    enter,
    exit: exit2,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };
  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  };
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context;
  function write(slice) {
    chunks = push(chunks, slice);
    main();
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);
    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events;
  }
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs);
  }
  function sliceStream(token) {
    return sliceChunks(chunks, token);
  }
  function now() {
    const { line, column, offset, _index, _bufferIndex } = point;
    return {
      line,
      column,
      offset,
      _index,
      _bufferIndex
    };
  }
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }
  function main() {
    let chunkIndex;
    while (point._index < chunks.length) {
      const chunk = chunks[point._index];
      if (typeof chunk === "string") {
        chunkIndex = point._index;
        if (point._bufferIndex < 0) {
          point._bufferIndex = 0;
        }
        while (point._index === chunkIndex && point._bufferIndex < chunk.length) {
          go(chunk.charCodeAt(point._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  }
  function go(code2) {
    state = state(code2);
  }
  function consume(code2) {
    if (markdownLineEnding(code2)) {
      point.line++;
      point.column = 1;
      point.offset += code2 === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code2 !== -1) {
      point.column++;
      point.offset++;
    }
    if (point._bufferIndex < 0) {
      point._index++;
    } else {
      point._bufferIndex++;
      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1;
        point._index++;
      }
    }
    context.previous = code2;
  }
  function enter(type, fields) {
    const token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(["enter", token, context]);
    stack.push(token);
    return token;
  }
  function exit2(type) {
    const token = stack.pop();
    token.end = now();
    context.events.push(["exit", token, context]);
    return token;
  }
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  function onsuccessfulcheck(_, info) {
    info.restore();
  }
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      let listOfConstructs;
      let constructIndex;
      let currentConstruct;
      let info;
      return Array.isArray(constructs2) ? handleListOfConstructs(constructs2) : "tokenize" in constructs2 ? handleListOfConstructs([constructs2]) : handleMapOfConstructs(constructs2);
      function handleMapOfConstructs(map) {
        return start;
        function start(code2) {
          const def = code2 !== null && map[code2];
          const all = code2 !== null && map.null;
          const list2 = [
            ...Array.isArray(def) ? def : def ? [def] : [],
            ...Array.isArray(all) ? all : all ? [all] : []
          ];
          return handleListOfConstructs(list2)(code2);
        }
      }
      function handleListOfConstructs(list2) {
        listOfConstructs = list2;
        constructIndex = 0;
        if (list2.length === 0) {
          return bogusState;
        }
        return handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code2) {
          info = store();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) {
            return nok();
          }
          return construct.tokenize.call(
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code2);
        }
      }
      function ok(code2) {
        onreturn(currentConstruct, info);
        return returnState;
      }
      function nok(code2) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from2) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice(
        context.events,
        from2,
        context.events.length - from2,
        construct.resolve(context.events.slice(from2), context)
      );
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store() {
    const startPoint = now();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      restore,
      from: startEventsIndex
    };
    function restore() {
      point = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line];
      point.offset += columnStart[point.line] - 1;
    }
  }
}
function sliceChunks(chunks, token) {
  const startIndex = token.start._index;
  const startBufferIndex = token.start._bufferIndex;
  const endIndex = token.end._index;
  const endBufferIndex = token.end._bufferIndex;
  let view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === "string") {
        view[0] = head.slice(startBufferIndex);
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
function serializeChunks(chunks, expandTabs) {
  let index = -1;
  const result = [];
  let atTab;
  while (++index < chunks.length) {
    const chunk = chunks[index];
    let value;
    if (typeof chunk === "string") {
      value = chunk;
    } else
      switch (chunk) {
        case -5: {
          value = "\r";
          break;
        }
        case -4: {
          value = "\n";
          break;
        }
        case -3: {
          value = "\r\n";
          break;
        }
        case -2: {
          value = expandTabs ? " " : "	";
          break;
        }
        case -1: {
          if (!expandTabs && atTab)
            continue;
          value = " ";
          break;
        }
        default: {
          value = String.fromCharCode(chunk);
        }
      }
    atTab = chunk === -2;
    result.push(value);
  }
  return result.join("");
}
const document$1 = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
};
const contentInitial = {
  [91]: definition
};
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};
const flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
};
const string = {
  [38]: characterReference,
  [92]: characterEscape
};
const text$1 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};
const insideSpan = {
  null: [attention, resolver]
};
const attentionMarkers = {
  null: [42, 95]
};
const disable = {
  null: []
};
var defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  document: document$1,
  contentInitial,
  flowInitial,
  flow,
  string,
  text: text$1,
  insideSpan,
  attentionMarkers,
  disable
}, Symbol.toStringTag, { value: "Module" }));
function parse(options) {
  const settings = options || {};
  const constructs2 = combineExtensions([defaultConstructs, ...settings.extensions || []]);
  const parser = {
    defined: [],
    lazy: {},
    constructs: constructs2,
    content: create(content$1),
    document: create(document$2),
    flow: create(flow$1),
    string: create(string$1),
    text: create(text$2)
  };
  return parser;
  function create(initial) {
    return creator;
    function creator(from) {
      return createTokenizer(parser, initial, from);
    }
  }
}
function postprocess(events) {
  while (!subtokenize(events)) {
  }
  return events;
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let column = 1;
  let buffer = "";
  let start = true;
  let atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end) {
    const chunks = [];
    let match;
    let next;
    let startPosition;
    let endPosition;
    let code2;
    value = buffer + value.toString(encoding);
    startPosition = 0;
    buffer = "";
    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = void 0;
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match = search.exec(value);
      endPosition = match && match.index !== void 0 ? match.index : value.length;
      code2 = value.charCodeAt(endPosition);
      if (!match) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code2 === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = void 0;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = void 0;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        switch (code2) {
          case 0: {
            chunks.push(65533);
            column++;
            break;
          }
          case 9: {
            next = Math.ceil(column / 4) * 4;
            chunks.push(-2);
            while (column++ < next)
              chunks.push(-1);
            break;
          }
          case 10: {
            chunks.push(-4);
            column = 1;
            break;
          }
          default: {
            atCarriageReturn = true;
            column = 1;
          }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn)
        chunks.push(-5);
      if (buffer)
        chunks.push(buffer);
      chunks.push(null);
    }
    return chunks;
  }
}
function micromark(value, encoding, options) {
  if (typeof encoding !== "string") {
    options = encoding;
    encoding = void 0;
  }
  return compile(options)(
    postprocess(
      parse(options).document().write(preprocess()(value, encoding, true))
    )
  );
}
const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
};
const domain = {
  tokenize: tokenizeDomain,
  partial: true
};
const path = {
  tokenize: tokenizePath,
  partial: true
};
const trail = {
  tokenize: tokenizeTrail,
  partial: true
};
const emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
};
const wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
};
const protocolAutolink = {
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
};
const emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
};
const text = {};
const gfmAutolinkLiteral = {
  text
};
let code = 48;
while (code < 123) {
  text[code] = emailAutolink;
  code++;
  if (code === 58)
    code = 65;
  else if (code === 91)
    code = 97;
}
text[43] = emailAutolink;
text[45] = emailAutolink;
text[46] = emailAutolink;
text[95] = emailAutolink;
text[72] = [emailAutolink, protocolAutolink];
text[104] = [emailAutolink, protocolAutolink];
text[87] = [emailAutolink, wwwAutolink];
text[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(effects, ok, nok) {
  const self2 = this;
  let dot;
  let data;
  return start;
  function start(code2) {
    if (!gfmAtext(code2) || !previousEmail.call(self2, self2.previous) || previousUnbalanced(self2.events)) {
      return nok(code2);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkEmail");
    return atext(code2);
  }
  function atext(code2) {
    if (gfmAtext(code2)) {
      effects.consume(code2);
      return atext;
    }
    if (code2 === 64) {
      effects.consume(code2);
      return emailDomain;
    }
    return nok(code2);
  }
  function emailDomain(code2) {
    if (code2 === 46) {
      return effects.check(
        emailDomainDotTrail,
        emailDomainAfter,
        emailDomainDot
      )(code2);
    }
    if (code2 === 45 || code2 === 95 || asciiAlphanumeric(code2)) {
      data = true;
      effects.consume(code2);
      return emailDomain;
    }
    return emailDomainAfter(code2);
  }
  function emailDomainDot(code2) {
    effects.consume(code2);
    dot = true;
    return emailDomain;
  }
  function emailDomainAfter(code2) {
    if (data && dot && asciiAlpha(self2.previous)) {
      effects.exit("literalAutolinkEmail");
      effects.exit("literalAutolink");
      return ok(code2);
    }
    return nok(code2);
  }
}
function tokenizeWwwAutolink(effects, ok, nok) {
  const self2 = this;
  return wwwStart;
  function wwwStart(code2) {
    if (code2 !== 87 && code2 !== 119 || !previousWww.call(self2, self2.previous) || previousUnbalanced(self2.events)) {
      return nok(code2);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkWww");
    return effects.check(
      wwwPrefix,
      effects.attempt(domain, effects.attempt(path, wwwAfter), nok),
      nok
    )(code2);
  }
  function wwwAfter(code2) {
    effects.exit("literalAutolinkWww");
    effects.exit("literalAutolink");
    return ok(code2);
  }
}
function tokenizeProtocolAutolink(effects, ok, nok) {
  const self2 = this;
  let buffer = "";
  let seen = false;
  return protocolStart;
  function protocolStart(code2) {
    if ((code2 === 72 || code2 === 104) && previousProtocol.call(self2, self2.previous) && !previousUnbalanced(self2.events)) {
      effects.enter("literalAutolink");
      effects.enter("literalAutolinkHttp");
      buffer += String.fromCodePoint(code2);
      effects.consume(code2);
      return protocolPrefixInside;
    }
    return nok(code2);
  }
  function protocolPrefixInside(code2) {
    if (asciiAlpha(code2) && buffer.length < 5) {
      buffer += String.fromCodePoint(code2);
      effects.consume(code2);
      return protocolPrefixInside;
    }
    if (code2 === 58) {
      const protocol = buffer.toLowerCase();
      if (protocol === "http" || protocol === "https") {
        effects.consume(code2);
        return protocolSlashesInside;
      }
    }
    return nok(code2);
  }
  function protocolSlashesInside(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      if (seen) {
        return afterProtocol;
      }
      seen = true;
      return protocolSlashesInside;
    }
    return nok(code2);
  }
  function afterProtocol(code2) {
    return code2 === null || asciiControl(code2) || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2) || unicodePunctuation(code2) ? nok(code2) : effects.attempt(domain, effects.attempt(path, protocolAfter), nok)(code2);
  }
  function protocolAfter(code2) {
    effects.exit("literalAutolinkHttp");
    effects.exit("literalAutolink");
    return ok(code2);
  }
}
function tokenizeWwwPrefix(effects, ok, nok) {
  let size = 0;
  return wwwPrefixInside;
  function wwwPrefixInside(code2) {
    if ((code2 === 87 || code2 === 119) && size < 3) {
      size++;
      effects.consume(code2);
      return wwwPrefixInside;
    }
    if (code2 === 46 && size === 3) {
      effects.consume(code2);
      return wwwPrefixAfter;
    }
    return nok(code2);
  }
  function wwwPrefixAfter(code2) {
    return code2 === null ? nok(code2) : ok(code2);
  }
}
function tokenizeDomain(effects, ok, nok) {
  let underscoreInLastSegment;
  let underscoreInLastLastSegment;
  let seen;
  return domainInside;
  function domainInside(code2) {
    if (code2 === 46 || code2 === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code2);
    }
    if (code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2) || code2 !== 45 && unicodePunctuation(code2)) {
      return domainAfter(code2);
    }
    seen = true;
    effects.consume(code2);
    return domainInside;
  }
  function domainAtPunctuation(code2) {
    if (code2 === 95) {
      underscoreInLastSegment = true;
    } else {
      underscoreInLastLastSegment = underscoreInLastSegment;
      underscoreInLastSegment = void 0;
    }
    effects.consume(code2);
    return domainInside;
  }
  function domainAfter(code2) {
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code2);
    }
    return ok(code2);
  }
}
function tokenizePath(effects, ok) {
  let sizeOpen = 0;
  let sizeClose = 0;
  return pathInside;
  function pathInside(code2) {
    if (code2 === 40) {
      sizeOpen++;
      effects.consume(code2);
      return pathInside;
    }
    if (code2 === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code2);
    }
    if (code2 === 33 || code2 === 34 || code2 === 38 || code2 === 39 || code2 === 41 || code2 === 42 || code2 === 44 || code2 === 46 || code2 === 58 || code2 === 59 || code2 === 60 || code2 === 63 || code2 === 93 || code2 === 95 || code2 === 126) {
      return effects.check(trail, ok, pathAtPunctuation)(code2);
    }
    if (code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2)) {
      return ok(code2);
    }
    effects.consume(code2);
    return pathInside;
  }
  function pathAtPunctuation(code2) {
    if (code2 === 41) {
      sizeClose++;
    }
    effects.consume(code2);
    return pathInside;
  }
}
function tokenizeTrail(effects, ok, nok) {
  return trail2;
  function trail2(code2) {
    if (code2 === 33 || code2 === 34 || code2 === 39 || code2 === 41 || code2 === 42 || code2 === 44 || code2 === 46 || code2 === 58 || code2 === 59 || code2 === 63 || code2 === 95 || code2 === 126) {
      effects.consume(code2);
      return trail2;
    }
    if (code2 === 38) {
      effects.consume(code2);
      return trailCharRefStart;
    }
    if (code2 === 93) {
      effects.consume(code2);
      return trailBracketAfter;
    }
    if (code2 === 60 || code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2)) {
      return ok(code2);
    }
    return nok(code2);
  }
  function trailBracketAfter(code2) {
    if (code2 === null || code2 === 40 || code2 === 91 || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2)) {
      return ok(code2);
    }
    return trail2(code2);
  }
  function trailCharRefStart(code2) {
    return asciiAlpha(code2) ? trailCharRefInside(code2) : nok(code2);
  }
  function trailCharRefInside(code2) {
    if (code2 === 59) {
      effects.consume(code2);
      return trail2;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return trailCharRefInside;
    }
    return nok(code2);
  }
}
function tokenizeEmailDomainDotTrail(effects, ok, nok) {
  return start;
  function start(code2) {
    effects.consume(code2);
    return after;
  }
  function after(code2) {
    return asciiAlphanumeric(code2) ? nok(code2) : ok(code2);
  }
}
function previousWww(code2) {
  return code2 === null || code2 === 40 || code2 === 42 || code2 === 95 || code2 === 91 || code2 === 93 || code2 === 126 || markdownLineEndingOrSpace(code2);
}
function previousProtocol(code2) {
  return !asciiAlpha(code2);
}
function previousEmail(code2) {
  return !(code2 === 47 || gfmAtext(code2));
}
function gfmAtext(code2) {
  return code2 === 43 || code2 === 45 || code2 === 46 || code2 === 95 || asciiAlphanumeric(code2);
}
function previousUnbalanced(events) {
  let index = events.length;
  let result = false;
  while (index--) {
    const token = events[index][1];
    if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
      result = true;
      break;
    }
    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false;
      break;
    }
  }
  if (events.length > 0 && !result) {
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
  }
  return result;
}
const gfmAutolinkLiteralHtml = {
  exit: {
    literalAutolinkEmail,
    literalAutolinkHttp,
    literalAutolinkWww
  }
};
function literalAutolinkWww(token) {
  anchorFromToken.call(this, token, "http://");
}
function literalAutolinkEmail(token) {
  anchorFromToken.call(this, token, "mailto:");
}
function literalAutolinkHttp(token) {
  anchorFromToken.call(this, token);
}
function anchorFromToken(token, protocol) {
  const url = this.sliceSerialize(token);
  this.tag('<a href="' + sanitizeUri((protocol || "") + url) + '">');
  this.raw(this.encode(url));
  this.tag("</a>");
}
const indent = {
  tokenize: tokenizeIndent,
  partial: true
};
function gfmFootnote() {
  return {
    document: {
      [91]: {
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
  const self2 = this;
  let index = self2.events.length;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let labelStart;
  while (index--) {
    const token = self2.events[index][1];
    if (token.type === "labelImage") {
      labelStart = token;
      break;
    }
    if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") {
      break;
    }
  }
  return start;
  function start(code2) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code2);
    }
    const id = normalizeIdentifier(
      self2.sliceSerialize({
        start: labelStart.end,
        end: self2.now()
      })
    );
    if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code2);
    }
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code2);
    effects.exit("gfmFootnoteCallLabelMarker");
    return ok(code2);
  }
}
function resolveToPotentialGfmFootnoteCall(events, context) {
  let index = events.length;
  while (index--) {
    if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
      events[index][1];
      break;
    }
  }
  events[index + 1][1].type = "data";
  events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
  const call = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, events[index + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  const marker = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, events[index + 3][1].end),
    end: Object.assign({}, events[index + 3][1].end)
  };
  marker.end.column++;
  marker.end.offset++;
  marker.end._bufferIndex++;
  const string2 = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  };
  const chunk = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, string2.start),
    end: Object.assign({}, string2.end)
  };
  const replacement = [
    events[index + 1],
    events[index + 2],
    ["enter", call, context],
    events[index + 3],
    events[index + 4],
    ["enter", marker, context],
    ["exit", marker, context],
    ["enter", string2, context],
    ["enter", chunk, context],
    ["exit", chunk, context],
    ["exit", string2, context],
    events[events.length - 2],
    events[events.length - 1],
    ["exit", call, context]
  ];
  events.splice(index, events.length - index + 1, ...replacement);
  return events;
}
function tokenizeGfmFootnoteCall(effects, ok, nok) {
  const self2 = this;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let size = 0;
  let data;
  return start;
  function start(code2) {
    effects.enter("gfmFootnoteCall");
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code2);
    effects.exit("gfmFootnoteCallLabelMarker");
    return callStart;
  }
  function callStart(code2) {
    if (code2 !== 94)
      return nok(code2);
    effects.enter("gfmFootnoteCallMarker");
    effects.consume(code2);
    effects.exit("gfmFootnoteCallMarker");
    effects.enter("gfmFootnoteCallString");
    effects.enter("chunkString").contentType = "string";
    return callData;
  }
  function callData(code2) {
    if (size > 999 || code2 === 93 && !data || code2 === null || code2 === 91 || markdownLineEndingOrSpace(code2)) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit("chunkString");
      const token = effects.exit("gfmFootnoteCallString");
      if (!defined.includes(normalizeIdentifier(self2.sliceSerialize(token)))) {
        return nok(code2);
      }
      effects.enter("gfmFootnoteCallLabelMarker");
      effects.consume(code2);
      effects.exit("gfmFootnoteCallLabelMarker");
      effects.exit("gfmFootnoteCall");
      return ok;
    }
    if (!markdownLineEndingOrSpace(code2)) {
      data = true;
    }
    size++;
    effects.consume(code2);
    return code2 === 92 ? callEscape : callData;
  }
  function callEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size++;
      return callData;
    }
    return callData(code2);
  }
}
function tokenizeDefinitionStart(effects, ok, nok) {
  const self2 = this;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let identifier;
  let size = 0;
  let data;
  return start;
  function start(code2) {
    effects.enter("gfmFootnoteDefinition")._container = true;
    effects.enter("gfmFootnoteDefinitionLabel");
    effects.enter("gfmFootnoteDefinitionLabelMarker");
    effects.consume(code2);
    effects.exit("gfmFootnoteDefinitionLabelMarker");
    return labelAtMarker;
  }
  function labelAtMarker(code2) {
    if (code2 === 94) {
      effects.enter("gfmFootnoteDefinitionMarker");
      effects.consume(code2);
      effects.exit("gfmFootnoteDefinitionMarker");
      effects.enter("gfmFootnoteDefinitionLabelString");
      effects.enter("chunkString").contentType = "string";
      return labelInside;
    }
    return nok(code2);
  }
  function labelInside(code2) {
    if (size > 999 || code2 === 93 && !data || code2 === null || code2 === 91 || markdownLineEndingOrSpace(code2)) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit("chunkString");
      const token = effects.exit("gfmFootnoteDefinitionLabelString");
      identifier = normalizeIdentifier(self2.sliceSerialize(token));
      effects.enter("gfmFootnoteDefinitionLabelMarker");
      effects.consume(code2);
      effects.exit("gfmFootnoteDefinitionLabelMarker");
      effects.exit("gfmFootnoteDefinitionLabel");
      return labelAfter;
    }
    if (!markdownLineEndingOrSpace(code2)) {
      data = true;
    }
    size++;
    effects.consume(code2);
    return code2 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size++;
      return labelInside;
    }
    return labelInside(code2);
  }
  function labelAfter(code2) {
    if (code2 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code2);
      effects.exit("definitionMarker");
      if (!defined.includes(identifier)) {
        defined.push(identifier);
      }
      return factorySpace(
        effects,
        whitespaceAfter,
        "gfmFootnoteDefinitionWhitespace"
      );
    }
    return nok(code2);
  }
  function whitespaceAfter(code2) {
    return ok(code2);
  }
}
function tokenizeDefinitionContinuation(effects, ok, nok) {
  return effects.check(blankLine, ok, effects.attempt(indent, ok, nok));
}
function gfmFootnoteDefinitionEnd(effects) {
  effects.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(effects, ok, nok) {
  const self2 = this;
  return factorySpace(
    effects,
    afterPrefix,
    "gfmFootnoteDefinitionIndent",
    4 + 1
  );
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code2) : nok(code2);
  }
}
const own = {}.hasOwnProperty;
const emptyOptions = {};
function defaultBackLabel(referenceIndex, rereferenceIndex) {
  return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function gfmFootnoteHtml(options) {
  const config = options || emptyOptions;
  const label = config.label || "Footnotes";
  const labelTagName = config.labelTagName || "h2";
  const labelAttributes = config.labelAttributes === null || config.labelAttributes === void 0 ? 'class="sr-only"' : config.labelAttributes;
  const backLabel = config.backLabel || defaultBackLabel;
  const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === void 0 ? "user-content-" : config.clobberPrefix;
  return {
    enter: {
      gfmFootnoteDefinition() {
        const stack = this.getData("tightStack");
        stack.push(false);
      },
      gfmFootnoteDefinitionLabelString() {
        this.buffer();
      },
      gfmFootnoteCallString() {
        this.buffer();
      }
    },
    exit: {
      gfmFootnoteDefinition() {
        let definitions = this.getData("gfmFootnoteDefinitions");
        const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
        const tightStack = this.getData("tightStack");
        const current = footnoteStack.pop();
        const value = this.resume();
        if (!definitions) {
          this.setData("gfmFootnoteDefinitions", definitions = {});
        }
        if (!own.call(definitions, current))
          definitions[current] = value;
        tightStack.pop();
        this.setData("slurpOneLineEnding", true);
        this.setData("lastWasTag");
      },
      gfmFootnoteDefinitionLabelString(token) {
        let footnoteStack = this.getData("gfmFootnoteDefinitionStack");
        if (!footnoteStack) {
          this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
        }
        footnoteStack.push(normalizeIdentifier(this.sliceSerialize(token)));
        this.resume();
        this.buffer();
      },
      gfmFootnoteCallString(token) {
        let calls = this.getData("gfmFootnoteCallOrder");
        let counts = this.getData("gfmFootnoteCallCounts");
        const id = normalizeIdentifier(this.sliceSerialize(token));
        let counter;
        this.resume();
        if (!calls)
          this.setData("gfmFootnoteCallOrder", calls = []);
        if (!counts)
          this.setData("gfmFootnoteCallCounts", counts = {});
        const index = calls.indexOf(id);
        const safeId = sanitizeUri(id.toLowerCase());
        if (index === -1) {
          calls.push(id);
          counts[id] = 1;
          counter = calls.length;
        } else {
          counts[id]++;
          counter = index + 1;
        }
        const reuseCounter = counts[id];
        this.tag(
          '<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>"
        );
      },
      null() {
        const calls = this.getData("gfmFootnoteCallOrder") || [];
        const counts = this.getData("gfmFootnoteCallCounts") || {};
        const definitions = this.getData("gfmFootnoteDefinitions") || {};
        let index = -1;
        if (calls.length > 0) {
          this.lineEndingIfNeeded();
          this.tag(
            '<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">"
          );
          this.raw(this.encode(label));
          this.tag("</" + labelTagName + ">");
          this.lineEndingIfNeeded();
          this.tag("<ol>");
        }
        while (++index < calls.length) {
          const id = calls[index];
          const safeId = sanitizeUri(id.toLowerCase());
          let referenceIndex = 0;
          const references = [];
          while (++referenceIndex <= counts[id]) {
            references.push(
              '<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(
                typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)
              ) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>"
            );
          }
          const reference = references.join(" ");
          let injected = false;
          this.lineEndingIfNeeded();
          this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
          this.lineEndingIfNeeded();
          this.tag(
            definitions[id].replace(
              /<\/p>(?:\r?\n|\r)?$/,
              ($0) => {
                injected = true;
                return " " + reference + $0;
              }
            )
          );
          if (!injected) {
            this.lineEndingIfNeeded();
            this.tag(reference);
          }
          this.lineEndingIfNeeded();
          this.tag("</li>");
        }
        if (calls.length > 0) {
          this.lineEndingIfNeeded();
          this.tag("</ol>");
          this.lineEndingIfNeeded();
          this.tag("</section>");
        }
      }
    }
  };
}
const gfmStrikethroughHtml = {
  enter: {
    strikethrough() {
      this.tag("<del>");
    }
  },
  exit: {
    strikethrough() {
      this.tag("</del>");
    }
  }
};
function gfmStrikethrough(options) {
  const options_ = options || {};
  let single = options_.singleTilde;
  const tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  };
  if (single === null || single === void 0) {
    single = true;
  }
  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function resolveAllStrikethrough(events, context) {
    let index = -1;
    while (++index < events.length) {
      if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
        let open = index;
        while (open--) {
          if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
            events[index][1].type = "strikethroughSequence";
            events[open][1].type = "strikethroughSequence";
            const strikethrough = {
              type: "strikethrough",
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            };
            const text2 = {
              type: "strikethroughText",
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            };
            const nextEvents = [
              ["enter", strikethrough, context],
              ["enter", events[open][1], context],
              ["exit", events[open][1], context],
              ["enter", text2, context]
            ];
            const insideSpan2 = context.parser.constructs.insideSpan.null;
            if (insideSpan2) {
              splice(
                nextEvents,
                nextEvents.length,
                0,
                resolveAll(insideSpan2, events.slice(open + 1, index), context)
              );
            }
            splice(nextEvents, nextEvents.length, 0, [
              ["exit", text2, context],
              ["enter", events[index][1], context],
              ["exit", events[index][1], context],
              ["exit", strikethrough, context]
            ]);
            splice(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - 2;
            break;
          }
        }
      }
    }
    index = -1;
    while (++index < events.length) {
      if (events[index][1].type === "strikethroughSequenceTemporary") {
        events[index][1].type = "data";
      }
    }
    return events;
  }
  function tokenizeStrikethrough(effects, ok, nok) {
    const previous2 = this.previous;
    const events = this.events;
    let size = 0;
    return start;
    function start(code2) {
      if (previous2 === 126 && events[events.length - 1][1].type !== "characterEscape") {
        return nok(code2);
      }
      effects.enter("strikethroughSequenceTemporary");
      return more(code2);
    }
    function more(code2) {
      const before = classifyCharacter(previous2);
      if (code2 === 126) {
        if (size > 1)
          return nok(code2);
        effects.consume(code2);
        size++;
        return more;
      }
      if (size < 2 && !single)
        return nok(code2);
      const token = effects.exit("strikethroughSequenceTemporary");
      const after = classifyCharacter(code2);
      token._open = !after || after === 2 && Boolean(before);
      token._close = !before || before === 2 && Boolean(after);
      return ok(code2);
    }
  }
}
const alignment = {
  none: "",
  left: ' align="left"',
  right: ' align="right"',
  center: ' align="center"'
};
const gfmTableHtml = {
  enter: {
    table(token) {
      const tableAlign = token._align;
      this.lineEndingIfNeeded();
      this.tag("<table>");
      this.setData("tableAlign", tableAlign);
    },
    tableBody() {
      this.tag("<tbody>");
    },
    tableData() {
      const tableAlign = this.getData("tableAlign");
      const tableColumn = this.getData("tableColumn");
      const align = alignment[tableAlign[tableColumn]];
      if (align === void 0) {
        this.buffer();
      } else {
        this.lineEndingIfNeeded();
        this.tag("<td" + align + ">");
      }
    },
    tableHead() {
      this.lineEndingIfNeeded();
      this.tag("<thead>");
    },
    tableHeader() {
      const tableAlign = this.getData("tableAlign");
      const tableColumn = this.getData("tableColumn");
      const align = alignment[tableAlign[tableColumn]];
      this.lineEndingIfNeeded();
      this.tag("<th" + align + ">");
    },
    tableRow() {
      this.setData("tableColumn", 0);
      this.lineEndingIfNeeded();
      this.tag("<tr>");
    }
  },
  exit: {
    codeTextData(token) {
      let value = this.sliceSerialize(token);
      if (this.getData("tableAlign")) {
        value = value.replace(/\\([\\|])/g, replace);
      }
      this.raw(this.encode(value));
    },
    table() {
      this.setData("tableAlign");
      this.setData("slurpAllLineEndings");
      this.lineEndingIfNeeded();
      this.tag("</table>");
    },
    tableBody() {
      this.lineEndingIfNeeded();
      this.tag("</tbody>");
    },
    tableData() {
      const tableAlign = this.getData("tableAlign");
      const tableColumn = this.getData("tableColumn");
      if (tableColumn in tableAlign) {
        this.tag("</td>");
        this.setData("tableColumn", tableColumn + 1);
      } else {
        this.resume();
      }
    },
    tableHead() {
      this.lineEndingIfNeeded();
      this.tag("</thead>");
    },
    tableHeader() {
      const tableColumn = this.getData("tableColumn");
      this.tag("</th>");
      this.setData("tableColumn", tableColumn + 1);
    },
    tableRow() {
      const tableAlign = this.getData("tableAlign");
      let tableColumn = this.getData("tableColumn");
      while (tableColumn < tableAlign.length) {
        this.lineEndingIfNeeded();
        this.tag("<td" + alignment[tableAlign[tableColumn]] + "></td>");
        tableColumn++;
      }
      this.setData("tableColumn", tableColumn);
      this.lineEndingIfNeeded();
      this.tag("</tr>");
    }
  }
};
function replace($0, $1) {
  return $1 === "|" ? $1 : $0;
}
class EditMap {
  constructor() {
    this.map = [];
  }
  add(index, remove, add) {
    addImpl(this, index, remove, add);
  }
  consume(events) {
    this.map.sort((a, b) => a[0] - b[0]);
    if (this.map.length === 0) {
      return;
    }
    let index = this.map.length;
    const vecs = [];
    while (index > 0) {
      index -= 1;
      vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
      vecs.push(this.map[index][2]);
      events.length = this.map[index][0];
    }
    vecs.push([...events]);
    events.length = 0;
    let slice = vecs.pop();
    while (slice) {
      events.push(...slice);
      slice = vecs.pop();
    }
    this.map.length = 0;
  }
}
function addImpl(editMap, at, remove, add) {
  let index = 0;
  if (remove === 0 && add.length === 0) {
    return;
  }
  while (index < editMap.map.length) {
    if (editMap.map[index][0] === at) {
      editMap.map[index][1] += remove;
      editMap.map[index][2].push(...add);
      return;
    }
    index += 1;
  }
  editMap.map.push([at, remove, add]);
}
function gfmTableAlign(events, index) {
  let inDelimiterRow = false;
  const align = [];
  while (index < events.length) {
    const event = events[index];
    if (inDelimiterRow) {
      if (event[0] === "enter") {
        if (event[1].type === "tableContent") {
          align.push(
            events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
          );
        }
      } else if (event[1].type === "tableContent") {
        if (events[index - 1][1].type === "tableDelimiterMarker") {
          const alignIndex = align.length - 1;
          align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
        }
      } else if (event[1].type === "tableDelimiterRow") {
        break;
      }
    } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") {
      inDelimiterRow = true;
    }
    index += 1;
  }
  return align;
}
const gfmTable = {
  flow: {
    null: {
      tokenize: tokenizeTable,
      resolveAll: resolveTable
    }
  }
};
function tokenizeTable(effects, ok, nok) {
  const self2 = this;
  let size = 0;
  let sizeB = 0;
  let seen;
  return start;
  function start(code2) {
    let index = self2.events.length - 1;
    while (index > -1) {
      const type = self2.events[index][1].type;
      if (type === "lineEnding" || type === "linePrefix")
        index--;
      else
        break;
    }
    const tail = index > -1 ? self2.events[index][1].type : null;
    const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
    if (next === bodyRowStart && self2.parser.lazy[self2.now().line]) {
      return nok(code2);
    }
    return next(code2);
  }
  function headRowBefore(code2) {
    effects.enter("tableHead");
    effects.enter("tableRow");
    return headRowStart(code2);
  }
  function headRowStart(code2) {
    if (code2 === 124) {
      return headRowBreak(code2);
    }
    seen = true;
    sizeB += 1;
    return headRowBreak(code2);
  }
  function headRowBreak(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      if (sizeB > 1) {
        sizeB = 0;
        self2.interrupt = true;
        effects.exit("tableRow");
        effects.enter("lineEnding");
        effects.consume(code2);
        effects.exit("lineEnding");
        return headDelimiterStart;
      }
      return nok(code2);
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, headRowBreak, "whitespace")(code2);
    }
    sizeB += 1;
    if (seen) {
      seen = false;
      size += 1;
    }
    if (code2 === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code2);
      effects.exit("tableCellDivider");
      seen = true;
      return headRowBreak;
    }
    effects.enter("data");
    return headRowData(code2);
  }
  function headRowData(code2) {
    if (code2 === null || code2 === 124 || markdownLineEndingOrSpace(code2)) {
      effects.exit("data");
      return headRowBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? headRowEscape : headRowData;
  }
  function headRowEscape(code2) {
    if (code2 === 92 || code2 === 124) {
      effects.consume(code2);
      return headRowData;
    }
    return headRowData(code2);
  }
  function headDelimiterStart(code2) {
    self2.interrupt = false;
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code2);
    }
    effects.enter("tableDelimiterRow");
    seen = false;
    if (markdownSpace(code2)) {
      return factorySpace(
        effects,
        headDelimiterBefore,
        "linePrefix",
        self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(code2);
    }
    return headDelimiterBefore(code2);
  }
  function headDelimiterBefore(code2) {
    if (code2 === 45 || code2 === 58) {
      return headDelimiterValueBefore(code2);
    }
    if (code2 === 124) {
      seen = true;
      effects.enter("tableCellDivider");
      effects.consume(code2);
      effects.exit("tableCellDivider");
      return headDelimiterCellBefore;
    }
    return headDelimiterNok(code2);
  }
  function headDelimiterCellBefore(code2) {
    if (markdownSpace(code2)) {
      return factorySpace(effects, headDelimiterValueBefore, "whitespace")(code2);
    }
    return headDelimiterValueBefore(code2);
  }
  function headDelimiterValueBefore(code2) {
    if (code2 === 58) {
      sizeB += 1;
      seen = true;
      effects.enter("tableDelimiterMarker");
      effects.consume(code2);
      effects.exit("tableDelimiterMarker");
      return headDelimiterLeftAlignmentAfter;
    }
    if (code2 === 45) {
      sizeB += 1;
      return headDelimiterLeftAlignmentAfter(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      return headDelimiterCellAfter(code2);
    }
    return headDelimiterNok(code2);
  }
  function headDelimiterLeftAlignmentAfter(code2) {
    if (code2 === 45) {
      effects.enter("tableDelimiterFiller");
      return headDelimiterFiller(code2);
    }
    return headDelimiterNok(code2);
  }
  function headDelimiterFiller(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return headDelimiterFiller;
    }
    if (code2 === 58) {
      seen = true;
      effects.exit("tableDelimiterFiller");
      effects.enter("tableDelimiterMarker");
      effects.consume(code2);
      effects.exit("tableDelimiterMarker");
      return headDelimiterRightAlignmentAfter;
    }
    effects.exit("tableDelimiterFiller");
    return headDelimiterRightAlignmentAfter(code2);
  }
  function headDelimiterRightAlignmentAfter(code2) {
    if (markdownSpace(code2)) {
      return factorySpace(effects, headDelimiterCellAfter, "whitespace")(code2);
    }
    return headDelimiterCellAfter(code2);
  }
  function headDelimiterCellAfter(code2) {
    if (code2 === 124) {
      return headDelimiterBefore(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      if (!seen || size !== sizeB) {
        return headDelimiterNok(code2);
      }
      effects.exit("tableDelimiterRow");
      effects.exit("tableHead");
      return ok(code2);
    }
    return headDelimiterNok(code2);
  }
  function headDelimiterNok(code2) {
    return nok(code2);
  }
  function bodyRowStart(code2) {
    effects.enter("tableRow");
    return bodyRowBreak(code2);
  }
  function bodyRowBreak(code2) {
    if (code2 === 124) {
      effects.enter("tableCellDivider");
      effects.consume(code2);
      effects.exit("tableCellDivider");
      return bodyRowBreak;
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("tableRow");
      return ok(code2);
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, bodyRowBreak, "whitespace")(code2);
    }
    effects.enter("data");
    return bodyRowData(code2);
  }
  function bodyRowData(code2) {
    if (code2 === null || code2 === 124 || markdownLineEndingOrSpace(code2)) {
      effects.exit("data");
      return bodyRowBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? bodyRowEscape : bodyRowData;
  }
  function bodyRowEscape(code2) {
    if (code2 === 92 || code2 === 124) {
      effects.consume(code2);
      return bodyRowData;
    }
    return bodyRowData(code2);
  }
}
function resolveTable(events, context) {
  let index = -1;
  let inFirstCellAwaitingPipe = true;
  let rowKind = 0;
  let lastCell = [0, 0, 0, 0];
  let cell = [0, 0, 0, 0];
  let afterHeadAwaitingFirstBodyRow = false;
  let lastTableEnd = 0;
  let currentTable;
  let currentBody;
  let currentCell;
  const map = new EditMap();
  while (++index < events.length) {
    const event = events[index];
    const token = event[1];
    if (event[0] === "enter") {
      if (token.type === "tableHead") {
        afterHeadAwaitingFirstBodyRow = false;
        if (lastTableEnd !== 0) {
          flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
          currentBody = void 0;
          lastTableEnd = 0;
        }
        currentTable = {
          type: "table",
          start: Object.assign({}, token.start),
          end: Object.assign({}, token.end)
        };
        map.add(index, 0, [["enter", currentTable, context]]);
      } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
        inFirstCellAwaitingPipe = true;
        currentCell = void 0;
        lastCell = [0, 0, 0, 0];
        cell = [0, index + 1, 0, 0];
        if (afterHeadAwaitingFirstBodyRow) {
          afterHeadAwaitingFirstBodyRow = false;
          currentBody = {
            type: "tableBody",
            start: Object.assign({}, token.start),
            end: Object.assign({}, token.end)
          };
          map.add(index, 0, [["enter", currentBody, context]]);
        }
        rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
      } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
        inFirstCellAwaitingPipe = false;
        if (cell[2] === 0) {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              void 0,
              currentCell
            );
            lastCell = [0, 0, 0, 0];
          }
          cell[2] = index;
        }
      } else if (token.type === "tableCellDivider") {
        if (inFirstCellAwaitingPipe) {
          inFirstCellAwaitingPipe = false;
        } else {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1];
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              void 0,
              currentCell
            );
          }
          lastCell = cell;
          cell = [lastCell[1], index, 0, 0];
        }
      }
    } else if (token.type === "tableHead") {
      afterHeadAwaitingFirstBodyRow = true;
      lastTableEnd = index;
    } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
      lastTableEnd = index;
      if (lastCell[1] !== 0) {
        cell[0] = cell[1];
        currentCell = flushCell(
          map,
          context,
          lastCell,
          rowKind,
          index,
          currentCell
        );
      } else if (cell[1] !== 0) {
        currentCell = flushCell(map, context, cell, rowKind, index, currentCell);
      }
      rowKind = 0;
    } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
      cell[3] = index;
    }
  }
  if (lastTableEnd !== 0) {
    flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
  }
  map.consume(context.events);
  index = -1;
  while (++index < context.events.length) {
    const event = context.events[index];
    if (event[0] === "enter" && event[1].type === "table") {
      event[1]._align = gfmTableAlign(context.events, index);
    }
  }
  return events;
}
function flushCell(map, context, range, rowKind, rowEnd, previousCell) {
  const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
  const valueName = "tableContent";
  if (range[0] !== 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, range[0]));
    map.add(range[0], 0, [["exit", previousCell, context]]);
  }
  const now = getPoint(context.events, range[1]);
  previousCell = {
    type: groupName,
    start: Object.assign({}, now),
    end: Object.assign({}, now)
  };
  map.add(range[1], 0, [["enter", previousCell, context]]);
  if (range[2] !== 0) {
    const relatedStart = getPoint(context.events, range[2]);
    const relatedEnd = getPoint(context.events, range[3]);
    const valueToken = {
      type: valueName,
      start: Object.assign({}, relatedStart),
      end: Object.assign({}, relatedEnd)
    };
    map.add(range[2], 0, [["enter", valueToken, context]]);
    if (rowKind !== 2) {
      const start = context.events[range[2]];
      const end = context.events[range[3]];
      start[1].end = Object.assign({}, end[1].end);
      start[1].type = "chunkText";
      start[1].contentType = "text";
      if (range[3] > range[2] + 1) {
        const a = range[2] + 1;
        const b = range[3] - range[2] - 1;
        map.add(a, b, []);
      }
    }
    map.add(range[3] + 1, 0, [["exit", valueToken, context]]);
  }
  if (rowEnd !== void 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, rowEnd));
    map.add(rowEnd, 0, [["exit", previousCell, context]]);
    previousCell = void 0;
  }
  return previousCell;
}
function flushTableEnd(map, context, index, table, tableBody) {
  const exits = [];
  const related = getPoint(context.events, index);
  if (tableBody) {
    tableBody.end = Object.assign({}, related);
    exits.push(["exit", tableBody, context]);
  }
  table.end = Object.assign({}, related);
  exits.push(["exit", table, context]);
  map.add(index + 1, 0, exits);
}
function getPoint(events, index) {
  const event = events[index];
  const side = event[0] === "enter" ? "start" : "end";
  return event[1][side];
}
const reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
const reText = new RegExp("^" + reFlow.source, "i");
const gfmTagfilterHtml = {
  exit: {
    htmlFlowData(token) {
      exitHtmlData.call(this, token, reFlow);
    },
    htmlTextData(token) {
      exitHtmlData.call(this, token, reText);
    }
  }
};
function exitHtmlData(token, filter) {
  let value = this.sliceSerialize(token);
  if (this.options.allowDangerousHtml) {
    value = value.replace(filter, "&lt;$1$2");
  }
  this.raw(this.encode(value));
}
const gfmTaskListItemHtml = {
  enter: {
    taskListCheck() {
      this.tag('<input type="checkbox" disabled="" ');
    }
  },
  exit: {
    taskListCheck() {
      this.tag("/>");
    },
    taskListCheckValueChecked() {
      this.tag('checked="" ');
    }
  }
};
const tasklistCheck = {
  tokenize: tokenizeTasklistCheck
};
const gfmTaskListItem = {
  text: {
    [91]: tasklistCheck
  }
};
function tokenizeTasklistCheck(effects, ok, nok) {
  const self2 = this;
  return open;
  function open(code2) {
    if (self2.previous !== null || !self2._gfmTasklistFirstContentOfListItem) {
      return nok(code2);
    }
    effects.enter("taskListCheck");
    effects.enter("taskListCheckMarker");
    effects.consume(code2);
    effects.exit("taskListCheckMarker");
    return inside;
  }
  function inside(code2) {
    if (markdownLineEndingOrSpace(code2)) {
      effects.enter("taskListCheckValueUnchecked");
      effects.consume(code2);
      effects.exit("taskListCheckValueUnchecked");
      return close;
    }
    if (code2 === 88 || code2 === 120) {
      effects.enter("taskListCheckValueChecked");
      effects.consume(code2);
      effects.exit("taskListCheckValueChecked");
      return close;
    }
    return nok(code2);
  }
  function close(code2) {
    if (code2 === 93) {
      effects.enter("taskListCheckMarker");
      effects.consume(code2);
      effects.exit("taskListCheckMarker");
      effects.exit("taskListCheck");
      return after;
    }
    return nok(code2);
  }
  function after(code2) {
    if (markdownLineEnding(code2)) {
      return ok(code2);
    }
    if (markdownSpace(code2)) {
      return effects.check(
        {
          tokenize: spaceThenNonSpace
        },
        ok,
        nok
      )(code2);
    }
    return nok(code2);
  }
}
function spaceThenNonSpace(effects, ok, nok) {
  return factorySpace(effects, after, "whitespace");
  function after(code2) {
    return code2 === null ? nok(code2) : ok(code2);
  }
}
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral,
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable,
    gfmTaskListItem
  ]);
}
function gfmHtml(options) {
  return combineHtmlExtensions([
    gfmAutolinkLiteralHtml,
    gfmFootnoteHtml(options),
    gfmStrikethroughHtml,
    gfmTableHtml,
    gfmTagfilterHtml,
    gfmTaskListItemHtml
  ]);
}
const codes = {
  carriageReturn: -5,
  lineFeed: -4,
  carriageReturnLineFeed: -3,
  horizontalTab: -2,
  virtualSpace: -1,
  eof: null,
  nul: 0,
  soh: 1,
  stx: 2,
  etx: 3,
  eot: 4,
  enq: 5,
  ack: 6,
  bel: 7,
  bs: 8,
  ht: 9,
  lf: 10,
  vt: 11,
  ff: 12,
  cr: 13,
  so: 14,
  si: 15,
  dle: 16,
  dc1: 17,
  dc2: 18,
  dc3: 19,
  dc4: 20,
  nak: 21,
  syn: 22,
  etb: 23,
  can: 24,
  em: 25,
  sub: 26,
  esc: 27,
  fs: 28,
  gs: 29,
  rs: 30,
  us: 31,
  space: 32,
  exclamationMark: 33,
  quotationMark: 34,
  numberSign: 35,
  dollarSign: 36,
  percentSign: 37,
  ampersand: 38,
  apostrophe: 39,
  leftParenthesis: 40,
  rightParenthesis: 41,
  asterisk: 42,
  plusSign: 43,
  comma: 44,
  dash: 45,
  dot: 46,
  slash: 47,
  digit0: 48,
  digit1: 49,
  digit2: 50,
  digit3: 51,
  digit4: 52,
  digit5: 53,
  digit6: 54,
  digit7: 55,
  digit8: 56,
  digit9: 57,
  colon: 58,
  semicolon: 59,
  lessThan: 60,
  equalsTo: 61,
  greaterThan: 62,
  questionMark: 63,
  atSign: 64,
  uppercaseA: 65,
  uppercaseB: 66,
  uppercaseC: 67,
  uppercaseD: 68,
  uppercaseE: 69,
  uppercaseF: 70,
  uppercaseG: 71,
  uppercaseH: 72,
  uppercaseI: 73,
  uppercaseJ: 74,
  uppercaseK: 75,
  uppercaseL: 76,
  uppercaseM: 77,
  uppercaseN: 78,
  uppercaseO: 79,
  uppercaseP: 80,
  uppercaseQ: 81,
  uppercaseR: 82,
  uppercaseS: 83,
  uppercaseT: 84,
  uppercaseU: 85,
  uppercaseV: 86,
  uppercaseW: 87,
  uppercaseX: 88,
  uppercaseY: 89,
  uppercaseZ: 90,
  leftSquareBracket: 91,
  backslash: 92,
  rightSquareBracket: 93,
  caret: 94,
  underscore: 95,
  graveAccent: 96,
  lowercaseA: 97,
  lowercaseB: 98,
  lowercaseC: 99,
  lowercaseD: 100,
  lowercaseE: 101,
  lowercaseF: 102,
  lowercaseG: 103,
  lowercaseH: 104,
  lowercaseI: 105,
  lowercaseJ: 106,
  lowercaseK: 107,
  lowercaseL: 108,
  lowercaseM: 109,
  lowercaseN: 110,
  lowercaseO: 111,
  lowercaseP: 112,
  lowercaseQ: 113,
  lowercaseR: 114,
  lowercaseS: 115,
  lowercaseT: 116,
  lowercaseU: 117,
  lowercaseV: 118,
  lowercaseW: 119,
  lowercaseX: 120,
  lowercaseY: 121,
  lowercaseZ: 122,
  leftCurlyBrace: 123,
  verticalBar: 124,
  rightCurlyBrace: 125,
  tilde: 126,
  del: 127,
  degree: 176,
  byteOrderMarker: 65279,
  replacementCharacter: 65533
};
const underlineTokenize = (effects, ok, nok) => {
  const inside = (code2) => {
    if (code2 === codes.carriageReturn || code2 === codes.lineFeed || code2 === codes.carriageReturnLineFeed || code2 === codes.eof) {
      return nok(code2);
    }
    if (code2 === codes.backslash) {
      effects.consume(code2);
      return insideEscape;
    }
    if (code2 === codes.degree) {
      effects.exit("underlineContent");
      effects.enter("underlineMarker");
      effects.consume(code2);
      effects.exit("underlineMarker");
      effects.exit("underline");
      return ok;
    }
    effects.consume(code2);
    return inside;
  };
  const insideEscape = (code2) => {
    if (code2 === codes.backslash || code2 === codes.degree) {
      effects.consume(code2);
      return inside;
    }
    return inside(code2);
  };
  const begin = (code2) => code2 === codes.degree ? nok(code2) : inside(code2);
  return (code2) => {
    effects.enter("underline");
    effects.enter("underlineMarker");
    effects.consume(code2);
    effects.exit("underlineMarker");
    effects.enter("underlineContent", { contentType: "string" });
    return begin;
  };
};
const underlineConstruct = { name: "underline", tokenize: underlineTokenize };
const underline = { text: { 176: underlineConstruct } };
const underlineHtml = {
  enter: {
    underline() {
      this.tag("<u>");
    }
  },
  exit: {
    underline() {
      this.tag("</u>");
    }
  }
};
const usertagTokenize = (effects, ok, nok) => {
  const inside = (code2) => {
    if (code2 === codes.carriageReturn || code2 === codes.lineFeed || code2 === codes.carriageReturnLineFeed || code2 === codes.eof) {
      return nok(code2);
    }
    if (code2 === codes.backslash) {
      effects.consume(code2);
      return insideEscape;
    }
    if (code2 === codes.greaterThan) {
      effects.exit("usertagContent");
      effects.enter("usertagMarker");
      effects.consume(code2);
      effects.exit("usertagMarker");
      effects.exit("usertag");
      return ok;
    }
    effects.consume(code2);
    return inside;
  };
  const insideEscape = (code2) => {
    if (code2 === codes.backslash || code2 === codes.greaterThan) {
      effects.consume(code2);
      return inside;
    }
    return inside(code2);
  };
  const begin = (code2) => {
    if (code2 === codes.atSign) {
      effects.consume(code2);
      effects.exit("usertagMarker");
      effects.enter("usertagContent");
      return inside;
    }
    return nok(code2);
  };
  return (code2) => {
    effects.enter("usertag");
    effects.enter("usertagMarker");
    effects.consume(code2);
    return begin;
  };
};
const usertagConstruct = { name: "usertag", tokenize: usertagTokenize };
const usertag = { text: { 60: usertagConstruct } };
const usertagHtml = (users) => ({
  exit: {
    usertagContent(token) {
      const userId = this.sliceSerialize(token);
      this.tag(`<span class="vac-text-tag" data-user-id="${userId}">`);
      const user = users.find((user2) => user2._id === userId);
      this.raw(`@${this.encode(user ? user.username : userId)}`);
      this.tag("</span>");
    }
  }
});
var markdown = (text2, { textFormatting }) => {
  if (textFormatting) {
    let gfmDisabled = [];
    if (!textFormatting.linkify) {
      gfmDisabled = ["literalAutolink", "literalAutolinkEmail"];
    }
    if (!String.prototype.replaceAll) {
      String.prototype.replaceAll = function(search2, replacement) {
        const target = this;
        return target.split(search2).join(replacement);
      };
    }
    const markdown2 = text2 ? micromark(
      text2.replaceAll("<usertag>", "<@").replaceAll("</usertag>", ">"),
      {
        extensions: [
          {
            ...gfm(),
            disable: { null: gfmDisabled }
          },
          underline,
          usertag
        ],
        htmlExtensions: [
          gfmHtml(),
          underlineHtml,
          usertagHtml(textFormatting.users),
          {
            enter: {
              emphasis() {
                this.tag("*");
              }
            },
            exit: {
              emphasis() {
                this.tag("*");
              }
            }
          }
        ]
      }
    ) : "";
    if (textFormatting.singleLine) {
      const element2 = document.createElement("div");
      element2.innerHTML = markdown2;
      return [
        {
          types: [],
          value: element2.innerText
        }
      ];
    }
    return [
      {
        types: ["markdown"],
        value: markdown2
      }
    ];
  }
  return [
    {
      types: [],
      value: text2
    }
  ];
};
const IMAGE_TYPES = ["png", "jpg", "jpeg", "webp", "svg", "gif", "dng"];
const VIDEO_TYPES = ["mp4", "video/ogg", "webm", "quicktime", "mov"];
const AUDIO_TYPES = ["mp3", "audio/ogg", "wav", "mpeg"];
const _sfc_main$v = {
  name: "FormatMessage",
  components: { SvgIcon },
  props: {
    messageId: { type: String, default: "" },
    roomId: { type: String, default: "" },
    roomList: { type: Boolean, default: false },
    content: { type: [String, Number], required: true },
    deleted: { type: Boolean, default: false },
    users: { type: Array, default: () => [] },
    linkify: { type: Boolean, default: true },
    singleLine: { type: Boolean, default: false },
    reply: { type: Boolean, default: false },
    textFormatting: { type: Object, required: true },
    textMessages: { type: Object, default: () => {
    } },
    linkOptions: { type: Object, required: true }
  },
  emits: ["open-user-tag"],
  computed: {
    parsedMessage() {
      if (this.deleted) {
        return [{ value: this.textMessages.MESSAGE_DELETED }];
      }
      let options;
      if (!this.textFormatting.disabled) {
        options = {
          textFormatting: {
            linkify: this.linkify,
            linkOptions: this.linkOptions,
            singleLine: this.singleLine,
            reply: this.reply,
            users: this.users,
            ...this.textFormatting
          }
        };
      } else {
        options = {};
      }
      const message = markdown(this.content, options);
      message.forEach((m) => {
        m.markdown = this.checkType(m, "markdown");
        m.tag = this.checkType(m, "tag");
        m.image = this.checkImageType(m);
      });
      return message;
    }
  },
  methods: {
    checkType(message, type) {
      return message.types && message.types.indexOf(type) !== -1;
    },
    checkImageType(message) {
      let index = message.value.lastIndexOf(".");
      const slashIndex = message.value.lastIndexOf("/");
      if (slashIndex > index)
        index = -1;
      const type = message.value.substring(index + 1, message.value.length);
      const isMedia = index > 0 && IMAGE_TYPES.some((t) => type.toLowerCase().includes(t));
      if (isMedia)
        this.setImageSize(message);
      return isMedia;
    },
    setImageSize(message) {
      const image = new Image();
      image.src = message.value;
      image.addEventListener("load", onLoad);
      function onLoad(img) {
        const ratio = img.path[0].width / 150;
        message.height = Math.round(img.path[0].height / ratio) + "px";
        image.removeEventListener("load", onLoad);
      }
    },
    openTag(event, message) {
      const userId = event.target.getAttribute("data-user-id");
      if (!this.singleLine && userId) {
        const user = this.users.find((u) => String(u._id) === userId);
        this.$emit("open-user-tag", { user, message: Object.assign(message, { messageId: this.messageId }) });
      }
    }
  }
};
const _hoisted_1$s = ["onClick", "innerHTML"];
const _hoisted_2$p = { class: "vac-image-link-container" };
const _hoisted_3$k = { class: "vac-image-link-message" };
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = resolveComponent("svg-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["vac-format-message-wrapper", { "vac-text-ellipsis": $props.singleLine }])
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($options.parsedMessage, (message, i) => {
      return openBlock(), createElementBlock(Fragment, { key: i }, [
        message.markdown ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "markdown",
          onClick: ($event) => $options.openTag($event, message),
          innerHTML: message.value
        }, null, 8, _hoisted_1$s)) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["vac-format-container", { "vac-text-ellipsis": $props.singleLine }])
        }, [
          (openBlock(), createBlock(resolveDynamicComponent(message.url ? "a" : "span"), {
            class: normalizeClass({
              "vac-text-ellipsis": $props.singleLine,
              "vac-text-tag": !$props.singleLine && !$props.reply && message.tag
            }),
            href: message.href,
            target: message.href ? $props.linkOptions.target : null,
            rel: message.href ? $props.linkOptions.rel : null
          }, {
            default: withCtx(() => [
              $props.deleted ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                renderSlot(
                  _ctx.$slots,
                  $props.roomList ? "deleted-icon-room_" + $props.roomId : "deleted-icon_" + $props.messageId,
                  {},
                  () => [
                    createVNode(_component_svg_icon, {
                      name: "deleted",
                      class: normalizeClass(["vac-icon-deleted", { "vac-icon-deleted-room": $props.roomList }])
                    }, null, 8, ["class"])
                  ]
                ),
                createTextVNode(" " + toDisplayString($props.textMessages.MESSAGE_DELETED), 1)
              ], 64)) : message.url && message.image ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createElementVNode("div", _hoisted_2$p, [
                  createElementVNode("div", {
                    class: "vac-image-link",
                    style: normalizeStyle({
                      "background-image": `url('${message.value}')`,
                      height: message.height
                    })
                  }, null, 4)
                ]),
                createElementVNode("div", _hoisted_3$k, toDisplayString(message.value), 1)
              ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                createTextVNode(toDisplayString(message.value), 1)
              ], 64))
            ]),
            _: 2
          }, 1032, ["class", "href", "target", "rel"]))
        ], 2))
      ], 64);
    }), 128))
  ], 2);
}
var FormatMessage = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$u]]);
const HANDLERS_PROPERTY = "__v-click-outside";
const HAS_WINDOWS = typeof window !== "undefined";
const HAS_NAVIGATOR = typeof navigator !== "undefined";
const IS_TOUCH = HAS_WINDOWS && ("ontouchstart" in window || HAS_NAVIGATOR && navigator.msMaxTouchPoints > 0);
const EVENTS = IS_TOUCH ? ["touchstart"] : ["click"];
const processDirectiveArguments = (bindingValue) => {
  const isFunction = typeof bindingValue === "function";
  if (!isFunction && typeof bindingValue !== "object") {
    throw new Error(
      "v-click-outside: Binding value must be a function or an object"
    );
  }
  return {
    handler: isFunction ? bindingValue : bindingValue.handler,
    middleware: bindingValue.middleware || ((item) => item),
    events: bindingValue.events || EVENTS,
    isActive: !(bindingValue.isActive === false),
    detectIframe: !(bindingValue.detectIframe === false),
    capture: Boolean(bindingValue.capture)
  };
};
const execHandler = ({ event, handler, middleware }) => {
  if (middleware(event)) {
    handler(event);
  }
};
const onFauxIframeClick = ({ el, event, handler, middleware }) => {
  setTimeout(() => {
    const { activeElement } = document;
    if (activeElement && activeElement.tagName === "IFRAME" && !el.contains(activeElement)) {
      execHandler({ event, handler, middleware });
    }
  }, 0);
};
const onEvent = ({ el, event, handler, middleware }) => {
  const path2 = event.path || event.composedPath && event.composedPath();
  const isClickOutside = path2 ? path2.indexOf(el) < 0 : !el.contains(event.target);
  if (!isClickOutside) {
    return;
  }
  execHandler({ event, handler, middleware });
};
const beforeMount = (el, { value }) => {
  const {
    events,
    handler,
    middleware,
    isActive,
    detectIframe,
    capture
  } = processDirectiveArguments(value);
  if (!isActive) {
    return;
  }
  el[HANDLERS_PROPERTY] = events.map((eventName) => ({
    event: eventName,
    srcTarget: document.documentElement,
    handler: (event) => onEvent({ el, event, handler, middleware }),
    capture
  }));
  if (detectIframe) {
    const detectIframeEvent = {
      event: "blur",
      srcTarget: window,
      handler: (event) => onFauxIframeClick({ el, event, handler, middleware }),
      capture
    };
    el[HANDLERS_PROPERTY] = [...el[HANDLERS_PROPERTY], detectIframeEvent];
  }
  el[HANDLERS_PROPERTY].forEach(
    ({ event, srcTarget, handler: thisHandler }) => setTimeout(() => {
      if (!el[HANDLERS_PROPERTY]) {
        return;
      }
      srcTarget.addEventListener(event, thisHandler, capture);
    }, 0)
  );
};
const unmounted = (el) => {
  const handlers = el[HANDLERS_PROPERTY] || [];
  handlers.forEach(
    ({ event, srcTarget, handler, capture }) => srcTarget.removeEventListener(event, handler, capture)
  );
  delete el[HANDLERS_PROPERTY];
};
const updated = (el, { value, oldValue }) => {
  if (JSON.stringify(value) === JSON.stringify(oldValue)) {
    return;
  }
  unmounted(el);
  beforeMount(el, { value });
};
const directive = {
  beforeMount,
  updated,
  unmounted
};
var vClickOutside = HAS_WINDOWS ? directive : {};
var typingText = (room, currentUserId, textMessages) => {
  if (room.typingUsers && room.typingUsers.length) {
    const typingUsers = room.users.filter((user) => {
      if (user._id === currentUserId)
        return;
      if (room.typingUsers.indexOf(user._id) === -1)
        return;
      if (user.status && user.status.state === "offline")
        return;
      return true;
    });
    if (!typingUsers.length)
      return;
    if (room.users.length === 2) {
      return textMessages.IS_TYPING;
    } else {
      return typingUsers.map((user) => user.username).join(", ") + " " + textMessages.IS_TYPING;
    }
  }
};
function checkMediaType(types, file) {
  if (!file || !file.type)
    return;
  return types.some((t) => file.type.toLowerCase().includes(t));
}
function isImageFile(file) {
  return checkMediaType(IMAGE_TYPES, file);
}
function isVideoFile(file) {
  return checkMediaType(VIDEO_TYPES, file);
}
function isImageVideoFile(file) {
  return checkMediaType(IMAGE_TYPES, file) || checkMediaType(VIDEO_TYPES, file);
}
function isAudioFile(file) {
  return checkMediaType(AUDIO_TYPES, file);
}
function resizeImage(src) {
  if (!src.startsWith("https")) {
    return src;
  }
  return getImageUrlLimitWidth(src, Math.min(2560, Math.round(window.innerWidth * window.devicePixelRatio)));
}
const _sfc_main$u = {
  name: "RoomsContent",
  components: {
    SvgIcon,
    FormatMessage
  },
  directives: {
    clickOutside: vClickOutside
  },
  props: {
    currentUserId: { type: [String, Number], required: true },
    room: { type: Object, required: true },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true },
    textMessages: { type: Object, required: true },
    roomActions: { type: Array, required: true },
    isLast: { type: Boolean, required: true }
  },
  emits: ["room-action-handler"],
  data() {
    return {
      roomMenuOpened: null
    };
  },
  computed: {
    getLastMessage() {
      const isTyping = this.typingUsers;
      if (isTyping)
        return isTyping;
      const content2 = this.room.lastMessage.content;
      if (this.room.users.length <= 2) {
        return content2;
      }
      const user = this.room.users.find(
        (user2) => user2._id === this.room.lastMessage.senderId
      );
      if (this.room.lastMessage.username) {
        return `${this.room.lastMessage.username} - ${content2}`;
      } else if (!user || user._id === this.currentUserId) {
        return content2;
      }
      return `${user.username} - ${content2}`;
    },
    userStatus() {
      if (!this.room.users || this.room.users.length !== 2)
        return;
      const user = this.room.users.find((u) => u._id !== this.currentUserId);
      if (user && user.status)
        return user.status.state;
      return null;
    },
    typingUsers() {
      return typingText(this.room, this.currentUserId, this.textMessages);
    },
    isMessageCheckmarkVisible() {
      return !this.typingUsers && this.room.lastMessage && !this.room.lastMessage.deleted && this.room.lastMessage.senderId === this.currentUserId && (this.room.lastMessage.saved || this.room.lastMessage.distributed || this.room.lastMessage.seen);
    },
    formattedDuration() {
      var _a, _b;
      const file = (_b = (_a = this.room.lastMessage) == null ? void 0 : _a.files) == null ? void 0 : _b[0];
      if (file) {
        if (!file.duration) {
          return `${file.name}.${file.extension}`;
        }
        let s = Math.floor(file.duration);
        return (s - (s %= 60)) / 60 + (s > 9 ? ":" : ":0") + s;
      }
      return "";
    },
    isAudio() {
      return this.room.lastMessage.files ? isAudioFile(this.room.lastMessage.files[0]) : false;
    },
    roomActionsList() {
      if (this.room.ignoreAction) {
        const arr = this.roomActions.filter((roomAction) => !this.room.ignoreAction.includes(roomAction.name));
        return arr;
      }
      return this.roomActions;
    }
  },
  methods: {
    roomActionHandler(action) {
      this.closeRoomMenu();
      this.$emit("room-action-handler", { action, roomId: this.room.roomId });
    },
    closeRoomMenu() {
      this.roomMenuOpened = null;
    }
  }
};
const _hoisted_1$r = { class: "vac-room-container" };
const _hoisted_2$o = { class: "vac-title-container" };
const _hoisted_3$j = { class: "vac-room-name vac-text-ellipsis" };
const _hoisted_4$g = {
  key: 0,
  style: `display: inline-block;margin-right: 5px;padding: 2px 3px;background: #f00;color: #fff;line-height: 16px;border-radius: 2px;`
};
const _hoisted_5$f = {
  key: 1,
  class: "vac-text-date"
};
const _hoisted_6$9 = { key: 0 };
const _hoisted_7$9 = {
  key: 1,
  class: "vac-text-ellipsis"
};
const _hoisted_8$8 = {
  key: 3,
  class: "vac-text-ellipsis"
};
const _hoisted_9$6 = { class: "vac-room-options-container" };
const _hoisted_10$5 = {
  key: 0,
  class: "vac-custom-icon"
};
const _hoisted_11$4 = { key: 0 };
const _hoisted_12$4 = {
  key: 0,
  class: "vac-menu-options"
};
const _hoisted_13$4 = { class: "vac-menu-list" };
const _hoisted_14$2 = ["onClick"];
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_format_message = resolveComponent("format-message");
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createElementBlock("div", _hoisted_1$r, [
    renderSlot(_ctx.$slots, "room-list-item_" + $props.room.roomId, {}, () => [
      renderSlot(_ctx.$slots, "room-list-avatar_" + $props.room.roomId, {}, () => [
        $props.room.avatar ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "vac-avatar",
          style: normalizeStyle({ "background-image": `url('${$props.room.avatar}')` })
        }, null, 4)) : createCommentVNode("", true)
      ]),
      createElementVNode("div", {
        class: "vac-name-container vac-text-ellipsis",
        style: normalizeStyle($props.isLast ? "border-bottom: none" : "")
      }, [
        createElementVNode("div", _hoisted_2$o, [
          $options.userStatus ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["vac-state-circle", { "vac-state-online": $options.userStatus === "online" }])
          }, null, 2)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "room-list-info_" + $props.room.roomId, {}, () => [
            createElementVNode("div", _hoisted_3$j, [
              $props.room.tipTxt ? (openBlock(), createElementBlock("span", _hoisted_4$g, toDisplayString($props.room.tipTxt), 1)) : createCommentVNode("", true),
              createElementVNode("span", null, toDisplayString($props.room.roomName), 1)
            ])
          ]),
          $props.room.lastMessage ? (openBlock(), createElementBlock("div", _hoisted_5$f, toDisplayString($props.room.lastMessage.timestamp), 1)) : createCommentVNode("", true)
        ]),
        createElementVNode("div", {
          class: normalizeClass(["vac-text-last", {
            "vac-message-new": $props.room.lastMessage && $props.room.lastMessage.new && !$options.typingUsers
          }])
        }, [
          $options.isMessageCheckmarkVisible ? (openBlock(), createElementBlock("span", _hoisted_6$9, [
            renderSlot(_ctx.$slots, "checkmark-icon_" + $props.room.roomId, {}, () => [
              createVNode(_component_svg_icon, {
                name: $props.room.lastMessage.distributed ? "double-checkmark" : "checkmark",
                param: $props.room.lastMessage.seen ? "seen" : "",
                class: "vac-icon-check"
              }, null, 8, ["name", "param"])
            ])
          ])) : createCommentVNode("", true),
          $props.room.lastMessage && !$props.room.lastMessage.deleted && $options.isAudio ? (openBlock(), createElementBlock("div", _hoisted_7$9, [
            renderSlot(_ctx.$slots, "microphone-icon_" + $props.room.roomId, {}, () => [
              createVNode(_component_svg_icon, {
                name: "microphone",
                class: "vac-icon-microphone"
              })
            ]),
            createTextVNode(" " + toDisplayString($options.formattedDuration), 1)
          ])) : $props.room.lastMessage ? (openBlock(), createBlock(_component_format_message, {
            key: 2,
            "message-id": $props.room.lastMessage._id,
            "room-id": $props.room.roomId,
            "room-list": true,
            content: $options.getLastMessage,
            deleted: !!$props.room.lastMessage.deleted && !$options.typingUsers,
            users: $props.room.users,
            "text-messages": $props.textMessages,
            linkify: false,
            "text-formatting": $props.textFormatting,
            "link-options": $props.linkOptions,
            "single-line": true
          }, createSlots({ _: 2 }, [
            renderList(_ctx.$slots, (idx, name) => {
              return {
                name,
                fn: withCtx((data) => [
                  renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                ])
              };
            })
          ]), 1032, ["message-id", "room-id", "content", "deleted", "users", "text-messages", "text-formatting", "link-options"])) : createCommentVNode("", true),
          !$props.room.lastMessage && $options.typingUsers ? (openBlock(), createElementBlock("div", _hoisted_8$8, toDisplayString($options.typingUsers), 1)) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_9$6, [
            renderSlot(_ctx.$slots, "room-custom-icon_" + $props.room.roomId, {}, () => [
              $props.room.flag ? (openBlock(), createElementBlock("div", _hoisted_10$5, [
                createVNode(_component_svg_icon, { name: "flag" })
              ])) : createCommentVNode("", true)
            ]),
            $props.room.unreadCount ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["vac-badge-counter vac-room-badge", { "vac-room-dot": $props.room.isRedDot }])
            }, [
              !$props.room.isRedDot ? (openBlock(), createElementBlock("span", _hoisted_11$4, toDisplayString($props.room.unreadCount), 1)) : createCommentVNode("", true)
            ], 2)) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "room-list-options_" + $props.room.roomId, {}, () => [
              $options.roomActionsList.length ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "vac-svg-button vac-list-room-options",
                onClick: _cache[0] || (_cache[0] = withModifiers(($event) => $data.roomMenuOpened = $props.room.roomId, ["stop"]))
              }, [
                renderSlot(_ctx.$slots, "room-list-options-icon_" + $props.room.roomId, {}, () => [
                  createVNode(_component_svg_icon, {
                    name: "dropdown",
                    param: "room"
                  })
                ])
              ])) : createCommentVNode("", true),
              $options.roomActionsList.length ? (openBlock(), createBlock(Transition, {
                key: 1,
                name: "vac-slide-left"
              }, {
                default: withCtx(() => [
                  $data.roomMenuOpened === $props.room.roomId ? withDirectives((openBlock(), createElementBlock("div", _hoisted_12$4, [
                    createElementVNode("div", _hoisted_13$4, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList($options.roomActionsList, (action) => {
                        return openBlock(), createElementBlock("div", {
                          key: action.name
                        }, [
                          createElementVNode("div", {
                            class: "vac-menu-item",
                            onClick: withModifiers(($event) => $options.roomActionHandler(action), ["stop"])
                          }, toDisplayString(action.title), 9, _hoisted_14$2)
                        ]);
                      }), 128))
                    ])
                  ])), [
                    [_directive_click_outside, $options.closeRoomMenu]
                  ]) : createCommentVNode("", true)
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ])
          ])
        ], 2)
      ], 4)
    ])
  ]);
}
var RoomContent = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$t]]);
var filteredItems = (items, prop, val, startsWith = false) => {
  if (!val || val === "")
    return items;
  return items.filter((v) => {
    if (startsWith)
      return formatString(v[prop]).startsWith(formatString(val));
    return formatString(v[prop]).includes(formatString(val));
  });
};
function formatString(string2) {
  return string2.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
const _sfc_main$t = {
  name: "RoomsList",
  components: {
    Loader,
    RoomsSearch,
    RoomContent
  },
  props: {
    currentUserId: { type: [String, Number], required: true },
    textMessages: { type: Object, required: true },
    showRoomsList: { type: Boolean, required: true },
    showSearch: { type: Boolean, required: true },
    showAddRoom: { type: Boolean, required: true },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true },
    isMobile: { type: Boolean, required: true },
    rooms: { type: Array, required: true },
    loadingRooms: { type: Boolean, required: true },
    roomsLoaded: { type: Boolean, required: true },
    room: { type: Object, required: true },
    customSearchRoomEnabled: { type: [Boolean, String], default: false },
    roomActions: { type: Array, required: true },
    scrollDistance: { type: Number, required: true },
    networkException: { type: [Boolean, String], required: true },
    roomHref: { type: Boolean, required: false }
  },
  emits: [
    "add-room",
    "search-room",
    "room-action-handler",
    "loading-more-rooms",
    "fetch-room",
    "fetch-more-rooms",
    "trigger-custom-room-select",
    "room-select"
  ],
  data() {
    return {
      filteredRooms: this.rooms || [],
      observer: null,
      showLoader: true,
      loadingMoreRooms: false,
      selectedRoomId: ""
    };
  },
  watch: {
    rooms: {
      deep: true,
      handler(newVal, oldVal) {
        this.filteredRooms = newVal;
        if (newVal.length !== oldVal.length || this.roomsLoaded) {
          this.loadingMoreRooms = false;
        }
      }
    },
    loadingRooms(val) {
      if (!val) {
        setTimeout(() => this.initIntersectionObserver());
      }
    },
    loadingMoreRooms(val) {
      this.$emit("loading-more-rooms", val);
    },
    roomsLoaded: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadingMoreRooms = false;
          if (!this.loadingRooms) {
            this.showLoader = false;
          }
        }
      }
    },
    room: {
      immediate: true,
      handler(val) {
        if (val && !this.isMobile)
          this.selectedRoomId = val.roomId;
      }
    },
    networkException: {
      immediate: true,
      handler() {
      }
    }
  },
  methods: {
    initIntersectionObserver() {
      if (this.observer) {
        this.showLoader = true;
        this.observer.disconnect();
      }
      const loader = this.$el.querySelector("#infinite-loader-rooms");
      if (loader) {
        const options = {
          root: this.$el.querySelector("#rooms-list"),
          rootMargin: `${this.scrollDistance}px`,
          threshold: 0
        };
        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.loadMoreRooms();
          }
        }, options);
        this.observer.observe(loader);
      }
    },
    searchRoom(ev) {
      if (this.customSearchRoomEnabled) {
        this.$emit("search-room", ev.target.value);
      } else {
        this.filteredRooms = filteredItems(
          this.rooms,
          "roomName",
          ev.target.value
        );
      }
    },
    openRoom(room) {
      if (this.roomHref)
        return;
      if (room.isCustom) {
        console.log("trigger-custom-room-select");
        this.$emit("trigger-custom-room-select", { room });
      } else {
        if (room.roomId === this.room.roomId && !this.isMobile)
          return;
        if (!this.isMobile)
          this.selectedRoomId = room.roomId;
        this.$emit("fetch-room", { room });
      }
    },
    loadMoreRooms() {
      if (this.loadingMoreRooms)
        return;
      if (this.roomsLoaded) {
        this.loadingMoreRooms = false;
        this.showLoader = false;
        return;
      }
      this.$emit("fetch-more-rooms");
      this.loadingMoreRooms = true;
    },
    roomSelect(room) {
      this.$emit("room-select", { room });
    }
  }
};
const _hoisted_1$q = {
  key: 0,
  class: "vac-rooms-empty"
};
const _hoisted_2$n = {
  key: 1,
  id: "rooms-list",
  class: "vac-room-list"
};
const _hoisted_3$i = {
  key: 0,
  class: "network-exception"
};
const _hoisted_4$f = /* @__PURE__ */ createElementVNode("div", { class: "error-info" }, [
  /* @__PURE__ */ createElementVNode("span", { class: "warn-icon" }, "!"),
  /* @__PURE__ */ createElementVNode("span", null, "The network connection is disconnected")
], -1);
const _hoisted_5$e = [
  _hoisted_4$f
];
const _hoisted_6$8 = ["id", "onClick"];
const _hoisted_7$8 = ["onClick"];
const _hoisted_8$7 = {
  key: 0,
  id: "infinite-loader-rooms"
};
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rooms_search = resolveComponent("rooms-search");
  const _component_loader = resolveComponent("loader");
  const _component_room_content = resolveComponent("room-content");
  return withDirectives((openBlock(), createElementBlock("div", {
    class: normalizeClass(["vac-rooms-container", {
      "vac-rooms-container-full": $props.isMobile,
      "vac-app-border-r": !$props.isMobile
    }])
  }, [
    renderSlot(_ctx.$slots, "rooms-header"),
    renderSlot(_ctx.$slots, "rooms-list-search", {}, () => [
      createVNode(_component_rooms_search, {
        rooms: $props.rooms,
        "loading-rooms": $props.loadingRooms,
        "text-messages": $props.textMessages,
        "show-search": $props.showSearch,
        "show-add-room": $props.showAddRoom,
        onSearchRoom: $options.searchRoom,
        onAddRoom: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("add-room"))
      }, createSlots({ _: 2 }, [
        renderList(_ctx.$slots, (idx, name) => {
          return {
            name,
            fn: withCtx((data) => [
              renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
            ])
          };
        })
      ]), 1032, ["rooms", "loading-rooms", "text-messages", "show-search", "show-add-room", "onSearchRoom"])
    ]),
    createVNode(_component_loader, {
      show: $props.loadingRooms,
      type: "rooms"
    }, createSlots({ _: 2 }, [
      renderList(_ctx.$slots, (idx, name) => {
        return {
          name,
          fn: withCtx((data) => [
            renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
          ])
        };
      })
    ]), 1032, ["show"]),
    !$props.loadingRooms && !$props.rooms.length ? (openBlock(), createElementBlock("div", _hoisted_1$q, [
      renderSlot(_ctx.$slots, "rooms-empty", {}, () => [
        createTextVNode(toDisplayString($props.textMessages.ROOMS_EMPTY), 1)
      ])
    ])) : createCommentVNode("", true),
    !$props.loadingRooms ? (openBlock(), createElementBlock("div", _hoisted_2$n, [
      JSON.parse($props.networkException) ? renderSlot(_ctx.$slots, "network-exception", { key: 0 }, () => [
        JSON.parse($props.networkException) ? (openBlock(), createElementBlock("div", _hoisted_3$i, _hoisted_5$e)) : createCommentVNode("", true)
      ]) : createCommentVNode("", true),
      (openBlock(true), createElementBlock(Fragment, null, renderList($data.filteredRooms, (fRoom, $index) => {
        return openBlock(), createElementBlock("div", {
          id: fRoom.roomId,
          key: fRoom.roomId,
          class: normalizeClass(["vac-room-item", { "vac-room-selected": $data.selectedRoomId === fRoom.roomId }]),
          onClick: ($event) => $options.roomSelect(fRoom)
        }, [
          createElementVNode("div", {
            style: { "width": "100%" },
            onClick: ($event) => $options.openRoom(fRoom)
          }, [
            createVNode(_component_room_content, {
              "current-user-id": $props.currentUserId,
              room: fRoom,
              "text-formatting": $props.textFormatting,
              "link-options": $props.linkOptions,
              "text-messages": $props.textMessages,
              "room-actions": $props.roomActions,
              "is-last": $index === $data.filteredRooms.length - 1,
              onRoomActionHandler: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("room-action-handler", $event))
            }, createSlots({ _: 2 }, [
              renderList(_ctx.$slots, (idx, name) => {
                return {
                  name,
                  fn: withCtx((data) => [
                    renderSlot(_ctx.$slots, name, mergeProps({ ref_for: true }, data))
                  ])
                };
              })
            ]), 1032, ["current-user-id", "room", "text-formatting", "link-options", "text-messages", "room-actions", "is-last"])
          ], 8, _hoisted_7$8)
        ], 10, _hoisted_6$8);
      }), 128)),
      createVNode(Transition, { name: "vac-fade-message" }, {
        default: withCtx(() => [
          $props.rooms.length && !$props.loadingRooms ? (openBlock(), createElementBlock("div", _hoisted_8$7, [
            createVNode(_component_loader, {
              show: $data.showLoader,
              infinite: true,
              type: "infinite-rooms"
            }, createSlots({ _: 2 }, [
              renderList(_ctx.$slots, (idx, name) => {
                return {
                  name,
                  fn: withCtx((data) => [
                    renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                  ])
                };
              })
            ]), 1032, ["show"])
          ])) : createCommentVNode("", true)
        ]),
        _: 3
      })
    ])) : createCommentVNode("", true)
  ], 2)), [
    [vShow, $props.showRoomsList]
  ]);
}
var RoomsList = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$s]]);
const _sfc_main$s = {
  name: "RoomHeader",
  components: {
    SvgIcon
  },
  directives: {
    clickOutside: vClickOutside
  },
  props: {
    currentUserId: { type: [String, Number], required: true },
    textMessages: { type: Object, required: true },
    singleRoom: { type: Boolean, required: true },
    showRoomsList: { type: Boolean, required: true },
    isMobile: { type: Boolean, required: true },
    roomInfoEnabled: { type: Boolean, required: true },
    menuActions: { type: Array, required: true },
    room: { type: Object, required: true },
    messageSelectionEnabled: { type: Boolean, required: true },
    messageSelectionActions: { type: Array, required: true },
    selectedMessagesTotal: { type: Number, required: true }
  },
  emits: [
    "toggle-rooms-list",
    "room-info",
    "menu-action-handler",
    "cancel-message-selection",
    "message-selection-action-handler"
  ],
  data() {
    return {
      menuOpened: false,
      messageSelectionAnimationEnded: true
    };
  },
  computed: {
    typingUsers() {
      return typingText(this.room, this.currentUserId, this.textMessages);
    },
    userStatus() {
      if (!this.room.users || this.room.users.length !== 2)
        return;
      const user = this.room.users.find((u) => u._id !== this.currentUserId);
      if (!(user == null ? void 0 : user.status))
        return;
      let text2 = "";
      if (user.status.state === "online") {
        text2 = this.textMessages.IS_ONLINE;
      } else if (user.status.lastChanged) {
        text2 = this.textMessages.LAST_SEEN + user.status.lastChanged;
      }
      return text2;
    }
  },
  watch: {
    messageSelectionEnabled(val) {
      if (val) {
        this.messageSelectionAnimationEnded = false;
      } else {
        setTimeout(() => {
          this.messageSelectionAnimationEnded = true;
        }, 300);
      }
    }
  },
  methods: {
    menuActionHandler(action) {
      this.closeMenu();
      this.$emit("menu-action-handler", action);
    },
    closeMenu() {
      this.menuOpened = false;
    },
    messageSelectionActionHandler(action) {
      this.$emit("message-selection-action-handler", action);
    }
  }
};
const _hoisted_1$p = { class: "vac-room-header vac-app-border-b" };
const _hoisted_2$m = { class: "vac-room-wrapper" };
const _hoisted_3$h = {
  key: 0,
  class: "vac-room-selection"
};
const _hoisted_4$e = ["id"];
const _hoisted_5$d = ["onClick"];
const _hoisted_6$7 = { class: "vac-selection-button-count" };
const _hoisted_7$7 = { class: "vac-text-ellipsis" };
const _hoisted_8$6 = { class: "vac-room-name vac-text-ellipsis" };
const _hoisted_9$5 = {
  key: 0,
  class: "vac-room-info vac-text-ellipsis"
};
const _hoisted_10$4 = {
  key: 1,
  class: "vac-room-info vac-text-ellipsis"
};
const _hoisted_11$3 = {
  key: 0,
  class: "vac-menu-options"
};
const _hoisted_12$3 = { class: "vac-menu-list" };
const _hoisted_13$3 = ["onClick"];
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = resolveComponent("svg-icon");
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createElementBlock("div", _hoisted_1$p, [
    renderSlot(_ctx.$slots, "room-header", {}, () => [
      createElementVNode("div", _hoisted_2$m, [
        createVNode(Transition, { name: "vac-slide-up" }, {
          default: withCtx(() => [
            $props.messageSelectionEnabled ? (openBlock(), createElementBlock("div", _hoisted_3$h, [
              (openBlock(true), createElementBlock(Fragment, null, renderList($props.messageSelectionActions, (action) => {
                return openBlock(), createElementBlock("div", {
                  id: action.name,
                  key: action.name
                }, [
                  createElementVNode("div", {
                    class: "vac-selection-button",
                    onClick: ($event) => $options.messageSelectionActionHandler(action)
                  }, [
                    createTextVNode(toDisplayString(action.title) + " ", 1),
                    createElementVNode("span", _hoisted_6$7, toDisplayString($props.selectedMessagesTotal), 1)
                  ], 8, _hoisted_5$d)
                ], 8, _hoisted_4$e);
              }), 128)),
              createElementVNode("div", {
                class: "vac-selection-cancel vac-item-clickable",
                onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("cancel-message-selection"))
              }, toDisplayString($props.textMessages.CANCEL_SELECT_MESSAGE), 1)
            ])) : createCommentVNode("", true)
          ]),
          _: 1
        }),
        !$props.messageSelectionEnabled && $data.messageSelectionAnimationEnded ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          !$props.singleRoom ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["vac-svg-button vac-toggle-button", {
              "vac-rotate-icon-init": !$props.isMobile,
              "vac-rotate-icon": !$props.showRoomsList && !$props.isMobile
            }]),
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("toggle-rooms-list"))
          }, [
            renderSlot(_ctx.$slots, "toggle-icon", {}, () => [
              createVNode(_component_svg_icon, { name: "toggle" })
            ])
          ], 2)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(["vac-info-wrapper", { "vac-item-clickable": $props.roomInfoEnabled }]),
            onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("room-info"))
          }, [
            renderSlot(_ctx.$slots, "room-header-avatar", {}, () => [
              $props.room.avatar ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "vac-avatar",
                style: normalizeStyle({ "background-image": `url('${$props.room.avatar}')` })
              }, null, 4)) : createCommentVNode("", true)
            ]),
            renderSlot(_ctx.$slots, "room-header-info", {}, () => [
              createElementVNode("div", _hoisted_7$7, [
                createElementVNode("div", _hoisted_8$6, toDisplayString($props.room.roomName), 1),
                $options.typingUsers ? (openBlock(), createElementBlock("div", _hoisted_9$5, toDisplayString($options.typingUsers), 1)) : (openBlock(), createElementBlock("div", _hoisted_10$4, toDisplayString($options.userStatus), 1))
              ])
            ])
          ], 2),
          $props.room.roomId ? renderSlot(_ctx.$slots, "room-options", { key: 1 }, () => [
            $props.menuActions.length ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "vac-svg-button vac-room-options",
              onClick: _cache[3] || (_cache[3] = ($event) => $data.menuOpened = !$data.menuOpened)
            }, [
              renderSlot(_ctx.$slots, "menu-icon", {}, () => [
                createVNode(_component_svg_icon, { name: "menu" })
              ])
            ])) : createCommentVNode("", true),
            $props.menuActions.length ? (openBlock(), createBlock(Transition, {
              key: 1,
              name: "vac-slide-left"
            }, {
              default: withCtx(() => [
                $data.menuOpened ? withDirectives((openBlock(), createElementBlock("div", _hoisted_11$3, [
                  createElementVNode("div", _hoisted_12$3, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList($props.menuActions, (action) => {
                      return openBlock(), createElementBlock("div", {
                        key: action.name
                      }, [
                        createElementVNode("div", {
                          class: "vac-menu-item",
                          onClick: ($event) => $options.menuActionHandler(action)
                        }, toDisplayString(action.title), 9, _hoisted_13$3)
                      ]);
                    }), 128))
                  ])
                ])), [
                  [_directive_click_outside, $options.closeMenu]
                ]) : createCommentVNode("", true)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]) : createCommentVNode("", true)
        ], 64)) : createCommentVNode("", true)
      ])
    ])
  ]);
}
var RoomHeader = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$r]]);
var DEFAULT_ICON_CONFIGS = {
  size: "1em",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rtl: false,
  theme: "outline",
  colors: {
    outline: {
      fill: "#333",
      background: "transparent"
    },
    filled: {
      fill: "#333",
      background: "#FFF"
    },
    twoTone: {
      fill: "#333",
      twoTone: "#2F88FF"
    },
    multiColor: {
      outStrokeColor: "#333",
      outFillColor: "#2F88FF",
      innerStrokeColor: "#FFF",
      innerFillColor: "#43CCF8"
    }
  },
  prefix: "i"
};
function guid() {
  return "icon-" + ((1 + Math.random()) * 4294967296 | 0).toString(16).substring(1);
}
function IconConverter(id, icon, config) {
  var fill = typeof icon.fill === "string" ? [icon.fill] : icon.fill || [];
  var colors = [];
  var theme = icon.theme || config.theme;
  switch (theme) {
    case "outline":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push("none");
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push("none");
      break;
    case "filled":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push("#FFF");
      colors.push("#FFF");
      break;
    case "two-tone":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[1] === "string" ? fill[1] : config.colors.twoTone.twoTone);
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[1] === "string" ? fill[1] : config.colors.twoTone.twoTone);
      break;
    case "multi-color":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[1] === "string" ? fill[1] : config.colors.multiColor.outFillColor);
      colors.push(typeof fill[2] === "string" ? fill[2] : config.colors.multiColor.innerStrokeColor);
      colors.push(typeof fill[3] === "string" ? fill[3] : config.colors.multiColor.innerFillColor);
      break;
  }
  return {
    size: icon.size || config.size,
    strokeWidth: icon.strokeWidth || config.strokeWidth,
    strokeLinecap: icon.strokeLinecap || config.strokeLinecap,
    strokeLinejoin: icon.strokeLinejoin || config.strokeLinejoin,
    colors,
    id
  };
}
var IconContext = Symbol("icon-context");
function IconWrapper(name, rtl, render) {
  var options = {
    name: "icon-" + name,
    props: ["size", "strokeWidth", "strokeLinecap", "strokeLinejoin", "theme", "fill", "spin"],
    setup: function setup(props) {
      var id = guid();
      var ICON_CONFIGS = inject(IconContext, DEFAULT_ICON_CONFIGS);
      return function() {
        var size = props.size, strokeWidth = props.strokeWidth, strokeLinecap = props.strokeLinecap, strokeLinejoin = props.strokeLinejoin, theme = props.theme, fill = props.fill, spin = props.spin;
        var svgProps = IconConverter(id, {
          size,
          strokeWidth,
          strokeLinecap,
          strokeLinejoin,
          theme,
          fill
        }, ICON_CONFIGS);
        var cls = [ICON_CONFIGS.prefix + "-icon"];
        cls.push(ICON_CONFIGS.prefix + "-icon-" + name);
        if (rtl && ICON_CONFIGS.rtl) {
          cls.push(ICON_CONFIGS.prefix + "-icon-rtl");
        }
        if (spin) {
          cls.push(ICON_CONFIGS.prefix + "-icon-spin");
        }
        return createVNode("span", {
          "class": cls.join(" ")
        }, [render(svgProps)]);
      };
    }
  };
  return options;
}
var AddOne = IconWrapper("add-one", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M24 16V32",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M16 24L32 24",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
var EmotionHappy = IconWrapper("emotion-happy", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M31 18V19",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M17 18V19",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M31 31C31 31 29 35 24 35C19 35 17 31 17 31",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
var Keyboard = IconWrapper("keyboard", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M15 19C16.3807 19 17.5 17.8807 17.5 16.5C17.5 15.1193 16.3807 14 15 14C13.6193 14 12.5 15.1193 12.5 16.5C12.5 17.8807 13.6193 19 15 19Z",
    "fill": props.colors[2]
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M15 27C16.3807 27 17.5 25.8807 17.5 24.5C17.5 23.1193 16.3807 22 15 22C13.6193 22 12.5 23.1193 12.5 24.5C12.5 25.8807 13.6193 27 15 27Z",
    "fill": props.colors[2]
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M24 19C25.3807 19 26.5 17.8807 26.5 16.5C26.5 15.1193 25.3807 14 24 14C22.6193 14 21.5 15.1193 21.5 16.5C21.5 17.8807 22.6193 19 24 19Z",
    "fill": props.colors[2]
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M24 27C25.3807 27 26.5 25.8807 26.5 24.5C26.5 23.1193 25.3807 22 24 22C22.6193 22 21.5 23.1193 21.5 24.5C21.5 25.8807 22.6193 27 24 27Z",
    "fill": props.colors[2]
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M33 19C34.3807 19 35.5 17.8807 35.5 16.5C35.5 15.1193 34.3807 14 33 14C31.6193 14 30.5 15.1193 30.5 16.5C30.5 17.8807 31.6193 19 33 19Z",
    "fill": props.colors[2]
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M33 27C34.3807 27 35.5 25.8807 35.5 24.5C35.5 23.1193 34.3807 22 33 22C31.6193 22 30.5 23.1193 30.5 24.5C30.5 25.8807 31.6193 27 33 27Z",
    "fill": props.colors[2]
  }, null), createVNode("path", {
    "d": "M17 33H31",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
var Pic = IconWrapper("pic", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M5 10C5 8.89543 5.89543 8 7 8L41 8C42.1046 8 43 8.89543 43 10V38C43 39.1046 42.1046 40 41 40H7C5.89543 40 5 39.1046 5 38V10Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M14.5 18C15.3284 18 16 17.3284 16 16.5C16 15.6716 15.3284 15 14.5 15C13.6716 15 13 15.6716 13 16.5C13 17.3284 13.6716 18 14.5 18Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M15 24L20 28L26 21L43 34V38C43 39.1046 42.1046 40 41 40H7C5.89543 40 5 39.1046 5 38V34L15 24Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
var ShareTwo = IconWrapper("share-two", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M26 4L44 22L26 39V28C12 28 6 43 6 43C6 26 11 15 26 15V4Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
var Translate = IconWrapper("translate", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M28.2857 37H39.7143M42 42L39.7143 37L42 42ZM26 42L28.2857 37L26 42ZM28.2857 37L34 24L39.7143 37H28.2857Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M16 6L17 9",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M6 11H28",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M10 16C10 16 11.7895 22.2609 16.2632 25.7391C20.7368 29.2174 28 32 28 32",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M24 11C24 11 22.2105 19.2174 17.7368 23.7826C13.2632 28.3478 6 32 6 32",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const getOperatingSystem = function() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }
  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/windows phone/i.test(userAgent)) {
    return "windows phone";
  }
  if (/windows/i.test(userAgent) && !/windows phone/i.test(userAgent)) {
    return "windows";
  }
  if (/macintosh|mac os x/i.test(userAgent)) {
    return "macos";
  }
  if (/linux/i.test(userAgent) && !/android/i.test(userAgent)) {
    return "linux";
  }
  if (/cros/i.test(userAgent)) {
    return "chrome os";
  }
  return "other";
};
const getBrowser = function() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/chrome|crios|crmo/.test(userAgent) && !/edge|edg|opr|opera|safari/.test(userAgent)) {
    return "chrome";
  }
  if (/firefox|fxios/.test(userAgent)) {
    return "firefox";
  }
  if (/safari/.test(userAgent) && !/chrome|crios|crmo|opr|opera|edg|edge/.test(userAgent)) {
    return "safari";
  }
  if (/edg|edge/.test(userAgent)) {
    return "edge";
  }
  if (/opr|opera/.test(userAgent)) {
    return "opera";
  }
  if (/msie|trident/.test(userAgent)) {
    return "internet explorer";
  }
  return "other";
};
const JudgeIsMobileDevice = function() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const deviceSystem = getOperatingSystem();
const isIOS = deviceSystem === "ios";
getBrowser();
const isMobileDevice = JudgeIsMobileDevice();
const MIME_TYPE_DNG = "image/x-adobe-dng";
const getFileDimensions = async (file) => {
  return new Promise((resolve, reject) => {
    const fileType = file.type.split("/")[0];
    if (fileType === "image") {
      const img = new Image();
      img.onload = function() {
        resolve({ width: img.width, height: img.height, type: "image" });
      };
      img.onerror = function() {
        if (file.type === MIME_TYPE_DNG) {
          resolve({ width: null, height: null, type: "file" });
        } else {
          reject(new Error("Failed to load image"));
        }
      };
      img.src = URL.createObjectURL(file);
    } else if (fileType === "video") {
      const video = document.createElement("video");
      video.onloadedmetadata = function() {
        resolve({ width: video.videoWidth, height: video.videoHeight, type: "video" });
      };
      video.onerror = function() {
        reject(new Error("Failed to load video"));
      };
      video.src = URL.createObjectURL(file);
    } else {
      resolve({ width: null, height: null, type: "file" });
    }
  });
};
const _sfc_main$r = {
  name: "EmojiPickerContainer",
  components: {
    SvgIcon
  },
  props: {
    emojiOpened: { type: Boolean, default: false },
    emojiReaction: { type: Boolean, default: false },
    messageId: { type: String, default: "" },
    emojiDataSource: { type: String, default: void 0 },
    pcMode: { type: Boolean, default: false }
  },
  emits: ["add-emoji", "open-emoji"],
  data() {
    return {
      emojiPickerHeight: 320,
      pickerStyle: {}
    };
  },
  watch: {
    emojiOpened(val) {
      if (val) {
        setTimeout(() => {
          this.addCustomStyling();
          this.$refs.emojiPicker.shadowRoot.addEventListener(
            "emoji-click",
            ({ detail }) => {
              this.$emit("add-emoji", {
                unicode: detail.unicode
              });
            }
          );
        }, 0);
      }
    }
  },
  methods: {
    addCustomStyling() {
      const picker = `.picker {
				border: none;
			}`;
      const nav = `.nav {
				overflow-x: auto;
			}`;
      const searchBox = `.search-wrapper {
				padding-right: 2px;
				padding-left: 2px;
			}`;
      const search2 = `input.search {
				height: 32px;
				font-size: 14px;
				border-radius: 10rem;
				border: var(--chat-border-style);
				padding: 5px 10px;
				outline: none;
				background: var(--chat-bg-color-input);
				color: var(--chat-color);
			}`;
      const style = document.createElement("style");
      style.textContent = picker + nav + searchBox + search2;
      this.$refs.emojiPicker.shadowRoot.appendChild(style);
    },
    openEmoji(ev) {
      this.$emit("open-emoji", !this.emojiOpened);
      this.setEmojiPickerPosition(
        ev.clientY,
        ev.view.innerWidth,
        ev.view.innerHeight
      );
    },
    setEmojiPickerPosition(clientY, innerWidth, innerHeight) {
      if (clientY < this.emojiPickerHeight + 30) {
        this.pickerStyle = {
          top: "32px"
        };
      } else {
        this.pickerStyle = {
          bottom: "32px"
        };
      }
    }
  }
};
const _hoisted_1$o = { class: "vac-emoji-wrapper" };
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_emoji_picker = resolveComponent("emoji-picker");
  return openBlock(), createElementBlock("div", _hoisted_1$o, [
    createElementVNode("div", {
      class: normalizeClass(["vac-svg-button", { "vac-emoji-reaction": $props.emojiReaction }]),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.openEmoji && $options.openEmoji(...args))
    }, [
      renderSlot(
        _ctx.$slots,
        $props.messageId ? "emoji-picker-reaction-icon_" + $props.messageId : "emoji-picker-icon",
        {},
        () => [
          createVNode(_component_svg_icon, {
            name: "emoji",
            param: $props.emojiReaction ? "reaction" : ""
          }, null, 8, ["param"])
        ]
      )
    ], 2),
    $props.emojiOpened ? (openBlock(), createBlock(Transition, {
      key: 0,
      name: "vac-slide-up",
      appear: ""
    }, {
      default: withCtx(() => [
        createElementVNode("div", {
          class: normalizeClass(["vac-emoji-picker", { "vac-picker-reaction": $props.emojiReaction, "vac-picker-pc": $props.pcMode }]),
          style: normalizeStyle({
            height: `${$data.emojiPickerHeight}px`,
            ...$data.pickerStyle
          })
        }, [
          $props.emojiOpened ? (openBlock(), createBlock(_component_emoji_picker, {
            key: 0,
            ref: "emojiPicker",
            "data-source": $props.emojiDataSource
          }, null, 8, ["data-source"])) : createCommentVNode("", true)
        ], 6)
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ]);
}
var EmojiPickerContainer = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$q]]);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var fastclick = { exports: {} };
(function(module) {
  (function() {
    /**
     * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
     *
     * @codingstandard ftlabs-jsv2
     * @copyright The Financial Times Limited [All Rights Reserved]
     * @license MIT License (see LICENSE.txt)
     */
    function FastClick(layer, options) {
      var oldOnClick;
      options = options || {};
      this.trackingClick = false;
      this.trackingClickStart = 0;
      this.targetElement = null;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.lastTouchIdentifier = 0;
      this.touchBoundary = options.touchBoundary || 10;
      this.layer = layer;
      this.tapDelay = options.tapDelay || 200;
      this.tapTimeout = options.tapTimeout || 700;
      if (FastClick.notNeeded(layer)) {
        return;
      }
      function bind(method, context2) {
        return function() {
          return method.apply(context2, arguments);
        };
      }
      var methods = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"];
      var context = this;
      for (var i = 0, l = methods.length; i < l; i++) {
        context[methods[i]] = bind(context[methods[i]], context);
      }
      if (deviceIsAndroid) {
        layer.addEventListener("mouseover", this.onMouse, true);
        layer.addEventListener("mousedown", this.onMouse, true);
        layer.addEventListener("mouseup", this.onMouse, true);
      }
      layer.addEventListener("click", this.onClick, true);
      layer.addEventListener("touchstart", this.onTouchStart, false);
      layer.addEventListener("touchmove", this.onTouchMove, false);
      layer.addEventListener("touchend", this.onTouchEnd, false);
      layer.addEventListener("touchcancel", this.onTouchCancel, false);
      if (!Event.prototype.stopImmediatePropagation) {
        layer.removeEventListener = function(type, callback, capture) {
          var rmv = Node.prototype.removeEventListener;
          if (type === "click") {
            rmv.call(layer, type, callback.hijacked || callback, capture);
          } else {
            rmv.call(layer, type, callback, capture);
          }
        };
        layer.addEventListener = function(type, callback, capture) {
          var adv = Node.prototype.addEventListener;
          if (type === "click") {
            adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
              if (!event.propagationStopped) {
                callback(event);
              }
            }), capture);
          } else {
            adv.call(layer, type, callback, capture);
          }
        };
      }
      if (typeof layer.onclick === "function") {
        oldOnClick = layer.onclick;
        layer.addEventListener("click", function(event) {
          oldOnClick(event);
        }, false);
        layer.onclick = null;
      }
    }
    var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
    var deviceIsAndroid = navigator.userAgent.indexOf("Android") > 0 && !deviceIsWindowsPhone;
    var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
    var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);
    var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);
    var deviceIsBlackBerry10 = navigator.userAgent.indexOf("BB10") > 0;
    FastClick.prototype.needsClick = function(target) {
      switch (target.nodeName.toLowerCase()) {
        case "button":
        case "select":
        case "textarea":
          if (target.disabled) {
            return true;
          }
          break;
        case "input":
          if (deviceIsIOS && target.type === "file" || target.disabled) {
            return true;
          }
          break;
        case "label":
        case "iframe":
        case "video":
          return true;
      }
      return /\bneedsclick\b/.test(target.className);
    };
    FastClick.prototype.needsFocus = function(target) {
      switch (target.nodeName.toLowerCase()) {
        case "textarea":
          return true;
        case "select":
          return !deviceIsAndroid;
        case "input":
          switch (target.type) {
            case "button":
            case "checkbox":
            case "file":
            case "image":
            case "radio":
            case "submit":
              return false;
          }
          return !target.disabled && !target.readOnly;
        default:
          return /\bneedsfocus\b/.test(target.className);
      }
    };
    FastClick.prototype.sendClick = function(targetElement, event) {
      var clickEvent, touch;
      if (document.activeElement && document.activeElement !== targetElement) {
        document.activeElement.blur();
      }
      touch = event.changedTouches[0];
      clickEvent = document.createEvent("MouseEvents");
      clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
      clickEvent.forwardedTouchEvent = true;
      targetElement.dispatchEvent(clickEvent);
    };
    FastClick.prototype.determineEventType = function(targetElement) {
      if (deviceIsAndroid && targetElement.tagName.toLowerCase() === "select") {
        return "mousedown";
      }
      return "click";
    };
    FastClick.prototype.focus = function(targetElement) {
      var length;
      if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf("date") !== 0 && targetElement.type !== "time" && targetElement.type !== "month") {
        length = targetElement.value.length;
        targetElement.setSelectionRange(length, length);
      } else {
        targetElement.focus();
      }
    };
    FastClick.prototype.updateScrollParent = function(targetElement) {
      var scrollParent, parentElement;
      scrollParent = targetElement.fastClickScrollParent;
      if (!scrollParent || !scrollParent.contains(targetElement)) {
        parentElement = targetElement;
        do {
          if (parentElement.scrollHeight > parentElement.offsetHeight) {
            scrollParent = parentElement;
            targetElement.fastClickScrollParent = parentElement;
            break;
          }
          parentElement = parentElement.parentElement;
        } while (parentElement);
      }
      if (scrollParent) {
        scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
      }
    };
    FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
      if (eventTarget.nodeType === Node.TEXT_NODE) {
        return eventTarget.parentNode;
      }
      return eventTarget;
    };
    FastClick.prototype.onTouchStart = function(event) {
      var targetElement, touch, selection;
      if (event.targetTouches.length > 1) {
        return true;
      }
      targetElement = this.getTargetElementFromEventTarget(event.target);
      touch = event.targetTouches[0];
      if (deviceIsIOS) {
        selection = window.getSelection();
        if (selection.rangeCount && !selection.isCollapsed) {
          return true;
        }
        if (!deviceIsIOS4) {
          if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
            event.preventDefault();
            return false;
          }
          this.lastTouchIdentifier = touch.identifier;
          this.updateScrollParent(targetElement);
        }
      }
      this.trackingClick = true;
      this.trackingClickStart = event.timeStamp;
      this.targetElement = targetElement;
      this.touchStartX = touch.pageX;
      this.touchStartY = touch.pageY;
      if (event.timeStamp - this.lastClickTime < this.tapDelay) {
        event.preventDefault();
      }
      return true;
    };
    FastClick.prototype.touchHasMoved = function(event) {
      var touch = event.changedTouches[0], boundary = this.touchBoundary;
      if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
        return true;
      }
      return false;
    };
    FastClick.prototype.onTouchMove = function(event) {
      if (!this.trackingClick) {
        return true;
      }
      if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
        this.trackingClick = false;
        this.targetElement = null;
      }
      return true;
    };
    FastClick.prototype.findControl = function(labelElement) {
      if (labelElement.control !== void 0) {
        return labelElement.control;
      }
      if (labelElement.htmlFor) {
        return document.getElementById(labelElement.htmlFor);
      }
      return labelElement.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea");
    };
    FastClick.prototype.onTouchEnd = function(event) {
      var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
      if (!this.trackingClick) {
        return true;
      }
      if (event.timeStamp - this.lastClickTime < this.tapDelay) {
        this.cancelNextClick = true;
        return true;
      }
      if (event.timeStamp - this.trackingClickStart > this.tapTimeout) {
        return true;
      }
      this.cancelNextClick = false;
      this.lastClickTime = event.timeStamp;
      trackingClickStart = this.trackingClickStart;
      this.trackingClick = false;
      this.trackingClickStart = 0;
      if (deviceIsIOSWithBadTarget) {
        touch = event.changedTouches[0];
        targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
        targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
      }
      targetTagName = targetElement.tagName.toLowerCase();
      if (targetTagName === "label") {
        forElement = this.findControl(targetElement);
        if (forElement) {
          this.focus(targetElement);
          if (deviceIsAndroid) {
            return false;
          }
          targetElement = forElement;
        }
      } else if (this.needsFocus(targetElement)) {
        if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === "input") {
          this.targetElement = null;
          return false;
        }
        this.focus(targetElement);
        this.sendClick(targetElement, event);
        if (!deviceIsIOS || targetTagName !== "select") {
          this.targetElement = null;
          event.preventDefault();
        }
        return false;
      }
      if (deviceIsIOS && !deviceIsIOS4) {
        scrollParent = targetElement.fastClickScrollParent;
        if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
          return true;
        }
      }
      if (!this.needsClick(targetElement)) {
        event.preventDefault();
        this.sendClick(targetElement, event);
      }
      return false;
    };
    FastClick.prototype.onTouchCancel = function() {
      this.trackingClick = false;
      this.targetElement = null;
    };
    FastClick.prototype.onMouse = function(event) {
      if (!this.targetElement) {
        return true;
      }
      if (event.forwardedTouchEvent) {
        return true;
      }
      if (!event.cancelable) {
        return true;
      }
      if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        } else {
          event.propagationStopped = true;
        }
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
      return true;
    };
    FastClick.prototype.onClick = function(event) {
      var permitted;
      if (this.trackingClick) {
        this.targetElement = null;
        this.trackingClick = false;
        return true;
      }
      if (event.target.type === "submit" && event.detail === 0) {
        return true;
      }
      permitted = this.onMouse(event);
      if (!permitted) {
        this.targetElement = null;
      }
      return permitted;
    };
    FastClick.prototype.destroy = function() {
      var layer = this.layer;
      if (deviceIsAndroid) {
        layer.removeEventListener("mouseover", this.onMouse, true);
        layer.removeEventListener("mousedown", this.onMouse, true);
        layer.removeEventListener("mouseup", this.onMouse, true);
      }
      layer.removeEventListener("click", this.onClick, true);
      layer.removeEventListener("touchstart", this.onTouchStart, false);
      layer.removeEventListener("touchmove", this.onTouchMove, false);
      layer.removeEventListener("touchend", this.onTouchEnd, false);
      layer.removeEventListener("touchcancel", this.onTouchCancel, false);
    };
    FastClick.notNeeded = function(layer) {
      var metaViewport;
      var chromeVersion;
      var blackberryVersion;
      var firefoxVersion;
      if (typeof window.ontouchstart === "undefined") {
        return true;
      }
      chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];
      if (chromeVersion) {
        if (deviceIsAndroid) {
          metaViewport = document.querySelector("meta[name=viewport]");
          if (metaViewport) {
            if (metaViewport.content.indexOf("user-scalable=no") !== -1) {
              return true;
            }
            if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
              return true;
            }
          }
        } else {
          return true;
        }
      }
      if (deviceIsBlackBerry10) {
        blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
        if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
          metaViewport = document.querySelector("meta[name=viewport]");
          if (metaViewport) {
            if (metaViewport.content.indexOf("user-scalable=no") !== -1) {
              return true;
            }
            if (document.documentElement.scrollWidth <= window.outerWidth) {
              return true;
            }
          }
        }
      }
      if (layer.style.msTouchAction === "none" || layer.style.touchAction === "manipulation") {
        return true;
      }
      firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];
      if (firefoxVersion >= 27) {
        metaViewport = document.querySelector("meta[name=viewport]");
        if (metaViewport && (metaViewport.content.indexOf("user-scalable=no") !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
          return true;
        }
      }
      if (layer.style.touchAction === "none" || layer.style.touchAction === "manipulation") {
        return true;
      }
      return false;
    };
    FastClick.attach = function(layer, options) {
      return new FastClick(layer, options);
    };
    if (module.exports) {
      module.exports = FastClick.attach;
      module.exports.FastClick = FastClick;
    } else {
      window.FastClick = FastClick;
    }
  })();
})(fastclick);
var FaskClick = fastclick.exports;
const _sfc_main$q = {
  name: "MobileEmojiPickerContainer",
  props: {
    emojiOpened: { type: Boolean, default: false },
    emojiDataSource: { type: String, default: void 0 }
  },
  emits: ["add-emoji"],
  watch: {
    emojiOpened(val) {
      if (val) {
        this.bindEvent();
      }
    }
  },
  mounted() {
    if (this.emojiOpened) {
      this.bindEvent();
    }
  },
  methods: {
    bindEvent() {
      setTimeout(() => {
        this.addCustomStyling();
        this.$refs.emojiPicker.shadowRoot.addEventListener(
          "emoji-click",
          ({ detail }) => {
            this.$emit("add-emoji", {
              unicode: detail.unicode
            });
          }
        );
        if (isIOS) {
          const sr = this.$refs.emojiPicker.shadowRoot;
          FaskClick(sr.querySelector(".picker .nav"));
          FaskClick(sr.querySelector(".picker .tabpanel"));
          FaskClick(sr.querySelector(".picker .favorites"));
        }
      }, 0);
    },
    addCustomStyling() {
      const picker = `.picker {
				border: none;
			}`;
      const nav = `.nav {
				overflow-x: auto;
			}`;
      const searchBox = `.search-wrapper {
				padding-right: 2px;
				padding-left: 2px;
			}`;
      const search2 = `input.search {
				height: 32px;
				font-size: 14px;
				border-radius: 10rem;
				border: var(--chat-border-style);
				padding: 5px 10px;
				outline: none;
				background: var(--chat-bg-color-input);
				color: var(--chat-color);
			}`;
      const style = document.createElement("style");
      style.textContent = picker + nav + searchBox + search2;
      this.$refs.emojiPicker.shadowRoot.appendChild(style);
    }
  }
};
const _hoisted_1$n = { class: "vac-mobile-emoji-wrapper" };
const _hoisted_2$l = { class: "vac-mobile-emoji-picker" };
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_emoji_picker = resolveComponent("emoji-picker");
  return openBlock(), createElementBlock("div", _hoisted_1$n, [
    $props.emojiOpened ? (openBlock(), createBlock(Transition, {
      key: 0,
      name: "vac-slide-up",
      appear: ""
    }, {
      default: withCtx(() => [
        createElementVNode("div", _hoisted_2$l, [
          $props.emojiOpened ? (openBlock(), createBlock(_component_emoji_picker, {
            key: 0,
            ref: "emojiPicker",
            "data-source": $props.emojiDataSource
          }, null, 8, ["data-source"])) : createCommentVNode("", true)
        ])
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ]);
}
var MobileEmojiPickerContainer = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$p]]);
var dist = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    return function(e) {
      var t = {};
      function n(i) {
        if (t[i])
          return t[i].exports;
        var r = t[i] = { i, l: false, exports: {} };
        return e[i].call(r.exports, r, r.exports, n), r.l = true, r.exports;
      }
      return n.m = e, n.c = t, n.d = function(e2, t2, i) {
        n.o(e2, t2) || Object.defineProperty(e2, t2, { enumerable: true, get: i });
      }, n.r = function(e2) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e2, "__esModule", { value: true });
      }, n.t = function(e2, t2) {
        if (1 & t2 && (e2 = n(e2)), 8 & t2)
          return e2;
        if (4 & t2 && "object" == typeof e2 && e2 && e2.__esModule)
          return e2;
        var i = /* @__PURE__ */ Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", { enumerable: true, value: e2 }), 2 & t2 && "string" != typeof e2)
          for (var r in e2)
            n.d(i, r, function(t3) {
              return e2[t3];
            }.bind(null, r));
        return i;
      }, n.n = function(e2) {
        var t2 = e2 && e2.__esModule ? function() {
          return e2.default;
        } : function() {
          return e2;
        };
        return n.d(t2, "a", t2), t2;
      }, n.o = function(e2, t2) {
        return Object.prototype.hasOwnProperty.call(e2, t2);
      }, n.p = "", n(n.s = 9);
    }([function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true }), t.util = t.PresentationMode = void 0, t.createDom = s, t.hasClass = a, t.addClass = l, t.removeClass = c, t.toggleClass = u, t.findDom = d, t.padStart = f, t.format = p, t.event = h, t.typeOf = v, t.deepCopy = g, t.getBgImage = y, t.copyDom = m, t._setInterval = x, t._clearInterval = w, t.createImgBtn = b, t.isWeiXin = E, t.isUc = _, t.computeWatchDur = T, t.offInDestroy = C, t.on = k, t.once = S, t.getBuffered2 = P, t.checkIsBrowser = L, t.setStyle = O, t.checkWebkitSetPresentationMode = function(e2) {
        return "function" == typeof e2.webkitSetPresentationMode;
      };
      var i, r = n(6), o = (i = r) && i.__esModule ? i : { default: i };
      function s() {
        var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "div", t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, i2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "", r2 = document.createElement(e2);
        return r2.className = i2, r2.innerHTML = t2, Object.keys(n2).forEach(function(t3) {
          var i3 = t3, o2 = n2[t3];
          "video" === e2 || "audio" === e2 ? o2 && r2.setAttribute(i3, o2) : r2.setAttribute(i3, o2);
        }), r2;
      }
      function a(e2, t2) {
        return !!e2 && (e2.classList ? Array.prototype.some.call(e2.classList, function(e3) {
          return e3 === t2;
        }) : !!e2.className && !!e2.className.match(new RegExp("(\\s|^)" + t2 + "(\\s|$)")));
      }
      function l(e2, t2) {
        e2 && (e2.classList ? t2.replace(/(^\s+|\s+$)/g, "").split(/\s+/g).forEach(function(t3) {
          t3 && e2.classList.add(t3);
        }) : a(e2, t2) || (e2.className += " " + t2));
      }
      function c(e2, t2) {
        e2 && (e2.classList ? t2.split(/\s+/g).forEach(function(t3) {
          e2.classList.remove(t3);
        }) : a(e2, t2) && t2.split(/\s+/g).forEach(function(t3) {
          var n2 = new RegExp("(\\s|^)" + t3 + "(\\s|$)");
          e2.className = e2.className.replace(n2, " ");
        }));
      }
      function u(e2, t2) {
        e2 && t2.split(/\s+/g).forEach(function(t3) {
          a(e2, t3) ? c(e2, t3) : l(e2, t3);
        });
      }
      function d() {
        var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document, t2 = arguments[1], n2 = void 0;
        try {
          n2 = e2.querySelector(t2);
        } catch (i2) {
          0 === t2.indexOf("#") && (n2 = e2.getElementById(t2.slice(1)));
        }
        return n2;
      }
      function f(e2, t2, n2) {
        for (var i2 = String(n2), r2 = t2 >> 0, o2 = Math.ceil(r2 / i2.length), s2 = [], a2 = String(e2); o2--; )
          s2.push(i2);
        return s2.join("").substring(0, r2 - a2.length) + a2;
      }
      function p(e2) {
        if (window.isNaN(e2))
          return "";
        var t2 = f(Math.floor(e2 / 3600), 2, 0), n2 = f(Math.floor((e2 - 3600 * t2) / 60), 2, 0), i2 = f(Math.floor(e2 - 3600 * t2 - 60 * n2), 2, 0);
        return ("00" === t2 ? [n2, i2] : [t2, n2, i2]).join(":");
      }
      function h(e2) {
        if (e2.touches) {
          var t2 = e2.touches[0] || e2.changedTouches[0];
          e2.clientX = t2.clientX || 0, e2.clientY = t2.clientY || 0, e2.offsetX = t2.pageX - t2.target.offsetLeft, e2.offsetY = t2.pageY - t2.target.offsetTop;
        }
        e2._target = e2.target || e2.srcElement;
      }
      function v(e2) {
        return Object.prototype.toString.call(e2).match(/([^\s.*]+)(?=]$)/g)[0];
      }
      function g(e2, t2) {
        if ("Object" === v(t2) && "Object" === v(e2))
          return Object.keys(t2).forEach(function(n2) {
            "Object" !== v(t2[n2]) || t2[n2] instanceof Node ? "Array" === v(t2[n2]) ? e2[n2] = "Array" === v(e2[n2]) ? e2[n2].concat(t2[n2]) : t2[n2] : e2[n2] = t2[n2] : e2[n2] ? g(e2[n2], t2[n2]) : e2[n2] = t2[n2];
          }), e2;
      }
      function y(e2) {
        var t2 = (e2.currentStyle || window.getComputedStyle(e2, null)).backgroundImage;
        if (!t2 || "none" === t2)
          return "";
        var n2 = document.createElement("a");
        return n2.href = t2.replace(/url\("|"\)/g, ""), n2.href;
      }
      function m(e2) {
        if (e2 && 1 === e2.nodeType) {
          var t2 = document.createElement(e2.tagName);
          return Array.prototype.forEach.call(e2.attributes, function(e3) {
            t2.setAttribute(e3.name, e3.value);
          }), e2.innerHTML && (t2.innerHTML = e2.innerHTML), t2;
        }
        return "";
      }
      function x(e2, t2, n2, i2) {
        e2._interval[t2] || (e2._interval[t2] = setInterval(n2.bind(e2), i2));
      }
      function w(e2, t2) {
        clearInterval(e2._interval[t2]), e2._interval[t2] = null;
      }
      function b(e2, t2, n2, i2) {
        var r2 = s("xg-" + e2, "", {}, "xgplayer-" + e2 + "-img");
        if (r2.style.backgroundImage = 'url("' + t2 + '")', n2 && i2) {
          var o2 = void 0, a2 = void 0, l2 = void 0;
          ["px", "rem", "em", "pt", "dp", "vw", "vh", "vm", "%"].every(function(e3) {
            return !(n2.indexOf(e3) > -1 && i2.indexOf(e3) > -1) || (o2 = Number(n2.slice(0, n2.indexOf(e3)).trim()), a2 = Number(i2.slice(0, i2.indexOf(e3)).trim()), l2 = e3, false);
          }), r2.style.width = "" + o2 + l2, r2.style.height = "" + a2 + l2, r2.style.backgroundSize = "" + o2 + l2 + " " + a2 + l2, r2.style.margin = "start" === e2 ? "-" + a2 / 2 + l2 + " auto auto -" + o2 / 2 + l2 : "auto 5px auto 5px";
        }
        return r2;
      }
      function E() {
        return window.navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1;
      }
      function _() {
        return window.navigator.userAgent.toLowerCase().indexOf("ucbrowser") > -1;
      }
      function T() {
        for (var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t2 = [], n2 = 0; n2 < e2.length; n2++)
          if (!(!e2[n2].end || e2[n2].begin < 0 || e2[n2].end < 0 || e2[n2].end < e2[n2].begin))
            if (t2.length < 1)
              t2.push({ begin: e2[n2].begin, end: e2[n2].end });
            else
              for (var i2 = 0; i2 < t2.length; i2++) {
                var r2 = e2[n2].begin, o2 = e2[n2].end;
                if (o2 < t2[i2].begin) {
                  t2.splice(i2, 0, { begin: r2, end: o2 });
                  break;
                }
                if (!(r2 > t2[i2].end)) {
                  var s2 = t2[i2].begin, a2 = t2[i2].end;
                  t2[i2].begin = Math.min(r2, s2), t2[i2].end = Math.max(o2, a2);
                  break;
                }
                if (i2 > t2.length - 2) {
                  t2.push({ begin: r2, end: o2 });
                  break;
                }
              }
        for (var l2 = 0, c2 = 0; c2 < t2.length; c2++)
          l2 += t2[c2].end - t2[c2].begin;
        return l2;
      }
      function C(e2, t2, n2, i2) {
        e2.once(i2, function r2() {
          e2.off(t2, n2), e2.off(i2, r2);
        });
      }
      function k(e2, t2, n2, i2) {
        if (i2)
          e2.on(t2, n2), C(e2, t2, n2, i2);
        else {
          e2.on(t2, function i3(r2) {
            n2(r2), e2.off(t2, i3);
          });
        }
      }
      function S(e2, t2, n2, i2) {
        if (i2)
          e2.once(t2, n2), C(e2, t2, n2, i2);
        else {
          e2.once(t2, function i3(r2) {
            n2(r2), e2.off(t2, i3);
          });
        }
      }
      function P(e2) {
        for (var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0.5, n2 = [], i2 = 0; i2 < e2.length; i2++)
          n2.push({ start: e2.start(i2) < 0.5 ? 0 : e2.start(i2), end: e2.end(i2) });
        n2.sort(function(e3, t3) {
          var n3 = e3.start - t3.start;
          return n3 || t3.end - e3.end;
        });
        var r2 = [];
        if (t2)
          for (var s2 = 0; s2 < n2.length; s2++) {
            var a2 = r2.length;
            if (a2) {
              var l2 = r2[a2 - 1].end;
              n2[s2].start - l2 < t2 ? n2[s2].end > l2 && (r2[a2 - 1].end = n2[s2].end) : r2.push(n2[s2]);
            } else
              r2.push(n2[s2]);
          }
        else
          r2 = n2;
        return new o.default(r2);
      }
      function L() {
        return !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement);
      }
      function O(e2, t2, n2) {
        var i2 = e2.style;
        try {
          i2[t2] = n2;
        } catch (e3) {
          i2.setProperty(t2, n2);
        }
      }
      t.PresentationMode = { PIP: "picture-in-picture", INLINE: "inline", FULLSCREEN: "fullscreen" };
      var A = t.util = { createDom: s, hasClass: a, addClass: l, removeClass: c, toggleClass: u, findDom: d, padStart: f, format: p, event: h, typeOf: v, deepCopy: g, getBgImage: y, copyDom: m, setInterval: x, clearInterval: w, createImgBtn: b, isWeiXin: E, isUc: _, computeWatchDur: T, offInDestroy: C, on: k, once: S, getBuffered2: P, checkIsBrowser: L, setStyle: O };
      t.default = A;
    }, function(e, t, n) {
      var i = n(27)();
      e.exports = function(e2) {
        return e2 !== i && null !== e2;
      };
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = {};
      Object.defineProperty(i, "device", { get: function() {
        return i.os.isPc ? "pc" : "mobile";
      } }), Object.defineProperty(i, "browser", { get: function() {
        var e2 = navigator.userAgent.toLowerCase(), t2 = { ie: /rv:([\d.]+)\) like gecko/, firfox: /firefox\/([\d.]+)/, chrome: /chrome\/([\d.]+)/, opera: /opera.([\d.]+)/, safari: /version\/([\d.]+).*safari/ };
        return [].concat(Object.keys(t2).filter(function(n2) {
          return t2[n2].test(e2);
        }))[0] || "";
      } }), Object.defineProperty(i, "os", { get: function() {
        var e2 = navigator.userAgent, t2 = /(?:Windows Phone)/.test(e2), n2 = /(?:SymbianOS)/.test(e2) || t2, i2 = /(?:Android)/.test(e2), r = /(?:Firefox)/.test(e2), o = /(?:iPad|PlayBook)/.test(e2) || i2 && !/(?:Mobile)/.test(e2) || r && /(?:Tablet)/.test(e2), s = /(?:iPhone)/.test(e2) && !o;
        return { isTablet: o, isPhone: s, isAndroid: i2, isPc: !(s || i2 || n2 || o), isSymbian: n2, isWindowsPhone: t2, isFireFox: r };
      } }), t.default = i, e.exports = t.default;
    }, function(e, t, n) {
      function i(e2, t2) {
        return e2.hasOwnProperty(t2);
      }
      function r(e2) {
        return "object" == typeof e2 && void 0 === e2.length;
      }
      function o(e2) {
        return "string" == typeof e2;
      }
      function s(e2) {
        let t2 = !e2 || void 0 === e2 || "object" == typeof e2 && "" === e2._blank;
        if (!t2 && "object" == typeof e2) {
          const n2 = JSON.stringify(e2);
          "[]" !== n2 && "{}" !== n2 || (t2 = true);
        }
        return t2;
      }
      function a(e2, t2) {
        const n2 = e2.split("."), i2 = t2.split("."), r2 = Math.max(n2.length, i2.length);
        for (; n2.length < r2; )
          n2.push("0");
        for (; i2.length < r2; )
          i2.push("0");
        for (let e3 = 0; e3 < r2; e3++) {
          const t3 = parseInt(n2[e3]), r3 = parseInt(i2[e3]);
          if (t3 > r3)
            return 1;
          if (t3 < r3)
            return -1;
        }
        return 0;
      }
      n.r(t), n.d(t, "hasOwn", function() {
        return i;
      }), n.d(t, "isObject", function() {
        return r;
      }), n.d(t, "isString", function() {
        return o;
      }), n.d(t, "isObjectEmpty", function() {
        return s;
      }), n.d(t, "compareVersion", function() {
        return a;
      }), n.d(t, "sessionStorageAvaiable", function() {
        return c;
      }), n.d(t, "localStorageAvaiable", function() {
        return u;
      }), n.d(t, "Style", function() {
        return p;
      }), n.d(t, "qsStringify", function() {
        return h;
      }), n.d(t, "qsParse", function() {
        return v;
      }), n.d(t, "urlParse", function() {
        return g;
      }), n.d(t, "urlStringify", function() {
        return m;
      }), n.d(t, "addQuery", function() {
        return y;
      }), n.d(t, "hexToRgb", function() {
        return x;
      }), n.d(t, "sketchToCss", function() {
        return w;
      }), n.d(t, "supplementZero", function() {
        return b;
      }), n.d(t, "commaNumber", function() {
        return E;
      }), n.d(t, "getTimestamp", function() {
        return _;
      }), n.d(t, "StorageType", function() {
        return T;
      }), n.d(t, "getStorageInstance", function() {
        return S;
      }), n.d(t, "getLocalStorage", function() {
        return P;
      }), n.d(t, "getSessionStorage", function() {
        return L;
      }), n.d(t, "Loader", function() {
        return V;
      }), n.d(t, "getScrollTop", function() {
        return j;
      }), n.d(t, "getScrollHeight", function() {
        return B;
      }), n.d(t, "AppEventTarget", function() {
        return Z;
      }), n.d(t, "dispatchWindowEvent", function() {
        return J;
      }), n.d(t, "dispatchAppEvent", function() {
        return Q;
      }), n.d(t, "dispatchEvent", function() {
        return z;
      }), n.d(t, "addEventListener", function() {
        return $;
      }), n.d(t, "removeEventListener", function() {
        return X;
      }), n.d(t, "dispatchLatestAppEventFromSession", function() {
        return Y;
      }), n.d(t, "CustomEvent", function() {
        return W;
      }), n.d(t, "Singleflight", function() {
        return O;
      }), n.d(t, "MESSAGE_NETWORK_TIMEOUT", function() {
        return ee;
      }), n.d(t, "MESSAGE_SERVER_ERROR", function() {
        return te;
      }), n.d(t, "MESSAGE_NETWORK_NOT_AVAILABLE", function() {
        return ne;
      }), n.d(t, "MESSAGE_OTHER_ERROR", function() {
        return ie;
      }), n.d(t, "ERROR_TYPE_AUTO", function() {
        return re;
      }), n.d(t, "ERROR_TYPE_SERVER", function() {
        return oe;
      }), n.d(t, "ERROR_TYPE_NETWORK_NOT_AVAILABLE", function() {
        return se;
      }), n.d(t, "ERROR_TYPE_NETWORK_TIMEOUT", function() {
        return ae;
      }), n.d(t, "ERROR_TYPE_404", function() {
        return le;
      }), n.d(t, "ERROR_TYPE_CANCEL", function() {
        return ce;
      }), n.d(t, "ERROR_TYPE_OTHER", function() {
        return ue;
      }), n.d(t, "HttpError", function() {
        return de;
      }), n.d(t, "Env", function() {
        return N;
      }), n.d(t, "getEnv", function() {
        return F;
      }), n.d(t, "formatPrice", function() {
        return he;
      }), n.d(t, "App", function() {
        return I;
      }), n.d(t, "voghionConfig", function() {
        return M;
      }), n.d(t, "mocasaShoppingConfig", function() {
        return D;
      });
      const l = "testAvaiable";
      function c() {
        let e2 = true;
        if ("undefined" != typeof window) {
          try {
            const e3 = window.sessionStorage;
            e3.setItem(l, "1"), e3.removeItem(l);
          } catch (t2) {
            e2 = false;
          }
          return e2;
        }
      }
      function u() {
        let e2 = true;
        if ("undefined" != typeof window) {
          try {
            const e3 = window.localStorage;
            e3.setItem(l, "1"), e3.removeItem(l);
          } catch (t2) {
            e2 = false;
          }
          return e2;
        }
      }
      let d = null;
      const f = "undefined" != typeof window;
      class p {
        static getInstance() {
          return p.instance || (p.instance = new p()), p.instance;
        }
        appendStyle(e2) {
          if (f) {
            if (!d) {
              d = document.createElement("style");
              document.getElementsByTagName("head")[0].appendChild(d);
            }
            try {
              d.appendChild(document.createTextNode(e2));
            } catch (e3) {
            }
          }
        }
        checkVarExists(e2) {
          return f && !!window.getComputedStyle(document.documentElement).getPropertyValue(e2);
        }
      }
      function h(e2, t2 = true) {
        const n2 = [];
        for (const i2 of Object.keys(e2)) {
          let r2 = e2[i2];
          "object" == typeof r2 && t2 && (r2 = JSON.stringify(r2)), n2.push(`${i2}=${encodeURIComponent(r2)}`);
        }
        return n2.join("&");
      }
      function v(e2, t2 = true) {
        0 === e2.indexOf("?") && (e2 = e2.slice(1));
        const n2 = {};
        if (!e2)
          return n2;
        const i2 = e2.split("&");
        for (const e3 of i2) {
          const i3 = e3.split("=");
          let r2 = decodeURIComponent(i3[1] || "");
          if (t2 && ("[" === r2[0] || "{" === r2[0]))
            try {
              r2 = JSON.parse(r2);
            } catch (e4) {
            }
          n2[i3[0]] = r2;
        }
        return n2;
      }
      function g(e2) {
        const t2 = e2.split("//"), n2 = t2[0];
        t2.splice(0, 1);
        const i2 = t2.join("//").split("#"), r2 = i2.length > 1 ? "#" + i2[1] : "", o2 = i2[0].split("?"), s2 = o2.length > 1 ? "?" + o2[1] : "", a2 = o2[0];
        let l2 = "", c2 = "", u2 = "";
        if (0 === n2.indexOf("com."))
          l2 = "/" + a2, c2 = "", u2 = "";
        else {
          const e3 = a2.split("/");
          u2 = e3[0];
          const t3 = u2.indexOf(":");
          c2 = t3 > 0 ? u2.slice(0, t3) : u2, e3.splice(0, 1), l2 = e3.join("/"), l2 && (l2 = "/" + l2);
        }
        return { protocol: n2, host: u2, hostname: c2, pathname: l2, search: s2, hash: r2 };
      }
      function y(e2, t2) {
        const n2 = g(e2), i2 = v(n2.search);
        return Object.assign(i2, t2), m(Object.assign({ query: i2 }, n2));
      }
      function m(e2) {
        const { protocol: t2 = "", host: n2 = "", pathname: i2 = "", query: r2 } = e2;
        let o2 = r2 ? h(r2) : e2.search || "";
        o2 && "?" !== o2[0] && (o2 = "?" + o2);
        let s2 = e2.hash || "";
        return s2 && "#" !== s2[0] && (s2 = "#" + s2), `${t2}${t2 ? "//" : ""}${n2}${i2}${o2}${s2}`;
      }
      function x(e2) {
        let t2 = e2.toLowerCase();
        if (/^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/.test(t2)) {
          if (4 === t2.length) {
            let e4 = "#";
            for (let n2 = 1; n2 < 4; n2 += 1)
              e4 += t2.slice(n2, n2 + 1).concat(t2.slice(n2, n2 + 1));
            t2 = e4;
          }
          const e3 = [];
          for (let n2 = 1; n2 < 7; n2 += 2)
            e3.push(parseInt("0x" + t2.slice(n2, n2 + 2)));
          return e3.join(",");
        }
        return t2;
      }
      function w(e2) {
        const t2 = e2.slice(0, 7), n2 = e2.slice(7);
        if (!t2)
          return "inherit";
        if (!n2)
          return e2;
        return `rgba(${x(t2)},${(parseInt(n2.replace("%", "")) / 100).toPrecision(2)})`;
      }
      function b(e2) {
        return e2 < 10 ? "0" + e2 : "" + e2;
      }
      function E(e2) {
        return (e2 + "").replace(/(\d)(?=(\d{3})+$)/gim, "$1,");
      }
      function _() {
        return new Date().getTime() / 1e3;
      }
      p.instance = null;
      var T;
      !function(e2) {
        e2[e2.LocalStorage = 0] = "LocalStorage", e2[e2.SessionStorage = 1] = "SessionStorage";
      }(T || (T = {}));
      class C {
        constructor(e2 = T.LocalStorage) {
          this._type = T.LocalStorage, this._storageAvailable = null, this._type = e2;
        }
        get adapter() {
          return this.storageAvailable ? this._type == T.LocalStorage ? window.localStorage : window.sessionStorage : null;
        }
        get storageAvailable() {
          return null === this._storageAvailable && (this._storageAvailable = this._type == T.LocalStorage ? u() : c()), this._storageAvailable;
        }
        buildStorageParams(e2) {
          return Object.assign({ cache: this._type !== T.LocalStorage }, e2);
        }
        setItem(e2, t2, n2 = {}) {
          if (!this.storageAvailable)
            return false;
          const i2 = this.adapter;
          i2.setItem(e2, JSON.stringify(t2));
          const r2 = e2 + "--time";
          if (n2 && "updateTime" in n2 && !n2.updateTime) {
            if (i2.getItem(r2))
              return true;
          }
          return i2.setItem(r2, _() + ""), true;
        }
        setItemAsync(e2, t2) {
          return new Promise((n2) => {
            setTimeout(() => {
              const i2 = this.setItem(e2, t2);
              n2(i2);
            }, 10);
          });
        }
        getItem(e2, t2 = null, n2 = 0) {
          if (!this.storageAvailable)
            return t2;
          const i2 = this.adapter;
          let r2 = i2.getItem(e2);
          if (null !== r2 && n2 > 0) {
            const t3 = _();
            let o2 = i2.getItem(e2 + "--time");
            o2 = o2 ? parseInt(o2) : 0, t3 - o2 > n2 && (r2 = null, this.removeItem(e2));
          }
          return null === r2 ? t2 : JSON.parse(r2);
        }
        getItemAsync(e2, t2 = null, n2 = 0) {
          return new Promise((i2) => {
            setTimeout(() => {
              const r2 = this.getItem(e2, t2, n2);
              i2(r2);
            }, 10);
          });
        }
        removeItem(e2) {
          if (!this.storageAvailable)
            return false;
          const t2 = this.adapter;
          return t2.removeItem(e2), t2.removeItem(e2 + "--time"), true;
        }
        removeItemAsync(e2) {
          return new Promise((t2) => {
            setTimeout(() => {
              const n2 = this.removeItem(e2);
              t2(n2);
            }, 10);
          });
        }
        clear() {
          if (!this.storageAvailable)
            return false;
          return this.adapter.clear(), true;
        }
        clearAsync() {
          return new Promise((e2) => {
            setTimeout(() => {
              const t2 = this.clear();
              e2(t2);
            }, 10);
          });
        }
        getStorageInfo() {
          return new Promise((e2) => {
            const t2 = [], n2 = this.adapter;
            for (let e3 = n2.length - 1; e3 >= 0; e3--)
              t2.push(n2.key(e3));
            setTimeout(() => {
              e2({ keys: t2 });
            }, 10);
          });
        }
      }
      let k = {};
      function S(e2) {
        return k[e2] || (k[e2] = new C(e2)), k[e2];
      }
      function P() {
        return S(T.LocalStorage);
      }
      function L() {
        return S(T.SessionStorage);
      }
      class O {
        constructor() {
          this.lockMap = {}, this.cbQueue = {};
        }
        static getInstance() {
          return O.instance || (O.instance = new O()), O.instance;
        }
        do(e2, t2) {
          return new Promise((n2, i2) => {
            const r2 = this.cbQueue;
            r2[e2] || (r2[e2] = []), r2[e2].push([n2, i2]);
            const o2 = this.lockMap;
            if (!o2[e2]) {
              o2[e2] = true;
              const n3 = t2(e2);
              n3 && n3.then && n3.then(this._resolveTask.bind(this, e2), this._rejectTask.bind(this, e2));
            }
          });
        }
        _resolveTask(e2, t2) {
          const n2 = this.cbQueue, i2 = n2[e2] || [];
          for (const e3 of i2)
            e3[0](t2);
          delete n2[e2], delete this.lockMap[e2];
        }
        _rejectTask(e2, t2) {
          const n2 = this.cbQueue, i2 = n2[e2] || [];
          for (const e3 of i2)
            e3[1](t2);
          delete n2[e2], delete this.lockMap[e2];
        }
      }
      O.instance = null;
      const A = "undefined" != typeof window, R = A ? `${location.protocol}//${location.host}` : "";
      var I;
      !function(e2) {
        e2[e2.Auto = 1] = "Auto", e2[e2.None = 2] = "None", e2[e2.Voghion = 4] = "Voghion", e2[e2.MocasaShopping = 8] = "MocasaShopping";
      }(I || (I = {}));
      const M = { app: I.Voghion, ua: "voghion/" }, D = { app: I.MocasaShopping, ua: "mocasashopping/" };
      class N extends class {
        constructor(e2 = {}) {
          if (this.ua = "", this.isIOS = false, this.isAllScreen = false, this.isIPad = false, this.isAndroid = false, this.isAndroidPad = false, this.isWx = false, this.isMiniProgram = false, this.isQq = false, this.isTrident = false, this.iOSVersion = "10.0.0", this.androidVersion = "5.0.0", this.screenWidth = 375, this.screenHeight = 667, this.devicePixelRatio = 2, this.statusBarHeight = 20, this.navigationBarHeight = 44, this.isProd = false, this.isWKWebView = false, this.isPageShow = false, this.pageShowed = false, this.envVarPrefix = "--app--", this._isClient = A, this._currentBaseUrl = R, this._isDeveloperTools = false, this._isWebDev = false, "envVarPrefix" in e2 && (this.envVarPrefix = e2.envVarPrefix), this._isClient) {
            const e3 = window;
            this._isDeveloperTools = !(!e3.chrome && !e3.safari), this.refreshFromClient(), this.refreshStatusBarHeight(), setTimeout(() => {
              this.preventIOSDbclickPageMove();
            }, 0), "complete" === document.readyState ? (this.isPageShow = true, this.pageShowed = true) : window.addEventListener("pageshow", () => {
              this.isPageShow = true, this.pageShowed = true;
            }), window.addEventListener("beforeunload", () => {
              this.isPageShow = false;
            }), window.addEventListener("pagehide", () => {
              this.isPageShow = false;
            });
          }
        }
        refreshFromClient() {
          this.isClient && (this.refreshWithUaAndHref(window.navigator.userAgent, window.location.href), this.screenWidth = window.screen.width, this.screenHeight = window.screen.height, this.devicePixelRatio = window.devicePixelRatio || 1, this.isAllScreen = this.isIOS && (812 == this.screenHeight || 896 == this.screenHeight || 844 == this.screenHeight || 926 == this.screenHeight), this.isAllScreen && (this.statusBarHeight = 44));
        }
        refreshWithUaAndHref(e2, t2) {
          this.refreshWithUa(e2), this.refreshWithHref(t2);
        }
        refreshWithUa(e2) {
          const t2 = e2.toLowerCase();
          if (this.ua = t2, this.isWx = /micromessenger/.test(t2), t2.indexOf("webdev") > -1 && (this._isWebDev = true), this.isQq = null !== t2.match(/\sqq/i), this.isAndroid = t2.indexOf("android") > -1 || t2.indexOf("adr") > -1, this.isAndroidPad = this.isAndroid && -1 === t2.indexOf("mobile"), this.isIPad = /ipad/.test(t2), this.isIOS = /iphone|ipad|ipod|iOS/.test(t2), this.isMiniProgram = t2.includes("miniprogram"), this.isTrident = t2.includes("trident/"), this.isIOS) {
            const e3 = /os [\d._]*/gi, n2 = t2.match(e3);
            this.iOSVersion = (n2 + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".") + "", this.isWKWebView = a(this.iOSVersion, "8.0.0") >= 0;
          } else if (this.isAndroid) {
            const e3 = /(android|adr) [\d._]*/gi, n2 = t2.match(e3);
            this.androidVersion = (n2 + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".") + "", this.navigationBarHeight = 49, this.statusBarHeight = 30;
          }
        }
        refreshWithHref(e2) {
          if (e2) {
            const { host: t2, protocol: n2 } = g(e2);
            this._currentBaseUrl && this.isClient || (this._currentBaseUrl = `${n2}//${t2}`);
          }
        }
        refreshStatusBarHeight() {
          this.isClient && (this.appendEnvVars(), setTimeout(() => {
            this._refreshStatusBarHeight();
          }, 0));
        }
        appendEnvVars() {
          const e2 = p.getInstance();
          e2.checkVarExists(this.envVarPrefix + "sait") || e2.appendStyle(`
:root {
  ${this.envVarPrefix}sait: env(safe-area-inset-top);
  ${this.envVarPrefix}sair: env(safe-area-inset-right);
  ${this.envVarPrefix}saib: env(safe-area-inset-bottom);
  ${this.envVarPrefix}sail: env(safe-area-inset-left);
}`);
        }
        _refreshStatusBarHeight() {
          const e2 = getComputedStyle(document.documentElement).getPropertyValue(this.envVarPrefix + "sait").replace(/\s/gi, "").replace("px", "");
          if (e2) {
            const t2 = parseInt(e2);
            t2 && (this.statusBarHeight = t2);
          }
        }
        preventIOSDbclickPageMove() {
          let e2 = 0;
          this.isIOS && this._isClient && document.body.addEventListener("touchend", (t2) => {
            const n2 = new Date().getTime();
            e2 = e2 || n2 + 1;
            let i2 = n2 - e2;
            if (i2 < 500 && i2 > 0)
              return t2.preventDefault(), false;
            e2 = n2;
          }, false);
        }
        set currentBaseUrl(e2) {
          this._currentBaseUrl = e2;
        }
        get currentBaseUrl() {
          return this._currentBaseUrl;
        }
        get enablePageTransition() {
          return !this.isIOS && !this.isAndroid || this.isIOS && a(this.iOSVersion, "10.0.0") >= 0 || this.isAndroid && a(this.androidVersion, "6.0.0") >= 0;
        }
        get isClient() {
          return this._isClient;
        }
        get isWxMini() {
          return this.isWx && this.isMiniProgram;
        }
        get canUseWebp() {
          return !this.isIOS && !this.isAndroid && !this.isTrident || this.isIOS && a(this.iOSVersion, "14.0.0") >= 0 || this.isAndroid && a(this.androidVersion, "4.2.0") >= 0;
        }
        get needFastClick() {
          return !(this.isWx || !this.isIOS && !this.isAndroid || this.isIOS && this.isWKWebView && a(this.iOSVersion, "9.3") >= 0 || this.isAndroid && a(this.androidVersion, "4.4") >= 0);
        }
        get isEnvWx() {
          return this.isWx || this.isWxMini;
        }
        get isDeveloperTools() {
          return this._isDeveloperTools;
        }
        get isEnvMobile() {
          return this.isIOS && !this.isIPad || this.isAndroid && !this.isAndroidPad || this.isClient && window.innerWidth < 501;
        }
        get isEnvPad() {
          return this.isIPad || this.isAndroidPad;
        }
      } {
        static getInstance(e2 = {}) {
          e2 || (e2 = {});
          const t2 = "{}" !== JSON.stringify(e2);
          return N.instance ? t2 && N.instance.init(e2) : N.instance = new N(e2), N.instance;
        }
        constructor(e2 = {}) {
          super(e2), this.isAppHome = false, this.isBottomSheet = false, this.isAppSubTab = false, this.isNativePage = false, this.mobileModel = "", this.iOSPerformanceModel = 9, this.androidPerformanceVersion = "8.0.0", this.visibilityState = "visible", this.systemInfo = {}, this._apiBaseUrl = "", this._webBaseUrl = "", this._enableImmersiveUI = false, this._immersiveUIChanged = false, this._appConfigs = [], this._hasNativeLoading = false, this.init();
        }
        init(e2 = {}) {
          let t2 = e2.appConfigs || [];
          t2.length || (t2 = [M, D]), this._appConfigs = t2;
          const n2 = this.ua;
          for (const e3 of this._appConfigs)
            if (e3.active = n2.indexOf(e3.ua) > -1, e3.active) {
              const t3 = new RegExp(e3.ua + "[0-9.]+", "g").exec(n2);
              null !== t3 && (e3.version = t3[0].replace(e3.ua, ""));
              break;
            }
        }
        refreshFromClient() {
          super.refreshFromClient();
          const e2 = window.screen.height, t2 = e2 - window.innerHeight;
          this.isBottomSheet = t2 / e2 > 0.29, this._hasNativeLoading = true, window.addEventListener("load", () => {
            setTimeout(() => {
              this._hasNativeLoading = false;
            }, 50);
          });
        }
        refreshWithUa(e2) {
          super.refreshWithUa(e2), this.checkImmersiveUI();
        }
        refreshWithHref(e2) {
          if (super.refreshWithHref(e2), e2) {
            const { search: t2 } = g(e2);
            this.isAppHome = t2.indexOf("inAppHome=1") > 0, this.isAppSubTab = t2.indexOf("inAppSubTab=1") > 0;
          }
        }
        set apiBaseUrl(e2) {
          this._apiBaseUrl = e2;
        }
        get apiBaseUrl() {
          return this._apiBaseUrl;
        }
        set webBaseUrl(e2) {
          this._webBaseUrl = e2;
        }
        get webBaseUrl() {
          return this._webBaseUrl;
        }
        get currentAppVersion() {
          const e2 = this._appConfigs.filter((e3) => e3.active);
          return e2.length ? e2[0].version : "";
        }
        get isSupportedImmersiveUI() {
          return this.isIOS || this.isAndroid && a(this.androidVersion, "5.0.0") >= 0;
        }
        checkImmersiveUI(e2 = true) {
          const t2 = this.isSupportedImmersiveUI;
          return e2 && !this._immersiveUIChanged && (this._enableImmersiveUI = t2), t2;
        }
        switchImmersiveUI(e2 = true) {
          return !(this.navBarLocked || !this.isSupportedImmersiveUI) && (this._immersiveUIChanged = true, this._enableImmersiveUI = !!e2, true);
        }
        getAppConfig(e2) {
          const t2 = this._appConfigs || [], n2 = e2 ? t2.filter((t3) => t3.app === e2) : t2.filter((e3) => e3.active);
          return n2.length ? n2[0] : null;
        }
        isApp(e2) {
          const t2 = this.getAppConfig(e2);
          return !!t2 && t2.active;
        }
        getAppVersion(e2) {
          const t2 = this.getAppConfig(e2);
          return t2 ? t2.version : "";
        }
        set enableImmersiveUI(e2) {
          this.switchImmersiveUI(e2);
        }
        get enableImmersiveUI() {
          return this._enableImmersiveUI;
        }
        get hasNativeLoading() {
          return this._hasNativeLoading;
        }
        get enableNewWebView() {
          let e2 = false;
          if (this.isEnvAppWebViewClient)
            if (this.isIOS) {
              if (this.screenHeight > 750)
                e2 = true;
              else if (this.mobileModel) {
                const t2 = this.mobileModel.toLowerCase().replace("iphone", "").split(",");
                parseInt(t2[0]) >= this.iOSPerformanceModel && (e2 = true);
              }
            } else
              window.navigator.serviceWorker && a(this.androidVersion, this.androidPerformanceVersion) >= 0 && (e2 = true);
          return e2;
        }
        get isEnvOutsideApp() {
          return !this.isEnvAppWebView;
        }
        get requestFromAppWebView() {
          return this.isEnvAppWebView && !this._isWebDev;
        }
        get isEnvAppWebViewClient() {
          return this.isEnvAppWebView && this.isClient;
        }
        get navBarLocked() {
          return this.isAppSubTab || this.isBottomSheet || this.isNativePage;
        }
        get isEnvAppWebView() {
          return this._appConfigs.filter((e2) => e2.active).length > 0;
        }
      }
      N.instance = null;
      const F = N.getInstance;
      class V {
        constructor() {
          this.jsMap = {}, this.cssMap = {};
        }
        static getInstance() {
          return V.instance || (V.instance = new V()), V.instance;
        }
        loadLibrary(e2, t2) {
          return this.loadJs(t2).then(() => window[e2] || {});
        }
        loadJs(e2) {
          "string" == typeof e2 ? e2 = { modern: e2, legacy: e2 } : e2.legacy || (e2.legacy = e2.modern);
          const t2 = N.getInstance(), n2 = !t2.isClient || "Proxy" in window ? e2.modern : e2.legacy;
          return O.getInstance().do("load_js_" + n2, () => new Promise((e3, i2) => {
            if (this.jsMap[n2] || !t2.isClient)
              e3(true);
            else {
              const t3 = document.createElement("script");
              t3.src = n2, t3.async = false, (document.head || document.body).appendChild(t3), t3.onload = () => {
                this.jsMap[n2] = true, "function" == typeof e3 && e3(true);
              }, t3.onerror = (e4) => {
                "function" == typeof i2 && i2(e4);
              };
            }
          }));
        }
        loadCss(e2) {
          return O.getInstance().do("load_css_" + e2, () => new Promise((t2, n2) => {
            const i2 = N.getInstance();
            if (this.cssMap[e2] || !i2.isClient)
              t2(true);
            else {
              const i3 = document.createElement("link");
              i3.type = "text/css", i3.rel = "stylesheet", i3.href = e2, (document.head || document.body).appendChild(i3), i3.onload = () => {
                this.cssMap[e2] = true, "function" == typeof t2 && t2(true);
              }, i3.onerror = (e3) => {
                "function" == typeof n2 && n2(e3);
              };
            }
          }));
        }
        loadImage(e2) {
          return O.getInstance().do("load_image_" + e2, function() {
            return new Promise((t2, n2) => {
              N.getInstance().isClient || t2(true);
              const i2 = new Image();
              i2.src = e2, i2.onload = () => {
                "function" == typeof t2 && t2(true);
              }, i2.onerror = (e3) => {
                "function" == typeof n2 && n2(e3);
              };
            });
          });
        }
        loadImages(e2) {
          const t2 = [];
          for (const n2 of e2)
            t2.push(this.loadImage(n2));
          return Promise.all(t2);
        }
      }
      function j(e2 = null) {
        return e2 ? e2.scrollTop : document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
      }
      function B(e2 = null) {
        return e2 ? e2.scrollHeight : document.documentElement.scrollHeight || document.body.scrollHeight;
      }
      V.instance = null;
      const U = "undefined" != typeof window;
      const W = U && "function" == typeof window.CustomEvent ? window.CustomEvent : class {
        initCustomEvent(e2, t2, n2, i2) {
          this.type = e2, this.cancelable = n2, this.detail = i2;
        }
        composedPath() {
          return [];
        }
        initEvent(e2, t2, n2) {
          this.type = e2, this.bubbles = t2, this.cancelable = n2;
        }
        preventDefault() {
        }
        stopImmediatePropagation() {
        }
        stopPropagation() {
        }
        constructor(e2, t2) {
          if (this.bubbles = false, this.cancelable = false, this.composed = false, this.isTrusted = false, !U)
            return this.type = e2, this.detail = t2.detail, this.cancelable = t2.cancelable, this;
          const n2 = t2 || { bubbles: false, cancelable: false, detail: void 0 }, i2 = document.createEvent("CustomEvent");
          return i2.initCustomEvent(e2, n2.bubbles, n2.cancelable, n2.detail), i2;
        }
      }, H = "undefined" != typeof window;
      let G = null, K = false;
      function q() {
        if (!G) {
          const e2 = n(45);
          G = new e2.EventEmitter();
        }
        return G;
      }
      function Y() {
        const e2 = L();
        if (e2 && e2.storageAvailable) {
          let t2 = e2.getItem("latest_app_event");
          t2 && (e2.removeItem("latest_app_event"), t2 = JSON.parse(t2), J(t2.event, t2.params));
        }
      }
      function z(e2, t2 = {}) {
        if (H)
          J(e2, t2);
        else {
          const n2 = q(), i2 = new W(e2, { detail: t2, cancelable: false });
          n2.emit(e2, i2);
        }
      }
      function $(e2, t2) {
        if (H)
          K || (K = true, window.addEventListener("storage", (e3) => {
            const t3 = e3.key, n2 = e3.newValue;
            if (0 === t3.indexOf("app_event_") && n2) {
              const n3 = t3.replace("app_event_", "");
              try {
                const t4 = new W(n3, { detail: JSON.parse(e3.newValue) });
                t4 && window.dispatchEvent(t4);
              } catch (e4) {
              }
            }
          })), window.addEventListener(e2, t2);
        else {
          q().addListener(e2, t2);
        }
      }
      function X(e2, t2) {
        if (H)
          window.removeEventListener(e2, t2);
        else {
          q().removeListener(e2, t2);
        }
      }
      function J(e2, t2 = {}) {
        if (!H)
          return;
        const n2 = new W(e2, { detail: t2 });
        n2 && window.dispatchEvent(n2);
      }
      var Z;
      function Q(e2, t2 = {}, n2 = Z.OtherWebView) {
        if (H) {
          if (n2 & Z.Current && J(e2, t2), n2 & Z.OtherWebView) {
            if (P().storageAvailable) {
              const n4 = "app_event_" + e2;
              window.localStorage.setItem(n4, JSON.stringify(t2)), setTimeout(() => {
                window.localStorage.removeItem(n4);
              }, 50);
            }
            const n3 = L();
            n3.storageAvailable && n3.setItem("latest_app_event", JSON.stringify({ event: e2, params: t2 }));
          }
          Z.Native;
        }
      }
      !function(e2) {
        e2[e2.OtherWebView = 1] = "OtherWebView", e2[e2.Native = 2] = "Native", e2[e2.Current = 4] = "Current";
      }(Z || (Z = {}));
      const ee = "network timeout, please retry~", te = "server error, please contact the manager~", ne = "network unreachable, please check~", ie = "unknown error, please contact the manager~", re = "", oe = "server", se = "networkNotAvailable", ae = "timeout", le = "404", ce = "cancel", ue = "other";
      class de extends Error {
        constructor(e2 = "", t2 = null, n2 = re) {
          if (n2 == re)
            if ("undefined" == typeof window || window.navigator.onLine) {
              let e3;
              t2 && (t2 instanceof Response ? e3 = t2 : "response" in t2 && (e3 = t2.response)), e3 && 404 === e3.status ? n2 = le : (n2 = ue, "undefined" != typeof window && t2 instanceof DOMException && "AbortError" === t2.name && (n2 = ce));
            } else
              n2 = se;
          if (!e2)
            switch (n2) {
              case oe:
                e2 = te;
                break;
              case se:
                e2 = ne;
                break;
              case ae:
                e2 = ee;
                break;
              case ce:
                break;
              default:
                n2 = ue, e2 = ie;
            }
          super(e2), this._type = n2, this._statusCode = 0, this.detail = t2;
        }
        get statusCode() {
          return this._statusCode || (this.is404Error ? 404 : 500);
        }
        set statusCode(e2) {
          this._statusCode = e2;
        }
        get type() {
          return this._type;
        }
        set type(e2) {
          this._type = e2;
        }
        get isServerError() {
          return this._type === oe;
        }
        get isNetworkNotAvailableError() {
          return this._type === se;
        }
        get isNetworkTimeoutError() {
          return this._type === ae;
        }
        get is404Error() {
          return this._type === le;
        }
        get isCancel() {
          return this._type === ce;
        }
        purify() {
          return { statusCode: this.statusCode, message: this.message, type: this.type, isServerError: this.isServerError, isNetworkNotAvailableError: this.isNetworkNotAvailableError, isNetworkTimeoutError: this.isNetworkTimeoutError, is404Error: this.is404Error, isCancel: this.isCancel };
        }
        toJSON() {
          return JSON.stringify(this.purify());
        }
      }
      const fe = ["\u20AC"], pe = /* @__PURE__ */ new Map([["EUR", "\u20AC"], ["NZD", "$"], ["AUD", "$"], ["CAD", "C$"], ["USD", "$"], ["HRK", "kn"], ["CZK", "K\u010D"], ["DKK", "kr"], ["NOK", "kr"], ["SEK", "kr"], ["ISK", "kr"], ["HUF", "Ft"], ["PLN", "z\u0142"], ["CHF", "Fr"], ["TRY", "\u20BA"], ["GBP", "\xA3"], ["BGN", "\u043B\u0432"], ["RSD", "\u0414\u0438\u043D"], ["RUB", "\u20BD"], ["PHP", "\u20B1"]]);
      function he(e2, t2, n2 = 2) {
        if (null == e2)
          return "";
        if (n2 >= 0) {
          e2 = ("number" == typeof e2 ? e2 : parseFloat(e2)).toFixed(n2);
        }
        if (t2.startsWith("#")) {
          let n3 = t2.slice(1);
          n3.endsWith("#") && (n3 = n3.slice(0, -1));
          const i2 = n3.split("#"), r2 = e2.toString().split("."), o2 = i2[3] || ".", s2 = r2[1] && "N" !== o2, a2 = `${r2[0].replace(/\B(?=(\d{3})+(?!\d))/g, i2[2] || ",")}${s2 ? o2 + r2[1] : ""}`;
          return ">" === i2[0] ? `${a2}${i2[1] || ""}` : `${i2[1] || ""}${a2}`;
        }
        {
          const n3 = pe.get(t2) || t2;
          return fe.includes(n3) ? `${e2}${n3}` : `${n3}${e2}`;
        }
      }
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = n(7);
      function r(e2, t2) {
        if (!(e2 instanceof t2))
          throw new TypeError("Cannot call a class as a function");
      }
      var o = { network: { code: 1, msg: "\u89C6\u9891\u4E0B\u8F7D\u9519\u8BEF", remark: "\u53EA\u8981\u89C6\u9891\u4E0B\u8F7D\u9519\u8BEF\u5C31\u4F7F\u7528\u6B64\u7C7B\u578B\uFF0C\u65E0\u8BBA\u662Fvideo\u672C\u8EAB\u7684\u8D85\u65F6\u8FD8\u662Fxhr\u7684\u5206\u6BB5\u8BF7\u6C42\u8D85\u65F6\u6216\u8005\u8D44\u6E90\u4E0D\u5B58\u5728" }, mse: { code: 2, msg: "\u6D41\u8FFD\u52A0\u9519\u8BEF", remark: "\u8FFD\u52A0\u6D41\u7684\u65F6\u5019\u5982\u679C\u7C7B\u578B\u4E0D\u5BF9\u3001\u65E0\u6CD5\u88AB\u6B63\u786E\u89E3\u7801\u5219\u4F1A\u89E6\u53D1\u6B64\u7C7B\u9519\u8BEF" }, parse: { code: 3, msg: "\u89E3\u6790\u9519\u8BEF", remark: "mp4\u3001hls\u3001flv\u6211\u4EEC\u90FD\u662F\u4F7F\u7528js\u8FDB\u884C\u683C\u5F0F\u89E3\u6790\uFF0C\u5982\u679C\u89E3\u6790\u5931\u8D25\u5219\u4F1A\u89E6\u53D1\u6B64\u7C7B\u9519\u8BEF" }, format: { code: 4, msg: "\u683C\u5F0F\u9519\u8BEF", remark: "\u5982\u679C\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u7684\u683C\u5F0F\u5BFC\u81F4\u64AD\u653E\u9519\u8BEF" }, decoder: { code: 5, msg: "\u89E3\u7801\u9519\u8BEF", remark: "\u6D4F\u89C8\u5668\u89E3\u7801\u5F02\u5E38\u4F1A\u629B\u51FA\u6B64\u7C7B\u578B\u9519\u8BEF" }, runtime: { code: 6, msg: "\u8BED\u6CD5\u9519\u8BEF", remark: "\u64AD\u653E\u5668\u8BED\u6CD5\u9519\u8BEF" }, timeout: { code: 7, msg: "\u64AD\u653E\u8D85\u65F6", remark: "\u64AD\u653E\u8FC7\u7A0B\u4E2D\u65E0\u6CD5\u6B63\u5E38\u8BF7\u6C42\u4E0B\u4E00\u4E2A\u5206\u6BB5\u5BFC\u81F4\u64AD\u653E\u4E2D\u65AD" }, other: { code: 8, msg: "\u5176\u4ED6\u9519\u8BEF", remark: "\u4E0D\u53EF\u77E5\u7684\u9519\u8BEF\u6216\u88AB\u5FFD\u7565\u7684\u9519\u8BEF\u7C7B\u578B" } };
      t.default = function e2(t2, n2, s, a, l, c, u, d) {
        var f = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : { line: "", handle: "", msg: "", version: "" }, p = arguments[9], h = arguments[10];
        r(this, e2);
        var v = {};
        if (arguments.length > 1)
          v.playerVersion = i.version, v.errorType = t2, v.domain = document.domain, v.duration = s, v.currentTime = n2, v.networkState = a, v.readyState = l, v.currentSrc = u, v.src = c, v.ended = d, v.errd = f, v.ex = (o[t2] || {}).msg, v.errorCode = p, v.mediaError = h;
        else {
          var g = arguments[0];
          Object.keys(g).map(function(e3) {
            v[e3] = g[e3];
          }), v.ex = (g.type && o[g.type] || {}).msg;
        }
        return v;
      }, e.exports = t.default;
    }, function(e, t, n) {
      e.exports = function(e2) {
        return null != e2;
      };
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e2(e3, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var i2 = t2[n2];
            i2.enumerable = i2.enumerable || false, i2.configurable = true, "value" in i2 && (i2.writable = true), Object.defineProperty(e3, i2.key, i2);
          }
        }
        return function(t2, n2, i2) {
          return n2 && e2(t2.prototype, n2), i2 && e2(t2, i2), t2;
        };
      }();
      var r = function() {
        function e2(t2) {
          !function(e3, t3) {
            if (!(e3 instanceof t3))
              throw new TypeError("Cannot call a class as a function");
          }(this, e2), this.bufferedList = t2;
        }
        return i(e2, [{ key: "start", value: function(e3) {
          return this.bufferedList[e3].start;
        } }, { key: "end", value: function(e3) {
          return this.bufferedList[e3].end;
        } }, { key: "length", get: function() {
          return this.bufferedList.length;
        } }]), e2;
      }();
      t.default = r, e.exports = t.default;
    }, function(e) {
      e.exports = JSON.parse('{"version":"2.32.6"}');
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = n(3).Env.getInstance();
      t.default = i, e.exports = t.default;
    }, function(e, t, n) {
      e.exports = n(10);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(11), o = (i = r) && i.__esModule ? i : { default: i };
      t.default = o.default, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e2(e3, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var i2 = t2[n2];
            i2.enumerable = i2.enumerable || false, i2.configurable = true, "value" in i2 && (i2.writable = true), Object.defineProperty(e3, i2.key, i2);
          }
        }
        return function(t2, n2, i2) {
          return n2 && e2(t2.prototype, n2), i2 && e2(t2, i2), t2;
        };
      }(), r = k(n(12)), o = k(n(41)), s = k(n(43)), a = k(n(46)), l = k(n(50)), c = k(n(52)), u = k(n(56)), d = k(n(61)), f = k(n(63)), p = k(n(65)), h = k(n(67)), v = k(n(69)), g = k(n(70)), y = k(n(71)), m = k(n(72)), x = k(n(75)), w = k(n(79)), b = k(n(81)), E = k(n(86)), _ = k(n(87));
      n(89);
      var T = k(n(0)), C = k(n(8));
      function k(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      var S = T.default.addClass, P = T.default.hasClass, L = T.default.removeClass, O = 0, A = void 0, R = true, I = true;
      function M(e2, t2) {
        this.config.closeVideoPreventDefault || e2.preventDefault(), this.config.closeVideoStopPropagation || e2.stopPropagation();
        var n2 = this;
        if (P(this.root, "xgplayer-inactive") || void 0 === A ? (I = true, n2.emit("focus")) : (I = false, L(n2.root, "xgplayer-show-control"), n2.emit("blur")), !n2.config.closeVideoTouch && !n2.isTouchMove) {
          var i2 = function() {
            A = setTimeout(function() {
              if (P(n2.root, "xgplayer-nostart"))
                return false;
              if (!n2.ended)
                if (n2.paused)
                  if (n2.showControlBar) {
                    var e3 = n2.play();
                    void 0 !== e3 && e3 && e3.catch(function(e4) {
                    });
                  } else
                    S(n2.root, "xgplayer-show-control"), S(n2.root, "xgplayer-pause");
                else
                  n2.showControlBar ? n2.pause() : P(n2.root, "xgplayer-playbackrate-active") ? L(n2.root, "xgplayer-playbackrate-active") : I && n2.onOnlyClick();
              O = 0;
            }, 200);
          };
          n2.config.closeVideoClick || (O++, A && clearTimeout(A), 1 === O ? n2.config.enableVideoDbltouch ? clickedTime.first = new Date() : i2() : 2 === O && n2.config.enableVideoDbltouch ? (clickedTime.second = new Date(), Math.abs(clickedTime.first - clickedTime.second) < 400 ? i2() : (clickedTime.first = new Date(), O = 1)) : O = 0);
        }
      }
      var D = function(e2) {
        function t2(e3) {
          !function(e4, t3) {
            if (!(e4 instanceof t3))
              throw new TypeError("Cannot call a class as a function");
          }(this, t2);
          var n2 = false;
          R && (R = false, e3.autoplay && (C.default.isWx || C.default.isWxMini ? n2 = true : C.default.isIOS && !C.default.isAppWebView && (e3.muted = true)));
          var i2 = function(e4, t3) {
            if (!e4)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t3 || "object" != typeof t3 && "function" != typeof t3 ? e4 : t3;
          }(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e3));
          return n2 && window.wx && window.wx.ready(function() {
            i2.start();
          }), i2.showControlBar = false, setTimeout(function() {
            i2.onElementTouchend = M.bind(i2);
          }, 0), i2;
        }
        return function(e3, t3) {
          if ("function" != typeof t3 && null !== t3)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t3);
          e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t3 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t3) : e3.__proto__ = t3);
        }(t2, e2), i(t2, [{ key: "onFocus", value: function() {
          var e3 = this;
          P(this.root, "xgplayer-playbackrate-active") || (P(this.root, "xgplayer-inactive") && (this.showControlBar = false, e3.emit("controlShow")), L(this.root, "xgplayer-inactive"), e3.userTimer && clearTimeout(e3.userTimer), e3.userTimer = setTimeout(function() {
            L(e3.root, "xgplayer-show-control"), e3.emit("blur");
          }, e3.config.inactive));
        } }, { key: "onBlur", value: function() {
          this.ended || this.config.closeInactive || (P(this.root, "xgplayer-inactive") || (this.showControlBar = false, this.emit("controlHide")), S(this.root, "xgplayer-inactive"));
        } }, { key: "onPause", value: function() {
          S(this.root, "xgplayer-pause"), this.userTimer && clearTimeout(this.userTimer), this.emit("focus");
        } }, { key: "onOnlyClick", value: function() {
          P(this.root, "xgplayer-show-control") || (S(this.root, "xgplayer-show-control"), this.emit("focus"));
        } }, { key: "autoplay", set: function(e3) {
          this.video && (this.video.autoplay = e3), this.config.autoplay = e3;
        }, get: function() {
          return this.config.autoplay || false;
        } }]), t2;
      }(r.default), N = [o.default, s.default, a.default, l.default, c.default, d.default, f.default, p.default, h.default, m.default, x.default, v.default, g.default, w.default, y.default, u.default, b.default, E.default, _.default];
      D.useAll(N), t.default = D, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = a(n(13)), r = a(n(38)), o = a(n(39)), s = a(n(40));
      function a(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      [r.default, o.default, s.default].forEach(function(e2) {
        i.default.install(e2.name, e2.method);
      }), t.default = i.default, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e2(e3, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var i2 = t2[n2];
            i2.enumerable = i2.enumerable || false, i2.configurable = true, "value" in i2 && (i2.writable = true), Object.defineProperty(e3, i2.key, i2);
          }
        }
        return function(t2, n2, i2) {
          return n2 && e2(t2.prototype, n2), i2 && e2(t2, i2), t2;
        };
      }(), r = function e2(t2, n2, i2) {
        null === t2 && (t2 = Function.prototype);
        var r2 = Object.getOwnPropertyDescriptor(t2, n2);
        if (void 0 === r2) {
          var o2 = Object.getPrototypeOf(t2);
          return null === o2 ? void 0 : e2(o2, n2, i2);
        }
        if ("value" in r2)
          return r2.value;
        var s2 = r2.get;
        return void 0 !== s2 ? s2.call(i2) : void 0;
      }, o = p(n(14)), s = n(0), a = p(n(2)), l = p(n(6)), c = p(n(4)), u = p(n(34)), d = p(n(37)), f = n(7);
      function p(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      function h(e2, t2) {
        if (!e2)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t2 || "object" != typeof t2 && "function" != typeof t2 ? e2 : t2;
      }
      var v = function(e2) {
        function t2(e3) {
          !function(e4, t3) {
            if (!(e4 instanceof t3))
              throw new TypeError("Cannot call a class as a function");
          }(this, t2);
          var n2 = h(this, (t2.__proto__ || Object.getPrototypeOf(t2)).call(this, e3));
          if (n2.config = (0, s.deepCopy)({ width: 600, height: 337.5, ignores: [], whitelist: [], lang: (document.documentElement.getAttribute("lang") || navigator.language || "zh-cn").toLocaleLowerCase(), inactive: 3e3, volume: 0.6, controls: true, controlsList: ["nodownload"] }, e3), n2.version = f.version, n2.userTimer = null, n2.waitTimer = null, n2.history = [], n2.isProgressMoving = false, n2.root = (0, s.findDom)(document, "#" + n2.config.id), n2.controls = (0, s.createDom)("xg-controls", "", { unselectable: "on", onselectstart: "return false" }, "xgplayer-controls"), n2.config.isShowControl && (n2.controls.style.display = "none"), !n2.root) {
            var i2 = n2.config.el;
            if (!i2 || 1 !== i2.nodeType)
              return n2.emit("error", new c.default({ type: "use", errd: { line: 45, handle: "Constructor", msg: "container id can't be empty" }, vid: n2.config.vid })), console.error("container id can't be empty"), h(n2, false);
            n2.root = i2;
          }
          if ((0, s.addClass)(n2.root, "xgplayer xgplayer-" + a.default.device + " xgplayer-nostart xgplayer-pause " + (n2.config.controls ? "" : "xgplayer-no-controls")), n2.root.appendChild(n2.controls), n2.config.fluid ? (n2.root.style["max-width"] = "100%", n2.root.style.width = "100%", n2.root.style.height = "0", n2.root.style["padding-top"] = 100 * n2.config.height / n2.config.width + "%", n2.video.style.position = "absolute", n2.video.style.top = "0", n2.video.style.left = "0") : (n2.config.width && ("number" != typeof n2.config.width ? n2.root.style.width = n2.config.width : n2.root.style.width = n2.config.width + "px"), n2.config.height && ("number" != typeof n2.config.height ? n2.root.style.height = n2.config.height : n2.root.style.height = n2.config.height + "px")), n2.config.execBeforePluginsCall && n2.config.execBeforePluginsCall.forEach(function(e4) {
            e4.call(n2, n2);
          }), n2.config.closeI18n || t2.install(d.default.name, d.default.method), n2.config.controlStyle && "String" === (0, s.typeOf)(n2.config.controlStyle)) {
            var r2 = n2;
            fetch(r2.config.controlStyle, { method: "GET", headers: { Accept: "application/json" } }).then(function(e4) {
              e4.ok && e4.json().then(function(e5) {
                for (var t3 in e5)
                  e5.hasOwnProperty(t3) && (r2.config[t3] = e5[t3]);
                r2.pluginsCall();
              });
            }).catch(function(e4) {
              console.log("Fetch\u9519\u8BEF:" + e4);
            });
          } else
            n2.pluginsCall();
          n2.config.controlPlugins && t2.controlsRun(n2.config.controlPlugins, n2), n2.ev.forEach(function(e4) {
            var t3 = Object.keys(e4)[0], i3 = n2[e4[t3]];
            i3 && n2.on(t3, i3);
          }), ["focus", "blur"].forEach(function(e4) {
            n2.on(e4, n2["on" + e4.charAt(0).toUpperCase() + e4.slice(1)]);
          });
          var o2 = n2;
          return n2.mousemoveFunc = function() {
            o2.emit("focus"), o2.config.closeFocusVideoFocus || o2.video.focus();
          }, n2.root.addEventListener("mousemove", n2.mousemoveFunc), n2.playFunc = function() {
            o2.emit("focus"), o2.config.closePlayVideoFocus || o2.video.focus();
          }, o2.once("play", n2.playFunc), n2.getVideoSize = function() {
            if (this.video.videoWidth && this.video.videoHeight) {
              var e4 = o2.root.getBoundingClientRect();
              "auto" === o2.config.fitVideoSize ? e4.width / e4.height > this.video.videoWidth / this.video.videoHeight ? o2.root.style.height = this.video.videoHeight / this.video.videoWidth * e4.width + "px" : o2.root.style.width = this.video.videoWidth / this.video.videoHeight * e4.height + "px" : "fixWidth" === o2.config.fitVideoSize ? o2.root.style.height = this.video.videoHeight / this.video.videoWidth * e4.width + "px" : "fixHeight" === o2.config.fitVideoSize && (o2.root.style.width = this.video.videoWidth / this.video.videoHeight * e4.height + "px");
            }
          }, o2.once("loadeddata", n2.getVideoSize), setTimeout(function() {
            n2.emit("ready"), n2.isReady = true;
          }, 0), n2.config.videoInit && (0, s.hasClass)(n2.root, "xgplayer-nostart") && n2.start(), o2.config.rotate && (o2.on("requestFullscreen", n2.updateRotateDeg), o2.on("exitFullscreen", n2.updateRotateDeg)), o2.once("destroy", function e4() {
            o2.root.removeEventListener("mousemove", o2.mousemoveFunc), o2.off("destroy", e4);
          }), n2;
        }
        return function(e3, t3) {
          if ("function" != typeof t3 && null !== t3)
            throw new TypeError("Super expression must either be null or a function, not " + typeof t3);
          e3.prototype = Object.create(t3 && t3.prototype, { constructor: { value: e3, enumerable: false, writable: true, configurable: true } }), t3 && (Object.setPrototypeOf ? Object.setPrototypeOf(e3, t3) : e3.__proto__ = t3);
        }(t2, e2), i(t2, [{ key: "attachVideo", value: function() {
          var e3 = this;
          this.video && 1 === this.video.nodeType && this.root.insertBefore(this.video, this.root.firstChild), setTimeout(function() {
            e3.emit("complete"), e3.danmu && "function" == typeof e3.danmu.resize && e3.danmu.resize();
          }, 1);
        } }, { key: "start", value: function() {
          var e3 = this, t3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.config.url;
          if (this.video) {
            var n2 = this;
            t3 && "" !== t3 ? (this.canPlayFunc = function() {
              n2.off("canplay", n2.canPlayFunc);
              var e4 = n2.video.play();
              void 0 !== e4 && e4 && e4.then(function() {
                n2.emit("autoplay started");
              }).catch(function() {
                n2.emit("autoplay was prevented"), (0, s.addClass)(n2.root, "xgplayer-is-autoplay");
              });
            }, "Array" !== (0, s.typeOf)(t3) ? "String" === (0, s.typeOf)(t3) && t3.indexOf("blob:") > -1 && t3 === this.video.src || (this.video.src = t3) : t3.forEach(function(t4) {
              e3.video.appendChild((0, s.createDom)("source", "", { src: "" + t4.src, type: "" + (t4.type || "") }));
            }), this.config.autoplay && (a.default.os.isPhone ? this.canPlayFunc() : this.on("canplay", this.canPlayFunc)), this.config.disableStartLoad || this.video.load(), this.attachVideo()) : this.emit("urlNull");
          }
        } }, { key: "reload", value: function() {
          this.video.load(), this.reloadFunc = function() {
            var e3 = this.play();
            void 0 !== e3 && e3 && e3.catch(function(e4) {
            });
          }, this.once("loadeddata", this.reloadFunc);
        } }, { key: "destroy", value: function() {
          var e3 = this, n2 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], i2 = this;
          for (var o2 in clearInterval(this.bulletResizeTimer), this._interval)
            clearInterval(this._interval[o2]), this._interval[o2] = null;
          function s2() {
            if (this.emit("destroy"), this.video.removeAttribute("src"), this.video.load(), n2) {
              this.root.innerHTML = "";
              var e4 = this.root.className.split(" ");
              e4.length > 0 ? this.root.className = e4.filter(function(e5) {
                return e5.indexOf("xgplayer") < 0;
              }).join(" ") : this.root.className = "";
            }
            for (var t3 in this)
              delete this[t3];
            (0, u.default)(this);
          }
          this.checkTimer && clearInterval(this.checkTimer), this.waitTimer && clearTimeout(this.waitTimer), this.ev.forEach(function(t3) {
            var n3 = Object.keys(t3)[0], i3 = e3[t3[n3]];
            i3 && e3.off(n3, i3);
          }), this.loadeddataFunc && this.off("loadeddata", this.loadeddataFunc), this.reloadFunc && this.off("loadeddata", this.reloadFunc), this.replayFunc && this.off("play", this.replayFunc), this.playFunc && this.off("play", this.playFunc), this.getVideoSize && this.off("loadeddata", this.getVideoSize), ["focus", "blur"].forEach(function(t3) {
            e3.off(t3, e3["on" + t3.charAt(0).toUpperCase() + t3.slice(1)]);
          }), this.config.keyShortcut && "on" !== this.config.keyShortcut || ["video", "controls"].forEach(function(t3) {
            e3[t3] && e3[t3].removeEventListener("keydown", function(e4) {
              i2.onKeydown(e4, i2);
            });
          }), s2.call(this), r(t2.prototype.__proto__ || Object.getPrototypeOf(t2.prototype), "destroy", this).call(this);
        } }, { key: "replay", value: function() {
          var e3 = this._replay;
          if ((0, s.removeClass)(this.root, "xgplayer-ended"), a.default.browser.indexOf("ie") > -1 && (this.emit("play"), this.emit("playing")), e3 && e3 instanceof Function)
            e3();
          else {
            this.currentTime = 0;
            var t3 = this.play();
            void 0 !== t3 && t3 && t3.catch(function(e4) {
            });
          }
        } }, { key: "userGestureTrigEvent", value: function(e3, t3) {
          var n2 = this, i2 = function(e4, t4) {
            n2.emit(e4, t4);
          };
          this.config.userGestureEventMiddleware && "function" == typeof this.config.userGestureEventMiddleware[e3] ? this.config.userGestureEventMiddleware[e3].call(this, this, e3, t3, i2) : i2.call(this, e3, t3);
        } }, { key: "pluginsCall", value: function() {
          var e3 = this;
          t2.plugins.s_i18n && t2.plugins.s_i18n.call(this, this);
          var n2 = this;
          if (t2.plugins) {
            var i2 = this.config.ignores;
            Object.keys(t2.plugins).forEach(function(r2) {
              var o2 = t2.plugins[r2];
              o2 && "function" == typeof o2 ? i2.some(function(e4) {
                return r2 === e4 || r2 === "s_" + e4;
              }) || "s_i18n" === r2 || (["pc", "tablet", "mobile"].some(function(e4) {
                return e4 === r2;
              }) ? r2 === a.default.device && setTimeout(function() {
                n2.video && o2.call(n2, n2);
              }, 0) : o2.call(e3, e3)) : console.warn("plugin name", r2, "is invalid");
            });
          }
        } }, { key: "onFocus", value: function() {
          var e3 = this;
          (0, s.hasClass)(this.root, "xgplayer-inactive") && e3.emit("controlShow"), (0, s.removeClass)(this.root, "xgplayer-inactive"), e3.userTimer && clearTimeout(e3.userTimer), e3.userTimer = setTimeout(function() {
            e3.emit("blur");
          }, e3.config.inactive);
        } }, { key: "onBlur", value: function() {
          !this.config.enablePausedInactive && this.paused || this.ended || this.config.closeInactive || ((0, s.hasClass)(this.root, "xgplayer-inactive") || this.emit("controlHide"), (0, s.addClass)(this.root, "xgplayer-inactive"));
        } }, { key: "onPlay", value: function() {
          (0, s.addClass)(this.root, "xgplayer-isloading"), (0, s.addClass)(this.root, "xgplayer-playing"), (0, s.removeClass)(this.root, "xgplayer-pause");
        } }, { key: "onPause", value: function() {
          (0, s.addClass)(this.root, "xgplayer-pause"), this.userTimer && clearTimeout(this.userTimer), this.emit("focus");
        } }, { key: "onEnded", value: function() {
          (0, s.addClass)(this.root, "xgplayer-ended"), (0, s.removeClass)(this.root, "xgplayer-playing");
        } }, { key: "onSeeking", value: function() {
          this.isSeeking = true, this.onWaiting();
        } }, { key: "onSeeked", value: function() {
          var e3 = this;
          this.once("timeupdate", function() {
            e3.isSeeking = false;
          }), this.waitTimer && clearTimeout(this.waitTimer), (0, s.removeClass)(this.root, "xgplayer-isloading");
        } }, { key: "onWaiting", value: function() {
          var e3 = this;
          e3.waitTimer && clearTimeout(e3.waitTimer), e3.checkTimer && (clearInterval(e3.checkTimer), e3.checkTimer = null);
          var t3 = e3.currentTime;
          e3.waitTimer = setTimeout(function() {
            (0, s.addClass)(e3.root, "xgplayer-isloading"), e3.checkTimer = setInterval(function() {
              e3.currentTime !== t3 && ((0, s.removeClass)(e3.root, "xgplayer-isloading"), clearInterval(e3.checkTimer), e3.checkTimer = null);
            }, 1e3);
          }, 500);
        } }, { key: "onPlaying", value: function() {
          this.paused || (this.isSeeking = false, this.waitTimer && clearTimeout(this.waitTimer), (0, s.removeClass)(this.root, "xgplayer-isloading xgplayer-nostart xgplayer-pause xgplayer-ended xgplayer-is-error xgplayer-replay"), (0, s.addClass)(this.root, "xgplayer-playing"));
        } }], [{ key: "install", value: function(e3, n2) {
          (0, s.checkIsBrowser)() && (t2.plugins || (t2.plugins = {}), t2.plugins[e3] || (t2.plugins[e3] = n2));
        } }, { key: "installAll", value: function(e3) {
          for (var n2 = 0; n2 < e3.length; n2++)
            t2.install(e3[n2].name, e3[n2].method);
        } }, { key: "use", value: function(e3, n2) {
          t2.plugins || (t2.plugins = {}), t2.plugins[e3] = n2;
        } }, { key: "useAll", value: function(e3) {
          for (var n2 in e3)
            t2.use(e3[n2].name, e3[n2].method);
        } }, { key: "controlsRun", value: function(e3, t3) {
          e3.forEach(function(e4) {
            e4.method.call(t3);
          });
        } }]), t2;
      }(o.default);
      v.util = s.util, v.sniffer = a.default, v.Errors = c.default, v.XgplayerTimeRange = l.default, t.default = v, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e2(e3, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var i2 = t2[n2];
            i2.enumerable = i2.enumerable || false, i2.configurable = true, "value" in i2 && (i2.writable = true), Object.defineProperty(e3, i2.key, i2);
          }
        }
        return function(t2, n2, i2) {
          return n2 && e2(t2.prototype, n2), i2 && e2(t2, i2), t2;
        };
      }(), r = a(n(15)), o = n(0), s = a(n(4));
      function a(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      var l = function() {
        function e2(t2) {
          var n2 = this;
          !function(e3, t3) {
            if (!(e3 instanceof t3))
              throw new TypeError("Cannot call a class as a function");
          }(this, e2), this._hasStart = false, this.videoConfig = { controls: !!t2.isShowControl, autoplay: t2.autoplay, playsinline: t2.playsinline, "webkit-playsinline": t2.playsinline, "x5-playsinline": t2.playsinline, "x5-video-player-type": t2["x5-video-player-type"] || t2.x5VideoPlayerType, "x5-video-player-fullscreen": t2["x5-video-player-fullscreen"] || t2.x5VideoPlayerFullscreen, "x5-video-orientation": t2["x5-video-orientation"] || t2.x5VideoOrientation, airplay: t2.airplay, "webkit-airplay": t2.airplay, tabindex: 2, mediaType: t2.mediaType || "video" }, t2.muted && (this.videoConfig.muted = "muted"), t2.loop && (this.videoConfig.loop = "loop");
          var i2 = "";
          if (this.textTrackShowDefault = true, t2.nativeTextTrack && Array.isArray(t2.nativeTextTrack) && (t2.nativeTextTrack.length > 0 && !t2.nativeTextTrack.some(function(e3) {
            return e3.default;
          }) && (t2.nativeTextTrack[0].default = true, this.textTrackShowDefault = false), t2.nativeTextTrack.some(function(e3) {
            if (e3.src && e3.label && e3.default)
              return i2 += '<track src="' + e3.src + '" ', e3.kind && (i2 += 'kind="' + e3.kind + '" '), i2 += 'label="' + e3.label + '" ', e3.srclang && (i2 += 'srclang="' + e3.srclang + '" '), i2 += (e3.default ? "default" : "") + ">", true;
          }), this.videoConfig.crossorigin = "anonymous"), t2.textTrackStyle) {
            var s2 = document.createElement("style");
            this.textTrackStyle = s2, document.head.appendChild(s2);
            var a2 = "";
            for (var l2 in t2.textTrackStyle)
              a2 += l2 + ": " + t2.textTrackStyle[l2] + ";";
            var c = t2.id ? "#" + t2.id : t2.el.id ? "#" + t2.el.id : "." + t2.el.className;
            s2.sheet.insertRule ? s2.sheet.insertRule(c + " video::cue { " + a2 + " }", 0) : s2.sheet.addRule && s2.sheet.addRule(c + " video::cue", a2);
          }
          var u = t2.el ? t2.el : (0, o.findDom)(document, "#" + t2.id), d = this.constructor.XgVideoProxy;
          (d && this.videoConfig.mediaType === d.mediaType ? this.video = new d(u, t2) : this.video = (0, o.createDom)(this.videoConfig.mediaType, i2, this.videoConfig, ""), t2.videoStyle && Object.keys(t2.videoStyle).forEach(function(e3) {
            (0, o.setStyle)(n2.video, e3, t2.videoStyle[e3]);
          }), !this.textTrackShowDefault && i2) && (this.video.getElementsByTagName("Track")[0].track.mode = "hidden");
          t2.autoplay && (this.video.autoplay = true, t2.autoplayMuted && (this.video.muted = true)), this.ev = ["play", "playing", "pause", "ended", "error", "seeking", "seeked", "progress", "timeupdate", "waiting", "canplay", "canplaythrough", "durationchange", "volumechange", "ratechange", "loadedmetadata", "loadeddata", "loadstart"].map(function(e3) {
            return t3 = {}, n3 = e3, i3 = "on" + e3.charAt(0).toUpperCase() + e3.slice(1), n3 in t3 ? Object.defineProperty(t3, n3, { value: i3, enumerable: true, configurable: true, writable: true }) : t3[n3] = i3, t3;
            var t3, n3, i3;
          }), (0, r.default)(this), this._interval = {};
          var f = "0,0", p = this, h = function(e3) {
            n2 && ("play" === e3 ? n2.hasStart = true : "canplay" === e3 ? (0, o.removeClass)(n2.root, "xgplayer-is-enter") : "waiting" === e3 ? n2.inWaitingStart = new Date().getTime() : "playing" === e3 && ((0, o.removeClass)(n2.root, "xgplayer-is-enter"), n2.inWaitingStart && (n2.inWaitingStart = void 0)), "error" === e3 ? n2._onError(e3) : n2.emit(e3, n2), n2.hasOwnProperty("_interval") && (["ended", "error", "timeupdate"].indexOf(e3) < 0 ? ((0, o._clearInterval)(n2, "bufferedChange"), (0, o._setInterval)(n2, "bufferedChange", function() {
              if (this.video && this.video.buffered) {
                for (var e4 = [], t3 = 0, n3 = this.video.buffered.length; t3 < n3; t3++)
                  e4.push([this.video.buffered.start(t3), this.video.buffered.end(t3)]);
                e4.toString() !== f && (f = e4.toString(), this.emit("bufferedChange", e4));
              }
            }, 200)) : "timeupdate" !== e3 && (0, o._clearInterval)(n2, "bufferedChange")));
          }, v = function(e3) {
            t2.videoEventMiddleware && "function" == typeof t2.videoEventMiddleware[e3] ? t2.videoEventMiddleware[e3].call(n2, n2, e3, h) : h.call(n2, e3);
          };
          this.ev.forEach(function(e3) {
            p.evItem = Object.keys(e3)[0];
            var t3 = Object.keys(e3)[0];
            p.video.addEventListener(Object.keys(e3)[0], v.bind(p, t3));
          });
        }
        return i(e2, [{ key: "_onError", value: function(e3) {
          this.video && this.video.error && this.emit(e3, new s.default("other", this.currentTime, this.duration, this.networkState, this.readyState, this.currentSrc, this.src, this.ended, { line: 162, msg: this.error, handle: "Constructor" }, this.video.error.code, this.video.error));
        } }, { key: "destroy", value: function() {
          this.textTrackStyle && this.textTrackStyle.parentNode.removeChild(this.textTrackStyle);
        } }, { key: "play", value: function() {
          return this.video.play();
        } }, { key: "pause", value: function() {
          this.video.pause();
        } }, { key: "canPlayType", value: function(e3) {
          return this.video.canPlayType(e3);
        } }, { key: "getBufferedRange", value: function(e3) {
          var t2 = [0, 0], n2 = this.video;
          e3 || (e3 = n2.buffered);
          var i2 = n2.currentTime;
          if (e3)
            for (var r2 = 0, o2 = e3.length; r2 < o2 && (t2[0] = e3.start(r2), t2[1] = e3.end(r2), !(t2[0] <= i2 && i2 <= t2[1])); r2++)
              ;
          return t2[0] - i2 <= 0 && i2 - t2[1] <= 0 ? t2 : [0, 0];
        } }, { key: "proxyOn", value: function(e3, t2) {
          (0, o.on)(this, e3, t2, "destroy");
        } }, { key: "proxyOnce", value: function(e3, t2) {
          (0, o.once)(this, e3, t2, "destroy");
        } }, { key: "hasStart", get: function() {
          return this._hasStart;
        }, set: function(e3) {
          "boolean" != typeof e3 || true !== e3 || this._hasStart || (this._hasStart = true, this.emit("hasstart"));
        } }, { key: "autoplay", set: function(e3) {
          this.video && (this.video.autoplay = e3);
        }, get: function() {
          return !!this.video && this.video.autoplay;
        } }, { key: "buffered", get: function() {
          return this.video ? this.video.buffered : void 0;
        } }, { key: "buffered2", get: function() {
          return (0, o.getBuffered2)(this.video.buffered);
        } }, { key: "crossOrigin", get: function() {
          return !!this.video && this.video.crossOrigin;
        }, set: function(e3) {
          this.video && (this.video.crossOrigin = e3);
        } }, { key: "currentSrc", get: function() {
          return this.video ? this.video.currentSrc : void 0;
        } }, { key: "currentTime", get: function() {
          return this.video && this.video.currentTime || 0;
        }, set: function(e3) {
          var t2 = this;
          ("function" != typeof isFinite || isFinite(e3)) && ((0, o.hasClass)(this.root, "xgplayer-ended") ? (this.once("playing", function() {
            t2.video.currentTime = e3;
          }), this.replay()) : this.video.currentTime = e3, this.emit("currentTimeChange", e3));
        } }, { key: "defaultMuted", get: function() {
          return !!this.video && this.video.defaultMuted;
        }, set: function(e3) {
          this.video && (this.video.defaultMuted = e3);
        } }, { key: "duration", get: function() {
          return this.config && this.config.duration ? this.video ? Math.min(this.config.duration, this.video.duration) : this.config.duration : this.video ? this.video.duration : null;
        } }, { key: "ended", get: function() {
          return !this.video || (this.video.ended || false);
        } }, { key: "error", get: function() {
          var e3 = this.video.error;
          if (!e3)
            return null;
          var t2 = [{ en: "MEDIA_ERR_ABORTED", cn: "\u53D6\u56DE\u8FC7\u7A0B\u88AB\u7528\u6237\u4E2D\u6B62" }, { en: "MEDIA_ERR_NETWORK", cn: "\u5F53\u4E0B\u8F7D\u65F6\u53D1\u751F\u9519\u8BEF" }, { en: "MEDIA_ERR_DECODE", cn: "\u5F53\u89E3\u7801\u65F6\u53D1\u751F\u9519\u8BEF" }, { en: "MEDIA_ERR_SRC_NOT_SUPPORTED", cn: "\u4E0D\u652F\u6301\u97F3\u9891/\u89C6\u9891" }];
          return this.lang ? this.lang[t2[e3.code - 1].en] : t2[e3.code - 1].en;
        } }, { key: "loop", get: function() {
          return !!this.video && this.video.loop;
        }, set: function(e3) {
          this.video && (this.video.loop = e3);
        } }, { key: "muted", get: function() {
          return !!this.video && this.video.muted;
        }, set: function(e3) {
          this.video && (this.video.muted = e3);
        } }, { key: "networkState", get: function() {
          var e3 = [{ en: "NETWORK_EMPTY", cn: "\u97F3\u9891/\u89C6\u9891\u5C1A\u672A\u521D\u59CB\u5316" }, { en: "NETWORK_IDLE", cn: "\u97F3\u9891/\u89C6\u9891\u662F\u6D3B\u52A8\u7684\u4E14\u5DF2\u9009\u53D6\u8D44\u6E90\uFF0C\u4F46\u5E76\u672A\u4F7F\u7528\u7F51\u7EDC" }, { en: "NETWORK_LOADING", cn: "\u6D4F\u89C8\u5668\u6B63\u5728\u4E0B\u8F7D\u6570\u636E" }, { en: "NETWORK_NO_SOURCE", cn: "\u672A\u627E\u5230\u97F3\u9891/\u89C6\u9891\u6765\u6E90" }];
          return this.lang ? this.lang[e3[this.video.networkState].en] : e3[this.video.networkState].en;
        } }, { key: "paused", get: function() {
          return (0, o.hasClass)(this.root, "xgplayer-pause");
        } }, { key: "playbackRate", get: function() {
          return this.video ? this.video.playbackRate : 1;
        }, set: function(e3) {
          this.video && (this.video.playbackRate = e3);
        } }, { key: "played", get: function() {
          return this.video ? this.video.played : void 0;
        } }, { key: "preload", get: function() {
          return !!this.video && this.video.preload;
        }, set: function(e3) {
          this.video && (this.video.preload = e3);
        } }, { key: "readyState", get: function() {
          var e3 = [{ en: "HAVE_NOTHING", cn: "\u6CA1\u6709\u5173\u4E8E\u97F3\u9891/\u89C6\u9891\u662F\u5426\u5C31\u7EEA\u7684\u4FE1\u606F" }, { en: "HAVE_METADATA", cn: "\u5173\u4E8E\u97F3\u9891/\u89C6\u9891\u5C31\u7EEA\u7684\u5143\u6570\u636E" }, { en: "HAVE_CURRENT_DATA", cn: "\u5173\u4E8E\u5F53\u524D\u64AD\u653E\u4F4D\u7F6E\u7684\u6570\u636E\u662F\u53EF\u7528\u7684\uFF0C\u4F46\u6CA1\u6709\u8DB3\u591F\u7684\u6570\u636E\u6765\u64AD\u653E\u4E0B\u4E00\u5E27/\u6BEB\u79D2" }, { en: "HAVE_FUTURE_DATA", cn: "\u5F53\u524D\u53CA\u81F3\u5C11\u4E0B\u4E00\u5E27\u7684\u6570\u636E\u662F\u53EF\u7528\u7684" }, { en: "HAVE_ENOUGH_DATA", cn: "\u53EF\u7528\u6570\u636E\u8DB3\u4EE5\u5F00\u59CB\u64AD\u653E" }];
          return this.lang ? this.lang[e3[this.video.readyState].en] : e3[this.video.readyState];
        } }, { key: "seekable", get: function() {
          return !!this.video && this.video.seekable;
        } }, { key: "seeking", get: function() {
          return !!this.video && this.video.seeking;
        } }, { key: "src", get: function() {
          return this.video ? this.video.src : void 0;
        }, set: function(e3) {
          (0, o.hasClass)(this.root, "xgplayer-ended") || this.emit("urlchange", this.video.src), (0, o.removeClass)(this.root, "xgplayer-ended xgplayer-is-replay xgplayer-is-error"), this.video.pause(), this.emit("pause"), this.video.src = e3, this.emit("srcChange");
        } }, { key: "poster", set: function(e3) {
          var t2 = (0, o.findDom)(this.root, ".xgplayer-poster");
          t2 && (t2.style.backgroundImage = "url(" + e3 + ")");
        } }, { key: "volume", get: function() {
          return this.video ? this.video.volume : 1;
        }, set: function(e3) {
          this.video && (this.video.volume = e3);
        } }, { key: "fullscreen", get: function() {
          return (0, o.hasClass)(this.root, "xgplayer-is-fullscreen") || (0, o.hasClass)(this.root, "xgplayer-fullscreen-active");
        } }, { key: "bullet", get: function() {
          return !!(0, o.findDom)(this.root, "xg-danmu") && (0, o.hasClass)((0, o.findDom)(this.root, "xg-danmu"), "xgplayer-has-danmu");
        } }, { key: "textTrack", get: function() {
          return (0, o.hasClass)(this.root, "xgplayer-is-textTrack");
        } }, { key: "pip", get: function() {
          return (0, o.hasClass)(this.root, "xgplayer-pip-active");
        } }, { key: "isMiniPlayer", get: function() {
          return (0, o.hasClass)(this.root, "xgplayer-miniplayer-active");
        } }]), e2;
      }();
      t.default = l, e.exports = t.default;
    }, function(e, t, n) {
      var i, r, o, s, a, l, c, u = n(16), d = n(33), f = Function.prototype.apply, p = Function.prototype.call, h = Object.create, v = Object.defineProperty, g = Object.defineProperties, y = Object.prototype.hasOwnProperty, m = { configurable: true, enumerable: false, writable: true };
      r = function(e2, t2) {
        var n2, r2;
        return d(t2), r2 = this, i.call(this, e2, n2 = function() {
          o.call(r2, e2, n2), f.call(t2, this, arguments);
        }), n2.__eeOnceListener__ = t2, this;
      }, a = { on: i = function(e2, t2) {
        var n2;
        return d(t2), y.call(this, "__ee__") ? n2 = this.__ee__ : (n2 = m.value = h(null), v(this, "__ee__", m), m.value = null), n2[e2] ? "object" == typeof n2[e2] ? n2[e2].push(t2) : n2[e2] = [n2[e2], t2] : n2[e2] = t2, this;
      }, once: r, off: o = function(e2, t2) {
        var n2, i2, r2, o2;
        if (d(t2), !y.call(this, "__ee__"))
          return this;
        if (!(n2 = this.__ee__)[e2])
          return this;
        if ("object" == typeof (i2 = n2[e2]))
          for (o2 = 0; r2 = i2[o2]; ++o2)
            r2 !== t2 && r2.__eeOnceListener__ !== t2 || (2 === i2.length ? n2[e2] = i2[o2 ? 0 : 1] : i2.splice(o2, 1));
        else
          i2 !== t2 && i2.__eeOnceListener__ !== t2 || delete n2[e2];
        return this;
      }, emit: s = function(e2) {
        var t2, n2, i2, r2, o2;
        if (y.call(this, "__ee__") && (r2 = this.__ee__[e2]))
          if ("object" == typeof r2) {
            for (n2 = arguments.length, o2 = new Array(n2 - 1), t2 = 1; t2 < n2; ++t2)
              o2[t2 - 1] = arguments[t2];
            for (r2 = r2.slice(), t2 = 0; i2 = r2[t2]; ++t2)
              f.call(i2, this, o2);
          } else
            switch (arguments.length) {
              case 1:
                p.call(r2, this);
                break;
              case 2:
                p.call(r2, this, arguments[1]);
                break;
              case 3:
                p.call(r2, this, arguments[1], arguments[2]);
                break;
              default:
                for (n2 = arguments.length, o2 = new Array(n2 - 1), t2 = 1; t2 < n2; ++t2)
                  o2[t2 - 1] = arguments[t2];
                f.call(r2, this, o2);
            }
      } }, l = { on: u(i), once: u(r), off: u(o), emit: u(s) }, c = g({}, l), e.exports = t = function(e2) {
        return null == e2 ? h(c) : g(Object(e2), l);
      }, t.methods = a;
    }, function(e, t, n) {
      var i = n(5), r = n(17), o = n(21), s = n(29), a = n(30);
      (e.exports = function(e2, t2) {
        var n2, r2, l, c, u;
        return arguments.length < 2 || "string" != typeof e2 ? (c = t2, t2 = e2, e2 = null) : c = arguments[2], i(e2) ? (n2 = a.call(e2, "c"), r2 = a.call(e2, "e"), l = a.call(e2, "w")) : (n2 = l = true, r2 = false), u = { value: t2, configurable: n2, enumerable: r2, writable: l }, c ? o(s(c), u) : u;
      }).gs = function(e2, t2, n2) {
        var l, c, u, d;
        return "string" != typeof e2 ? (u = n2, n2 = t2, t2 = e2, e2 = null) : u = arguments[3], i(t2) ? r(t2) ? i(n2) ? r(n2) || (u = n2, n2 = void 0) : n2 = void 0 : (u = t2, t2 = n2 = void 0) : t2 = void 0, i(e2) ? (l = a.call(e2, "c"), c = a.call(e2, "e")) : (l = true, c = false), d = { get: t2, set: n2, configurable: l, enumerable: c }, u ? o(s(u), d) : d;
      };
    }, function(e, t, n) {
      var i = n(18), r = /^\s*class[\s{/}]/, o = Function.prototype.toString;
      e.exports = function(e2) {
        return !!i(e2) && !r.test(o.call(e2));
      };
    }, function(e, t, n) {
      var i = n(19);
      e.exports = function(e2) {
        if ("function" != typeof e2)
          return false;
        if (!hasOwnProperty.call(e2, "length"))
          return false;
        try {
          if ("number" != typeof e2.length)
            return false;
          if ("function" != typeof e2.call)
            return false;
          if ("function" != typeof e2.apply)
            return false;
        } catch (e3) {
          return false;
        }
        return !i(e2);
      };
    }, function(e, t, n) {
      var i = n(20);
      e.exports = function(e2) {
        if (!i(e2))
          return false;
        try {
          return !!e2.constructor && e2.constructor.prototype === e2;
        } catch (e3) {
          return false;
        }
      };
    }, function(e, t, n) {
      var i = n(5), r = { object: true, function: true, undefined: true };
      e.exports = function(e2) {
        return !!i(e2) && hasOwnProperty.call(r, typeof e2);
      };
    }, function(e, t, n) {
      e.exports = n(22)() ? Object.assign : n(23);
    }, function(e, t, n) {
      e.exports = function() {
        var e2, t2 = Object.assign;
        return "function" == typeof t2 && (t2(e2 = { foo: "raz" }, { bar: "dwa" }, { trzy: "trzy" }), e2.foo + e2.bar + e2.trzy === "razdwatrzy");
      };
    }, function(e, t, n) {
      var i = n(24), r = n(28), o = Math.max;
      e.exports = function(e2, t2) {
        var n2, s, a, l = o(arguments.length, 2);
        for (e2 = Object(r(e2)), a = function(i2) {
          try {
            e2[i2] = t2[i2];
          } catch (e3) {
            n2 || (n2 = e3);
          }
        }, s = 1; s < l; ++s)
          i(t2 = arguments[s]).forEach(a);
        if (void 0 !== n2)
          throw n2;
        return e2;
      };
    }, function(e, t, n) {
      e.exports = n(25)() ? Object.keys : n(26);
    }, function(e, t, n) {
      e.exports = function() {
        try {
          return Object.keys("primitive"), true;
        } catch (e2) {
          return false;
        }
      };
    }, function(e, t, n) {
      var i = n(1), r = Object.keys;
      e.exports = function(e2) {
        return r(i(e2) ? Object(e2) : e2);
      };
    }, function(e, t, n) {
      e.exports = function() {
      };
    }, function(e, t, n) {
      var i = n(1);
      e.exports = function(e2) {
        if (!i(e2))
          throw new TypeError("Cannot use null or undefined");
        return e2;
      };
    }, function(e, t, n) {
      var i = n(1), r = Array.prototype.forEach, o = Object.create, s = function(e2, t2) {
        var n2;
        for (n2 in e2)
          t2[n2] = e2[n2];
      };
      e.exports = function(e2) {
        var t2 = o(null);
        return r.call(arguments, function(e3) {
          i(e3) && s(Object(e3), t2);
        }), t2;
      };
    }, function(e, t, n) {
      e.exports = n(31)() ? String.prototype.contains : n(32);
    }, function(e, t, n) {
      var i = "razdwatrzy";
      e.exports = function() {
        return "function" == typeof i.contains && (true === i.contains("dwa") && false === i.contains("foo"));
      };
    }, function(e, t, n) {
      var i = String.prototype.indexOf;
      e.exports = function(e2) {
        return i.call(this, e2, arguments[1]) > -1;
      };
    }, function(e, t, n) {
      e.exports = function(e2) {
        if ("function" != typeof e2)
          throw new TypeError(e2 + " is not a function");
        return e2;
      };
    }, function(e, t, n) {
      var i = n(35), r = Object.prototype.hasOwnProperty;
      e.exports = function(e2) {
        var t2, n2 = arguments[1];
        if (i(e2), void 0 === n2)
          r.call(e2, "__ee__") && delete e2.__ee__;
        else {
          if (!(t2 = r.call(e2, "__ee__") && e2.__ee__))
            return;
          t2[n2] && delete t2[n2];
        }
      };
    }, function(e, t, n) {
      var i = n(36);
      e.exports = function(e2) {
        if (!i(e2))
          throw new TypeError(e2 + " is not an Object");
        return e2;
      };
    }, function(e, t, n) {
      var i = n(1), r = { function: true, object: true };
      e.exports = function(e2) {
        return i(e2) && r[typeof e2] || false;
      };
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = n(0);
      t.default = { name: "s_i18n", method: function() {
        var e2 = this, t2 = { en: { HAVE_NOTHING: "There is no information on whether audio/video is ready", HAVE_METADATA: "Audio/video metadata is ready ", HAVE_CURRENT_DATA: "Data about the current play location is available, but there is not enough data to play the next frame/millisecond", HAVE_FUTURE_DATA: "Current and at least one frame of data is available", HAVE_ENOUGH_DATA: "The available data is sufficient to start playing", NETWORK_EMPTY: "Audio/video has not been initialized", NETWORK_IDLE: "Audio/video is active and has been selected for resources, but no network is used", NETWORK_LOADING: "The browser is downloading the data", NETWORK_NO_SOURCE: "No audio/video source was found", MEDIA_ERR_ABORTED: "The fetch process is aborted by the user", MEDIA_ERR_NETWORK: "An error occurred while downloading", MEDIA_ERR_DECODE: "An error occurred while decoding", MEDIA_ERR_SRC_NOT_SUPPORTED: "Audio/video is not supported", REPLAY: "Replay", ERROR: "Network is offline", PLAY_TIPS: "Play", PAUSE_TIPS: "Pause", PLAYNEXT_TIPS: "Play next", DOWNLOAD_TIPS: "Download", ROTATE_TIPS: "Rotate", RELOAD_TIPS: "Reload", FULLSCREEN_TIPS: "Fullscreen", EXITFULLSCREEN_TIPS: "Exit fullscreen", CSSFULLSCREEN_TIPS: "Cssfullscreen", EXITCSSFULLSCREEN_TIPS: "Exit cssfullscreen", TEXTTRACK: "Caption", PIP: "Pip", MINIPLAYER: "Miniplayer", SCREENSHOT: "Screenshot", LIVE: "LIVE", OFF: "Off", MINIPLAYER_DRAG: "Click and hold to drag", AIRPLAY_TIPS: "Airplay" }, "zh-cn": { HAVE_NOTHING: "\u6CA1\u6709\u5173\u4E8E\u97F3\u9891/\u89C6\u9891\u662F\u5426\u5C31\u7EEA\u7684\u4FE1\u606F", HAVE_METADATA: "\u97F3\u9891/\u89C6\u9891\u7684\u5143\u6570\u636E\u5DF2\u5C31\u7EEA", HAVE_CURRENT_DATA: "\u5173\u4E8E\u5F53\u524D\u64AD\u653E\u4F4D\u7F6E\u7684\u6570\u636E\u662F\u53EF\u7528\u7684\uFF0C\u4F46\u6CA1\u6709\u8DB3\u591F\u7684\u6570\u636E\u6765\u64AD\u653E\u4E0B\u4E00\u5E27/\u6BEB\u79D2", HAVE_FUTURE_DATA: "\u5F53\u524D\u53CA\u81F3\u5C11\u4E0B\u4E00\u5E27\u7684\u6570\u636E\u662F\u53EF\u7528\u7684", HAVE_ENOUGH_DATA: "\u53EF\u7528\u6570\u636E\u8DB3\u4EE5\u5F00\u59CB\u64AD\u653E", NETWORK_EMPTY: "\u97F3\u9891/\u89C6\u9891\u5C1A\u672A\u521D\u59CB\u5316", NETWORK_IDLE: "\u97F3\u9891/\u89C6\u9891\u662F\u6D3B\u52A8\u7684\u4E14\u5DF2\u9009\u53D6\u8D44\u6E90\uFF0C\u4F46\u5E76\u672A\u4F7F\u7528\u7F51\u7EDC", NETWORK_LOADING: "\u6D4F\u89C8\u5668\u6B63\u5728\u4E0B\u8F7D\u6570\u636E", NETWORK_NO_SOURCE: "\u672A\u627E\u5230\u97F3\u9891/\u89C6\u9891\u6765\u6E90", MEDIA_ERR_ABORTED: "\u53D6\u56DE\u8FC7\u7A0B\u88AB\u7528\u6237\u4E2D\u6B62", MEDIA_ERR_NETWORK: "\u5F53\u4E0B\u8F7D\u65F6\u53D1\u751F\u9519\u8BEF", MEDIA_ERR_DECODE: "\u5F53\u89E3\u7801\u65F6\u53D1\u751F\u9519\u8BEF", MEDIA_ERR_SRC_NOT_SUPPORTED: "\u4E0D\u652F\u6301\u7684\u97F3\u9891/\u89C6\u9891\u683C\u5F0F", REPLAY: "\u91CD\u64AD", ERROR: "\u7F51\u7EDC\u8FDE\u63A5\u4F3C\u4E4E\u51FA\u73B0\u4E86\u95EE\u9898", PLAY_TIPS: "\u64AD\u653E", PAUSE_TIPS: "\u6682\u505C", PLAYNEXT_TIPS: "\u4E0B\u4E00\u96C6", DOWNLOAD_TIPS: "\u4E0B\u8F7D", ROTATE_TIPS: "\u65CB\u8F6C", RELOAD_TIPS: "\u91CD\u65B0\u8F7D\u5165", FULLSCREEN_TIPS: "\u8FDB\u5165\u5168\u5C4F", EXITFULLSCREEN_TIPS: "\u9000\u51FA\u5168\u5C4F", CSSFULLSCREEN_TIPS: "\u8FDB\u5165\u6837\u5F0F\u5168\u5C4F", EXITCSSFULLSCREEN_TIPS: "\u9000\u51FA\u6837\u5F0F\u5168\u5C4F", TEXTTRACK: "\u5B57\u5E55", PIP: "\u753B\u4E2D\u753B", MINIPLAYER: "\u8FF7\u4F60\u64AD\u653E\u5668", SCREENSHOT: "\u622A\u56FE", LIVE: "\u6B63\u5728\u76F4\u64AD", OFF: "\u5173\u95ED", MINIPLAYER_DRAG: "\u70B9\u51FB\u6309\u4F4F\u53EF\u62D6\u52A8\u89C6\u9891", AIRPLAY_TIPS: "\u9694\u7A7A\u64AD\u653E" }, "zh-hk": { HAVE_NOTHING: "\u6C92\u6709\u95DC\u65BC\u97F3\u983B/\u8996\u983B\u662F\u5426\u5C31\u7DD2\u7684\u4FE1\u606F", HAVE_METADATA: "\u97F3\u983B/\u8996\u983B\u7684\u5143\u6578\u64DA\u5DF2\u5C31\u7DD2", HAVE_CURRENT_DATA: "\u95DC\u65BC\u7576\u524D\u64AD\u653E\u4F4D\u7F6E\u7684\u6578\u64DA\u662F\u53EF\u7528\u7684\uFF0C\u4F46\u6C92\u6709\u8DB3\u5920\u7684\u6578\u64DA\u4F86\u64AD\u653E\u4E0B\u58F9\u5E40/\u6BEB\u79D2", HAVE_FUTURE_DATA: "\u7576\u524D\u53CA\u81F3\u5C11\u4E0B\u58F9\u5E40\u7684\u6578\u64DA\u662F\u53EF\u7528\u7684", HAVE_ENOUGH_DATA: "\u53EF\u7528\u6578\u64DA\u8DB3\u4EE5\u958B\u59CB\u64AD\u653E", NETWORK_EMPTY: "\u97F3\u983B/\u8996\u983B\u5C1A\u672A\u521D\u59CB\u5316", NETWORK_IDLE: "\u97F3\u983B/\u8996\u983B\u662F\u6D3B\u52D5\u7684\u4E14\u5DF2\u9078\u53D6\u8CC7\u6E90\uFF0C\u4F46\u4E26\u672A\u4F7F\u7528\u7DB2\u7D61", NETWORK_LOADING: "\u700F\u89BD\u5668\u6B63\u5728\u4E0B\u8F09\u6578\u64DA", NETWORK_NO_SOURCE: "\u672A\u627E\u5230\u97F3\u983B/\u8996\u983B\u4F86\u6E90", MEDIA_ERR_ABORTED: "\u53D6\u56DE\u904E\u7A0B\u88AB\u7528\u6236\u4E2D\u6B62", MEDIA_ERR_NETWORK: "\u7576\u4E0B\u8F09\u6642\u767C\u751F\u932F\u8AA4", MEDIA_ERR_DECODE: "\u7576\u89E3\u78BC\u6642\u767C\u751F\u932F\u8AA4", MEDIA_ERR_SRC_NOT_SUPPORTED: "\u4E0D\u652F\u6301\u7684\u97F3\u983B/\u8996\u983B\u683C\u5F0F", REPLAY: "\u91CD\u64AD", ERROR: "\u7DB2\u7D61\u9023\u63A5\u4F3C\u4E4E\u51FA\u73FE\u4E86\u554F\u984C", PLAY_TIPS: "\u64AD\u653E", PAUSE_TIPS: "\u66AB\u505C", PLAYNEXT_TIPS: "\u4E0B\u58F9\u96C6", DOWNLOAD_TIPS: "\u4E0B\u8F09", ROTATE_TIPS: "\u65CB\u8F49", RELOAD_TIPS: "\u91CD\u65B0\u8F09\u5165", FULLSCREEN_TIPS: "\u9032\u5165\u5168\u5C4F", EXITFULLSCREEN_TIPS: "\u9000\u51FA\u5168\u5C4F", CSSFULLSCREEN_TIPS: "\u9032\u5165\u6A23\u5F0F\u5168\u5C4F", EXITCSSFULLSCREEN_TIPS: "\u9000\u51FA\u6A23\u5F0F\u5168\u5C4F", TEXTTRACK: "\u5B57\u5E55", PIP: "\u756B\u4E2D\u756B", MINIPLAYER: "\u8FF7\u59B3\u64AD\u653E\u5668", SCREENSHOT: "\u622A\u5716", LIVE: "\u6B63\u5728\u76F4\u64AD", OFF: "\u95DC\u9589", MINIPLAYER_DRAG: "\u9EDE\u64CA\u6309\u4F4F\u53EF\u62D6\u52D5\u8996\u983B", AIRPLAY_TIPS: "\u9694\u7A7A\u64AD\u653E" }, jp: { HAVE_NOTHING: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u304C\u6E96\u5099\u3067\u304D\u3066\u3044\u308B\u304B\u60C5\u5831\u304C\u3042\u308A\u307E\u305B\u3093", HAVE_METADATA: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u306E\u30E1\u30BF\u30C7\u30FC\u30BF\u306F\u6E96\u5099\u3067\u304D\u3066\u3044\u307E\u3059", HAVE_CURRENT_DATA: "\u73FE\u5728\u306E\u518D\u751F\u4F4D\u7F6E\u306B\u95A2\u3059\u308B\u30C7\u30FC\u30BF\u306F\u5229\u7528\u53EF\u80FD\u3067\u3059\u304C\u3001\u6B21\u306E\u30D5\u30EC\u30FC\u30E0/\u30DF\u30EA\u79D2\u3092\u518D\u751F\u3059\u308B\u306E\u306B\u5341\u5206\u306A\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093", HAVE_FUTURE_DATA: "\u73FE\u5728\u3001\u5C11\u306A\u304F\u3068\u3082\u6B21\u306E\u30D5\u30EC\u30FC\u30E0\u306E\u30C7\u30FC\u30BF\u304C\u5229\u7528\u53EF\u80FD\u3067\u3059", HAVE_ENOUGH_DATA: "\u5229\u7528\u53EF\u80FD\u306A\u30C7\u30FC\u30BF\u306F\u518D\u751F\u3092\u958B\u59CB\u3059\u308B\u306E\u306B\u5341\u5206\u3067\u3059", NETWORK_EMPTY: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u304C\u521D\u671F\u5316\u3055\u308C\u3066\u3044\u307E\u305B\u3093", NETWORK_IDLE: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA\u306F\u30A2\u30AF\u30C6\u30A3\u30D6\u3067\u30EA\u30BD\u30FC\u30B9\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u3059\u304C\u3001\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u304C\u4F7F\u7528\u3055\u308C\u3066\u3044\u307E\u305B\u3093", NETWORK_LOADING: "\u30D6\u30E9\u30A6\u30B6\u30FC\u306F\u30C7\u30FC\u30BF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3044\u307E\u3059", NETWORK_NO_SOURCE: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA \u306E\u30BD\u30FC\u30B9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093", MEDIA_ERR_ABORTED: "\u30E6\u30FC\u30B6\u30FC\u306B\u3088\u3063\u3066\u30D5\u30A7\u30C3\u30C1\u30D7\u30ED\u30BB\u30B9\u304C\u4E2D\u6B62\u3055\u308C\u307E\u3057\u305F", MEDIA_ERR_NETWORK: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F", MEDIA_ERR_DECODE: "\u30C7\u30B3\u30FC\u30C9\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F", MEDIA_ERR_SRC_NOT_SUPPORTED: "\u30AA\u30FC\u30C7\u30A3\u30AA/\u30D3\u30C7\u30AA \u306E\u5F62\u5F0F\u304C\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093", REPLAY: "\u30EA\u30D7\u30EC\u30A4", ERROR: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306E\u63A5\u7D9A\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F", PLAY_TIPS: "\u30D7\u30EC\u30A4", PAUSE_TIPS: "\u4E00\u6642\u505C\u6B62", PLAYNEXT_TIPS: "\u6B21\u3092\u30D7\u30EC\u30A4", DOWNLOAD_TIPS: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9", ROTATE_TIPS: "\u56DE\u8EE2", RELOAD_TIPS: "\u518D\u8AAD\u307F\u8FBC\u307F", FULLSCREEN_TIPS: "\u30D5\u30EB\u30B9\u30AF\u30EA\u30FC\u30F3", EXITFULLSCREEN_TIPS: "\u30D5\u30EB\u30B9\u30AF\u30EA\u30FC\u30F3\u3092\u7D42\u4E86", CSSFULLSCREEN_TIPS: "\u30B7\u30A2\u30BF\u30FC\u30E2\u30FC\u30C9", EXITCSSFULLSCREEN_TIPS: "\u30B7\u30A2\u30BF\u30FC\u30E2\u30FC\u30C9\u3092\u7D42\u4E86", TEXTTRACK: "\u5B57\u5E55", PIP: "\u30DF\u30CB\u30D7\u30EC\u30FC\u30E4\u30FC", MINIPLAYER: "\u30DF\u30CB\u30D7\u30EC\u30FC\u30E4\u30FC", SCREENSHOT: "\u30B9\u30AF\u30EA\u30FC\u30F3\u30B7\u30E7\u30C3\u30C8", LIVE: "\u751F\u653E\u9001", OFF: "\u30AA\u30D5", MINIPLAYER_DRAG: "\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u50CD\u753B\u3092\u30C9\u30E9\u30C3\u30B0\u3059\u308B", AIRPLAY_TIPS: "\u9694\u7A7A\u653E\u9001" } };
        Object.defineProperty(e2, "lang", { get: function() {
          return e2.config && t2[e2.config.lang] || t2.en;
        }, set: function(e3) {
          "Object" === (0, i.typeOf)(e3) && Object.keys(e3).forEach(function(n2) {
            t2[n2] = e3[n2];
          });
        } });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = n(0);
      t.default = { name: "mobile", method: function() {
        var e2 = this, t2 = e2.root, n2 = 0, r = void 0, o = { first: "", second: "" };
        function s(t3) {
          e2.video.addEventListener("touchend", function(t4) {
            e2.onElementTouchend(t4, e2.video);
          }), e2.video.addEventListener("touchstart", function() {
            e2.isTouchMove = false;
          }), e2.video.addEventListener("touchmove", function() {
            e2.isTouchMove = true;
          }), e2.config.autoplay && e2.start();
        }
        e2.onElementTouchend = function(e3, s2) {
          this.config.closeVideoPreventDefault || e3.preventDefault(), this.config.closeVideoStopPropagation || e3.stopPropagation();
          var a = this;
          if ((0, i.hasClass)(t2, "xgplayer-inactive") ? a.emit("focus") : a.emit("blur"), !a.config.closeVideoTouch && !a.isTouchMove) {
            var l = function() {
              r = setTimeout(function() {
                if ((0, i.hasClass)(a.root, "xgplayer-nostart"))
                  return false;
                if (!a.ended)
                  if (a.paused) {
                    var e4 = a.play();
                    void 0 !== e4 && e4 && e4.catch(function(e5) {
                    });
                  } else
                    a.pause();
                n2 = 0;
              }, 200);
            };
            a.config.closeVideoClick || (n2++, r && clearTimeout(r), 1 === n2 ? a.config.enableVideoDbltouch ? o.first = new Date() : l() : 2 === n2 && a.config.enableVideoDbltouch ? (o.second = new Date(), Math.abs(o.first - o.second) < 400 ? l() : (o.first = new Date(), n2 = 1)) : n2 = 0);
          }
        }, e2.once("ready", s), e2.once("destroy", function t3() {
          e2.off("ready", s), e2.off("destroy", t3);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = n(0);
      t.default = { name: "pc", method: function() {
        var e2 = this;
        if (e2.controls && e2.video) {
          var t2 = e2.controls, n2 = e2.root, r = 0, o = void 0;
          e2.onElementClick = function(e3, t3) {
            this.config.closeVideoPreventDefault || e3.preventDefault(), this.config.closeVideoStopPropagation || e3.stopPropagation();
            var n3 = this;
            n3.config.closeVideoClick || (r++, o && clearTimeout(o), 1 === r ? o = setTimeout(function() {
              if ((0, i.hasClass)(n3.root, "xgplayer-nostart"))
                return false;
              if (!n3.ended)
                if (n3.paused) {
                  var e4 = n3.play();
                  void 0 !== e4 && e4 && e4.catch(function(e5) {
                  });
                } else
                  n3.pause();
              r = 0;
            }, 200) : r = 0);
          }, e2.video.addEventListener("click", function(t3) {
            e2.onElementClick(t3, e2.video);
          }, false), e2.onElementDblclick = function(e3, n3) {
            this.config.closeVideoPreventDefault || e3.preventDefault(), this.config.closeVideoStopPropagation || e3.stopPropagation();
            if (!this.config.closeVideoDblclick) {
              var i2 = t2.querySelector(".xgplayer-fullscreen");
              if (i2) {
                var r2 = void 0;
                document.createEvent ? (r2 = document.createEvent("Event")).initEvent("click", true, true) : r2 = new Event("click"), i2.dispatchEvent(r2);
              }
            }
          }, e2.video.addEventListener("dblclick", function(t3) {
            e2.onElementDblclick(t3, e2.video);
          }, false), n2.addEventListener("mouseenter", s), n2.addEventListener("mouseleave", a), t2.addEventListener("mouseenter", l), t2.addEventListener("mouseleave", c), t2.addEventListener("click", u), e2.once("ready", d), e2.once("destroy", function t3() {
            n2.removeEventListener("mouseenter", s), n2.removeEventListener("mouseleave", a);
            var i2 = e2.controls;
            i2 && (i2.removeEventListener("mouseleave", c), i2.removeEventListener("mouseenter", l), i2.removeEventListener("click", u)), e2.off("ready", d), e2.off("destroy", t3);
          });
        }
        function s() {
          clearTimeout(e2.leavePlayerTimer), e2.emit("focus", e2);
        }
        function a() {
          e2.config.closePlayerBlur || (e2.leavePlayerTimer = setTimeout(function() {
            e2.emit("blur", e2);
          }, e2.config.leavePlayerTime || 0));
        }
        function l(t3) {
          e2.userTimer && clearTimeout(e2.userTimer);
        }
        function c(t3) {
          e2.config.closeControlsBlur || e2.emit("focus", e2);
        }
        function u(e3) {
          e3.preventDefault(), e3.stopPropagation();
        }
        function d(t3) {
          e2.config.autoplay && e2.start();
        }
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = function() {
        function e2(e3, t2) {
          for (var n2 = 0; n2 < t2.length; n2++) {
            var i2 = t2[n2];
            i2.enumerable = i2.enumerable || false, i2.configurable = true, "value" in i2 && (i2.writable = true), Object.defineProperty(e3, i2.key, i2);
          }
        }
        return function(t2, n2, i2) {
          return n2 && e2(t2.prototype, n2), i2 && e2(t2, i2), t2;
        };
      }(), r = n(0);
      var o = function() {
        function e2(t2) {
          !function(e3, t3) {
            if (!(e3 instanceof t3))
              throw new TypeError("Cannot call a class as a function");
          }(this, e2), this.player = t2, this.state = { playbackRate: 0, isRepeat: false, keyCode: 0, repeat: 0, isBody: false }, this.timer = null, this.initEvents();
        }
        return i(e2, [{ key: "initEvents", value: function() {
          var e3 = this, t2 = this.player, n2 = t2.root, i2 = t2.config;
          if (this.player.onBodyKeydown = this.onBodyKeydown.bind(this), this.player.onKeydown = this.onKeydown.bind(this), this.player.onKeyup = this.onKeyup.bind(this), !i2.keyShortcut || "on" === i2.keyShortcut) {
            document.addEventListener("keydown", this.player.onBodyKeydown), n2.addEventListener("keydown", this.player.onKeydown);
            (0, r.on)(this.player, "destroy", function() {
              document.removeEventListener("keydown", e3.player.onBodyKeydown), n2.removeEventListener("keydown", e3.player.onKeydown), clearTimeout(e3.timer), e3.timer = null;
            });
          }
        } }, { key: "checkTarget", value: function(e3) {
          var t2 = this.player;
          return e3.target === t2.root || e3.target === t2.video || e3.target === t2.controls;
        } }, { key: "onBodyKeydown", value: function(e3) {
          var t2 = e3 || window.event, n2 = t2.keyCode;
          if (t2.target === document.body && (37 === n2 || 39 === n2 || 32 === n2 || 27 === n2))
            return t2.preventDefault(), t2.cancelBubble = true, t2.returnValue = false, t2.repeat || document.addEventListener("keyup", this.player.onKeyup), this.handler(t2), false;
        } }, { key: "onKeydown", value: function(e3) {
          var t2 = e3 || window.event, n2 = t2.keyCode;
          if (this.checkTarget(t2) && (37 === n2 || 38 === n2 || 39 === n2 || 40 === n2 || 32 === n2 || 27 === n2))
            return t2.preventDefault(), t2.cancelBubble = true, t2.returnValue = false, this.player.emit("focus"), t2.repeat || this.player.root.addEventListener("keyup", this.player.onKeyup), this.handler(t2), false;
        } }, { key: "onKeyup", value: function() {
          var e3 = this.state, t2 = this.player;
          document.removeEventListener("keyup", this.player.onKeyup), t2.root.removeEventListener("keyup", this.player.onKeyup), e3.keyCode && (0 !== e3.playbackRate && (t2.playbackRate = e3.playbackRate), e3.isRepeat || this.handlerKeyCode(e3.keyCode, false), e3.playbackRate = 0, e3.isRepeat = false, e3.keyCode = 0, e3.repeat = 0, this.changeVolumeSlide());
        } }, { key: "handler", value: function(e3) {
          var t2 = this.state, n2 = this.player;
          t2.keyCode = e3.keyCode, t2.isRepeat = e3.repeat, e3.repeat && (n2.config.disableLongPress ? this.handlerKeyCode(t2.keyCode, false) : t2.repeat % 2 == 0 && this.handlerKeyCode(t2.keyCode, true), t2.repeat++);
        } }, { key: "handlerKeyCode", value: function(e3, t2) {
          var n2 = this.player, i2 = this.state;
          switch (e3) {
            case 39:
              t2 ? 0 === i2.repeat && this.changeRate() : this.seek(false, t2);
              break;
            case 37:
              this.seek(true, t2);
              break;
            case 38:
              this.changeVolume(true);
              break;
            case 40:
              this.changeVolume(false);
              break;
            case 32:
              t2 || (n2.paused ? n2.play() : n2.pause());
              break;
            case 27:
              (0, r.hasClass)(n2.root, "xgplayer-is-cssfullscreen") && n2.exitCssFullscreen();
          }
        } }, { key: "seek", value: function(e3, t2) {
          var n2 = this.player, i2 = (n2.config.keyShortcutStep || {}).currentTime || 10;
          n2.isLoading || n2.isSeeking || t2 && this.state.repeat % 8 > 0 || (e3 ? n2.currentTime - i2 >= 0 ? n2.currentTime -= i2 : n2.currentTime = 0 : n2.maxPlayedTime && n2.config.allowSeekPlayed && n2.currentTime + i2 > n2.maxPlayedTime ? n2.currentTime = n2.maxPlayedTime : n2.currentTime + i2 <= n2.duration ? n2.currentTime += i2 : n2.currentTime = n2.duration + 1);
        } }, { key: "changeRate", value: function() {
          this.state.playbackRate = this.player.playbackRate, this.player.playbackRate = this.player.config.keyboardRate || 5;
        } }, { key: "changeVolumeSlide", value: function(e3) {
          var t2 = this.player;
          t2.controls && (e3 ? (t2.emit("focus"), (0, r.hasClass)(t2.root, "xgplayer-volume-active") || (0, r.addClass)(t2.root, "xgplayer-volume-active")) : (clearTimeout(this.timer), this.timer = setTimeout(function() {
            (0, r.removeClass)(t2.root, "xgplayer-volume-active");
          }, 1e3)));
        } }, { key: "changeVolume", value: function(e3) {
          var t2 = this.player, n2 = (t2.config.keyShortcutStep || {}).volume || 0.1;
          this.changeVolumeSlide(true);
          var i2 = t2.volume;
          e3 && i2 + n2 <= 1 ? t2.volume = i2 + n2 : !e3 && i2 - n2 >= 0 && (t2.volume = i2 - n2);
        } }]), e2;
      }();
      t.default = { name: "keyboard", method: function() {
        this.keyboard = new o(this);
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      n(42);
      var s = o.default.createDom;
      t.default = { name: "s_flex", method: function() {
        var e2 = s("xg-placeholder", "", {}, "xgplayer-placeholder");
        this.controls.appendChild(e2);
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      n(44);
      var s = n(3);
      var a = o.default.addClass, l = o.default.removeClass;
      t.default = { name: "s_cssFullscreen", method: function() {
        var e2 = this;
        if (e2.config.cssFullscreen) {
          e2.getCssFullscreen = function() {
            e2.config.fluid && (e2.root.style["padding-top"] = ""), a(e2.root, "xgplayer-is-cssfullscreen"), e2.emit("requestCssFullscreen"), (0, s.dispatchWindowEvent)("videoRequestCssFullscreen", { target: e2 });
          }, e2.exitCssFullscreen = function() {
            e2.config.fluid && (e2.root.style.width = "100%", e2.root.style.height = "0", e2.root.style["padding-top"] = 100 * e2.config.height / e2.config.width + "%"), l(e2.root, "xgplayer-is-cssfullscreen"), e2.emit("exitCssFullscreen"), (0, s.dispatchWindowEvent)("videoExitCssFullscreen", { target: e2 });
          };
        }
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      var i, r = "object" == typeof Reflect ? Reflect : null, o = r && "function" == typeof r.apply ? r.apply : function(e2, t2, n2) {
        return Function.prototype.apply.call(e2, t2, n2);
      };
      i = r && "function" == typeof r.ownKeys ? r.ownKeys : Object.getOwnPropertySymbols ? function(e2) {
        return Object.getOwnPropertyNames(e2).concat(Object.getOwnPropertySymbols(e2));
      } : function(e2) {
        return Object.getOwnPropertyNames(e2);
      };
      var s = Number.isNaN || function(e2) {
        return e2 != e2;
      };
      function a() {
        a.init.call(this);
      }
      e.exports = a, e.exports.once = function(e2, t2) {
        return new Promise(function(n2, i2) {
          function r2(n3) {
            e2.removeListener(t2, o2), i2(n3);
          }
          function o2() {
            "function" == typeof e2.removeListener && e2.removeListener("error", r2), n2([].slice.call(arguments));
          }
          y(e2, t2, o2, { once: true }), "error" !== t2 && function(e3, t3, n3) {
            "function" == typeof e3.on && y(e3, "error", t3, n3);
          }(e2, r2, { once: true });
        });
      }, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
      var l = 10;
      function c(e2) {
        if ("function" != typeof e2)
          throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e2);
      }
      function u(e2) {
        return void 0 === e2._maxListeners ? a.defaultMaxListeners : e2._maxListeners;
      }
      function d(e2, t2, n2, i2) {
        var r2, o2, s2, a2;
        if (c(n2), void 0 === (o2 = e2._events) ? (o2 = e2._events = /* @__PURE__ */ Object.create(null), e2._eventsCount = 0) : (void 0 !== o2.newListener && (e2.emit("newListener", t2, n2.listener ? n2.listener : n2), o2 = e2._events), s2 = o2[t2]), void 0 === s2)
          s2 = o2[t2] = n2, ++e2._eventsCount;
        else if ("function" == typeof s2 ? s2 = o2[t2] = i2 ? [n2, s2] : [s2, n2] : i2 ? s2.unshift(n2) : s2.push(n2), (r2 = u(e2)) > 0 && s2.length > r2 && !s2.warned) {
          s2.warned = true;
          var l2 = new Error("Possible EventEmitter memory leak detected. " + s2.length + " " + String(t2) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          l2.name = "MaxListenersExceededWarning", l2.emitter = e2, l2.type = t2, l2.count = s2.length, a2 = l2, console && console.warn && console.warn(a2);
        }
        return e2;
      }
      function f() {
        if (!this.fired)
          return this.target.removeListener(this.type, this.wrapFn), this.fired = true, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
      }
      function p(e2, t2, n2) {
        var i2 = { fired: false, wrapFn: void 0, target: e2, type: t2, listener: n2 }, r2 = f.bind(i2);
        return r2.listener = n2, i2.wrapFn = r2, r2;
      }
      function h(e2, t2, n2) {
        var i2 = e2._events;
        if (void 0 === i2)
          return [];
        var r2 = i2[t2];
        return void 0 === r2 ? [] : "function" == typeof r2 ? n2 ? [r2.listener || r2] : [r2] : n2 ? function(e3) {
          for (var t3 = new Array(e3.length), n3 = 0; n3 < t3.length; ++n3)
            t3[n3] = e3[n3].listener || e3[n3];
          return t3;
        }(r2) : g(r2, r2.length);
      }
      function v(e2) {
        var t2 = this._events;
        if (void 0 !== t2) {
          var n2 = t2[e2];
          if ("function" == typeof n2)
            return 1;
          if (void 0 !== n2)
            return n2.length;
        }
        return 0;
      }
      function g(e2, t2) {
        for (var n2 = new Array(t2), i2 = 0; i2 < t2; ++i2)
          n2[i2] = e2[i2];
        return n2;
      }
      function y(e2, t2, n2, i2) {
        if ("function" == typeof e2.on)
          i2.once ? e2.once(t2, n2) : e2.on(t2, n2);
        else {
          if ("function" != typeof e2.addEventListener)
            throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e2);
          e2.addEventListener(t2, function r2(o2) {
            i2.once && e2.removeEventListener(t2, r2), n2(o2);
          });
        }
      }
      Object.defineProperty(a, "defaultMaxListeners", { enumerable: true, get: function() {
        return l;
      }, set: function(e2) {
        if ("number" != typeof e2 || e2 < 0 || s(e2))
          throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e2 + ".");
        l = e2;
      } }), a.init = function() {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, a.prototype.setMaxListeners = function(e2) {
        if ("number" != typeof e2 || e2 < 0 || s(e2))
          throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e2 + ".");
        return this._maxListeners = e2, this;
      }, a.prototype.getMaxListeners = function() {
        return u(this);
      }, a.prototype.emit = function(e2) {
        for (var t2 = [], n2 = 1; n2 < arguments.length; n2++)
          t2.push(arguments[n2]);
        var i2 = "error" === e2, r2 = this._events;
        if (void 0 !== r2)
          i2 = i2 && void 0 === r2.error;
        else if (!i2)
          return false;
        if (i2) {
          var s2;
          if (t2.length > 0 && (s2 = t2[0]), s2 instanceof Error)
            throw s2;
          var a2 = new Error("Unhandled error." + (s2 ? " (" + s2.message + ")" : ""));
          throw a2.context = s2, a2;
        }
        var l2 = r2[e2];
        if (void 0 === l2)
          return false;
        if ("function" == typeof l2)
          o(l2, this, t2);
        else {
          var c2 = l2.length, u2 = g(l2, c2);
          for (n2 = 0; n2 < c2; ++n2)
            o(u2[n2], this, t2);
        }
        return true;
      }, a.prototype.addListener = function(e2, t2) {
        return d(this, e2, t2, false);
      }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(e2, t2) {
        return d(this, e2, t2, true);
      }, a.prototype.once = function(e2, t2) {
        return c(t2), this.on(e2, p(this, e2, t2)), this;
      }, a.prototype.prependOnceListener = function(e2, t2) {
        return c(t2), this.prependListener(e2, p(this, e2, t2)), this;
      }, a.prototype.removeListener = function(e2, t2) {
        var n2, i2, r2, o2, s2;
        if (c(t2), void 0 === (i2 = this._events))
          return this;
        if (void 0 === (n2 = i2[e2]))
          return this;
        if (n2 === t2 || n2.listener === t2)
          0 == --this._eventsCount ? this._events = /* @__PURE__ */ Object.create(null) : (delete i2[e2], i2.removeListener && this.emit("removeListener", e2, n2.listener || t2));
        else if ("function" != typeof n2) {
          for (r2 = -1, o2 = n2.length - 1; o2 >= 0; o2--)
            if (n2[o2] === t2 || n2[o2].listener === t2) {
              s2 = n2[o2].listener, r2 = o2;
              break;
            }
          if (r2 < 0)
            return this;
          0 === r2 ? n2.shift() : function(e3, t3) {
            for (; t3 + 1 < e3.length; t3++)
              e3[t3] = e3[t3 + 1];
            e3.pop();
          }(n2, r2), 1 === n2.length && (i2[e2] = n2[0]), void 0 !== i2.removeListener && this.emit("removeListener", e2, s2 || t2);
        }
        return this;
      }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(e2) {
        var t2, n2, i2;
        if (void 0 === (n2 = this._events))
          return this;
        if (void 0 === n2.removeListener)
          return 0 === arguments.length ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : void 0 !== n2[e2] && (0 == --this._eventsCount ? this._events = /* @__PURE__ */ Object.create(null) : delete n2[e2]), this;
        if (0 === arguments.length) {
          var r2, o2 = Object.keys(n2);
          for (i2 = 0; i2 < o2.length; ++i2)
            "removeListener" !== (r2 = o2[i2]) && this.removeAllListeners(r2);
          return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
        }
        if ("function" == typeof (t2 = n2[e2]))
          this.removeListener(e2, t2);
        else if (void 0 !== t2)
          for (i2 = t2.length - 1; i2 >= 0; i2--)
            this.removeListener(e2, t2[i2]);
        return this;
      }, a.prototype.listeners = function(e2) {
        return h(this, e2, true);
      }, a.prototype.rawListeners = function(e2) {
        return h(this, e2, false);
      }, a.listenerCount = function(e2, t2) {
        return "function" == typeof e2.listenerCount ? e2.listenerCount(t2) : v.call(e2, t2);
      }, a.prototype.listenerCount = v, a.prototype.eventNames = function() {
        return this._eventsCount > 0 ? i(this._events) : [];
      };
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = s(n(0)), r = s(n(47)), o = s(n(48));
      function s(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      n(49);
      var a = i.default.createDom, l = i.default.createImgBtn, c = i.default.addClass;
      t.default = { name: "s_fullscreen", method: function() {
        var e2 = this, t2 = e2.config.fullscreenBtn ? e2.config.fullscreenBtn : {}, n2 = void 0;
        n2 = "img" === t2.type ? l("fullscreen", t2.url.request, t2.width, t2.height) : a("xg-fullscreen", '<xg-icon class="xgplayer-icon">\n                                             <div class="xgplayer-icon-requestfull">' + r.default + '</div>\n                                             <div class="xgplayer-icon-exitfull">' + o.default + "</div>\n                                           </xg-icon>", {}, "xgplayer-fullscreen");
        var i2 = {};
        i2.requestfull = e2.lang.FULLSCREEN_TIPS, i2.exitfull = e2.lang.EXITFULLSCREEN_TIPS;
        var s2 = a("xg-tips", '<span class="xgplayer-tip-requestfull">' + i2.requestfull + '</span>\n                                        <span class="xgplayer-tip-exitfull">' + i2.exitfull + "</span>", {}, "xgplayer-tips");
        n2.appendChild(s2);
        var u = e2.config.hasOwnProperty("portrait") ? e2.config.portrait : -1;
        u = -1 === u ? e2.config.height >= e2.config.width : !!u, e2.once("ready", function() {
          e2.controls && (e2.controls.appendChild(n2), c(e2.root, u ? "xgplayer-portrait" : "xgplayer-landscape"));
        }), ["click", "touchend"].forEach(function(t3) {
          n2.addEventListener(t3, function(t4) {
            t4.preventDefault(), t4.stopPropagation(), e2.userGestureTrigEvent("fullscreenBtnClick");
          });
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="UTF-8" standalone="no"?> <!-- Created with Vectornator for iOS (http://vectornator.io/) --><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n<svg style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="40" height="40" xmlns:vectornator="http://vectornator.io" version="1.1" viewBox="0 0 40 40">\n<metadata>\n<vectornator:setting key="DimensionsVisible" value="1"/>\n<vectornator:setting key="PencilOnly" value="0"/>\n<vectornator:setting key="SnapToPoints" value="0"/>\n<vectornator:setting key="OutlineMode" value="0"/>\n<vectornator:setting key="CMYKEnabledKey" value="0"/>\n<vectornator:setting key="RulersVisible" value="1"/>\n<vectornator:setting key="SnapToEdges" value="0"/>\n<vectornator:setting key="GuidesVisible" value="1"/>\n<vectornator:setting key="DisplayWhiteBackground" value="0"/>\n<vectornator:setting key="doHistoryDisabled" value="0"/>\n<vectornator:setting key="SnapToGuides" value="1"/>\n<vectornator:setting key="TimeLapseWatermarkDisabled" value="0"/>\n<vectornator:setting key="Units" value="Pixels"/>\n<vectornator:setting key="DynamicGuides" value="0"/>\n<vectornator:setting key="IsolateActiveLayer" value="0"/>\n<vectornator:setting key="SnapToGrid" value="0"/>\n</metadata>\n<defs/>\n<g id="\u56FE\u5C42 1" vectornator:layerName="\u56FE\u5C42 1">\n<path d="M18.9745+10.495C20.4153+10.495+21.5832+11.663+21.5832+13.1037L21.5832+27.1907C21.5832+28.6314+20.4153+29.7993+18.9745+29.7993L11.1485+29.7993C9.70773+29.7993+8.53977+28.6314+8.53976+27.1907L8.53976+13.1037C8.53976+11.663+9.70772+10.495+11.1485+10.495C11.1485+10.495+18.9745+10.495+18.9745+10.495ZM29.9311+16.7559C31.3718+16.7559+32.5398+17.9238+32.5398+19.3646L32.5398+27.1907C32.5397+28.6314+31.3718+29.7993+29.9311+29.7993L24.1919+29.7993C23.8179+29.8011+23.4716+29.6026+23.284+29.2791C23.0965+28.9555+23.0965+28.5563+23.284+28.2327C23.4716+27.9091+23.8179+27.7106+24.1919+27.7124L29.9311+27.7124C30.2192+27.7124+30.4528+27.4788+30.4528+27.1907L30.4528+19.3646C30.4528+19.0764+30.2192+18.8428+29.9311+18.8428L24.1919+18.8428C23.8179+18.8446+23.4716+18.6461+23.284+18.3225C23.0965+17.9989+23.0965+17.5997+23.284+17.2761C23.4716+16.9525+23.8179+16.7541+24.1919+16.7559L29.9311+16.7559ZM18.9745+12.5819L11.1485+12.5819C10.8603+12.5819+10.6267+12.8156+10.6267+13.1037L10.6267+26.6689C10.6267+26.957+10.8603+27.1907+11.1485+27.1907L18.9745+27.1907C19.2627+27.1907+19.4963+26.957+19.4963+26.6689L19.4963+13.1037C19.4963+12.8156+19.2627+12.5819+18.9745+12.5819ZM17.4093+23.7993C17.8416+23.7993+18.1919+24.1497+18.1919+24.5819C18.1919+25.0142+17.8416+25.3646+17.4093+25.3646L13.2354+25.3646C12.8032+25.3646+12.4528+25.0142+12.4528+24.5819C12.4528+24.1497+12.8032+23.7993+13.2354+23.7993L17.4093+23.7993Z" opacity="1" fill="#ffffff"/>\n</g>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="UTF-8" standalone="no"?> <!-- Created with Vectornator for iOS (http://vectornator.io/) --><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n<svg style="fill-rule:nonzero;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="40" height="40" xmlns:vectornator="http://vectornator.io" version="1.1" viewBox="0 0 40 40">\n<metadata>\n<vectornator:setting key="DimensionsVisible" value="1"/>\n<vectornator:setting key="PencilOnly" value="0"/>\n<vectornator:setting key="SnapToPoints" value="0"/>\n<vectornator:setting key="OutlineMode" value="0"/>\n<vectornator:setting key="CMYKEnabledKey" value="0"/>\n<vectornator:setting key="RulersVisible" value="1"/>\n<vectornator:setting key="SnapToEdges" value="0"/>\n<vectornator:setting key="GuidesVisible" value="1"/>\n<vectornator:setting key="DisplayWhiteBackground" value="0"/>\n<vectornator:setting key="doHistoryDisabled" value="0"/>\n<vectornator:setting key="SnapToGuides" value="1"/>\n<vectornator:setting key="TimeLapseWatermarkDisabled" value="0"/>\n<vectornator:setting key="Units" value="Pixels"/>\n<vectornator:setting key="DynamicGuides" value="0"/>\n<vectornator:setting key="IsolateActiveLayer" value="0"/>\n<vectornator:setting key="SnapToGrid" value="0"/>\n</metadata>\n<defs/>\n<g id="\u56FE\u5C42 1" vectornator:layerName="\u56FE\u5C42 1">\n<path d="M18.9745+10.495C20.4153+10.495+21.5832+11.663+21.5832+13.1037L21.5832+27.1907C21.5832+28.6314+20.4153+29.7993+18.9745+29.7993L11.1485+29.7993C9.70773+29.7993+8.53977+28.6314+8.53976+27.1907L8.53976+13.1037C8.53976+11.663+9.70772+10.495+11.1485+10.495C11.1485+10.495+18.9745+10.495+18.9745+10.495ZM29.9311+16.7559C31.3718+16.7559+32.5398+17.9238+32.5398+19.3646L32.5398+27.1907C32.5397+28.6314+31.3718+29.7993+29.9311+29.7993L24.1919+29.7993C23.8179+29.8011+23.4716+29.6026+23.284+29.2791C23.0965+28.9555+23.0965+28.5563+23.284+28.2327C23.4716+27.9091+23.8179+27.7106+24.1919+27.7124L29.9311+27.7124C30.2192+27.7124+30.4528+27.4788+30.4528+27.1907L30.4528+19.3646C30.4528+19.0764+30.2192+18.8428+29.9311+18.8428L24.1919+18.8428C23.8179+18.8446+23.4716+18.6461+23.284+18.3225C23.0965+17.9989+23.0965+17.5997+23.284+17.2761C23.4716+16.9525+23.8179+16.7541+24.1919+16.7559L29.9311+16.7559ZM18.9745+12.5819L11.1485+12.5819C10.8603+12.5819+10.6267+12.8156+10.6267+13.1037L10.6267+26.6689C10.6267+26.957+10.8603+27.1907+11.1485+27.1907L18.9745+27.1907C19.2627+27.1907+19.4963+26.957+19.4963+26.6689L19.4963+13.1037C19.4963+12.8156+19.2627+12.5819+18.9745+12.5819ZM17.4093+23.7993C17.8416+23.7993+18.1919+24.1497+18.1919+24.5819C18.1919+25.0142+17.8416+25.3646+17.4093+25.3646L13.2354+25.3646C12.8032+25.3646+12.4528+25.0142+12.4528+24.5819C12.4528+24.1497+12.8032+23.7993+13.2354+23.7993L17.4093+23.7993Z" opacity="1" fill="#ffffff"/>\n</g>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      n(51);
      var s = o.default.createDom;
      t.default = { name: "s_loading", method: function() {
        for (var e2 = this.root, t2 = "", n2 = 1; n2 <= 12; n2++)
          t2 += '<div class="xgplayer-loading-bar' + n2 + '"></div>';
        var i2 = s("xg-loading", "" + t2, {}, "xgplayer-loading");
        this.once("ready", function() {
          e2.appendChild(i2);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = s(n(0)), r = s(n(53)), o = s(n(54));
      function s(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      n(55);
      var a = i.default.createDom, l = i.default.createImgBtn, c = i.default.hasClass;
      t.default = { name: "s_play", method: function() {
        var e2 = this, t2 = e2.config.playBtn ? e2.config.playBtn : {}, n2 = void 0;
        n2 = "img" === t2.type ? l("play", t2.url.play, t2.width, t2.height) : a("xg-play", '<xg-icon class="xgplayer-icon">\n                                      <div class="xgplayer-icon-play">' + r.default + '</div>\n                                      <div class="xgplayer-icon-pause">' + o.default + "</div>\n                                     </xg-icon>", {}, "xgplayer-play");
        var i2 = {};
        i2.play = e2.lang.PLAY_TIPS, i2.pause = e2.lang.PAUSE_TIPS;
        var s2 = a("xg-tips", '<span class="xgplayer-tip-play">' + i2.play + '</span>\n                                        <span class="xgplayer-tip-pause">' + i2.pause + "</span>", {}, "xgplayer-tips");
        n2.appendChild(s2), e2.once("ready", function() {
          e2.controls && e2.controls.appendChild(n2);
        }), ["click", "touchend"].forEach(function(t3) {
          n2.addEventListener(t3, function(t4) {
            t4.preventDefault(), t4.stopPropagation(), e2.userGestureTrigEvent("playBtnClick");
          });
        });
        var u = function() {
          if (e2.config.allowPlayAfterEnded || !e2.ended)
            if (c(e2.root, "xgplayer-nostart") && e2.start(), e2.paused) {
              var t3 = e2.play();
              t3 && t3.catch(function() {
              });
            } else
              e2.pause();
        };
        e2.on("playBtnClick", u), e2.once("destroy", function t3() {
          e2.off("destroy", t3), e2.off("playBtnClick", u);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="utf-8"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version="1.1" id="\u56FE\u5C42_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40"\n	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">\n<style type="text/css">\n	.st0{fill:#FFFFFF;}\n</style>\n<path class="st0" d="M15,8.9c0.6,0,1.3,0.2,1.8,0.6l9.3,6.3c0.9,0.6,1.4,1.6,1.4,2.7s-0.5,2.1-1.4,2.7l-9.3,6.3\n	c-0.5,0.3-1,0.5-1.6,0.5H15c-0.9,0-1.7-0.3-2.3-0.9s-0.9-1.4-0.9-2.3V12.2c0-0.9,0.3-1.7,0.9-2.3C13.4,9.3,14.2,8.9,15,8.9L15,8.9z"\n	/>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="utf-8"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version="1.1" id="\u56FE\u5C42_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40"\n	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">\n<style type="text/css">\n	.st0{fill:#FFFFFF;}\n</style>\n<path class="st0" d="M24.5,8.9c1.7,0,2.6,0.9,2.6,2.8v13.5c0,1.9-0.9,2.8-2.6,2.8c-1.7,0-2.6-0.9-2.6-2.8V11.7\n	C21.9,9.8,22.7,8.9,24.5,8.9 M12.3,8.9c1.7,0,2.6,0.9,2.6,2.8v13.5c0,1.9-0.9,2.8-2.6,2.8c-1.7,0-2.6-0.9-2.6-2.8V11.7\n	C9.7,9.8,10.6,8.9,12.3,8.9"/>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = a(n(57)), r = a(n(58));
      n(59);
      var o = n(60), s = n(3);
      function a(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      var l = a(n(0)).default.createDom;
      t.default = { name: "s_volume", method: function() {
        var e2 = this, t2 = l("xg-volume", '<xg-icon class="xgplayer-icon">\n                                         <div class="xgplayer-icon-large">' + r.default + '</div>\n                                         <div class="xgplayer-icon-small">' + r.default + '</div>\n                                         <div class="xgplayer-icon-muted">' + i.default + '</div>\n                                         </xg-icon>\n                                         <xg-slider class="xgplayer-slider" tabindex="2">\n                                           <xg-bar class="xgplayer-bar">\n                                             <xg-drag class="xgplayer-drag"></xg-drag>\n                                           </xg-bar>\n                                         </xg-slider>', {}, "xgplayer-volume");
        e2.once("ready", function() {
          e2.controls && e2.controls.appendChild(t2);
        });
        var n2 = t2.querySelector(".xgplayer-slider"), a2 = t2.querySelector(".xgplayer-bar"), c = t2.querySelector(".xgplayer-drag"), u = t2.querySelector(".xgplayer-icon");
        c.style.height = 100 * e2.config.volume + "%", n2.volume = e2.config.volume, a2.addEventListener("mousedown", function(t3) {
          t3.preventDefault(), t3.stopPropagation(), e2.userGestureTrigEvent("volumeBarClick", t3);
        });
        var d = false;
        ["click", "touchend"].forEach(function(t3) {
          u.addEventListener(t3, function(t4) {
            t4.preventDefault(), t4.stopPropagation(), d = true, e2.userGestureTrigEvent("volumeIconClick");
          });
        }), u.addEventListener("mouseenter", function(t3) {
          t3.preventDefault(), t3.stopPropagation(), e2.userGestureTrigEvent("volumeIconEnter");
        }), ["blur", "mouseleave"].forEach(function(n3) {
          t2.addEventListener(n3, function(t3) {
            t3.preventDefault(), t3.stopPropagation(), e2.userGestureTrigEvent("volumeIconLeave");
          });
        });
        function f() {
          d && (d = false, o.session.setItem("video_muted", 1), (0, s.dispatchWindowEvent)("videoMuted", { target: e2 }));
        }
        function p() {
          d && (d = false, o.session.removeItem("video_muted"), (0, s.dispatchWindowEvent)("videoUnmuted", { target: e2 }));
        }
        function h(t3) {
          t3.detail.target !== e2 && (e2.muted = true);
        }
        function v(t3) {
          t3.detail.target !== e2 && (e2.muted = false);
        }
        e2.on("mute", f), e2.on("unmute", p), window.addEventListener("videoMuted", h), window.addEventListener("videoUnmuted", v), e2.once("destroy", function() {
          e2.off("mute", f), e2.off("unmute", p), window.removeEventListener("videoMuted", h), window.removeEventListener("videoUnmuted", v);
        }), e2.muted = e2.defaultMuted = !!e2.config.autoplay || !!o.session.getItem("video_muted");
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="utf-8"?>\n<!-- Generator: Adobe Illustrator 25.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version="1.1" id="\u56FE\u5C42_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28"\n	 viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">\n<path fill="#ffffff" d="M14.5,3.6c0.1,0.2,0.2,0.4,0.2,0.6V8l-3.3-3.3L13,3.4C13.5,3,14.1,3.1,14.5,3.6z M16.7,7.3c1.8,0.5,3.1,2.1,3.1,4\n	c0,0.5-0.1,1.1-0.3,1.5L16.7,10L16.7,7.3z M18.1,3.4c3.5,1,5.9,4.2,5.9,7.9c0,1.7-0.5,3.2-1.4,4.6L21,14.4c0.5-0.9,0.8-2,0.8-3.1\n	c0-2.7-1.8-5.1-4.4-5.9c-0.5-0.2-0.9-0.7-0.7-1.3C16.9,3.6,17.5,3.3,18.1,3.4z M6.1,2.3L6.1,2.3l0.4,0.4l0.1,0.1l0.1,0.1l16.2,16.2\n	c0.3,0.4,0.2,0.9-0.1,1.3c-0.4,0.4-1,0.4-1.4,0.1l-0.1-0.1l-1.6-1.6c-0.5,0.2-0.9,0.4-1.4,0.6c-0.5,0.2-1.1-0.1-1.3-0.7\n	s0.1-1.1,0.7-1.3c0.2,0,0.3-0.1,0.5-0.2l-3.3-3.3v4.6c0,0.6-0.5,1-1,1c-0.2,0-0.5-0.1-0.6-0.2l-4.7-3.8H4.4c-0.6,0-1-0.5-1-1V8.2\n	c0-0.6,0.5-1,1-1h3.7L4.7,3.8c-0.4-0.4-0.4-1.1,0-1.5C5.1,2,5.7,2,6.1,2.3z"/>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="utf-8"?>\n<!-- Generator: Adobe Illustrator 25.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version="1.1" id="\u56FE\u5C42_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28"\n	 viewBox="0 0 28 28" style="enable-background:new 0 0 28 28;" xml:space="preserve">\n<path fill="#ffffff" d="M16.7,7.3c1.8,0.5,3.1,2.1,3.1,4s-1.3,3.5-3.1,4V7.3z M18,3.4c3.4,1,5.9,4.2,5.9,7.9s-2.4,6.8-5.9,7.9\n	c-0.5,0.2-1.1-0.1-1.3-0.7c-0.2-0.5,0.1-1.1,0.7-1.3c2.6-0.8,4.4-3.2,4.4-5.9S20,6.2,17.4,5.4c-0.5-0.2-0.9-0.7-0.7-1.3\n	C16.9,3.6,17.5,3.3,18,3.4z M14.4,3.6c0.1,0.2,0.2,0.4,0.2,0.6v14.2c0,0.6-0.5,1-1,1c-0.2,0-0.5-0.1-0.6-0.2l-4.7-3.8l-3.9,0\n	c-0.6,0-1-0.5-1-1V8.2c0-0.6,0.5-1,1-1l3.9,0L13,3.4C13.4,3.1,14.1,3.1,14.4,3.6z"/>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true }), t.session = void 0;
      var i = n(3);
      t.session = (0, i.getSessionStorage)();
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = o(n(0)), r = o(n(2));
      function o(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      n(62);
      var s = i.default.createDom, a = i.default.addClass, l = i.default.removeClass, c = i.default.hasClass, u = i.default.toggleClass, d = i.default.typeOf, f = i.default.event, p = i.default.format, h = i.default.findDom, v = function(e2) {
        return c(e2.root, "xgplayer-rotate-fullscreen");
      };
      t.default = { name: "s_progress", method: function() {
        var e2 = this, t2 = s("xg-progress", '<xg-outer class="xgplayer-progress-outer">\n                                                   <xg-cache class="xgplayer-progress-cache"></xg-cache>\n                                                   <xg-played class="xgplayer-progress-played">\n                                                     <xg-progress-btn class="xgplayer-progress-btn"></xg-progress-btn>\n                                                     <xg-point class="xgplayer-progress-point xgplayer-tips"></xg-point>\n                                                     <xg-thumbnail class="xgplayer-progress-thumbnail xgplayer-tips"></xg-thumbnail>\n                                                   </xg-played>\n                                                 </xg-outer>', { tabindex: 1 }, "xgplayer-progress"), n2 = void 0;
        e2.controls.appendChild(t2);
        var i2 = t2.querySelector(".xgplayer-progress-played"), o2 = t2.querySelector(".xgplayer-progress-outer"), g = t2.querySelector(".xgplayer-progress-cache"), y = t2.querySelector(".xgplayer-progress-point"), m = t2.querySelector(".xgplayer-progress-thumbnail");
        function x(n3, i3) {
          n3.addEventListener("mouseenter", function(e3) {
            i3 && (a(n3, "xgplayer-progress-dot-show"), a(t2, "xgplayer-progress-dot-active"));
          }), n3.addEventListener("mouseleave", function(e3) {
            i3 && (l(n3, "xgplayer-progress-dot-show"), l(t2, "xgplayer-progress-dot-active"));
          }), n3.addEventListener("touchend", function(r2) {
            r2.stopPropagation(), i3 && (c(n3, "xgplayer-progress-dot-show") || Object.keys(e2.dotArr).forEach(function(t3) {
              e2.dotArr[t3] && l(e2.dotArr[t3], "xgplayer-progress-dot-show");
            }), u(n3, "xgplayer-progress-dot-show"), u(t2, "xgplayer-progress-dot-active"));
          });
        }
        function w() {
          e2.config.progressDot && "Array" === d(e2.config.progressDot) && e2.config.progressDot.forEach(function(t3) {
            if (t3.time >= 0 && t3.time <= e2.duration) {
              var n3 = s("xg-progress-dot", t3.text ? '<span class="xgplayer-progress-tip">' + t3.text + "</span>" : "", {}, "xgplayer-progress-dot");
              if (n3.style.left = t3.time / e2.duration * 100 + "%", t3.duration >= 0 && (n3.style.width = Math.min(t3.duration, e2.duration - t3.time) / e2.duration * 100 + "%"), t3.style)
                for (var i3 in t3.style)
                  n3.style[i3] = t3.style[i3];
              o2.appendChild(n3), e2.dotArr[t3.time] = n3, x(n3, t3.text);
            }
          });
        }
        e2.dotArr = {}, e2.once("canplay", w), e2.addProgressDot = function(t3, n3, i3, r2) {
          if (!e2.dotArr[t3] && t3 >= 0 && t3 <= e2.duration) {
            var a2 = s("xg-progress-dot", n3 ? '<span class="xgplayer-progress-tip">' + n3 + "</span>" : "", {}, "xgplayer-progress-dot");
            if (a2.style.left = t3 / e2.duration * 100 + "%", i3 >= 0 && (a2.style.width = Math.min(i3, e2.duration - t3) / e2.duration * 100 + "%"), r2)
              for (var l2 in r2)
                a2.style[l2] = r2[l2];
            o2.appendChild(a2), e2.dotArr[t3] = a2, x(a2, n3);
          }
        }, e2.removeProgressDot = function(t3) {
          if (t3 >= 0 && t3 <= e2.duration && e2.dotArr[t3]) {
            var n3 = e2.dotArr[t3];
            n3.parentNode.removeChild(n3), n3 = null, e2.dotArr[t3] = null;
          }
        }, e2.removeAllProgressDot = function() {
          Object.keys(e2.dotArr).forEach(function(t3) {
            if (e2.dotArr[t3]) {
              var n3 = e2.dotArr[t3];
              n3.parentNode.removeChild(n3), n3 = null, e2.dotArr[t3] = null;
            }
          });
        };
        var b = 0, E = 0, _ = 0, T = 0, C = 0, k = 0, S = [], P = void 0, L = void 0, O = function() {
          e2.config.thumbnail && (e2.config.thumbnail.isShowCoverPreview && !P && (i2.removeChild(m), P = s("xg-coverpreview", '<xg-outer class="xgplayer-coverpreview-outer">\n            <xg-thumbnail class="xgplayer-coverpreview-thumbnail"></xg-thumbnail>\n            <xg-point class="xgplayer-coverpreview-point"></xg-point>\n          </xg-outer>', { tabindex: 1 }, "xgplayer-coverpreview"), P.querySelector(".xgplayer-coverpreview-outer"), L = P.querySelector(".xgplayer-coverpreview-point"), m = P.querySelector(".xgplayer-coverpreview-thumbnail"), e2.root.appendChild(P)), b = e2.config.thumbnail.pic_num, E = e2.config.thumbnail.width, _ = e2.config.thumbnail.height, T = e2.config.thumbnail.col, C = e2.config.thumbnail.row, S = e2.config.thumbnail.urls, m.style.width = E + "px", m.style.height = _ + "px");
        };
        e2.on("loadedmetadata", O), "function" == typeof e2.config.disableSwipeHandler && "function" == typeof e2.config.enableSwipeHandler && (e2.root.addEventListener("touchmove", function(t3) {
          t3.preventDefault(), e2.disableSwipe || (e2.disableSwipe = true, e2.config.disableSwipeHandler.call(e2));
        }), e2.root.addEventListener("touchstart", function(t3) {
          e2.disableSwipe = true, e2.config.disableSwipeHandler.call(e2);
        }), e2.root.addEventListener("touchend", function(t3) {
          e2.disableSwipe = false, e2.config.enableSwipeHandler.call(e2);
        })), ["touchstart", "mousedown"].forEach(function(o3) {
          t2.addEventListener(o3, function(o4) {
            if (!e2.config.disableProgress) {
              if (o4.stopPropagation(), f(o4), o4._target === y || !e2.config.allowSeekAfterEnded && e2.ended)
                return true;
              t2.focus();
              var s2 = i2.getBoundingClientRect().left, a2 = v(e2);
              a2 ? (s2 = i2.getBoundingClientRect().top, n2 = t2.getBoundingClientRect().height) : (n2 = t2.getBoundingClientRect().width, s2 = i2.getBoundingClientRect().left);
              var l2 = function(t3) {
                t3.stopPropagation(), f(t3), e2.isProgressMoving = true;
                var r2 = (a2 ? t3.clientY : t3.clientX) - s2;
                r2 > n2 && (r2 = n2);
                var o5 = r2 / n2 * e2.duration;
                if (o5 < 0 && (o5 = 0), e2.config.allowSeekPlayed && Number(o5).toFixed(1) > e2.maxPlayedTime)
                  ;
                else if (i2.style.width = 100 * r2 / n2 + "%", "video" !== e2.videoConfig.mediaType || e2.dash || e2.config.closeMoveSeek) {
                  var l3 = h(e2.controls, ".xgplayer-time");
                  l3 && (l3.innerHTML = '<span class="xgplayer-time-current">' + p(o5 || 0) + "</span><span>" + p(e2.duration) + "</span>");
                } else
                  e2.currentTime = Number(o5).toFixed(1);
                if (e2.config.thumbnail && e2.config.thumbnail.isShowCoverPreview) {
                  L.innerHTML = "<span>" + p(o5) + "</span> / " + p(e2.duration || 0), k = e2.duration / b;
                  var c3 = Math.floor(o5 / k);
                  m.style.backgroundImage = "url(" + S[Math.ceil((c3 + 1) / (T * C)) - 1] + ")";
                  var u2 = c3 + 1 - T * C * (Math.ceil((c3 + 1) / (T * C)) - 1), d2 = Math.ceil(u2 / C) - 1, v2 = u2 - d2 * C - 1;
                  m.style["background-position"] = "-" + v2 * E + "px -" + d2 * _ + "px", P.style.display = "block";
                }
                e2.emit("focus");
              }, c2 = function o5(c3) {
                if (c3.stopPropagation(), f(c3), window.removeEventListener("mousemove", l2), window.removeEventListener("touchmove", l2, { passive: false }), window.removeEventListener("mouseup", o5), window.removeEventListener("touchend", o5), r.default.browser.indexOf("ie") < 0 && t2.blur(), !e2.isProgressMoving || e2.videoConfig && "audio" === e2.videoConfig.mediaType || e2.dash || e2.config.closeMoveSeek) {
                  var u2 = (a2 ? c3.clientY : c3.clientX) - s2;
                  u2 > n2 && (u2 = n2);
                  var d2 = u2 / n2 * e2.duration;
                  d2 < 0 && (d2 = 0), e2.config.allowSeekPlayed && Number(d2).toFixed(1) > e2.maxPlayedTime || (i2.style.width = 100 * u2 / n2 + "%", e2.currentTime = Number(d2).toFixed(1));
                }
                e2.config.thumbnail && e2.config.thumbnail.isShowCoverPreview && (P.style.display = "none"), e2.emit("focus"), e2.isProgressMoving = false;
              };
              return window.addEventListener("mousemove", l2), window.addEventListener("touchmove", l2, { passive: false }), window.addEventListener("mouseup", c2), window.addEventListener("touchend", c2), true;
            }
          });
        }), t2.addEventListener("mouseenter", function(n3) {
          if (!e2.config.allowSeekAfterEnded && e2.ended)
            return true;
          var i3 = v(e2), r2 = i3 ? t2.getBoundingClientRect().top : t2.getBoundingClientRect().left, o3 = i3 ? t2.getBoundingClientRect().height : t2.getBoundingClientRect().width, s2 = function(n4) {
            var s3 = ((i3 ? n4.clientY : n4.clientX) - r2) / o3 * e2.duration;
            s3 = s3 < 0 ? 0 : s3, y.textContent = p(s3);
            var a3 = y.getBoundingClientRect().width;
            if (e2.config.thumbnail && !e2.config.thumbnail.isShowCoverPreview) {
              k = e2.duration / b;
              var l2 = Math.floor(s3 / k);
              m.style.backgroundImage = "url(" + S[Math.ceil((l2 + 1) / (T * C)) - 1] + ")";
              var u2 = l2 + 1 - T * C * (Math.ceil((l2 + 1) / (T * C)) - 1), d2 = Math.ceil(u2 / C) - 1, f2 = u2 - d2 * C - 1;
              m.style["background-position"] = "-" + f2 * E + "px -" + d2 * _ + "px";
              var h2 = (i3 ? n4.clientY : n4.clientX) - r2 - E / 2;
              h2 = (h2 = h2 > 0 ? h2 : 0) < o3 - E ? h2 : o3 - E, m.style.left = h2 + "px", m.style.top = -10 - _ + "px", m.style.display = "block", y.style.left = h2 + E / 2 - a3 / 2 + "px";
            } else {
              var v2 = n4.clientX - r2 - a3 / 2;
              v2 = (v2 = v2 > 0 ? v2 : 0) > o3 - a3 ? o3 - a3 : v2, y.style.left = v2 + "px";
            }
            c(t2, "xgplayer-progress-dot-active") ? y.style.display = "none" : y.style.display = "block";
          }, a2 = function(e3) {
            s2(e3);
          };
          t2.addEventListener("mousemove", a2, false), t2.addEventListener("mouseleave", function n4(i4) {
            t2.removeEventListener("mousemove", a2, false), t2.removeEventListener("mouseleave", n4, false), s2(i4), y.style.display = "none", e2.config.thumbnail && !e2.config.thumbnail.isShowCoverPreview && (m.style.display = "none");
          }, false), s2(n3);
        }, false);
        var A = function() {
          if (void 0 === e2.maxPlayedTime && (e2.maxPlayedTime = 0), e2.maxPlayedTime < e2.currentTime && (e2.maxPlayedTime = e2.currentTime), !n2 && t2 && (n2 = t2.getBoundingClientRect().width), "audio" !== e2.videoConfig.mediaType || !e2.isProgressMoving || !e2.dash) {
            var r2 = e2.currentTime / e2.duration, o3 = Number(i2.style.width.replace("%", "") || "0") / Number(t2.style.width || "100");
            Math.abs(r2 - o3) <= 1 && (i2.style.width = 100 * e2.currentTime / e2.duration + "%");
          }
        };
        e2.on("timeupdate", A);
        var R = function() {
          i2.style.width = 100 * e2.currentTime / e2.duration + "%";
        };
        e2.on("currentTimeChange", R);
        var I = function() {
          i2.style.width = "0%";
        };
        e2.on("srcChange", I);
        var M = function() {
          var t3 = e2.buffered;
          if (t3 && t3.length > 0) {
            for (var n3 = t3.end(t3.length - 1), i3 = 0, r2 = t3.length; i3 < r2; i3++)
              if (e2.currentTime >= t3.start(i3) && e2.currentTime <= t3.end(i3)) {
                n3 = t3.end(i3);
                for (var o3 = i3 + 1; o3 < t3.length; o3++)
                  if (t3.start(o3) - t3.end(o3 - 1) >= 2) {
                    n3 = t3.end(o3 - 1);
                    break;
                  }
                break;
              }
            g.style.width = n3 / e2.duration * 100 + "%";
          }
        }, D = ["bufferedChange", "cacheupdate", "ended", "timeupdate"];
        D.forEach(function(t3) {
          e2.on(t3, M);
        }), e2.once("destroy", function t3() {
          e2.removeAllProgressDot(), e2.off("canplay", w), e2.off("timeupdate", A), e2.off("currentTimeChange", R), e2.off("srcChange", I), e2.off("loadedmetadata", O), D.forEach(function(t4) {
            e2.off(t4, M);
          }), e2.off("destroy", t3);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      n(64);
      var s = o.default.createDom;
      t.default = { name: "s_poster", method: function() {
        var e2 = this.root;
        if (this.config.poster) {
          var t2 = s("xg-poster", "", {}, "xgplayer-poster");
          t2.style.backgroundImage = "url(" + this.config.poster + ")", e2.appendChild(t2);
        }
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true }), n(66);
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      var s = o.default.createDom, a = o.default.format;
      t.default = { name: "s_time", method: function() {
        var e2 = this, t2 = s("xg-time", '<span class="xgplayer-time-current">' + (e2.currentTime || a(0)) + "</span>", {}, "xgplayer-time"), n2 = s("xg-duration", "<span>" + (e2.duration || a(0)) + "</span>", {}, "xgplayer-duration");
        e2.once("ready", function() {
          e2.controls && (e2.controls.appendChild(t2), e2.controls.appendChild(n2));
        });
        var i2 = function() {
          "audio" === e2.videoConfig.mediaType && e2.isProgressMoving && e2.dash || (t2.innerHTML = '<span class="xgplayer-time-current">' + a(e2.currentTime || 0) + "</span>");
        }, r2 = function() {
          "audio" === e2.videoConfig.mediaType && e2.isProgressMoving && e2.dash || (n2.innerHTML = "<span>" + a(e2.duration) + "</span>");
        };
        e2.on("durationchange", r2), e2.on("timeupdate", i2), e2.once("destroy", function t3() {
          e2.off("durationchange", r2), e2.off("timeupdate", i2), e2.off("destroy", t3);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = o(n(0)), r = o(n(2));
      function o(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      n(68);
      var s = i.default.createDom, a = i.default.addClass, l = i.default.removeClass, c = i.default.hasClass, u = i.default.toggleClass;
      t.default = { name: "s_playbackRate", method: function() {
        var e2 = this, t2 = [];
        if (!e2.config.playbackRate)
          return false;
        (t2 = [].concat(e2.config.playbackRate)).sort(function(e3, t3) {
          return t3 - e3;
        });
        var n2 = void 0 !== e2.config.playbackRateUnit ? e2.config.playbackRateUnit : "x", i2 = s("xg-playbackrate", " ", {}, "xgplayer-playbackrate");
        "mobile" === r.default.device && (e2.config.playbackRateActive = "click");
        var o2 = [];
        t2.forEach(function(e3) {
          o2.push({ name: "" + e3, rate: "" + e3 + n2, selected: false });
        });
        var d = 1, f = s("xg-playbackrate-list", " ", {}, "xgplayer-playbackrate-list"), p = ["<ul>"];
        o2.forEach(function(t3) {
          e2.config.defaultPlaybackRate && e2.config.defaultPlaybackRate.toString() === t3.name ? (t3.selected = true, d = e2.config.defaultPlaybackRate, e2.once("playing", function() {
            e2.video.playbackRate = e2.config.defaultPlaybackRate;
          })) : "1.0" !== t3.name && "1" !== t3.name || e2.config.defaultPlaybackRate && 1 !== e2.config.defaultPlaybackRate || (t3.selected = true), p.push("<li cname='" + t3.name + "' class='" + (t3.selected ? "selected" : "") + "'>" + t3.rate + "</li>");
        }), p.push("</ul>");
        var h = ["<p class='name'>" + ("1.0" === d || 1 === d ? "\u500D\u901F" : "" + d + n2) + "</p>"], v = e2.root.querySelector(".xgplayer-playbackrate");
        if (v) {
          f.innerHTML = p.join(""), v.innerHTML = h.join("");
          var g = v.querySelector(".name");
          e2.config.playbackRateActive && "hover" !== e2.config.playbackRateActive || g.addEventListener("mouseenter", function(t3) {
            t3.preventDefault(), t3.stopPropagation(), a(e2.root, "xgplayer-playbackrate-active"), v.focus();
          });
        } else {
          f.innerHTML = p.join(""), i2.innerHTML = h.join("");
          var y = i2.querySelector(".name");
          e2.config.playbackRateActive && "hover" !== e2.config.playbackRateActive || y.addEventListener("mouseenter", function(t3) {
            t3.preventDefault(), t3.stopPropagation(), a(e2.root, "xgplayer-playbackrate-active"), i2.focus();
          }), e2.once("ready", function() {
            e2.root.appendChild(f), e2.controls.appendChild(i2);
          });
        }
        ["touchend", "click"].forEach(function(t3) {
          f.addEventListener(t3, function(t4) {
            var i3 = t4.target;
            if (i3 && "li" === i3.tagName.toLocaleLowerCase()) {
              var s2, u2 = void 0;
              o2.forEach(function(t5) {
                t5.selected = false, i3.textContent.replace(/\s+/g, "") === t5.rate && (Array.prototype.forEach.call(i3.parentNode.childNodes, function(e3) {
                  c(e3, "selected") && (u2 = Number(e3.getAttribute("cname")), l(e3, "selected"));
                }), t5.selected = true, e2.video.playbackRate = 1 * t5.name, d = 1 * t5.name);
              }), a(i3, "selected"), s2 = Number(i3.getAttribute("cname")), document.querySelector(".xgplayer-playbackrate .name").innerHTML = "1.0" === s2 || 1 === s2 ? "\u500D\u901F" : "" + i3.getAttribute("cname") + n2, e2.emit("playbackrateChange", { from: u2, to: s2 }), "mobile" === r.default.device && l(e2.root, "xgplayer-playbackrate-active");
            }
          }), i2.addEventListener(t3, function(t4) {
            t4.stopPropagation(), t4.preventDefault();
            var n3 = t4.target;
            "click" !== e2.config.playbackRateActive || !n3 || "p" !== n3.tagName.toLocaleLowerCase() && "span" !== n3.tagName.toLocaleLowerCase() || ("mobile" === r.default.device ? (e2.emit("blur"), l(e2.root, "xgplayer-show-control"), l(e2.root, "xgplayer-pause"), u(e2.root, "xgplayer-playbackrate-active")) : a(e2.root, "xgplayer-playbackrate-active"), i2.focus()), e2.emit("focus");
          }, false);
        }), i2.addEventListener("mouseleave", function(t3) {
          t3.preventDefault(), t3.stopPropagation(), l(e2.root, "xgplayer-playbackrate-active");
        }), e2.on("blur", function() {
        }), e2.on("play", function() {
          e2.video.playbackRate.toFixed(1) !== d.toFixed(1) && (e2.video.playbackRate = d);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      var s = o.default.addClass, a = o.default.hasClass, l = o.default.removeClass;
      t.default = { name: "start", method: function() {
        var e2 = this, t2 = e2.root;
        function n2() {
          e2.off("canplay", n2);
          var t3 = e2.play();
          void 0 !== t3 && t3 && t3.catch(function(e3) {
          });
        }
        function i2() {
          a(t2, "xgplayer-nostart") ? (l(t2, "xgplayer-nostart"), s(t2, "xgplayer-is-enter"), "function" == typeof t2.contains ? e2.video && 1 === e2.video.nodeType && !t2.contains(e2.video) || e2.video && 1 !== e2.video.nodeType && "ready" !== e2.video.audioPlayer.status ? (e2.once("canplay", n2), e2.start()) : n2() : e2.video && 1 === e2.video.nodeType && !t2.querySelector(this.videoConfig.mediaType) || e2.video && 1 !== e2.video.nodeType && !t2.querySelector("canvas") && "ready" !== e2.video.audioPlayer.status ? (e2.once("canplay", n2), e2.start()) : n2()) : e2.paused ? (l(t2, "xgplayer-nostart xgplayer-isloading"), setTimeout(function() {
            var t3 = e2.play();
            void 0 !== t3 && t3 && t3.catch(function(e3) {
            });
          }, 10)) : e2.pause();
        }
        e2.on("startBtnClick", i2), e2.once("destroy", function t3() {
          e2.off("startBtnClick", i2), e2.off("canplay", n2), e2.off("destroy", t3);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      var s = o.default.addClass, a = o.default.hasClass, l = o.default.removeClass;
      t.default = { name: "fullscreen", method: function() {
        var e2 = this, t2 = e2.root;
        function n2() {
          e2.config.rotateFullscreen ? a(t2, "xgplayer-rotate-fullscreen") ? e2.exitRotateFullscreen() : e2.getRotateFullscreen() : e2.config.cssFullscreen ? a(t2, "xgplayer-is-cssfullscreen") ? e2.exitCssFullscreen() : e2.getCssFullscreen() : a(t2, "xgplayer-is-fullscreen") ? e2.exitFullscreen(t2) : e2.getFullscreen(t2), e2.emit("focus");
        }
        function i2() {
          var n3 = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
          n3 && (n3 === t2 || n3.shadowRoot && n3.shadowRoot.contains(t2)) ? (s(t2, "xgplayer-is-fullscreen"), e2.emit("requestFullscreen")) : a(t2, "xgplayer-is-fullscreen") && (l(t2, "xgplayer-is-fullscreen"), e2.emit("exitFullscreen")), e2.danmu && "function" == typeof e2.danmu.resize && e2.danmu.resize();
        }
        e2.on("fullscreenBtnClick", n2), ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"].forEach(function(e3) {
          document.addEventListener(e3, i2);
        }), e2.video.addEventListener("webkitbeginfullscreen", function() {
          s(t2, "xgplayer-is-fullscreen"), e2.emit("requestFullscreen");
        }), e2.video.addEventListener("webkitendfullscreen", function() {
          l(t2, "xgplayer-is-fullscreen"), e2.emit("exitFullscreen");
        }), e2.once("destroy", function t3() {
          e2.off("fullscreenBtnClick", n2), ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"].forEach(function(e3) {
            document.removeEventListener(e3, i2);
          }), e2.off("destroy", t3);
        }), e2.getFullscreen = function(e3) {
          var t3 = this;
          if (e3.requestFullscreen) {
            var n3 = e3.requestFullscreen();
            n3 && n3.catch(function() {
              t3.emit("fullscreen error");
            });
          } else
            e3.mozRequestFullScreen ? e3.mozRequestFullScreen() : e3.webkitRequestFullscreen ? e3.webkitRequestFullscreen(window.Element.ALLOW_KEYBOARD_INPUT) : t3.video.webkitSupportsFullscreen ? t3.video.webkitEnterFullscreen() : e3.msRequestFullscreen ? e3.msRequestFullscreen() : s(e3, "xgplayer-is-cssfullscreen");
        }, e2.exitFullscreen = function(e3) {
          document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen(), l(e3, "xgplayer-is-cssfullscreen");
        }, e2.getRotateFullscreen = function() {
          document.documentElement.style.width = "100%", document.documentElement.style.height = "100%", this.root && !a(this.root, "xgplayer-rotate-fullscreen") && s(this.root, "xgplayer-rotate-fullscreen"), this.emit("getRotateFullscreen");
        }, e2.exitRotateFullscreen = function() {
          document.documentElement.style.width = "unset", document.documentElement.style.height = "unset", this.root && a(this.root, "xgplayer-rotate-fullscreen") && l(this.root, "xgplayer-rotate-fullscreen"), this.emit("exitRotateFullscreen");
        };
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = o(n(0)), r = o(n(2));
      function o(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      var s = i.default.addClass, a = i.default.removeClass, l = i.default.event;
      t.default = { name: "volume", method: function() {
        var e2 = this, t2 = e2.root, n2 = void 0, i2 = void 0, o2 = void 0, c = void 0;
        function u() {
          e2.controls && (e2.volume = e2.config.volume, (n2 = e2.controls.querySelector(".xgplayer-volume")) && (i2 = n2.querySelector(".xgplayer-slider"), o2 = n2.querySelector(".xgplayer-bar"), c = n2.querySelector(".xgplayer-drag"), "mobile" === r.default.device && g()));
        }
        function d(t3) {
          if (i2) {
            e2.video.muted = false, i2.focus(), l(t3);
            var n3 = o2.getBoundingClientRect(), r2 = (t3.clientX, t3.clientY), s2 = c.getBoundingClientRect().height, a2 = false, u2 = function(t4) {
              t4.preventDefault(), t4.stopPropagation(), l(t4), a2 = true;
              var i3 = s2 - t4.clientY + r2, o3 = i3 / n3.height;
              c.style.height = i3 + "px", e2.volume = Math.max(Math.min(o3, 1), 0);
            }, d2 = function t4(r3) {
              if (r3.preventDefault(), r3.stopPropagation(), l(r3), window.removeEventListener("mousemove", u2), window.removeEventListener("touchmove", u2), window.removeEventListener("mouseup", t4), window.removeEventListener("touchend", t4), !a2) {
                var o3 = n3.height - (r3.clientY - n3.top), s3 = o3 / n3.height;
                c.style.height = o3 + "px", s3 <= 0 && (e2.volume > 0 ? c.volume = e2.video.volume : s3 = c.volume), e2.volume = Math.max(Math.min(s3, 1), 0);
              }
              i2.volume = e2.volume, a2 = false;
            };
            return window.addEventListener("mousemove", u2), window.addEventListener("touchmove", u2), window.addEventListener("mouseup", d2), window.addEventListener("touchend", d2), false;
          }
        }
        function f() {
          if ("mobile" === r.default.device)
            e2.video.muted ? (e2.video.muted = false, e2.emit("unmute"), e2.volume = 1) : (e2.video.muted = true, e2.emit("mute"), e2.volume = 0), e2.emit("focus");
          else {
            if (!i2)
              return;
            e2.video.muted = false, e2.volume < 0.1 ? (i2.volume < 0.1 ? e2.volume = 0.6 : e2.volume = i2.volume, e2.emit("unmute")) : (e2.volume = 0, e2.emit("mute"));
          }
        }
        function p() {
          s(t2, "xgplayer-volume-active"), n2 && n2.focus();
        }
        function h() {
          a(t2, "xgplayer-volume-active");
        }
        e2.once("canplay", u), e2.on("volumeBarClick", d), e2.on("volumeIconClick", f), e2.on("volumeIconEnter", p), e2.on("volumeIconLeave", h);
        var v = null;
        function g() {
          v && clearTimeout(v), v = setTimeout(function() {
            if ("mobile" === r.default.device)
              a(t2, "xgplayer-volume-muted"), a(t2, "xgplayer-volume-large"), e2.video.muted || e2.video.defaultMuted ? (e2.video.muted || (e2.video.muted = true), e2.video.defaultMuted = false, s(t2, "xgplayer-volume-muted")) : s(t2, "xgplayer-volume-large");
            else {
              if (a(t2, "xgplayer-volume-muted"), a(t2, "xgplayer-volume-small"), a(t2, "xgplayer-volume-large"), 0 === e2.volume ? s(t2, "xgplayer-volume-muted") : e2.volume < 0.5 ? s(t2, "xgplayer-volume-small") : s(t2, "xgplayer-volume-large"), !o2)
                return;
              var n3 = o2.getBoundingClientRect().height || 76;
              c.style.height = e2.volume * n3 + "px";
            }
          }, 50);
        }
        e2.on("volumechange", g), e2.once("destroy", function t3() {
          e2.off("canplay", u), e2.off("volumeBarClick", d), e2.off("volumeIconClick", f), e2.off("volumeIconEnter", p), e2.off("volumeIconLeave", h), e2.off("volumechange", g), e2.off("destroy", t3), v && (clearTimeout(v), v = null);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = o(n(0)), r = o(n(73));
      function o(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      n(74);
      var s = i.default.createDom, a = i.default.addClass, l = i.default.removeClass;
      t.default = { name: "s_replay", method: function() {
        var e2 = this, t2 = e2.root, n2 = e2.lang.REPLAY, i2 = s("xg-replay", r.default + '\n                                         <xg-replay-txt class="xgplayer-replay-txt">' + n2 + "</xg-replay-txt>\n                                        ", {}, "xgplayer-replay");
        function o2() {
          e2.config.loop || a(e2.root, "xgplayer-is-replay");
          var t3 = i2.querySelector("path");
          if (t3) {
            var n3 = window.getComputedStyle(t3).getPropertyValue("transform");
            if ("string" == typeof n3 && n3.indexOf("none") > -1)
              return;
            t3.setAttribute("transform", n3);
          }
        }
        e2.once("ready", function() {
          t2.appendChild(i2);
        }), e2.on("ended", o2), i2.addEventListener("click", function(e3) {
          e3.preventDefault(), e3.stopPropagation();
        });
        var c = i2.querySelector("svg");
        ["click", "touchend"].forEach(function(t3) {
          c.addEventListener(t3, function(t4) {
            t4.preventDefault(), t4.stopPropagation(), e2.userGestureTrigEvent("replayBtnClick");
          });
        });
        var u = function() {
          l(e2.root, "xgplayer-is-replay"), e2.replay();
        };
        e2.on("replayBtnClick", u), e2.once("destroy", function t3() {
          e2.off("ended", o2), e2.off("destroy", t3), e2.off("replayBtnClick", u);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t), t.default = '<svg class="xgplayer-replay-svg" xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewbox="0 0 78 78">\n  <path d="M8.22708362,13.8757234 L11.2677371,12.6472196 C11.7798067,12.4403301 12.3626381,12.6877273 12.5695276,13.1997969 L12.9441342,14.1269807 C13.1510237,14.6390502 12.9036264,15.2218816 12.3915569,15.4287712 L6.8284538,17.6764107 L5.90126995,18.0510173 C5.38920044,18.2579068 4.80636901,18.0105096 4.5994795,17.49844 L1.97723335,11.0081531 C1.77034384,10.4960836 2.0177411,9.91325213 2.52981061,9.70636262 L3.45699446,9.33175602 C3.96906396,9.12486652 4.5518954,9.37226378 4.75878491,9.88433329 L5.67885163,12.1615783 C7.99551726,6.6766934 13.3983951,3 19.5,3 C27.7842712,3 34.5,9.71572875 34.5,18 C34.5,26.2842712 27.7842712,33 19.5,33 C15.4573596,33 11.6658607,31.3912946 8.87004692,28.5831991 C8.28554571,27.9961303 8.28762719,27.0463851 8.87469603,26.4618839 C9.46176488,25.8773827 10.4115101,25.8794641 10.9960113,26.466533 C13.2344327,28.7147875 16.263503,30 19.5,30 C26.127417,30 31.5,24.627417 31.5,18 C31.5,11.372583 26.127417,6 19.5,6 C14.4183772,6 9.94214483,9.18783811 8.22708362,13.8757234 Z"></path>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = a(n(76)), r = a(n(77));
      n(78);
      var o = a(n(8)), s = a(n(0));
      function a(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      var l = s.default.createDom, c = s.default.addClass, u = s.default.removeClass, d = o.default.isWx || o.default.isWxMini, f = o.default.isAndroid && !o.default.isAppWebView, p = false;
      t.default = { name: "s_start", method: function() {
        var e2 = this, t2 = e2.root, n2 = l("xg-start", '<div class="xgplayer-icon-play">' + i.default + '</div>\n                                      <div class="xgplayer-icon-pause">' + r.default + "</div>", {}, "xgplayer-start"), s2 = l("xg-shade", "", {}, "xgplayer-shade");
        function a2(e3) {
          c(e3.root, "xgplayer-skin-default"), e3.config && (!e3.config.autoplay || f && !p || c(e3.root, "xgplayer-is-enter"), e3.config.lang && "en" === e3.config.lang ? c(e3.root, "xgplayer-lang-is-en") : "jp" === e3.config.lang && c(e3.root, "xgplayer-lang-is-jp"), e3.config.enableContextmenu || e3.video.addEventListener("contextmenu", function(e4) {
            e4.preventDefault(), e4.stopPropagation();
          }));
        }
        e2.isReady ? (t2.appendChild(n2), s2 && t2.appendChild(s2), a2(e2)) : e2.once("ready", function() {
          t2.appendChild(n2), s2 && t2.appendChild(s2), a2(e2);
        }), e2.once("autoplay was prevented", function() {
          o.default.isAppWebView || o.default.isIOS && (d || o.default.isQq) || (u(e2.root, "xgplayer-is-enter"), u(e2.root, "xgplayer-will-play"), c(e2.root, "xgplayer-nostart"));
        }), e2.once("canplay", function() {
          u(e2.root, "xgplayer-is-enter");
        });
        var h = false;
        if (e2.once("play", function() {
          h = true, p = true;
        }), n2.onclick = function(t3) {
          t3.preventDefault(), t3.stopPropagation(), e2.userGestureTrigEvent("startBtnClick");
        }, d && !p) {
          var v = function() {
            h || !e2.autoplay || p || e2.play();
          };
          document.addEventListener("WeixinJSBridgeReady", v, false), e2.once("destroy", function() {
            document.removeEventListener("WeixinJSBridgeReady", v, false);
          });
        }
        if (!p && f) {
          var g = function() {
            h || !e2.autoplay || p || (p = true, e2.play());
          };
          document.addEventListener("touchend", g, false), e2.once("destroy", function() {
            document.removeEventListener("touchend", g, false);
          });
        }
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="utf-8"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version="1.1" id="\u56FE\u5C42_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70" height="70"\n	 viewBox="0 0 70 70" style="enable-background:new 0 0 70 70;" xml:space="preserve">\n<path d="M32.2,23.6c0.7,0,1.6,0.2,2.2,0.7l11.6,7.9c1.1,0.7,1.7,2,1.7,3.4s-0.6,2.6-1.7,3.4l-11.6,7.9c-0.6,0.4-1.2,0.6-2,0.6h-0.2\n	c-1.1,0-2.1-0.4-2.9-1.1c-0.7-0.7-1.1-1.7-1.1-2.9V27.7c0-1.1,0.4-2.1,1.1-2.9C30.2,24.1,31.2,23.6,32.2,23.6L32.2,23.6z"/>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" encoding="utf-8"?>\n<!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version="1.1" id="\u56FE\u5C42_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70" height="70"\n	 viewBox="0 0 70 70" style="enable-background:new 0 0 70 70;" xml:space="preserve">\n<style type="text/css">\n	.st0{fill:#FFFFFF;}\n</style>\n<path class="st0" d="M43.1,23.6c2.1,0,3.2,1.1,3.2,3.5v16.8c0,2.4-1.1,3.5-3.2,3.5c-2.1,0-3.2-1.1-3.2-3.5V27.1\n	C39.8,24.7,40.8,23.6,43.1,23.6 M27.8,23.6c2.1,0,3.2,1.1,3.2,3.5v16.8c0,2.4-1.1,3.5-3.2,3.5s-3.2-1.1-3.2-3.5V27.1\n	C24.6,24.7,25.7,23.6,27.8,23.6"/>\n</svg>\n';
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      n(80);
      var s = o.default.createDom, a = o.default.removeClass, l = o.default.addClass;
      t.default = { name: "s_enter", method: function() {
        for (var e2 = this, t2 = e2.root, n2 = "", i2 = 1; i2 <= 12; i2++)
          n2 += '<div class="xgplayer-enter-bar' + i2 + '"></div>';
        var r2 = s("xg-enter", '<div class="xgplayer-enter-spinner">\n                                                  ' + n2 + "\n                                                </div>", {}, "xgplayer-enter");
        t2.appendChild(r2);
        var o2 = true;
        function c(e3) {
          e3.currentTime > 0 && o2 && (o2 = false, setTimeout(function() {
            a(t2, "xgplayer-will-play");
          }, 0));
        }
        function u() {
          o2 = true, e2.autoplay ? l(t2, "xgplayer-will-play") : l(t2, "xgplayer-nostart");
        }
        function d() {
          e2.video.autoplay = e2.autoplay;
        }
        e2.once("ready", function() {
          e2.config.autoplay && l(t2, "xgplayer-will-play");
        }), e2.on("timeupdate", c), e2.on("srcChange", u), e2.on("playing", d), e2.once("destroy", function() {
          e2.off("timeupdate", c), e2.off("srcChange", u), e2.off("playing", d);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i = a(n(0)), r = a(n(82)), o = a(n(83)), s = a(n(84));
      function a(e2) {
        return e2 && e2.__esModule ? e2 : { default: e2 };
      }
      n(85);
      var l = i.default.createDom, c = i.default.createImgBtn;
      t.default = { name: "s_nav", method: function() {
        var e2 = this, t2 = e2.config.navRightBtn ? e2.config.navRightBtn : {}, n2 = e2.config.showNavInline || false, i2 = e2.config.lockNavInline || false, a2 = "";
        "img" === t2.type ? a2 = c("nav-right", t2.url.request, t2.width, t2.height) : "more" !== t2.type && "share" !== t2.type || (a2 = l("xg-icon", '<div class="xgplayer-icon-nav-right">' + ("more" === t2.type ? s.default : o.default) + "</div>", {}, "xgplayer-icon"));
        var u = l("xg-icon", '<div class="xgplayer-icon-nav-left">' + r.default + "</div>", {}, "xgplayer-icon"), d = l("xg-nav", "", {}, "xgplayer-nav " + (n2 ? "xgplayer-nav-inline" : "") + " " + (i2 ? "xgplayer-nav-inline-lock" : ""));
        d.appendChild(u), a2 && d.appendChild(a2);
        var f = l("xg-nav", "", {}, "xgplayer-nav-fullscreen"), p = l("xg-icon", '<div class="xgplayer-icon-nav-left">' + r.default + "</div>", {}, "xgplayer-icon");
        f.appendChild(p), e2.once("ready", function() {
          e2.root && (e2.root.appendChild(d), e2.root.appendChild(f));
        }), ["click", "touchend"].forEach(function(t3) {
          a2 && a2.addEventListener(t3, function(t4) {
            t4.preventDefault(), t4.stopPropagation(), e2.userGestureTrigEvent("clickNavRight");
          }), u.addEventListener(t3, function(t4) {
            t4.preventDefault(), t4.stopPropagation(), e2.userGestureTrigEvent("clickNavLeft");
          }), p.addEventListener(t3, function(t4) {
            t4.preventDefault(), t4.stopPropagation(), e2.userGestureTrigEvent("fullscreenBtnClick");
          });
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg t="1624072468176" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11946" width="22" height="22" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><style type="text/css"></style></defs><path d="M399.20110933 102.912a66.56 66.56 0 0 1 98.9696 88.7808l-4.864 5.376-311.0912 311.0912 311.6032 311.6032a66.56 66.56 0 0 1 4.864 88.7296l-4.864 5.376a66.56 66.56 0 0 1-88.7296 4.864l-5.376-4.864L41.00590933 555.2128a66.56 66.56 0 0 1-4.864-88.7296l4.864-5.376L399.20110933 102.912z" fill="#FFFFFF" p-id="11947"></path></svg>';
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg t="1624093348556" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10507" width="21" height="21" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><style type="text/css"></style></defs><path d="M431.294361 6.916018a51.176689 51.176689 0 1 1 49.794919 89.405675L157.703782 276.361285c-18.423608 10.286514-29.52895 28.812476-29.52895 48.566678v360.130361c0 19.703025 11.105342 38.228987 29.52895 48.515501l323.385498 180.090769a63.970861 63.970861 0 0 0 61.82144 0l323.385498-180.141946c18.423608-10.235338 29.52895-28.761299 29.52895-48.464324v-153.17183a51.176689 51.176689 0 1 1 102.353378 0v153.17183a158.135969 158.135969 0 0 1-82.08741 137.921177l-323.385497 180.090768a166.324239 166.324239 0 0 1-161.411278 0l-323.385497-180.090768A158.135969 158.135969 0 0 1 25.821454 685.058324V324.876787a158.135969 158.135969 0 0 1 82.08741-137.972354zM947.001857 0.416578a51.176689 51.176689 0 0 1 51.176689 51.176689v255.883445a51.176689 51.176689 0 0 1-102.353378 0V175.082618l-239.609258 239.660435a51.176689 51.176689 0 0 1-67.55323 4.247665l-4.810609-4.247665a51.176689 51.176689 0 0 1-4.247665-67.55323l4.247665-4.810609L823.461329 102.769956 691.118412 102.769956a51.176689 51.176689 0 1 1 0-102.353378h255.883445z" fill="#FFFFFF" p-id="10508"></path></svg>';
    }, function(e, t, n) {
      n.r(t), t.default = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg t="1624093381853" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10833" width="21" height="21" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><style type="text/css"></style></defs><path d="M204.8 409.6a102.4 102.4 0 1 1 0 204.8 102.4 102.4 0 0 1 0-204.8z m307.2 0a102.4 102.4 0 1 1 0 204.8 102.4 102.4 0 0 1 0-204.8z m307.2 0a102.4 102.4 0 1 1 0 204.8 102.4 102.4 0 0 1 0-204.8z" p-id="10834" fill="#FFFFFF"></path></svg>';
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(4), o = (i = r) && i.__esModule ? i : { default: i };
      var s = { maxCount: 3, backupUrl: "", isFetch: true, fetchTimeout: 100 };
      t.default = { name: "errorretry", method: function() {
        var e2 = this, t2 = this;
        if (t2.config.errorConfig && !(t2.src.indexOf("blob:") > -1)) {
          var n2 = {}, i2 = t2.config.errorConfig;
          for (var r2 in s)
            void 0 === i2[r2] ? n2[r2] = s[r2] : n2[r2] = i2[r2];
          t2.retryData = { count: 0, errfTimer: null, isFetchReturn: false, currentTime: 0 };
          var a = t2._onError;
          t2._onError = function(i3) {
            var r3 = e2.retryData.count;
            if (r3 > n2.maxCount)
              n2.isFetch ? function(e3, t3, n3) {
                var i4 = function(t4, n4) {
                  e3.retryData.isFetchReturn || (e3.retryData.isFetchReturn = true, t4(n4));
                };
                return new Promise(function(r4, o2) {
                  try {
                    var s3 = new window.XMLHttpRequest();
                    s3.open("get", t3), s3.onload = function() {
                      i4(r4, { status: s3.status, statusText: s3.statusText, xhr: s3 });
                    }, s3.onerror = function() {
                      i4(r4, { status: s3.status, statusText: s3.statusText || "The network environment is disconnected or the address is invalid", xhr: s3 });
                    }, s3.onabort = function() {
                    }, e3.retryData.errfTimer = window.setTimeout(function() {
                      var t4 = e3.retryData.errfTimer;
                      window.clearTimeout(t4), e3.retryData.errfTimer = null, i4(r4, { status: -1, statusText: "request timeout" });
                    }, n3), s3.send();
                  } catch (t4) {
                    e3.retryData.isFetchReturn = true, i4(r4, { status: -2, statusText: "request error" });
                  }
                });
              }(e2, e2.currentSrc, n2.fetchTimeout).then(function(t3) {
                e2.emit("error", new o.default({ type: "network", currentTime: e2.currentTime, duration: e2.duration || 0, networkState: e2.networkState, readyState: e2.readyState, currentSrc: e2.currentSrc, src: e2.src, ended: e2.ended, httpCode: t3.status, httpMsg: t3.statusText, errd: { line: 101, msg: e2.error, handle: "plugin errorRetry" }, errorCode: e2.video && e2.video.error.code, mediaError: e2.video && e2.video.error })), a.call(e2, t3);
              }) : a.call(e2, i3);
            else {
              0 === r3 && (e2.retryData.currentTime = e2.currentTime, e2.once("canplay", l.bind(e2)));
              var s2 = "";
              s2 = n2.count < 2 ? n2.backupUrl ? n2.backupUrl : t2.currentSrc : n2.backupUrl && r3 > 1 ? n2.backupUrl : t2.currentSrc, e2.retryData.count++, e2.src = s2;
            }
          };
        }
        function l() {
          this.currentTime = this.retryData.currentTime, this.play(), this.retryData.retryCode = 0, this.retryData.isFetchReturn = false, this.retryData.currentTime = 0;
        }
      } }, e.exports = t.default;
    }, function(e, t, n) {
      Object.defineProperty(t, "__esModule", { value: true });
      var i, r = n(0), o = (i = r) && i.__esModule ? i : { default: i };
      n(88);
      var s = o.default.addClass, a = o.default.removeClass, l = o.default.createDom;
      t.default = { name: "s_error", method: function() {
        var e2 = this, t2 = e2.root, n2 = l("xg-error", '<span class="xgplayer-error-text">\u8BF7<span class="xgplayer-error-refresh">\u5237\u65B0</span>\u8BD5\u8BD5</span>', {}, "xgplayer-error");
        e2.once("ready", function() {
          t2.appendChild(n2);
        });
        var i2 = n2.querySelector(".xgplayer-error-text");
        e2.config.lang && "zh-cn" === e2.config.lang ? i2.innerHTML = e2.config.errorTips || '\u8BF7<span class="xgplayer-error-refresh">\u5237\u65B0</span>\u8BD5\u8BD5' : i2.innerHTML = e2.config.errorTips || 'please try to <span class="xgplayer-error-refresh">refresh</span>';
        var r2 = null;
        function o2() {
          s(e2.root, "xgplayer-is-error"), (r2 = n2.querySelector(".xgplayer-error-refresh")) && ["touchend", "click"].forEach(function(t3) {
            r2.addEventListener(t3, function(t4) {
              t4.preventDefault(), t4.stopPropagation(), e2.video && (e2.video.autoplay = true);
              var n3 = e2.currentTime;
              e2.once("playing", function() {
                e2.currentTime = n3, a(e2.root, "xgplayer-is-error");
              }), e2.src = e2.config.url;
            });
          });
        }
        e2.on("error", o2), e2.once("destroy", function t3() {
          e2.off("error", o2), e2.off("destroy", t3);
        });
      } }, e.exports = t.default;
    }, function(e, t, n) {
      n.r(t);
    }, function(e, t, n) {
      n.r(t);
    }]);
  });
})(dist);
var VideoPlayer$1 = /* @__PURE__ */ getDefaultExportFromCjs(dist.exports);
function generateUUID() {
  function S4() {
    return ((1 + Math.random()) * 65536 || 0).toString(16).substring(1);
  }
  return `pc-${S4()}-${S4()}`;
}
let Player = null;
let androidScrollFix = false;
const env$1 = Env.getInstance();
let isQqBrowser = false;
if (env$1.isClient) {
  const ua = window.navigator.userAgent.toLowerCase();
  isQqBrowser = ua.indexOf("qqbrowser") > 0;
}
const isX5 = env$1.isAndroid && (env$1.isEnvWx || env$1.isQq || isQqBrowser);
const EVENT_VIDEO_PLAY = "videoPlay";
let shadowStyleInjected = false;
const _sfc_main$p = {
  name: "VideoPlayer",
  props: {
    src: {
      type: String,
      default() {
        return "";
      }
    },
    showPlaybackRate: {
      type: Boolean,
      default: false
    },
    playbackRate: {
      type: Array,
      default() {
        return [0.5, 0.75, 1, 1.5, 2];
      }
    },
    poster: {
      type: String,
      default() {
        return "";
      }
    },
    width: {
      type: Number,
      default() {
        return 750;
      }
    },
    height: {
      type: Number,
      default() {
        return 422;
      }
    },
    fitVideoSize: {
      type: String,
      default() {
        return "";
      }
    },
    autoplay: {
      type: Boolean,
      default() {
        return false;
      }
    },
    fluid: {
      type: Boolean,
      default() {
        return true;
      }
    },
    portrait: {
      type: [Number, Boolean],
      default() {
        return -1;
      }
    },
    ext: {
      type: Object,
      default() {
        return {};
      }
    },
    cssFullscreen: {
      type: [Number, Boolean],
      default() {
        return -1;
      }
    },
    resumeAfterVisible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    exitFullscreenAfterEnded: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showNavInline: {
      type: Boolean,
      default() {
        return false;
      }
    },
    lockNavInline: {
      type: Boolean,
      default() {
        return false;
      }
    },
    navRightIcon: {
      type: String,
      default() {
        return "";
      }
    },
    playsinline: {
      type: Boolean,
      default() {
        return false;
      }
    },
    controls: {
      type: Boolean,
      default() {
        return true;
      }
    },
    preventDefault: {
      type: Boolean,
      default() {
        return true;
      }
    },
    videoInit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    controlsInline: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  emits: ["toggle-fullscreen", "pause", "start", "play", "error", "ended", "click-nav-left", "click-nav-right", "timeupdate", "view"],
  data() {
    return {
      player: null,
      videoProgress: 0,
      needPlay: false,
      needTriggerView: true,
      domReady: false,
      cacheExts: {},
      isFullscreen: false,
      isCssFullscreen: false,
      isRotateFullscreen: false,
      isPip: false,
      videoPortrait: -1,
      videoAspectRatio: 1,
      removeCustomBack: null
    };
  },
  computed: {
    landscape() {
      return this.portrait === -1 ? this.videoPortrait === -1 ? this.width > this.height : !this.videoPortrait : !this.portrait;
    },
    autoUseCssFullscreen() {
      return !(!env$1.isAppWebView && env$1.isIOS || isX5);
    },
    finalCssFullscreen() {
      return (this.cssFullscreen === -1 ? this.autoUseCssFullscreen : !!this.cssFullscreen) || env$1.isAndroid;
    },
    finalUseCssFullscreen() {
      return this.finalCssFullscreen && (!env$1.isEnvMobile || !this.landscape);
    },
    finalUseRotateFullscreen() {
      return this.finalCssFullscreen && !this.finalUseCssFullscreen;
    },
    objectFitCover() {
      return Math.abs(this.videoAspectRatio - this.containerAspectRatio) < 0.01;
    },
    containerAspectRatio() {
      return this.width / this.height;
    }
  },
  watch: {
    src: {
      immediate: true,
      handler() {
        this.changeSrc();
      }
    },
    poster(val) {
      if (this.player && val) {
        this.player.poster = val;
      }
    },
    ext(val) {
      this.$nextTick(() => {
        this.cacheExts[this.src] = val;
      });
    },
    isCssFullscreen(fullscreen) {
      this.togglePopGesture(fullscreen);
      this.toggleStatusBar(fullscreen);
      this.$emit("toggle-fullscreen", {
        isCss: true,
        fullscreen
      });
      if (fullscreen) {
        customBack({
          enable: true,
          handler: this.exitFullscreen
        }).then((res) => {
          this.removeCustomBack = res.data.removeHandler;
        });
      } else {
        if (this.removeCustomBack) {
          this.removeCustomBack();
          this.removeCustomBack = null;
        }
      }
    },
    isRotateFullscreen(fullscreen) {
      this.$emit("toggle-fullscreen", {
        isRotate: true,
        fullscreen
      });
      if (fullscreen) {
        customBack({
          enable: true,
          handler: this.exitFullscreen
        }).then((res) => {
          this.removeCustomBack = res.data.removeHandler;
        });
      } else {
        if (this.removeCustomBack) {
          this.removeCustomBack();
          this.removeCustomBack = null;
        }
      }
    },
    isFullscreen(fullscreen) {
      this.$emit("toggle-fullscreen", {
        isNative: true,
        fullscreen
      });
    },
    autoplay(val) {
      if (this.player) {
        this.player.autoplay = val;
      }
    }
  },
  created() {
    this.uuid = generateUUID();
  },
  mounted() {
    this.domReady = true;
    this.cacheExts[this.src] = this.ext;
    this.initVideoObserve();
    this.initPlayer();
    if (!androidScrollFix && env$1.isAndroid) {
      androidScrollFix = true;
      document.addEventListener("fullscreenchange", this.onFullscreenChange);
      document.addEventListener(
        "webkitfullscreenchange",
        this.onFullscreenChange
      );
    }
    if (env$1.isAppWebView && env$1.isAndroid) {
      this.delegateHistoryBack(({ next }) => {
        const player = this.player;
        if (this.isCssFullscreen) {
          player.exitRotateFullscreen();
        } else if (this.isFullscreen) {
          player.exitFullscreen(player.root);
        } else {
          next();
        }
      });
    }
    this.videoPlayHandler = (e) => {
      const detail = e.detail;
      if (detail.playerId !== this.uuid) {
        this.pause();
      }
    };
    addEventListener$1(EVENT_VIDEO_PLAY, this.videoPlayHandler);
    if (!shadowStyleInjected) {
      shadowStyleInjected = true;
      const styles = document.head.querySelectorAll("style");
      let styleContent = "";
      for (const style of styles) {
        if (style.textContent.includes("xgplayer")) {
          styleContent += style.textContent;
        }
      }
      const shadowRoot = document.querySelector("vue-advanced-chat").shadowRoot;
      if (shadowRoot) {
        const s = document.createElement("style");
        s.textContent = styleContent;
        shadowRoot.appendChild(s);
      }
    }
  },
  beforeUnmount() {
    this.domReady = false;
    removeEventListener(EVENT_VIDEO_PLAY, this.videoPlayHandler);
    if (this.intersectionObserver && this.$refs.video) {
      this.intersectionObserver.unobserve(this.$refs.video);
    }
    const player = this.player;
    if (player) {
      this.isCssFullscreen = false;
      const progress = player.controls.getElementsByClassName("xgplayer-progress");
      if (progress.length) {
        const item = progress[0];
        item.removeEventListener("touchstart", this.onProgressTouchStart);
        item.removeEventListener("touchend", this.onProgressTouchEnd);
        item.removeEventListener("touchcancel", this.onProgressTouchEnd);
      }
      player.root.removeEventListener("touchstart", this.onPlayerTouch);
      player.video.removeEventListener("enterpictureinpicture", this.enterPip);
      player.video.removeEventListener("leavepictureinpicture", this.exitPip);
      if (!player.paused) {
        player.pause();
        setTimeout(() => {
          player.destroy();
        }, 100);
      } else {
        player.destroy();
      }
    }
  },
  methods: {
    requestFullscreen() {
      return new Promise((resolve, reject) => {
        if (!this.src) {
          return reject(new Error("\u8BF7\u5148\u8BBE\u7F6E src \u540E\u518D\u5524\u8D77\u5168\u5C4F~"));
        }
        this.initPlayer().then(() => {
          const player = this.player;
          const root = player.root;
          const that = this;
          function onCanPlay() {
            player.off("canplay", onCanPlay);
            if (that.finalUseRotateFullscreen) {
              player.getRotateFullscreen();
            } else if (that.finalUseCssFullscreen) {
              player.getCssFullscreen();
            } else {
              player.getFullscreen(player.root);
            }
            resolve(true);
          }
          function onError(error) {
            player.off("error", onError);
            reject(error);
          }
          if (!root.contains(player.video)) {
            this.player.once("canplay", onCanPlay);
            this.player.once("error", onError);
            player.start();
          } else {
            onCanPlay();
          }
        });
      });
    },
    exitFullscreen() {
      if (this.player) {
        const player = this.player;
        if (this.isFullscreen) {
          player.exitFullscreen(player.root);
        } else if (this.isCssFullscreen) {
          player.exitCssFullscreen();
        } else if (this.isRotateFullscreen) {
          player.exitRotateFullscreen();
        }
      }
    },
    pause() {
      if (this.player && !this.player.paused) {
        this.player.pause();
      }
    },
    changeSrc() {
      this.changePlayerSrc();
      this.initPlayer();
    },
    changePlayerSrc() {
      if (this.src) {
        this.needTriggerView = true;
      }
      const player = this.player;
      if (player) {
        if (!player.root || !player.root.contains(player.video)) {
          player.config.url = this.src;
        } else {
          player.src = this.src;
        }
      }
    },
    loadSdk() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            Player: VideoPlayer$1
          });
        });
      });
    },
    initPlayer() {
      return this.loadSdk().then((m) => {
        Player = m.Player;
        if (!this.src || !this.domReady) {
          return;
        }
        if (!this.player) {
          const options = {
            width: this.width,
            height: this.height,
            fluid: this.fluid,
            el: this.$refs.video,
            poster: this.poster,
            playsinline: true,
            airplay: false,
            autoplay: this.autoplay,
            url: this.src,
            controls: this.controls,
            playbackRate: this.showPlaybackRate && this.playbackRate ? this.playbackRate : "",
            showNavInline: this.showNavInline,
            lockNavInline: this.lockNavInline,
            navRightBtn: {
              type: this.navRightIcon
            },
            portrait: !this.landscape,
            lang: "en",
            "x5-video-orientation": this.landscape ? "landscape" : "portraint",
            "x5-video-player-fullscreen": true,
            "x5-video-player-type": "h5-page",
            closeVideoPreventDefault: !this.preventDefault,
            videoInit: this.videoInit
          };
          if (this.finalUseCssFullscreen) {
            options.cssFullscreen = true;
          } else if (this.finalUseRotateFullscreen) {
            options.rotateFullscreen = true;
          }
          if (this.fitVideoSize) {
            options.fitVideoSize = this.fitVideoSize;
          }
          const player = this.player = new Player(options);
          this.player.once("ready", (a) => {
            const progress = this.player.controls.getElementsByClassName("xgplayer-progress");
            if (progress.length) {
              const item = progress[0];
              item.addEventListener("touchstart", this.onProgressTouchStart);
              item.addEventListener("touchend", this.onProgressTouchEnd);
              item.addEventListener("touchcancel", this.onProgressTouchEnd);
            }
            player.root.addEventListener("touchstart", this.onPlayerTouch);
            player.video.addEventListener(
              "enterpictureinpicture",
              this.enterPip
            );
            player.video.addEventListener("leavepictureinpicture", this.exitPip);
          });
          this.player.on("pause", (e) => {
            if (!e) {
              e = this.player;
            }
            const src = e.src;
            this.$emit("pause", {
              progress: this.videoProgress,
              src,
              ext: this.cacheExts[src] || {}
            });
          });
          this.player.on("canplay", () => {
            const video = this.player.video;
            this.videoPortrait = video.videoHeight > video.videoWidth;
            this.videoAspectRatio = video.videoWidth / video.videoHeight;
          });
          this.player.on("startBtnClick", () => {
            this.$emit("start", {});
          });
          this.player.on("play", (e) => {
            Player.util.removeClass(this.player.root, "xgplayer-is-replay");
            const src = e.src;
            dispatchEvent(EVENT_VIDEO_PLAY, {
              playerId: this.uuid,
              src
            });
            if (!this.playsinline) {
              this.requestFullscreen();
            }
            this.$emit("play", {
              src,
              ext: this.cacheExts[src] || {}
            });
          });
          this.player.on("error", (err) => {
            this.$emit("error", err);
          });
          this.player.on("getRotateFullscreen", () => {
            this.isRotateFullscreen = true;
          });
          this.player.on("exitRotateFullscreen", () => {
            this.isRotateFullscreen = false;
            if (!this.playsinline) {
              this.pause();
            }
          });
          this.player.on("requestCssFullscreen", () => {
            this.isCssFullscreen = true;
          });
          this.player.on("exitCssFullscreen", () => {
            this.isCssFullscreen = false;
            if (!this.playsinline) {
              this.pause();
            }
          });
          this.player.on("requestFullscreen", () => {
            this.isFullscreen = true;
          });
          this.player.on("exitFullscreen", () => {
            this.isFullscreen = false;
            if (!this.playsinline) {
              this.pause();
            }
          });
          this.player.on("ended", (e) => {
            if (this.exitFullscreenAfterEnded) {
              this.exitFullscreen();
            }
            const src = e.src;
            this.$emit("ended", {
              src,
              ext: this.cacheExts[src] || {}
            });
          });
          this.player.on("clickNavLeft", () => {
            this.$emit("click-nav-left");
          });
          this.player.on("clickNavRight", () => {
            this.$emit("click-nav-right");
          });
          this.player.on("timeupdate", (e) => {
            if (e.duration) {
              this.videoProgress = parseInt(
                parseInt(e.currentTime) / parseInt(e.duration) * 100
              );
            } else {
              this.videoProgress = 0;
            }
            e.progress = this.videoProgress;
            this.$emit("timeupdate", e);
          });
        } else {
          if (this.player.src !== this.src) {
            this.changePlayerSrc();
          }
        }
      });
    },
    initVideoObserve() {
      if (!window.IntersectionObserver) {
        return;
      }
      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((v) => {
          if (v.isIntersecting) {
            if (this.needTriggerView) {
              this.needTriggerView = false;
              const src = this.src;
              this.$emit("view", {
                src,
                ext: this.cacheExts[src] || {}
              });
            }
            if (this.needPlay) {
              this.needPlay = false;
              if (this.player.paused) {
                this.player.play();
              }
            }
          } else {
            if (this.player && !this.player.paused && !this.isPip) {
              this.player.pause();
              if (this.resumeAfterVisible) {
                this.needPlay = true;
              }
            }
          }
        });
      });
      setTimeout(() => {
        if (this.$refs.video) {
          this.intersectionObserver = intersectionObserver;
          intersectionObserver.observe(this.$refs.video);
        }
      }, 0);
    },
    onProgressTouchStart(e) {
      if (this.isCssFullscreen) {
        e.preventDefault();
      } else {
        this.lockPopGesture();
      }
    },
    onProgressTouchEnd() {
      if (!this.isCssFullscreen) {
        this.revertPopGesture();
      }
    },
    onPlayerTouch(e) {
      if (this.isCssFullscreen && e.target === this.player.video) {
        e.preventDefault();
      }
    },
    onFullscreenChange() {
      const isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      if (isFullscreen) {
        this.saveScrollTop();
      } else {
        this.revertScrollTop();
      }
      this.togglePopGesture(isFullscreen);
    },
    togglePopGesture(disablePopGesture) {
      if (!env$1.isAppWebView) {
        return;
      }
      if (env$1.isIOS && !this.finalCssFullscreen) {
        return;
      }
      if (disablePopGesture) {
        this.latestPopGestureEnable = this.popGestureEnable;
        if (this.popGestureEnable)
          ;
      } else {
        if (!this.popGestureEnable && this.latestPopGestureEnable)
          ;
      }
    },
    toggleStatusBar(fullscreen) {
      if (!env$1.isAppWebView)
        ;
    },
    enterPip() {
      this.isPip = true;
    },
    exitPip() {
      this.isPip = false;
    }
  }
};
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([
      "video-wrapper",
      $options.landscape ? "landscape" : "portrait",
      $options.objectFitCover ? "cover" : "",
      !$props.playsinline && !$props.controlsInline ? "no-control-inline" : ""
    ])
  }, [
    createElementVNode("div", {
      ref: "video",
      class: normalizeClass(["video-container", { "auto-height": $props.fitVideoSize }])
    }, null, 2)
  ], 2);
}
var VideoPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$o]]);
const _sfc_main$o = {
  name: "RoomFiles",
  components: {
    Loader,
    SvgIcon,
    VideoPlayer
  },
  props: {
    file: { type: Object, required: true },
    index: { type: Number, required: true }
  },
  emits: ["remove-file", "toggle-video-fullscreen", "preview-image"],
  computed: {
    isImage() {
      return isImageFile(this.file);
    },
    isVideo() {
      return isVideoFile(this.file);
    },
    fileWidth() {
      return this.file.width || 300;
    },
    fileHeight() {
      return this.file.height || 300;
    }
  },
  methods: {
    previewImage() {
      const file = this.file;
      this.$emit("preview-image", {
        ...file,
        blob: void 0,
        url: file.url || file.localUrl
      });
    }
  }
};
const _hoisted_1$m = { class: "vac-room-file-container" };
const _hoisted_2$k = { class: "vac-text-ellipsis" };
const _hoisted_3$g = {
  key: 0,
  class: "vac-text-ellipsis vac-text-extension"
};
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = resolveComponent("loader");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_video_player = resolveComponent("video-player");
  return openBlock(), createElementBlock("div", _hoisted_1$m, [
    createVNode(_component_loader, {
      show: $props.file.loading,
      type: "room-file"
    }, createSlots({ _: 2 }, [
      renderList(_ctx.$slots, (idx, name) => {
        return {
          name,
          fn: withCtx((data) => [
            renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
          ])
        };
      })
    ]), 1032, ["show"]),
    createElementVNode("div", {
      class: "vac-svg-button vac-icon-remove",
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("remove-file", $props.index))
    }, [
      renderSlot(_ctx.$slots, "image-close-icon", {}, () => [
        createVNode(_component_svg_icon, {
          name: "close",
          param: "image"
        })
      ])
    ]),
    $options.isImage ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["vac-message-image", { "vac-blur-loading": $props.file.loading }]),
      style: normalizeStyle({
        "background-image": `url('${$props.file.localUrl || $props.file.url}')`
      }),
      onClick: _cache[1] || (_cache[1] = (...args) => $options.previewImage && $options.previewImage(...args))
    }, null, 6)) : $options.isVideo ? (openBlock(), createBlock(_component_video_player, {
      key: 1,
      src: $props.file.localUrl || $props.file.url,
      width: "100",
      height: "100",
      "controls-inline": false,
      portrait: $options.fileWidth <= $options.fileHeight,
      class: normalizeClass({ "vac-blur-loading": $props.file.loading, "video-player": true }),
      onToggleFullscreen: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("toggle-video-fullscreen", $event))
    }, null, 8, ["src", "portrait", "class"])) : (openBlock(), createElementBlock("div", {
      key: 2,
      class: normalizeClass(["vac-file-container", { "vac-blur-loading": $props.file.loading }])
    }, [
      createElementVNode("div", null, [
        renderSlot(_ctx.$slots, "file-icon", {}, () => [
          createVNode(_component_svg_icon, { name: "file" })
        ])
      ]),
      createElementVNode("div", _hoisted_2$k, toDisplayString($props.file.name), 1),
      $props.file.extension ? (openBlock(), createElementBlock("div", _hoisted_3$g, toDisplayString($props.file.extension), 1)) : createCommentVNode("", true)
    ], 2))
  ]);
}
var RoomFile = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$n]]);
const _sfc_main$n = {
  name: "RoomFiles",
  components: {
    SvgIcon,
    RoomFile
  },
  props: {
    files: { type: Array, required: true }
  },
  emits: ["remove-file", "reset-message", "toggle-video-fullscreen", "preview-image"],
  computed: {}
};
const _hoisted_1$l = {
  key: 0,
  class: "vac-room-files-container"
};
const _hoisted_2$j = { class: "vac-files-box" };
const _hoisted_3$f = { class: "vac-icon-close" };
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_room_file = resolveComponent("room-file");
  const _component_svg_icon = resolveComponent("svg-icon");
  return openBlock(), createBlock(Transition, { name: "vac-slide-up" }, {
    default: withCtx(() => [
      $props.files.length ? (openBlock(), createElementBlock("div", _hoisted_1$l, [
        createElementVNode("div", _hoisted_2$j, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.files, (file, i) => {
            return openBlock(), createElementBlock("div", { key: i }, [
              createVNode(_component_room_file, {
                file,
                index: i,
                onRemoveFile: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("remove-file", $event)),
                onPreviewImage: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("preview-image", $event)),
                onToggleVideoFullscreen: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("toggle-video-fullscreen", $event))
              }, createSlots({ _: 2 }, [
                renderList(_ctx.$slots, (idx, name) => {
                  return {
                    name,
                    fn: withCtx((data) => [
                      renderSlot(_ctx.$slots, name, mergeProps({ ref_for: true }, data))
                    ])
                  };
                })
              ]), 1032, ["file", "index"])
            ]);
          }), 128))
        ]),
        createElementVNode("div", _hoisted_3$f, [
          createElementVNode("div", {
            class: "vac-svg-button",
            onClick: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("reset-message"))
          }, [
            renderSlot(_ctx.$slots, "files-close-icon", {}, () => [
              createVNode(_component_svg_icon, { name: "close-outline" })
            ])
          ])
        ])
      ])) : createCommentVNode("", true)
    ]),
    _: 3
  });
}
var RoomFiles = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$m]]);
const _sfc_main$m = {
  props: {
    percentage: { type: Number, default: 0 },
    messageSelectionEnabled: { type: Boolean, required: true }
  },
  emits: ["hover-audio-progress", "change-linehead"],
  data() {
    return {
      isMouseDown: false
    };
  },
  methods: {
    onMouseDown(ev) {
      if (this.messageSelectionEnabled)
        return;
      this.isMouseDown = true;
      const seekPos = this.calculateLineHeadPosition(ev, this.$refs.progress);
      this.$emit("change-linehead", seekPos);
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
    },
    onMouseUp(ev) {
      if (this.messageSelectionEnabled)
        return;
      this.isMouseDown = false;
      document.removeEventListener("mouseup", this.onMouseUp);
      document.removeEventListener("mousemove", this.onMouseMove);
      const seekPos = this.calculateLineHeadPosition(ev, this.$refs.progress);
      this.$emit("change-linehead", seekPos);
    },
    onMouseMove(ev) {
      if (this.messageSelectionEnabled)
        return;
      const seekPos = this.calculateLineHeadPosition(ev, this.$refs.progress);
      this.$emit("change-linehead", seekPos);
    },
    calculateLineHeadPosition(ev, element2) {
      const progressWidth = element2.getBoundingClientRect().width;
      const leftPosition = element2.getBoundingClientRect().left;
      let pos = (ev.clientX - leftPosition) / progressWidth;
      pos = pos < 0 ? 0 : pos;
      pos = pos > 1 ? 1 : pos;
      return pos;
    }
  }
};
const _hoisted_1$k = { class: "vac-player-progress" };
const _hoisted_2$i = { class: "vac-line-container" };
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "progress",
    class: "vac-player-bar",
    onMousedown: _cache[0] || (_cache[0] = (...args) => $options.onMouseDown && $options.onMouseDown(...args)),
    onMouseover: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("hover-audio-progress", true)),
    onMouseout: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("hover-audio-progress", false))
  }, [
    createElementVNode("div", _hoisted_1$k, [
      createElementVNode("div", _hoisted_2$i, [
        createElementVNode("div", {
          class: "vac-line-progress",
          style: normalizeStyle({ width: `${$props.percentage}%` })
        }, null, 4),
        createElementVNode("div", {
          class: normalizeClass(["vac-line-dot", { "vac-line-dot__active": $data.isMouseDown }]),
          style: normalizeStyle({ left: `${$props.percentage}%` })
        }, null, 6)
      ])
    ])
  ], 544);
}
var AudioControl = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$l]]);
const _sfc_main$l = {
  name: "AudioPlayer",
  components: {
    SvgIcon,
    AudioControl
  },
  props: {
    messageId: { type: [String, Number], default: null },
    src: { type: String, default: null },
    messageSelectionEnabled: { type: Boolean, required: true }
  },
  emits: ["hover-audio-progress", "update-progress-time"],
  data() {
    return {
      isPlaying: false,
      duration: this.convertTimeMMSS(0),
      playedTime: this.convertTimeMMSS(0),
      progress: 0
    };
  },
  computed: {
    playerUniqId() {
      return `audio-player${this.messageId}`;
    },
    audioSource() {
      if (this.src)
        return this.src;
      this.resetProgress();
      return null;
    }
  },
  mounted() {
    this.player = this.$el.querySelector("#" + this.playerUniqId);
    this.player.addEventListener("ended", () => {
      this.isPlaying = false;
    });
    this.player.addEventListener("loadeddata", () => {
      this.resetProgress();
      this.duration = this.convertTimeMMSS(this.player.duration);
      this.updateProgressTime();
    });
    this.player.addEventListener("timeupdate", this.onTimeUpdate);
  },
  methods: {
    convertTimeMMSS(seconds) {
      return new Date(seconds * 1e3).toISOString().substr(14, 5);
    },
    playback() {
      if (this.messageSelectionEnabled || !this.audioSource)
        return;
      if (this.isPlaying)
        this.player.pause();
      else
        setTimeout(() => this.player.play());
      this.isPlaying = !this.isPlaying;
    },
    resetProgress() {
      if (this.isPlaying)
        this.player.pause();
      this.duration = this.convertTimeMMSS(0);
      this.playedTime = this.convertTimeMMSS(0);
      this.progress = 0;
      this.isPlaying = false;
      this.updateProgressTime();
    },
    onTimeUpdate() {
      this.playedTime = this.convertTimeMMSS(this.player.currentTime);
      this.progress = this.player.currentTime / this.player.duration * 100;
      this.updateProgressTime();
    },
    onUpdateProgress(pos) {
      if (pos)
        this.player.currentTime = pos * this.player.duration;
    },
    updateProgressTime() {
      this.$emit(
        "update-progress-time",
        this.progress > 1 ? this.playedTime : this.duration
      );
    }
  }
};
const _hoisted_1$j = { class: "vac-audio-player" };
const _hoisted_2$h = ["id", "src"];
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_audio_control = resolveComponent("audio-control");
  return openBlock(), createElementBlock("div", null, [
    createElementVNode("div", _hoisted_1$j, [
      createElementVNode("div", {
        class: "vac-svg-button",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.playback && $options.playback(...args))
      }, [
        $data.isPlaying ? renderSlot(_ctx.$slots, "audio-pause-icon_" + $props.messageId, { key: 0 }, () => [
          createVNode(_component_svg_icon, { name: "audio-pause" })
        ]) : renderSlot(_ctx.$slots, "audio-play-icon_" + $props.messageId, { key: 1 }, () => [
          createVNode(_component_svg_icon, { name: "audio-play" })
        ])
      ]),
      createVNode(_component_audio_control, {
        percentage: $data.progress,
        "message-selection-enabled": $props.messageSelectionEnabled,
        onChangeLinehead: $options.onUpdateProgress,
        onHoverAudioProgress: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("hover-audio-progress", $event))
      }, null, 8, ["percentage", "message-selection-enabled", "onChangeLinehead"]),
      createElementVNode("audio", {
        id: $options.playerUniqId,
        src: $options.audioSource
      }, null, 8, _hoisted_2$h)
    ])
  ]);
}
var AudioPlayer = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$k]]);
const env = Env.getInstance();
const _sfc_main$k = {
  props: {
    cardInfo: { type: Object, required: true },
    isSelf: { type: Boolean, default: () => false }
  },
  emits: ["send-custom-card", "trigger-custom-card"],
  computed: {
    cardStyle() {
      const { client } = this.cardInfo;
      if (client === "merchant") {
        if (!this.isSelf) {
          return "max-width:500px;";
        } else {
          return "max-width:500px;";
        }
      } else {
        return "margin-left:0;margin-right:0;";
      }
    },
    isEnvAppWebView() {
      return env.isEnvAppWebView;
    }
  },
  methods: {
    doSendCard(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit("send-custom-card");
    },
    triggerCard() {
      this.$emit("trigger-custom-card");
    }
  }
};
const _hoisted_1$i = {
  key: 0,
  class: "order-card"
};
const _hoisted_2$g = {
  key: 0,
  class: "merchant-head"
};
const _hoisted_3$e = { class: "card-header" };
const _hoisted_4$d = { class: "order-time" };
const _hoisted_5$c = { class: "order-status" };
const _hoisted_6$6 = { class: "card-img" };
const _hoisted_7$6 = ["src"];
const _hoisted_8$5 = { class: "card-info" };
const _hoisted_9$4 = { class: "card-title two-line" };
const _hoisted_10$3 = { class: "card-quantity" };
const _hoisted_11$2 = { key: 0 };
const _hoisted_12$2 = { class: "card-info-data" };
const _hoisted_13$2 = { class: "card-price" };
const _hoisted_14$1 = {
  key: 0,
  class: "card-send"
};
const _hoisted_15$1 = { class: "card-bottom-line" };
const _hoisted_16$1 = {
  key: 1,
  class: "goods-card"
};
const _hoisted_17$1 = {
  key: 0,
  class: "merchant-head"
};
const _hoisted_18$1 = { class: "goods-card-img" };
const _hoisted_19$1 = ["src"];
const _hoisted_20 = { class: "goods-card-info" };
const _hoisted_21 = { class: "goods-card-title two-line" };
const _hoisted_22 = { class: "goods-card-bottom" };
const _hoisted_23 = { class: "goods-card-price" };
const _hoisted_24 = {
  key: 0,
  class: "card-send"
};
const _hoisted_25 = { class: "card-header" };
const _hoisted_26 = { class: "card-content" };
const _hoisted_27 = { class: "card-img" };
const _hoisted_28 = ["src"];
const _hoisted_29 = { class: "goods-card-info" };
const _hoisted_30 = { class: "goods-card-title two-line" };
const _hoisted_31 = { class: "card-footer" };
const _hoisted_32 = { class: "btn" };
const _hoisted_33 = { class: "card-header" };
const _hoisted_34 = { class: "card-content" };
const _hoisted_35 = { class: "card-balance" };
const _hoisted_36 = { class: "title" };
const _hoisted_37 = { class: "text" };
const _hoisted_38 = { class: "card-points" };
const _hoisted_39 = { class: "title" };
const _hoisted_40 = { class: "text" };
const _hoisted_41 = { class: "card-frozenPoints" };
const _hoisted_42 = { class: "title" };
const _hoisted_43 = { class: "text" };
const _hoisted_44 = {
  key: 0,
  class: "card-currency"
};
const _hoisted_45 = {
  key: 0,
  class: "card-footer"
};
const _hoisted_46 = { class: "btn" };
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "custom-card-contain",
    style: normalizeStyle($options.cardStyle)
  }, [
    $props.cardInfo.type === "order" ? (openBlock(), createElementBlock("div", _hoisted_1$i, [
      $props.cardInfo.client === "merchant" ? (openBlock(), createElementBlock("div", _hoisted_2$g, toDisplayString($props.cardInfo.desc), 1)) : createCommentVNode("", true),
      createElementVNode("div", _hoisted_3$e, [
        createElementVNode("div", _hoisted_4$d, toDisplayString($props.cardInfo.time), 1),
        createElementVNode("div", _hoisted_5$c, toDisplayString($props.cardInfo.orderStatus), 1)
      ]),
      createElementVNode("div", {
        class: "card-content",
        onClick: _cache[1] || (_cache[1] = (...args) => $options.triggerCard && $options.triggerCard(...args))
      }, [
        createElementVNode("div", _hoisted_6$6, [
          createElementVNode("img", {
            src: $props.cardInfo.image,
            alt: "goods card"
          }, null, 8, _hoisted_7$6)
        ]),
        createElementVNode("div", _hoisted_8$5, [
          createElementVNode("div", _hoisted_9$4, toDisplayString($props.cardInfo.title), 1),
          createElementVNode("div", _hoisted_10$3, [
            createElementVNode("span", null, toDisplayString($props.cardInfo.specification), 1),
            $props.cardInfo.quantity >= 0 ? (openBlock(), createElementBlock("span", _hoisted_11$2, "x" + toDisplayString($props.cardInfo.quantity), 1)) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_12$2, [
            createElementVNode("span", _hoisted_13$2, toDisplayString($props.cardInfo.price), 1),
            !$props.cardInfo.isSend && $props.cardInfo.client !== "merchant" ? (openBlock(), createElementBlock("div", _hoisted_14$1, [
              createElementVNode("div", {
                class: "card-send-btn",
                onClick: _cache[0] || (_cache[0] = (...args) => $options.doSendCard && $options.doSendCard(...args))
              }, toDisplayString($props.cardInfo.sendTxt), 1)
            ])) : createCommentVNode("", true)
          ])
        ])
      ]),
      createElementVNode("div", _hoisted_15$1, toDisplayString($props.cardInfo.orderIdTxt) + "#" + toDisplayString($props.cardInfo.orderNo), 1)
    ])) : $props.cardInfo.type === "goods" ? (openBlock(), createElementBlock("div", _hoisted_16$1, [
      $props.cardInfo.client === "merchant" ? (openBlock(), createElementBlock("div", _hoisted_17$1, toDisplayString($props.cardInfo.desc), 1)) : createCommentVNode("", true),
      createElementVNode("div", {
        class: "goods-content",
        onClick: _cache[3] || (_cache[3] = (...args) => $options.triggerCard && $options.triggerCard(...args))
      }, [
        createElementVNode("div", _hoisted_18$1, [
          createElementVNode("img", {
            src: $props.cardInfo.image,
            alt: "goods card"
          }, null, 8, _hoisted_19$1)
        ]),
        createElementVNode("div", _hoisted_20, [
          createElementVNode("div", _hoisted_21, toDisplayString($props.cardInfo.title), 1),
          createElementVNode("div", _hoisted_22, [
            createElementVNode("span", _hoisted_23, toDisplayString($props.cardInfo.price), 1),
            !$props.cardInfo.isSend && $props.cardInfo.client !== "merchant" ? (openBlock(), createElementBlock("div", _hoisted_24, [
              createElementVNode("div", {
                class: "card-send-btn",
                onClick: _cache[2] || (_cache[2] = (...args) => $options.doSendCard && $options.doSendCard(...args))
              }, toDisplayString($props.cardInfo.sendTxt), 1)
            ])) : createCommentVNode("", true)
          ])
        ])
      ])
    ])) : $props.cardInfo.messageType === "CARD_GOODS_GUIDE_BOOK" ? (openBlock(), createElementBlock("div", {
      key: 2,
      class: "guide-book-card",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.triggerCard && $options.triggerCard(...args))
    }, [
      createElementVNode("div", _hoisted_25, [
        createElementVNode("span", null, toDisplayString($props.cardInfo.titleTranslate), 1)
      ]),
      createElementVNode("div", _hoisted_26, [
        createElementVNode("div", _hoisted_27, [
          createElementVNode("img", {
            src: $props.cardInfo.mainImage,
            alt: "goods card"
          }, null, 8, _hoisted_28)
        ]),
        createElementVNode("div", _hoisted_29, [
          createElementVNode("div", _hoisted_30, toDisplayString($props.cardInfo.goodsNameTranslate), 1)
        ])
      ]),
      createElementVNode("div", _hoisted_31, [
        createElementVNode("button", _hoisted_32, toDisplayString($props.cardInfo.btnTxt), 1)
      ])
    ])) : $props.cardInfo.messageType === "CARD_USER_POINTS_INFO" ? (openBlock(), createElementBlock("div", {
      key: 3,
      class: "points-card",
      onClick: _cache[5] || (_cache[5] = (...args) => $options.triggerCard && $options.triggerCard(...args))
    }, [
      createElementVNode("div", _hoisted_33, [
        createElementVNode("span", null, toDisplayString($props.cardInfo.titleTranslate), 1)
      ]),
      createElementVNode("div", _hoisted_34, [
        createElementVNode("div", _hoisted_35, [
          createElementVNode("div", _hoisted_36, toDisplayString($props.cardInfo.balanceCopyWritingTranslate), 1),
          createElementVNode("div", _hoisted_37, toDisplayString($props.cardInfo.currentCurrencyBalance), 1)
        ]),
        createElementVNode("div", _hoisted_38, [
          createElementVNode("div", _hoisted_39, toDisplayString($props.cardInfo.pointsCopyWritingTranslate), 1),
          createElementVNode("div", _hoisted_40, toDisplayString($props.cardInfo.currentCurrencyPoints), 1)
        ]),
        createElementVNode("div", _hoisted_41, [
          createElementVNode("div", _hoisted_42, toDisplayString($props.cardInfo.frozenPointsCopyWritingTranslate), 1),
          createElementVNode("div", _hoisted_43, toDisplayString($props.cardInfo.currentCurrencyFrozenPoints), 1)
        ]),
        $props.cardInfo.currencyCopyWritingTranslate ? (openBlock(), createElementBlock("div", _hoisted_44, [
          createElementVNode("span", null, toDisplayString($props.cardInfo.currencyCopyWritingTranslate), 1),
          createElementVNode("span", null, toDisplayString($props.cardInfo.currentCurrency), 1)
        ])) : createCommentVNode("", true)
      ]),
      $options.isEnvAppWebView && $props.cardInfo.sendButtonText ? (openBlock(), createElementBlock("div", _hoisted_45, [
        createElementVNode("button", _hoisted_46, toDisplayString($props.cardInfo.sendButtonText), 1)
      ])) : createCommentVNode("", true)
    ])) : createCommentVNode("", true)
  ], 4);
}
var CustomSendCard = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$j]]);
const _sfc_main$j = {
  name: "RoomMessageReply",
  components: {
    SvgIcon,
    FormatMessage,
    AudioPlayer,
    VideoPlayer,
    CustomSendCard
  },
  props: {
    room: { type: Object, required: true },
    messageReply: { type: Object, default: null },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true }
  },
  emits: ["reset-message"],
  computed: {
    firstFile() {
      var _a, _b;
      return ((_b = (_a = this.messageReply) == null ? void 0 : _a.files) == null ? void 0 : _b.length) ? this.messageReply.files[0] : {};
    },
    isImage() {
      return isImageFile(this.firstFile);
    },
    isVideo() {
      return isVideoFile(this.firstFile);
    },
    isAudio() {
      return isAudioFile(this.firstFile);
    },
    firstFileWidth() {
      return this.firstFile.width || 300;
    },
    firstFileHeight() {
      return this.firstFile.height || 300;
    },
    isOtherFile() {
      var _a, _b;
      return ((_b = (_a = this.messageReply) == null ? void 0 : _a.files) == null ? void 0 : _b.length) && !this.isAudio && !this.isVideo && !this.isImage;
    }
  }
};
const _hoisted_1$h = {
  key: 0,
  class: "vac-reply-container"
};
const _hoisted_2$f = { class: "vac-reply-box" };
const _hoisted_3$d = { class: "vac-reply-info" };
const _hoisted_4$c = { class: "vac-reply-username" };
const _hoisted_5$b = { class: "vac-reply-content" };
const _hoisted_6$5 = ["src"];
const _hoisted_7$5 = {
  key: 3,
  class: "vac-image-reply vac-file-container"
};
const _hoisted_8$4 = { class: "vac-text-ellipsis" };
const _hoisted_9$3 = {
  key: 0,
  class: "vac-text-ellipsis vac-text-extension"
};
const _hoisted_10$2 = { class: "vac-icon-reply" };
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_custom_send_card = resolveComponent("custom-send-card");
  const _component_format_message = resolveComponent("format-message");
  const _component_video_player = resolveComponent("video-player");
  const _component_audio_player = resolveComponent("audio-player");
  const _component_svg_icon = resolveComponent("svg-icon");
  return openBlock(), createBlock(Transition, { name: "vac-slide-up" }, {
    default: withCtx(() => [
      $props.messageReply ? (openBlock(), createElementBlock("div", _hoisted_1$h, [
        createElementVNode("div", _hoisted_2$f, [
          createElementVNode("div", _hoisted_3$d, [
            createElementVNode("div", _hoisted_4$c, toDisplayString($props.messageReply.username), 1),
            createElementVNode("div", _hoisted_5$b, [
              $props.messageReply.card ? (openBlock(), createBlock(_component_custom_send_card, {
                key: 0,
                "card-info": $props.messageReply.card
              }, null, 8, ["card-info"])) : (openBlock(), createBlock(_component_format_message, {
                key: 1,
                "message-id": $props.messageReply._id,
                content: $props.messageReply.content,
                users: $props.room.users,
                "text-formatting": $props.textFormatting,
                "link-options": $props.linkOptions,
                reply: true
              }, null, 8, ["message-id", "content", "users", "text-formatting", "link-options"]))
            ])
          ]),
          $options.isImage ? (openBlock(), createElementBlock("img", {
            key: 0,
            src: $options.firstFile.url,
            class: "vac-image-reply"
          }, null, 8, _hoisted_6$5)) : $options.isVideo ? (openBlock(), createBlock(_component_video_player, {
            key: 1,
            src: $options.firstFile.url,
            width: "100",
            height: "100",
            "controls-inline": false,
            portrait: $options.firstFileWidth <= $options.firstFileHeight,
            "video-init": "",
            class: "vac-image-reply video-player"
          }, null, 8, ["src", "portrait"])) : $options.isAudio ? (openBlock(), createBlock(_component_audio_player, {
            key: 2,
            src: $options.firstFile.url,
            "message-selection-enabled": false,
            class: "vac-audio-reply"
          }, createSlots({ _: 2 }, [
            renderList(_ctx.$slots, (idx, name) => {
              return {
                name,
                fn: withCtx((data) => [
                  renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                ])
              };
            })
          ]), 1032, ["src"])) : $options.isOtherFile ? (openBlock(), createElementBlock("div", _hoisted_7$5, [
            createElementVNode("div", null, [
              renderSlot(_ctx.$slots, "file-icon", {}, () => [
                createVNode(_component_svg_icon, { name: "file" })
              ])
            ]),
            createElementVNode("div", _hoisted_8$4, toDisplayString($options.firstFile.name), 1),
            $options.firstFile.extension ? (openBlock(), createElementBlock("div", _hoisted_9$3, toDisplayString($options.firstFile.extension), 1)) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_10$2, [
          createElementVNode("div", {
            class: "vac-svg-button",
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("reset-message"))
          }, [
            renderSlot(_ctx.$slots, "reply-close-icon", {}, () => [
              createVNode(_component_svg_icon, { name: "close-outline" })
            ])
          ])
        ])
      ])) : createCommentVNode("", true)
    ]),
    _: 3
  });
}
var RoomMessageReply = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$i]]);
const _sfc_main$i = {
  name: "RoomUsersTag",
  props: {
    filteredUsersTag: { type: Array, required: true },
    selectItem: { type: Boolean, default: null },
    activeUpOrDown: { type: Number, default: null }
  },
  emits: ["select-user-tag", "activate-item"],
  data() {
    return {
      activeItem: null
    };
  },
  watch: {
    filteredUsersTag(val, oldVal) {
      if (!oldVal.length || val.length !== oldVal.length) {
        this.activeItem = 0;
      }
    },
    selectItem(val) {
      if (val) {
        this.$emit("select-user-tag", this.filteredUsersTag[this.activeItem]);
      }
    },
    activeUpOrDown() {
      if (this.activeUpOrDown > 0 && this.activeItem < this.filteredUsersTag.length - 1) {
        this.activeItem++;
      } else if (this.activeUpOrDown < 0 && this.activeItem > 0) {
        this.activeItem--;
      }
      this.$emit("activate-item");
    }
  }
};
const _hoisted_1$g = {
  key: 0,
  class: "vac-tags-container"
};
const _hoisted_2$e = ["onMouseover", "onClick"];
const _hoisted_3$c = { class: "vac-tags-info" };
const _hoisted_4$b = { class: "vac-tags-username" };
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, { name: "vac-slide-up" }, {
    default: withCtx(() => [
      $props.filteredUsersTag.length ? (openBlock(), createElementBlock("div", _hoisted_1$g, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.filteredUsersTag, (user, index) => {
          return openBlock(), createElementBlock("div", {
            key: user._id,
            class: normalizeClass(["vac-tags-box", { "vac-tags-box-active": index === $data.activeItem }]),
            onMouseover: ($event) => $data.activeItem = index,
            onClick: ($event) => _ctx.$emit("select-user-tag", user)
          }, [
            createElementVNode("div", _hoisted_3$c, [
              user.avatar ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "vac-avatar vac-tags-avatar",
                style: normalizeStyle({ "background-image": `url('${user.avatar}')` })
              }, null, 4)) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_4$b, toDisplayString(user.username), 1)
            ])
          ], 42, _hoisted_2$e);
        }), 128))
      ])) : createCommentVNode("", true)
    ]),
    _: 1
  });
}
var RoomUsersTag = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$h]]);
const _sfc_main$h = {
  name: "RoomEmojis",
  props: {
    filteredEmojis: { type: Array, required: true },
    selectItem: { type: Boolean, default: null },
    activeUpOrDown: { type: Number, default: null }
  },
  emits: ["select-emoji", "activate-item"],
  data() {
    return {
      activeItem: null
    };
  },
  watch: {
    filteredEmojis(val, oldVal) {
      if (!oldVal.length || val.length !== oldVal.length) {
        this.activeItem = 0;
      }
    },
    selectItem(val) {
      if (val) {
        this.$emit("select-emoji", this.filteredEmojis[this.activeItem]);
      }
    },
    activeUpOrDown() {
      if (this.activeUpOrDown > 0 && this.activeItem < this.filteredEmojis.length - 1) {
        this.activeItem++;
      } else if (this.activeUpOrDown < 0 && this.activeItem > 0) {
        this.activeItem--;
      }
      this.$emit("activate-item");
    }
  }
};
const _hoisted_1$f = {
  key: 0,
  class: "vac-emojis-container"
};
const _hoisted_2$d = ["onMouseover", "onClick"];
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, { name: "vac-slide-up" }, {
    default: withCtx(() => [
      $props.filteredEmojis.length ? (openBlock(), createElementBlock("div", _hoisted_1$f, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.filteredEmojis, (emoji, index) => {
          return openBlock(), createElementBlock("div", {
            key: emoji,
            class: normalizeClass(["vac-emoji-element", { "vac-emoji-element-active": index === $data.activeItem }]),
            onMouseover: ($event) => $data.activeItem = index,
            onClick: ($event) => _ctx.$emit("select-emoji", emoji)
          }, toDisplayString(emoji), 43, _hoisted_2$d);
        }), 128))
      ])) : createCommentVNode("", true)
    ]),
    _: 1
  });
}
var RoomEmojis = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$g]]);
const _sfc_main$g = {
  name: "RoomTemplatesText",
  props: {
    filteredTemplatesText: { type: Array, required: true },
    selectItem: { type: Boolean, default: null },
    activeUpOrDown: { type: Number, default: null }
  },
  emits: ["select-template-text", "activate-item"],
  data() {
    return {
      activeItem: null
    };
  },
  watch: {
    filteredTemplatesText(val, oldVal) {
      if (!oldVal.length || val.length !== oldVal.length) {
        this.activeItem = 0;
      }
    },
    selectItem(val) {
      if (val) {
        this.$emit(
          "select-template-text",
          this.filteredTemplatesText[this.activeItem]
        );
      }
    },
    activeUpOrDown() {
      if (this.activeUpOrDown > 0 && this.activeItem < this.filteredTemplatesText.length - 1) {
        this.activeItem++;
      } else if (this.activeUpOrDown < 0 && this.activeItem > 0) {
        this.activeItem--;
      }
      this.$emit("activate-item");
    }
  }
};
const _hoisted_1$e = {
  key: 0,
  class: "vac-template-container vac-app-box-shadow"
};
const _hoisted_2$c = ["onMouseover", "onClick"];
const _hoisted_3$b = { class: "vac-template-info" };
const _hoisted_4$a = { class: "vac-template-tag" };
const _hoisted_5$a = { class: "vac-template-text" };
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, { name: "vac-slide-up" }, {
    default: withCtx(() => [
      $props.filteredTemplatesText.length ? (openBlock(), createElementBlock("div", _hoisted_1$e, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.filteredTemplatesText, (template, index) => {
          return openBlock(), createElementBlock("div", {
            key: index,
            class: normalizeClass(["vac-template-box", { "vac-template-active": index === $data.activeItem }]),
            onMouseover: ($event) => $data.activeItem = index,
            onClick: ($event) => _ctx.$emit("select-template-text", template)
          }, [
            createElementVNode("div", _hoisted_3$b, [
              createElementVNode("div", _hoisted_4$a, " /" + toDisplayString(template.tag), 1),
              createElementVNode("div", _hoisted_5$a, toDisplayString(template.text), 1)
            ])
          ], 42, _hoisted_2$c);
        }), 128))
      ])) : createCommentVNode("", true)
    ]),
    _: 1
  });
}
var RoomTemplatesText = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$f]]);
var cameraIcon = "data:image/webp;base64,UklGRowDAABXRUJQVlA4WAoAAAAwAAAAHwAAGgAASUNDUMgBAAAAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADZWUDhMnQEAAC8fgAYQV+Iokmwpyr8ccYMWVKKN8w4NMybcRJLkSLnCPDaH5VA+trf1f7mJJMmRcoV5bA7LoXxsb+v/Yty2jeToSHEye/+2Dlhwui7m243xPFnu91ofjzre7zz/v8NxeH4+ub7fBin63jsFSFHnPFPcv9+Z6jLGCWHKOucAkAKCVNU5g0oFQHypqXOuVACSCkTKGA1wA1wIhKkBoIwRkGpMGWOlqozxp85/kCoAIAAE27aWJQc7aFv87YBrd3fhnf+EqO9/OIKI/its27ZR93aSXgEAABTKlUqlUqmURwAAIFlubNu27dNQWbdTuRjBTufkfRONLMuyzzyeelpWx4EX27Zt27bzrnugbA+Xpw96546PT8JsNW2/Au0+Gb+3d+0ctptJERf9jroMU6P+Yb+VmAuyxHO/gCs28+i/g7NBCXv8RVgjGbXdCJ0IJBkLsZhilgijk8lqKsJ+evoodVFKzPygghIxv5+z3C+gznUwboew83i/AafhuH/P9MJe/Mn5F6F/978sDEuVr+HKO9BoSZIkSZIkSZIktVYAAA==";
const _sfc_main$f = {
  emits: ["send-file-change"],
  data() {
    return {
      cameraIcon
    };
  },
  methods: {
    customMenuSendFile() {
      this.$emit("send-file-change");
    }
  }
};
const _hoisted_1$d = { class: "room-custom-menu" };
const _hoisted_2$b = { class: "send-menu-list" };
const _hoisted_3$a = { class: "send-menu-item-card" };
const _hoisted_4$9 = ["src"];
const _hoisted_5$9 = /* @__PURE__ */ createElementVNode("div", { class: "send-menu-item-title" }, "Camera", -1);
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$d, [
    renderSlot(_ctx.$slots, "send-menu-list", {}, () => [
      createElementVNode("div", _hoisted_2$b, [
        createElementVNode("div", {
          class: "send-menu-item",
          onClick: _cache[0] || (_cache[0] = (...args) => $options.customMenuSendFile && $options.customMenuSendFile(...args))
        }, [
          createElementVNode("div", _hoisted_3$a, [
            createElementVNode("img", {
              class: "menu-icon",
              src: $data.cameraIcon,
              alt: "camera"
            }, null, 8, _hoisted_4$9)
          ]),
          _hoisted_5$9
        ])
      ])
    ])
  ]);
}
var RoomCustomMenu = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$e]]);
class Recorder {
  constructor(options = {}) {
    this.beforeRecording = options.beforeRecording;
    this.pauseRecording = options.pauseRecording;
    this.afterRecording = options.afterRecording;
    this.micFailed = options.micFailed;
    this.encoderOptions = {
      bitRate: options.bitRate,
      sampleRate: options.sampleRate
    };
    this.bufferSize = 4096;
    this.records = [];
    this.isPause = false;
    this.isRecording = false;
    this.duration = 0;
    this.volume = 0;
    this._duration = 0;
  }
  start() {
    const constraints = {
      video: false,
      audio: {
        channelCount: 1,
        echoCancellation: false
      }
    };
    this.beforeRecording && this.beforeRecording("start recording");
    navigator.mediaDevices.getUserMedia(constraints).then(this._micCaptured.bind(this)).catch(this._micError.bind(this));
    this.isPause = false;
    this.isRecording = true;
    if (!this.lameEncoder) {
      console.warn("mp3 encoder \u6682\u672A\u5F15\u5165~");
    }
  }
  stop() {
    this.stream.getTracks().forEach((track) => track.stop());
    this.input.disconnect();
    this.processor.disconnect();
    this.context.close();
    let record = null;
    if (this.lameEncoder) {
      record = this.lameEncoder.finish();
      record.duration = this.duration;
      this.records.push(record);
      this._duration = 0;
      this.duration = 0;
      this.isPause = false;
      this.isRecording = false;
      this.afterRecording && this.afterRecording(record);
    }
  }
  pause() {
    this.stream.getTracks().forEach((track) => track.stop());
    this.input.disconnect();
    this.processor.disconnect();
    this._duration = this.duration;
    this.isPause = true;
    this.pauseRecording && this.pauseRecording("pause recording");
  }
  _micCaptured(stream) {
    this.context = new (window.AudioContext || window.webkitAudioContext)();
    this.duration = this._duration;
    this.input = this.context.createMediaStreamSource(stream);
    this.processor = this.context.createScriptProcessor(this.bufferSize, 1, 1);
    this.stream = stream;
    this.processor.onaudioprocess = (ev) => {
      const sample = ev.inputBuffer.getChannelData(0);
      let sum = 0;
      if (this.lameEncoder) {
        this.lameEncoder.encode(sample);
      }
      for (let i = 0; i < sample.length; ++i) {
        sum += sample[i] * sample[i];
      }
      this.duration = parseFloat(this._duration) + parseFloat(this.context.currentTime.toFixed(2));
      this.volume = Math.sqrt(sum / sample.length).toFixed(2);
    };
    this.input.connect(this.processor);
    this.processor.connect(this.context.destination);
  }
  _micError(error) {
    this.micFailed && this.micFailed(error);
  }
}
var isChromium = window.chrome;
var winNav = window.navigator;
var vendorName = winNav.vendor;
var isOpera = typeof window.opr !== "undefined";
var isIEedge = winNav.userAgent.indexOf("Edg") > -1;
var isIOSChrome = winNav.userAgent.match("CriOS");
function detectChrome() {
  if (isIOSChrome) {
    return true;
  } else if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
    return true;
  } else {
    return false;
  }
}
function detectMobile() {
  var userAgent = getUserAgent();
  var userAgentPart = userAgent.substr(0, 4);
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
    userAgent
  ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
    userAgentPart
  );
}
function getUserAgent() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera || null;
  if (!userAgent)
    throw new Error("Failed to look for user agent information.");
  return userAgent;
}
var plusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAXJJREFUWEftlz8vBUEUR8/PBxDJC4nEV1BoJVQSQiGvotVLJGgkr1GokChVCuWrdBKiEQrRiob4CCQKBZFrh13ZN4m3a0feKmba+XPPnJmde1f8s6YQHjMbBTaAfuBQUjtkPTe3MpCZDQO3wEAOoinpKAQqBGgJOPCCtyUt1AW0Cux6wU8kTUcgZ8DMoqGuVyEaKvpSoqFoKDXwnTrMrAFMpomySJDrnwEWvYE3wE6ZycAbcC3pLj/+E8jMxoBTwEH1sr0Dy5L2s6AZkMvQ870kycV6cRWDJGfsq/wws0tgvCYgF7Yh6TEPtA5s1wR0JmnKP7I+d5ZA8xeXeggY8TbxDNyX3NgrcJWc0qakpw6gkgt0DIsvdZG1aCga8nNZkRG/P96hImPRUAlDK0mW3vPGHUuaLZrbrT/k334COPcW35LUqgUoLVtchbCWljEXSQU4J8kl2MqtsqEsopkNphXCgySrTBL6DoUG/ml+sKG/BvsA516vJSlvtKwAAAAASUVORK5CYII=";
var photoIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAAAXNSR0IArs4c6QAAATpJREFUOE+V0zFLGEEQhuFnEZukEgSRFBIbSaGQFFYWsYydAW2U1GKtBvIPojZWaVMISRMQtLKxMFiJ2EiwUBQlIT8gghDc3MIKx3nnXa7am2/mndmZ2aDmizG+xiaeVeSfmAkhHFTDQtUQY+wrnE8wWJcEZxgLIdyU9RBjfIllPM3Cc4w2QO7NR7jOP3+K2LUEusBQS2CbfJlAMXtt4BM+4F22/cb3fJ4o9IEmYhlU9fmIr5hCSraDObyvgzWB0sS28AW9OfA2TQyzmH8wtdLVyto4tmuucoVpHHYFvcCPhn4MFz087wp6hV30VwJ+4Q2Ou4LS9NL2fkZPDvqbmz2Jha6gNKUl7OMt7ool/Yb0dNbx4EU8Nv6U9BR7OXuqZOSxPUor/qRtdVv0m1TRYgFaLb21/2WmQlb+Af33ZVBDCmfHAAAAAElFTkSuQmCC";
const _sfc_main$e = {
  name: "RoomFooter",
  components: {
    SvgIcon,
    EmojiPickerContainer,
    RoomFiles,
    RoomMessageReply,
    RoomUsersTag,
    RoomEmojis,
    RoomTemplatesText,
    RoomCustomMenu,
    MobileEmojiPickerContainer,
    EmotionHappy,
    Keyboard,
    Pic,
    AddOne
  },
  directives: {
    clickOutside: vClickOutside
  },
  props: {
    disabledEnterKeySend: { type: Boolean, required: true },
    room: { type: Object, required: true },
    roomId: { type: [String, Number], required: true },
    platform: { type: String, required: true },
    pcMode: { type: Boolean, required: false },
    roomMessage: { type: String, default: null },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true },
    textMessages: { type: Object, required: true },
    showSendIcon: { type: Boolean, required: true },
    showFiles: { type: Boolean, required: true },
    showMenu: { type: Boolean, default: true },
    showAudio: { type: Boolean, required: true },
    showEmojis: { type: Boolean, required: true },
    showFooter: { type: Boolean, required: true },
    acceptedFiles: { type: String, required: true },
    multipleFiles: { type: Boolean, default: true },
    captureFiles: { type: String, required: true },
    textareaActionEnabled: { type: Boolean, required: true },
    textareaAutoFocus: { type: Boolean, required: true },
    userTagsEnabled: { type: Boolean, required: true },
    emojisSuggestionEnabled: { type: Boolean, required: true },
    templatesText: { type: Array, default: null },
    audioBitRate: { type: Number, required: true },
    audioSampleRate: { type: Number, required: true },
    initReplyMessage: { type: Object, default: null },
    initEditMessage: { type: Object, default: null },
    droppedFiles: { type: Array, default: null },
    emojiDataSource: { type: String, default: void 0 }
  },
  emits: [
    "edit-message",
    "send-message",
    "update-edited-message-id",
    "textarea-action-handler",
    "typing-message",
    "preview-image",
    "blur",
    "focus",
    "scroll-to-bottom"
  ],
  data() {
    return {
      plusIcon,
      photoIcon,
      message: "",
      editedMessage: {},
      messageReply: null,
      cursorRangePosition: null,
      files: [],
      fileDialog: false,
      selectUsersTagItem: null,
      selectEmojiItem: null,
      selectTemplatesTextItem: null,
      format: "mp3",
      activeUpOrDownEmojis: null,
      activeUpOrDownUsersTag: null,
      activeUpOrDownTemplatesText: null,
      emojisDB: new Database({ dataSource: this.emojiDataSource }),
      emojiOpened: false,
      keepKeyboardOpen: false,
      filteredEmojis: [],
      filteredUsersTag: [],
      selectedUsersTag: [],
      filteredTemplatesText: [],
      recorder: this.initRecorder(),
      isRecording: false,
      showSendMenu: false,
      fullscreen: false,
      inputFocused: false,
      needKeepFocus: false,
      keepFocusTimer: 0,
      keepKeyboardOpenTimer: 0
    };
  },
  computed: {
    isCustomer() {
      return this.platform === "customer";
    },
    isMessageEmpty() {
      return !this.files.length && !this.message.trim();
    },
    isFileLoading() {
      return this.files.some((e) => e.loading);
    },
    recordedTime() {
      return new Date(this.recorder.duration * 1e3).toISOString().substr(14, 5);
    },
    shadowFooter() {
      return !!this.filteredEmojis.length || !!this.filteredUsersTag.length || !!this.filteredTemplatesText.length || !!this.files.length || !!this.messageReply;
    },
    isIos() {
      return deviceSystem === "ios";
    },
    finalMobile() {
      return this.platform === "customer" && !this.pcMode;
    },
    needSafeArea() {
      return this.finalMobile && !this.inputFocused;
    }
  },
  watch: {
    roomId() {
      this.resetMessage(true, true);
      if (this.roomMessage) {
        this.message = this.roomMessage;
        setTimeout(() => this.onChangeInput());
      }
    },
    message(val) {
      this.getTextareaRef().value = val;
    },
    roomMessage: {
      immediate: true,
      handler(val) {
        if (val)
          this.message = this.roomMessage;
      }
    },
    editedMessage(val) {
      this.$emit("update-edited-message-id", val._id);
    },
    initReplyMessage(val) {
      if (val) {
        this.replyMessage(val);
      }
    },
    initEditMessage(val) {
      if (val) {
        this.editMessage(val);
      }
    },
    droppedFiles(val) {
      if (val) {
        this.onFileChange(val);
      }
    }
  },
  mounted() {
    const isMobile = detectMobile();
    let isComposed = true;
    this.getTextareaRef().addEventListener("keyup", (e) => {
      if (this.disabledEnterKeySend) {
        return;
      }
      if (e.key === "Enter" && !e.shiftKey && !this.fileDialog) {
        if (isMobile) {
          this.message = this.message + "\n";
          setTimeout(() => this.onChangeInput());
        } else if (isComposed && !this.filteredEmojis.length && !this.filteredUsersTag.length && !this.filteredTemplatesText.length) {
          this.sendMessage();
        }
      }
      isComposed = !e.isComposing;
      setTimeout(() => {
        this.updateFooterLists();
      }, 60);
    });
    this.getTextareaRef().addEventListener("click", () => {
      if (isMobile)
        this.keepKeyboardOpen = true;
      this.updateFooterLists();
    });
    this.getTextareaRef().addEventListener("blur", () => {
      setTimeout(() => {
        this.resetFooterList();
      }, 100);
      if (isMobile) {
        this.keepKeyboardOpenTimer = setTimeout(() => {
          this.keepKeyboardOpen = false;
        });
      }
    });
    const alldom = document.querySelector("vue-advanced-chat").shadowRoot;
    alldom.addEventListener("click", this.rootClickHandler);
    if (isIOS) {
      FaskClick(this.$refs.emojiBtn);
      FaskClick(this.$refs.menuBtn);
      FaskClick(this.$refs.sendBtn);
    }
  },
  beforeUnmount() {
    this.stopRecorder();
    const vac = document.querySelector("vue-advanced-chat");
    if (vac) {
      const alldom = vac.shadowRoot;
      alldom.removeEventListener("click", this.rootClickHandler);
    }
  },
  methods: {
    rootClickHandler(event) {
      var target = event.target;
      var box = this.$refs["room-footer-contain"];
      if (box && target !== box && !box.contains(target)) {
        this.showSendMenu = false;
        this.emojiOpened = false;
      }
    },
    getTextareaRef() {
      return this.$refs.roomTextarea;
    },
    scrollToBottom(delay = 150) {
      this.$emit("scroll-to-bottom", delay);
    },
    focusTextarea(disableMobileFocus) {
      if (detectMobile() && disableMobileFocus)
        return;
      if (!this.getTextareaRef())
        return;
      this.getTextareaRef().focus();
      if (this.cursorRangePosition) {
        setTimeout(() => {
          const offset = detectChrome() ? 0 : 1;
          this.getTextareaRef().setSelectionRange(
            this.cursorRangePosition + offset,
            this.cursorRangePosition + offset
          );
          this.cursorRangePosition = null;
        });
      }
    },
    onChangeInput() {
      var _a, _b, _c;
      if (((_a = this.getTextareaRef()) == null ? void 0 : _a.value) || ((_b = this.getTextareaRef()) == null ? void 0 : _b.value) === "") {
        this.message = (_c = this.getTextareaRef()) == null ? void 0 : _c.value;
      }
      this.keepKeyboardOpen = true;
      this.resizeTextarea();
      this.$emit("typing-message", this.message);
    },
    resizeTextarea() {
      const el = this.getTextareaRef();
      if (!el)
        return;
      const padding = window.getComputedStyle(el, null).getPropertyValue("padding-top").replace("px", "");
      el.style.height = 0;
      el.style.height = el.scrollHeight - padding * 2 + "px";
    },
    escapeTextarea() {
      if (this.filteredEmojis.length)
        this.filteredEmojis = [];
      else if (this.filteredUsersTag.length)
        this.filteredUsersTag = [];
      else if (this.filteredTemplatesText.length) {
        this.filteredTemplatesText = [];
      } else
        this.resetMessage();
    },
    onPasteImage(pasteEvent) {
      var _a;
      const items = (_a = pasteEvent.clipboardData) == null ? void 0 : _a.items;
      if (items) {
        Array.from(items).forEach((item) => {
          if (item.type.includes("image")) {
            const blob = item.getAsFile();
            this.onFileChange([blob]);
          }
        });
      }
    },
    updateActiveUpOrDown(event, direction) {
      if (this.filteredEmojis.length) {
        this.activeUpOrDownEmojis = direction;
        event.preventDefault();
      } else if (this.filteredUsersTag.length) {
        this.activeUpOrDownUsersTag = direction;
        event.preventDefault();
      } else if (this.filteredTemplatesText.length) {
        this.activeUpOrDownTemplatesText = direction;
        event.preventDefault();
      }
    },
    selectItem() {
      if (this.filteredEmojis.length) {
        this.selectEmojiItem = true;
      } else if (this.filteredUsersTag.length) {
        this.selectUsersTagItem = true;
      } else if (this.filteredTemplatesText.length) {
        this.selectTemplatesTextItem = true;
      }
    },
    selectEmoji(emoji) {
      this.selectEmojiItem = false;
      if (!emoji)
        return;
      const { position, endPosition } = this.getCharPosition(":");
      this.message = this.message.substr(0, position - 1) + emoji + this.message.substr(endPosition, this.message.length - 1);
      this.cursorRangePosition = position;
      this.focusTextarea();
    },
    selectTemplateText(template) {
      this.selectTemplatesTextItem = false;
      if (!template)
        return;
      const { position, endPosition } = this.getCharPosition("/");
      const space = this.message.substr(endPosition, endPosition).length ? "" : " ";
      this.message = this.message.substr(0, position - 1) + template.text + space + this.message.substr(endPosition, this.message.length - 1);
      this.cursorRangePosition = position + template.text.length + space.length + 1;
      this.focusTextarea();
    },
    addEmoji(emoji) {
      this.message += emoji.unicode;
      this.focusTextarea(true);
      setTimeout(() => this.onChangeInput());
    },
    launchFilePicker() {
      this.$refs.file.value = "";
      this.$refs.file.click();
    },
    async onFileChange(files) {
      this.fileDialog = true;
      this.focusTextarea(true);
      if (isMobileDevice) {
        this.showSendMenu = false;
      }
      Array.from(files).forEach(async (file) => {
        const { width, height } = await getFileDimensions(file);
        const fileURL = URL.createObjectURL(file);
        const typeIndex = file.name.lastIndexOf(".");
        this.files.push({
          loading: true,
          name: file.name.substring(0, typeIndex),
          size: file.size,
          type: file.type,
          extension: file.name.substring(typeIndex + 1),
          localUrl: fileURL,
          width,
          height
        });
        const blobFile = await fetch(fileURL).then((res) => res.blob());
        let loadedFile = this.files.find((file2) => file2.localUrl === fileURL);
        if (loadedFile) {
          loadedFile.blob = blobFile;
          loadedFile.loading = false;
          delete loadedFile.loading;
        }
      });
      setTimeout(() => this.fileDialog = false, 500);
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.focusTextarea();
    },
    toggleRecorder(recording) {
      this.isRecording = recording;
      if (!this.recorder.isRecording) {
        setTimeout(() => this.recorder.start(), 200);
      } else {
        try {
          this.recorder.stop();
          const record = this.recorder.records[0];
          this.files.push({
            blob: record.blob,
            name: `audio.${this.format}`,
            size: record.blob.size,
            duration: record.duration,
            type: record.blob.type,
            audio: true,
            localUrl: URL.createObjectURL(record.blob)
          });
          this.recorder = this.initRecorder();
          this.sendMessage();
        } catch {
          setTimeout(() => this.stopRecorder(), 100);
        }
      }
    },
    stopRecorder() {
      if (this.recorder.isRecording) {
        try {
          this.recorder.stop();
          this.recorder = this.initRecorder();
        } catch {
          setTimeout(() => this.stopRecorder(), 100);
        }
      }
    },
    textareaActionHandler() {
      this.$emit("textarea-action-handler", this.message);
    },
    sendMessage() {
      var _a;
      let message = this.message.trim();
      if (!this.files.length && !message)
        return;
      if (this.isFileLoading)
        return;
      this.selectedUsersTag.forEach((user) => {
        message = message.replace(
          `@${user.username}`,
          `<usertag>${user._id}</usertag>`
        );
      });
      const files = this.files.length ? this.files : null;
      if (this.editedMessage._id) {
        if (this.editedMessage.content !== message || ((_a = this.editedMessage.files) == null ? void 0 : _a.length) || this.files.length) {
          this.$emit("edit-message", {
            messageId: this.editedMessage._id,
            newContent: message,
            files,
            replyMessage: this.messageReply,
            usersTag: this.selectedUsersTag
          });
        }
      } else {
        this.$emit("send-message", {
          content: message,
          files,
          replyMessage: this.messageReply,
          usersTag: this.selectedUsersTag
        });
      }
      this.resetMessage(true);
    },
    editMessage(message) {
      this.resetMessage();
      this.editedMessage = { ...message };
      let messageContent = message.content;
      const initialContent = messageContent;
      const firstTag = "<usertag>";
      const secondTag = "</usertag>";
      const usertags = [
        ...messageContent.matchAll(new RegExp(firstTag, "gi"))
      ].map((a) => a.index);
      usertags.forEach((index) => {
        const userId = initialContent.substring(
          index + firstTag.length,
          initialContent.indexOf(secondTag, index)
        );
        const user = this.room.users.find((user2) => user2._id === userId);
        messageContent = messageContent.replace(
          `${firstTag}${userId}${secondTag}`,
          `@${(user == null ? void 0 : user.username) || "unknown"}`
        );
        this.selectUserTag(user, true);
      });
      this.message = messageContent;
      if (message.files) {
        this.files = [...message.files];
      }
      setTimeout(() => this.resizeTextarea());
    },
    replyMessage(message) {
      this.editedMessage = {};
      this.messageReply = message;
      this.focusTextarea();
    },
    updateFooterLists() {
      this.updateFooterList("@");
      this.updateFooterList(":");
      this.updateFooterList("/");
    },
    updateFooterList(tagChar) {
      if (!this.getTextareaRef())
        return;
      if (tagChar === ":" && !this.emojisSuggestionEnabled) {
        return;
      }
      if (tagChar === "@" && (!this.userTagsEnabled || !this.room.users)) {
        return;
      }
      if (tagChar === "/" && !this.templatesText) {
        return;
      }
      const textareaCursorPosition = this.getTextareaRef().selectionStart;
      let position = textareaCursorPosition;
      while (position > 0 && this.message.charAt(position - 1) !== tagChar && (this.message.charAt(position - 1) !== " " || tagChar !== ":")) {
        position--;
      }
      const beforeTag = this.message.charAt(position - 2);
      const notLetterNumber = !beforeTag.match(/^[0-9a-zA-Z]+$/);
      if (this.message.charAt(position - 1) === tagChar && (!beforeTag || beforeTag === " " || notLetterNumber)) {
        const query = this.message.substring(position, textareaCursorPosition);
        if (tagChar === ":") {
          this.updateEmojis(query);
        } else if (tagChar === "@") {
          this.updateShowUsersTag(query);
        } else if (tagChar === "/") {
          this.updateShowTemplatesText(query);
        }
      } else {
        this.resetFooterList(tagChar);
      }
    },
    updateShowUsersTag(query) {
      this.filteredUsersTag = filteredItems(
        this.room.users,
        "username",
        query,
        true
      ).filter((user) => user._id !== this.currentUserId);
    },
    selectUserTag(user, editMode = false) {
      this.selectUsersTagItem = false;
      if (!user)
        return;
      const { position, endPosition } = this.getCharPosition("@");
      const space = this.message.substr(endPosition, endPosition).length ? "" : " ";
      this.message = this.message.substr(0, position) + user.username + space + this.message.substr(endPosition, this.message.length - 1);
      this.selectedUsersTag = [...this.selectedUsersTag, { ...user }];
      if (!editMode) {
        this.cursorRangePosition = position + user.username.length + space.length + 1;
      }
      this.focusTextarea();
    },
    updateShowTemplatesText(query) {
      this.filteredTemplatesText = filteredItems(
        this.templatesText,
        "tag",
        query,
        true
      );
    },
    getCharPosition(tagChar) {
      const cursorPosition = this.getTextareaRef().selectionStart;
      let position = cursorPosition;
      while (position > 0 && this.message.charAt(position - 1) !== tagChar) {
        position--;
      }
      const endPosition = this.getTextareaRef().selectionEnd;
      return { position, endPosition };
    },
    async updateEmojis(query) {
      if (!query)
        return;
      const emojis = await this.emojisDB.getEmojiBySearchQuery(query);
      this.filteredEmojis = emojis.map((emoji) => emoji.unicode);
    },
    resetFooterList(tagChar = null) {
      if (tagChar === ":") {
        this.filteredEmojis = [];
      } else if (tagChar === "@") {
        this.filteredUsersTag = [];
      } else if (tagChar === "/") {
        this.filteredTemplatesText = [];
      } else {
        this.filteredEmojis = [];
        this.filteredUsersTag = [];
        this.filteredTemplatesText = [];
      }
    },
    resetMessage(disableMobileFocus = false, initRoom = false) {
      if (!initRoom) {
        this.$emit("typing-message", null);
      }
      const el = this.$refs.file;
      if (el) {
        el.value = "";
      }
      this.selectedUsersTag = [];
      this.resetFooterList();
      this.resetTextareaSize();
      this.message = "";
      this.editedMessage = {};
      this.messageReply = null;
      this.files = [];
      if (!disableMobileFocus) {
        this.emojiOpened = false;
      }
      this.preventKeyboardFromClosing();
      if (this.textareaAutoFocus || !initRoom) {
        setTimeout(() => this.focusTextarea(disableMobileFocus || isIOS));
      }
    },
    resetTextareaSize() {
      if (this.getTextareaRef()) {
        this.getTextareaRef().style.height = "20px";
      }
    },
    preventKeyboardFromClosing() {
      if (this.keepKeyboardOpen && this.needKeepFocus) {
        this.getTextareaRef().focus();
        if (this.keepFocusTimer) {
          clearTimeout(this.keepFocusTimer);
          this.keepFocusTimer = 0;
        }
        if (this.keepKeyboardOpenTimer) {
          clearTimeout(this.keepKeyboardOpenTimer);
          this.keepKeyboardOpenTimer = 0;
        }
      }
    },
    initRecorder() {
      this.isRecording = false;
      return new Recorder({
        bitRate: Number(this.audioBitRate),
        sampleRate: Number(this.audioSampleRate),
        beforeRecording: null,
        afterRecording: null,
        pauseRecording: null,
        micFailed: this.micFailed
      });
    },
    micFailed() {
      this.isRecording = false;
      this.recorder = this.initRecorder();
    },
    toggleMenu() {
      this.$emit("blur", { noAnimate: true });
      this.emojiOpened = false;
      this.showSendMenu = !this.showSendMenu;
      this.scrollToBottom();
    },
    toggleEmoji() {
      if (this.emojiOpened) {
        this.emojiOpened = false;
        this.focusTextarea();
        if (detectMobile())
          this.keepKeyboardOpen = true;
      } else {
        this.$emit("blur", { noAnimate: true });
        this.showSendMenu = false;
        this.emojiOpened = true;
        this.scrollToBottom();
      }
    },
    toggleVideoFullscreen(e) {
      if (!e.fullscreen) {
        this.fullscreen = false;
      } else {
        if (e.isCss || e.isRotate) {
          this.fullscreen = true;
        }
      }
    },
    onFocusInput() {
      if (this.finalMobile) {
        this.emojiOpened = false;
        this.showSendMenu = false;
        this.scrollToBottom(350);
      }
      this.inputFocused = true;
      this.needKeepFocus = true;
      this.keepKeyboardOpen = true;
    },
    onBlurInput() {
      this.inputFocused = false;
      this.keepFocusTimer = setTimeout(() => {
        this.needKeepFocus = false;
      }, 50);
    }
  }
};
const _hoisted_1$c = {
  key: 0,
  class: "vac-icon-textarea-left"
};
const _hoisted_2$a = /* @__PURE__ */ createElementVNode("div", { class: "vac-dot-audio-record" }, null, -1);
const _hoisted_3$9 = { class: "vac-dot-audio-record-time" };
const _hoisted_4$8 = {
  key: 1,
  class: "vac-icon-textarea-left"
};
const _hoisted_5$8 = ["src"];
const _hoisted_6$4 = ["src"];
const _hoisted_7$4 = ["placeholder"];
const _hoisted_8$3 = { class: "vac-icon-textarea" };
const _hoisted_9$2 = { key: 0 };
const _hoisted_10$1 = { key: 1 };
const _hoisted_11$1 = ["multiple", "accept", "capture"];
const _hoisted_12$1 = ["multiple", "accept"];
const _hoisted_13$1 = { key: 1 };
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_room_emojis = resolveComponent("room-emojis");
  const _component_room_users_tag = resolveComponent("room-users-tag");
  const _component_room_templates_text = resolveComponent("room-templates-text");
  const _component_room_message_reply = resolveComponent("room-message-reply");
  const _component_room_files = resolveComponent("room-files");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_emoji_picker_container = resolveComponent("emoji-picker-container");
  const _component_EmotionHappy = resolveComponent("EmotionHappy");
  const _component_Keyboard = resolveComponent("Keyboard");
  const _component_AddOne = resolveComponent("AddOne");
  const _component_Pic = resolveComponent("Pic");
  const _component_mobile_emoji_picker_container = resolveComponent("mobile-emoji-picker-container");
  const _component_room_custom_menu = resolveComponent("room-custom-menu");
  const _directive_click_outside = resolveDirective("click-outside");
  return withDirectives((openBlock(), createElementBlock("div", {
    id: "room-footer",
    ref: "room-footer-contain",
    class: normalizeClass(["vac-room-footer", {
      "vac-app-box-shadow": $options.shadowFooter,
      "vac-room-footer-fullscreen": $data.fullscreen,
      "vac-room-footer-safe-area": $options.needSafeArea
    }])
  }, [
    createVNode(_component_room_emojis, {
      "filtered-emojis": $data.filteredEmojis,
      "select-item": $data.selectEmojiItem,
      "active-up-or-down": $data.activeUpOrDownEmojis,
      onSelectEmoji: _cache[0] || (_cache[0] = ($event) => $options.selectEmoji($event)),
      onActivateItem: _cache[1] || (_cache[1] = ($event) => $data.activeUpOrDownEmojis = 0)
    }, null, 8, ["filtered-emojis", "select-item", "active-up-or-down"]),
    createVNode(_component_room_users_tag, {
      "filtered-users-tag": $data.filteredUsersTag,
      "select-item": $data.selectUsersTagItem,
      "active-up-or-down": $data.activeUpOrDownUsersTag,
      onSelectUserTag: _cache[2] || (_cache[2] = ($event) => $options.selectUserTag($event)),
      onActivateItem: _cache[3] || (_cache[3] = ($event) => $data.activeUpOrDownUsersTag = 0)
    }, null, 8, ["filtered-users-tag", "select-item", "active-up-or-down"]),
    createVNode(_component_room_templates_text, {
      "filtered-templates-text": $data.filteredTemplatesText,
      "select-item": $data.selectTemplatesTextItem,
      "active-up-or-down": $data.activeUpOrDownTemplatesText,
      onSelectTemplateText: _cache[4] || (_cache[4] = ($event) => $options.selectTemplateText($event)),
      onActivateItem: _cache[5] || (_cache[5] = ($event) => $data.activeUpOrDownTemplatesText = 0)
    }, null, 8, ["filtered-templates-text", "select-item", "active-up-or-down"]),
    createVNode(_component_room_message_reply, {
      room: $props.room,
      "message-reply": $data.messageReply,
      "text-formatting": $props.textFormatting,
      "link-options": $props.linkOptions,
      onResetMessage: $options.resetMessage
    }, createSlots({ _: 2 }, [
      renderList(_ctx.$slots, (i, name) => {
        return {
          name,
          fn: withCtx((data) => [
            renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
          ])
        };
      })
    ]), 1032, ["room", "message-reply", "text-formatting", "link-options", "onResetMessage"]),
    createVNode(_component_room_files, {
      files: $data.files,
      onRemoveFile: $options.removeFile,
      onResetMessage: $options.resetMessage,
      onPreviewImage: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("preview-image", $event)),
      onToggleVideoFullscreen: $options.toggleVideoFullscreen
    }, createSlots({ _: 2 }, [
      renderList(_ctx.$slots, (i, name) => {
        return {
          name,
          fn: withCtx((data) => [
            renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
          ])
        };
      })
    ]), 1032, ["files", "onRemoveFile", "onResetMessage", "onToggleVideoFullscreen"]),
    createElementVNode("div", {
      class: normalizeClass(["vac-box-footer", { "vac-box-footer-border": !$data.files.length }])
    }, [
      $props.showAudio && !$data.files.length ? (openBlock(), createElementBlock("div", _hoisted_1$c, [
        $data.isRecording ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", {
            class: "vac-svg-button vac-icon-audio-stop",
            onClick: _cache[7] || (_cache[7] = (...args) => $options.stopRecorder && $options.stopRecorder(...args))
          }, [
            renderSlot(_ctx.$slots, "audio-stop-icon", {}, () => [
              createVNode(_component_svg_icon, { name: "close-outline" })
            ])
          ]),
          _hoisted_2$a,
          createElementVNode("div", _hoisted_3$9, toDisplayString($options.recordedTime), 1),
          createElementVNode("div", {
            class: "vac-svg-button vac-icon-audio-confirm",
            onClick: _cache[8] || (_cache[8] = ($event) => $options.toggleRecorder(false))
          }, [
            renderSlot(_ctx.$slots, "audio-check-icon", {}, () => [
              createVNode(_component_svg_icon, { name: "checkmark" })
            ])
          ])
        ], 64)) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: "vac-svg-button",
          onClick: _cache[9] || (_cache[9] = ($event) => $options.toggleRecorder(true))
        }, [
          renderSlot(_ctx.$slots, "microphone-icon", {}, () => [
            createVNode(_component_svg_icon, {
              name: "microphone",
              class: "vac-icon-microphone"
            })
          ])
        ]))
      ])) : createCommentVNode("", true),
      $props.platform !== "customer" ? (openBlock(), createElementBlock("div", _hoisted_4$8, [
        $props.showFiles ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "custom-menu-icon",
          onClick: _cache[10] || (_cache[10] = (...args) => $options.launchFilePicker && $options.launchFilePicker(...args))
        }, [
          createElementVNode("img", {
            src: $data.photoIcon,
            style: { "width": "18px", "height": "18px" }
          }, null, 8, _hoisted_5$8)
        ])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "toogle-menu-icon", {}, () => [
          $options.finalMobile && $props.showMenu ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["custom-menu-icon", $data.showSendMenu ? "rotate-45" : ""]),
            style: { "margin-left": "5px" },
            onClick: _cache[11] || (_cache[11] = (...args) => $options.toggleMenu && $options.toggleMenu(...args))
          }, [
            createElementVNode("img", {
              src: $data.plusIcon,
              style: { "width": "18px", "height": "18px" }
            }, null, 8, _hoisted_6$4)
          ], 2)) : createCommentVNode("", true)
        ])
      ])) : createCommentVNode("", true),
      createElementVNode("textarea", {
        id: "roomTextarea",
        ref: "roomTextarea",
        placeholder: $props.textMessages.TYPE_MESSAGE,
        class: normalizeClass(["vac-textarea", {
          "vac-textarea-outline": $data.editedMessage._id
        }]),
        style: {
          "min-height": `24px`,
          "padding-left": `12px`
        },
        onInput: _cache[12] || (_cache[12] = (...args) => $options.onChangeInput && $options.onChangeInput(...args)),
        onFocus: _cache[13] || (_cache[13] = (...args) => $options.onFocusInput && $options.onFocusInput(...args)),
        onBlur: _cache[14] || (_cache[14] = (...args) => $options.onBlurInput && $options.onBlurInput(...args)),
        onKeydown: [
          _cache[15] || (_cache[15] = withKeys((...args) => $options.escapeTextarea && $options.escapeTextarea(...args), ["esc"])),
          _cache[16] || (_cache[16] = withKeys(withModifiers((...args) => $options.selectItem && $options.selectItem(...args), ["exact", "prevent"]), ["enter"])),
          _cache[18] || (_cache[18] = withKeys(withModifiers(() => {
          }, ["exact", "prevent"]), ["tab"])),
          _cache[19] || (_cache[19] = withKeys((...args) => $options.selectItem && $options.selectItem(...args), ["tab"])),
          _cache[20] || (_cache[20] = withKeys(($event) => $options.updateActiveUpOrDown($event, -1), ["up"])),
          _cache[21] || (_cache[21] = withKeys(($event) => $options.updateActiveUpOrDown($event, 1), ["down"]))
        ],
        onPaste: _cache[17] || (_cache[17] = (...args) => $options.onPasteImage && $options.onPasteImage(...args))
      }, null, 42, _hoisted_7$4),
      createElementVNode("div", _hoisted_8$3, [
        $data.editedMessage._id ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "vac-svg-button",
          onClick: _cache[22] || (_cache[22] = (...args) => $options.resetMessage && $options.resetMessage(...args))
        }, [
          renderSlot(_ctx.$slots, "edit-close-icon", {}, () => [
            createVNode(_component_svg_icon, { name: "close-outline" })
          ])
        ])) : createCommentVNode("", true),
        $props.showEmojis ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          $props.platform === "business" ? withDirectives((openBlock(), createElementBlock("div", _hoisted_9$2, [
            renderSlot(_ctx.$slots, "emoji-picker", mergeProps({ emojiOpened: $data.emojiOpened }, { addEmoji: $options.addEmoji }), () => [
              createVNode(_component_emoji_picker_container, {
                "emoji-opened": $data.emojiOpened,
                "position-top": true,
                "emoji-data-source": $props.emojiDataSource,
                onAddEmoji: $options.addEmoji,
                onOpenEmoji: _cache[23] || (_cache[23] = ($event) => $data.emojiOpened = $event)
              }, {
                "emoji-picker-icon": withCtx(() => [
                  renderSlot(_ctx.$slots, "emoji-picker-icon")
                ]),
                _: 3
              }, 8, ["emoji-opened", "emoji-data-source", "onAddEmoji"])
            ])
          ])), [
            [_directive_click_outside, () => $data.emojiOpened = false]
          ]) : $props.pcMode ? withDirectives((openBlock(), createElementBlock("div", _hoisted_10$1, [
            renderSlot(_ctx.$slots, "emoji-picker", mergeProps({ emojiOpened: $data.emojiOpened }, { addEmoji: $options.addEmoji }), () => [
              createVNode(_component_emoji_picker_container, {
                "emoji-opened": $data.emojiOpened,
                "position-top": true,
                "pc-mode": "",
                "emoji-data-source": $props.emojiDataSource,
                onAddEmoji: $options.addEmoji,
                onOpenEmoji: _cache[24] || (_cache[24] = ($event) => $data.emojiOpened = $event)
              }, {
                "emoji-picker-icon": withCtx(() => [
                  createVNode(_component_EmotionHappy, {
                    size: "28",
                    fill: "#9EA7B5",
                    "stroke-width": "3"
                  })
                ]),
                _: 1
              }, 8, ["emoji-opened", "emoji-data-source", "onAddEmoji"])
            ])
          ])), [
            [_directive_click_outside, () => $data.emojiOpened = false]
          ]) : (openBlock(), createElementBlock("div", {
            key: 2,
            ref: "emojiBtn",
            class: "vac-emoji-btn-mobile",
            onClick: _cache[25] || (_cache[25] = (...args) => $options.toggleEmoji && $options.toggleEmoji(...args))
          }, [
            $data.emojiOpened ? (openBlock(), createBlock(_component_Keyboard, {
              key: 0,
              size: "33",
              fill: "#0a0a0a",
              "stroke-width": "3",
              style: { "display": "flex", "align-items": "center" }
            })) : (openBlock(), createBlock(_component_EmotionHappy, {
              key: 1,
              size: "33",
              fill: "#0a0a0a",
              "stroke-width": "3",
              style: { "display": "flex", "align-items": "center" }
            }))
          ], 512))
        ], 64)) : createCommentVNode("", true),
        $props.textareaActionEnabled ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: "vac-svg-button",
          onClick: _cache[26] || (_cache[26] = (...args) => $options.textareaActionHandler && $options.textareaActionHandler(...args))
        }, [
          renderSlot(_ctx.$slots, "custom-action-icon", {}, () => [
            createVNode(_component_svg_icon, { name: "deleted" })
          ])
        ])) : createCommentVNode("", true),
        $props.showFiles && !$options.isIos ? (openBlock(), createElementBlock("input", {
          key: 3,
          id: "footerFile",
          ref: "file",
          type: "file",
          multiple: $props.multipleFiles ? true : null,
          accept: $props.acceptedFiles,
          capture: $props.captureFiles,
          style: { "display": "none" },
          onChange: _cache[27] || (_cache[27] = ($event) => $options.onFileChange($event.target.files))
        }, null, 40, _hoisted_11$1)) : createCommentVNode("", true),
        $props.showFiles && $options.isIos ? (openBlock(), createElementBlock("input", {
          key: 4,
          id: "footerFile",
          ref: "file",
          type: "file",
          multiple: $props.multipleFiles ? true : null,
          accept: $props.acceptedFiles,
          style: { "display": "none" },
          onChange: _cache[28] || (_cache[28] = ($event) => $options.onFileChange($event.target.files))
        }, null, 40, _hoisted_12$1)) : createCommentVNode("", true),
        !$props.pcMode && $options.isCustomer && $props.showMenu ? (openBlock(), createElementBlock("div", {
          key: 5,
          ref: "menuBtn",
          class: normalizeClass(["opt-icon", $data.showSendMenu ? "rotate-45" : ""]),
          onClick: _cache[29] || (_cache[29] = (...args) => $options.toggleMenu && $options.toggleMenu(...args))
        }, [
          createVNode(_component_AddOne, {
            size: "33",
            fill: "#0a0a0a",
            "stroke-width": "3",
            style: { "display": "flex", "align-items": "center" }
          })
        ], 2)) : createCommentVNode("", true),
        $props.pcMode && $props.showFiles ? (openBlock(), createElementBlock("div", {
          key: 6,
          class: "upload-pic-icon vac-svg-button",
          onClick: _cache[30] || (_cache[30] = (...args) => $options.launchFilePicker && $options.launchFilePicker(...args))
        }, [
          createVNode(_component_Pic, {
            size: "28",
            fill: "#9EA7B5",
            "stroke-width": "3"
          })
        ])) : createCommentVNode("", true),
        $props.showSendIcon ? (openBlock(), createElementBlock("div", {
          key: 7,
          ref: "sendBtn",
          class: normalizeClass(["vac-svg-button", { "vac-send-disabled": $options.isMessageEmpty }]),
          onClick: _cache[31] || (_cache[31] = (...args) => $options.sendMessage && $options.sendMessage(...args))
        }, [
          renderSlot(_ctx.$slots, "send-icon", {
            isMessageEmpty: $options.isMessageEmpty,
            isFileLoading: $options.isFileLoading
          }, () => [
            $options.isCustomer && (!($options.isMessageEmpty || $options.isFileLoading) || $props.pcMode) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["send-btn", {
                disabled: $options.isMessageEmpty || $options.isFileLoading
              }])
            }, " Send ", 2)) : $options.isCustomer && ($options.isMessageEmpty || $options.isFileLoading) ? (openBlock(), createElementBlock("div", _hoisted_13$1)) : (openBlock(), createBlock(_component_svg_icon, {
              key: 2,
              name: "send",
              param: $options.isMessageEmpty || $options.isFileLoading ? "disabled" : ""
            }, null, 8, ["param"]))
          ])
        ], 2)) : createCommentVNode("", true)
      ])
    ], 2),
    createVNode(Transition, { name: "vac-slide-up" }, {
      default: withCtx(() => [
        withDirectives(createElementVNode("div", null, [
          $options.finalMobile ? withDirectives((openBlock(), createBlock(_component_mobile_emoji_picker_container, {
            key: 0,
            "emoji-opened": $data.emojiOpened,
            "emoji-data-source": $props.emojiDataSource,
            onAddEmoji: $options.addEmoji
          }, null, 8, ["emoji-opened", "emoji-data-source", "onAddEmoji"])), [
            [vShow, $data.emojiOpened]
          ]) : createCommentVNode("", true),
          withDirectives(createVNode(_component_room_custom_menu, { onSendFileChange: $options.launchFilePicker }, createSlots({ _: 2 }, [
            renderList(_ctx.$slots, (i, name) => {
              return {
                name,
                fn: withCtx((data) => [
                  renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                ])
              };
            })
          ]), 1032, ["onSendFileChange"]), [
            [vShow, $data.showSendMenu]
          ])
        ], 512), [
          [vShow, $data.emojiOpened || $data.showSendMenu]
        ])
      ]),
      _: 3
    })
  ], 2)), [
    [vShow, Object.keys($props.room).length && $props.showFooter]
  ]);
}
var RoomFooter = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$d]]);
const _sfc_main$d = {
  __name: "AspectRatio",
  props: {
    value: {
      type: [Number, String],
      default: 1
    }
  },
  setup(__props) {
    const props = __props;
    const finalContainerStyle = computed(() => {
      if (typeof props.value === "number") {
        return `height: auto; min-height: auto; padding-top: ${100 / props.value}%`;
      } else {
        return "";
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "ar-container",
        style: normalizeStyle(finalContainerStyle.value)
      }, [
        createElementVNode("div", {
          class: normalizeClass(["ar-inner", { "ar-limit": finalContainerStyle.value }])
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 4);
    };
  }
};
const _sfc_main$c = {
  name: "MessageReply",
  components: {
    AudioPlayer,
    SvgIcon,
    FormatMessage,
    VideoPlayer,
    AspectRatio: _sfc_main$d,
    CustomSendCard
  },
  props: {
    message: { type: Object, required: true },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true },
    roomUsers: { type: Array, required: true }
  },
  computed: {
    replyUsername() {
      const { username } = this.message.replyMessage;
      return username || "";
    },
    firstFile() {
      var _a, _b;
      return ((_b = (_a = this.message.replyMessage) == null ? void 0 : _a.files) == null ? void 0 : _b.length) ? this.message.replyMessage.files[0] : {};
    },
    isAudio() {
      return isAudioFile(this.firstFile);
    },
    isImage() {
      return isImageFile(this.firstFile);
    },
    isVideo() {
      return isVideoFile(this.firstFile);
    },
    firstFileWidth() {
      return 300;
    },
    firstFileHeight() {
      return 300;
    },
    isOtherFile() {
      var _a;
      return ((_a = this.message.replyMessage.files) == null ? void 0 : _a.length) && !this.isAudio && !this.isVideo && !this.isImage;
    }
  }
};
const _hoisted_1$b = { class: "vac-reply-message" };
const _hoisted_2$9 = { class: "vac-reply-username" };
const _hoisted_3$8 = {
  key: 0,
  class: "vac-image-reply-container"
};
const _hoisted_4$7 = {
  key: 1,
  class: "vac-video-reply-container"
};
const _hoisted_5$7 = {
  key: 3,
  class: "vac-file-container"
};
const _hoisted_6$3 = { class: "vac-text-ellipsis" };
const _hoisted_7$3 = {
  key: 0,
  class: "vac-text-ellipsis vac-text-extension"
};
const _hoisted_8$2 = { class: "vac-reply-content" };
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_video_player = resolveComponent("video-player");
  const _component_aspect_ratio = resolveComponent("aspect-ratio");
  const _component_audio_player = resolveComponent("audio-player");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_custom_send_card = resolveComponent("custom-send-card");
  const _component_format_message = resolveComponent("format-message");
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    createElementVNode("div", _hoisted_2$9, toDisplayString($options.replyUsername), 1),
    $options.isImage ? (openBlock(), createElementBlock("div", _hoisted_3$8, [
      createElementVNode("div", {
        class: "vac-message-image vac-message-image-reply",
        style: normalizeStyle({
          "background-image": `url('${$options.firstFile.url}')`
        })
      }, null, 4)
    ])) : $options.isVideo ? (openBlock(), createElementBlock("div", _hoisted_4$7, [
      createVNode(_component_aspect_ratio, {
        value: $options.firstFileWidth / $options.firstFileHeight
      }, {
        default: withCtx(() => [
          createVNode(_component_video_player, {
            src: $options.firstFile.url,
            class: "video-player",
            controls: "",
            playsinline: "",
            width: $options.firstFileWidth,
            height: $options.firstFileHeight,
            portrait: $options.firstFileWidth <= $options.firstFileHeight,
            "video-init": ""
          }, null, 8, ["src", "width", "height", "portrait"])
        ]),
        _: 1
      }, 8, ["value"])
    ])) : $options.isAudio ? (openBlock(), createBlock(_component_audio_player, {
      key: 2,
      src: $options.firstFile.url,
      "message-selection-enabled": false,
      onUpdateProgressTime: _cache[0] || (_cache[0] = ($event) => _ctx.progressTime = $event),
      onHoverAudioProgress: _cache[1] || (_cache[1] = ($event) => _ctx.hoverAudioProgress = $event)
    }, createSlots({ _: 2 }, [
      renderList(_ctx.$slots, (idx, name) => {
        return {
          name,
          fn: withCtx((data) => [
            renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
          ])
        };
      })
    ]), 1032, ["src"])) : $options.isOtherFile ? (openBlock(), createElementBlock("div", _hoisted_5$7, [
      createElementVNode("div", null, [
        renderSlot(_ctx.$slots, "file-icon", {}, () => [
          createVNode(_component_svg_icon, { name: "file" })
        ])
      ]),
      createElementVNode("div", _hoisted_6$3, toDisplayString($options.firstFile.name), 1),
      $options.firstFile.extension ? (openBlock(), createElementBlock("div", _hoisted_7$3, toDisplayString($options.firstFile.extension), 1)) : createCommentVNode("", true)
    ])) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_8$2, [
      $props.message.replyMessage.card ? (openBlock(), createBlock(_component_custom_send_card, {
        key: 0,
        "card-info": $props.message.replyMessage.card
      }, null, 8, ["card-info"])) : !!$props.message.deleted || !$props.message.replyMessage.files || !$props.message.replyMessage.files.length ? (openBlock(), createBlock(_component_format_message, {
        key: 1,
        "message-id": $props.message.replyMessage._id,
        content: $props.message.replyMessage.content,
        users: $props.roomUsers,
        "text-formatting": $props.textFormatting,
        "link-options": $props.linkOptions,
        reply: true
      }, null, 8, ["message-id", "content", "users", "text-formatting", "link-options"])) : createCommentVNode("", true)
    ])
  ]);
}
var MessageReply = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c]]);
const _sfc_main$b = {
  name: "ProgressBar",
  props: {
    progress: { type: Number, default: 0 }
  },
  data() {
    const radius = 35;
    const stroke = 4;
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    return {
      radius,
      stroke,
      normalizedRadius,
      circumference
    };
  },
  computed: {
    strokeDashoffset() {
      return this.circumference - this.progress / 100 * this.circumference;
    }
  }
};
const _hoisted_1$a = {
  ref: "progress",
  class: "vac-progress-wrapper"
};
const _hoisted_2$8 = ["height", "width"];
const _hoisted_3$7 = ["stroke-dasharray", "stroke-width", "r", "cx", "cy"];
const _hoisted_4$6 = { class: "vac-progress-text" };
const _hoisted_5$6 = /* @__PURE__ */ createElementVNode("span", { class: "vac-progress-pourcent" }, "%", -1);
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, {
    name: "vac-fade-spinner",
    appear: ""
  }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$a, [
        (openBlock(), createElementBlock("svg", {
          height: $data.radius * 2,
          width: $data.radius * 2
        }, [
          createElementVNode("circle", {
            stroke: "rgba(255, 255, 255, 0.7)",
            "stroke-dasharray": $data.circumference + " " + $data.circumference,
            style: normalizeStyle({
              strokeDashoffset: $options.strokeDashoffset,
              strokeLinecap: "round"
            }),
            "stroke-width": $data.stroke,
            fill: "transparent",
            r: $data.normalizedRadius,
            cx: $data.radius,
            cy: $data.radius
          }, null, 12, _hoisted_3$7)
        ], 8, _hoisted_2$8)),
        createElementVNode("div", {
          class: "vac-progress-content",
          style: normalizeStyle({
            height: $data.radius * 2 - 19 + "px",
            width: $data.radius * 2 - 19 + "px"
          })
        }, [
          createElementVNode("div", _hoisted_4$6, [
            createTextVNode(toDisplayString($props.progress), 1),
            _hoisted_5$6
          ])
        ], 4)
      ], 512)
    ]),
    _: 1
  });
}
var ProgressBar = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b]]);
const _sfc_main$a = {
  name: "MessageFile",
  components: { SvgIcon, Loader, ProgressBar, VideoPlayer, AspectRatio: _sfc_main$d },
  props: {
    currentUserId: { type: [String, Number], required: true },
    message: { type: Object, required: true },
    file: { type: Object, required: true },
    index: { type: Number, required: true },
    messageSelectionEnabled: { type: Boolean, required: true }
  },
  emits: ["open-file"],
  data() {
    return {
      imageResponsive: "",
      imageLoading: false,
      imageHover: false
    };
  },
  computed: {
    isImageLoading() {
      return this.file.url.indexOf("blob:http") !== -1 || this.imageLoading;
    },
    isImage() {
      return isImageFile(this.file);
    },
    isVideo() {
      return isVideoFile(this.file);
    },
    fileWidth() {
      return 300;
    },
    fileHeight() {
      return 300;
    }
  },
  watch: {
    file: {
      immediate: true,
      handler() {
        this.checkImgLoad();
      }
    }
  },
  mounted() {
    const ref = this.$refs["imageRef" + this.index];
    if (ref) {
      this.imageResponsive = {
        maxHeight: ref.clientWidth - 18,
        loaderTop: ref.clientHeight / 2 - 9
      };
    }
  },
  methods: {
    checkImgLoad() {
      if (!isImageFile(this.file))
        return;
      this.imageLoading = true;
      const image = new Image();
      image.src = this.resizeImage(this.file.url);
      image.addEventListener("load", () => this.imageLoading = false);
    },
    openFile(event, action) {
      if (!this.messageSelectionEnabled) {
        event.stopPropagation();
        this.$emit("open-file", { file: this.file, action });
      }
    },
    resizeImage(src) {
      return resizeImage(src);
    }
  }
};
const _hoisted_1$9 = { class: "vac-message-file-container" };
const _hoisted_2$7 = {
  key: 0,
  class: "vac-image-buttons"
};
const _hoisted_3$6 = {
  key: 1,
  class: "vac-video-container"
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_progress_bar = resolveComponent("progress-bar");
  const _component_loader = resolveComponent("loader");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_video_player = resolveComponent("video-player");
  const _component_aspect_ratio = resolveComponent("aspect-ratio");
  return openBlock(), createElementBlock("div", _hoisted_1$9, [
    $options.isImage ? (openBlock(), createElementBlock("div", {
      key: 0,
      ref: "imageRef" + $props.index,
      class: "vac-message-image-container",
      onMouseover: _cache[2] || (_cache[2] = ($event) => $data.imageHover = true),
      onMouseleave: _cache[3] || (_cache[3] = ($event) => $data.imageHover = false),
      onClick: _cache[4] || (_cache[4] = ($event) => $options.openFile($event, "preview"))
    }, [
      $props.file.progress >= 0 ? (openBlock(), createBlock(_component_progress_bar, {
        key: 0,
        progress: $props.file.progress,
        style: normalizeStyle({ top: `${$data.imageResponsive.loaderTop}px` })
      }, null, 8, ["progress", "style"])) : (openBlock(), createBlock(_component_loader, {
        key: 1,
        show: $options.isImageLoading,
        type: "message-file",
        "message-id": $props.message._id,
        style: normalizeStyle({ top: `${$data.imageResponsive.loaderTop}px` })
      }, createSlots({ _: 2 }, [
        renderList(_ctx.$slots, (idx, name) => {
          return {
            name,
            fn: withCtx((data) => [
              renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
            ])
          };
        })
      ]), 1032, ["show", "message-id", "style"])),
      createElementVNode("div", {
        class: normalizeClass(["vac-message-image", {
          "vac-blur-loading": $options.isImageLoading && $props.message.senderId === $props.currentUserId
        }]),
        style: normalizeStyle({
          "background-image": `url('${$options.resizeImage($options.isImageLoading ? $props.file.preview || $props.file.url : $props.file.url)}')`,
          "max-height": `${$data.imageResponsive.maxHeight}px`
        })
      }, [
        createVNode(Transition, { name: "vac-fade-image" }, {
          default: withCtx(() => [
            !$props.messageSelectionEnabled && $data.imageHover && !$options.isImageLoading ? (openBlock(), createElementBlock("div", _hoisted_2$7, [
              createElementVNode("div", {
                class: "vac-svg-button vac-button-view",
                onClick: _cache[0] || (_cache[0] = ($event) => $options.openFile($event, "preview"))
              }, [
                renderSlot(_ctx.$slots, "eye-icon_" + $props.message._id, {}, () => [
                  createVNode(_component_svg_icon, { name: "eye" })
                ])
              ]),
              createElementVNode("div", {
                class: "vac-svg-button vac-button-download",
                onClick: _cache[1] || (_cache[1] = ($event) => $options.openFile($event, "download"))
              }, [
                renderSlot(_ctx.$slots, "document-icon_" + $props.message._id, {}, () => [
                  createVNode(_component_svg_icon, { name: "document" })
                ])
              ])
            ])) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 6)
    ], 544)) : $options.isVideo ? (openBlock(), createElementBlock("div", _hoisted_3$6, [
      $props.file.progress >= 0 ? (openBlock(), createBlock(_component_progress_bar, {
        key: 0,
        progress: $props.file.progress
      }, null, 8, ["progress"])) : createCommentVNode("", true),
      createVNode(_component_aspect_ratio, {
        value: $options.fileWidth / $options.fileHeight
      }, {
        default: withCtx(() => [
          createVNode(_component_video_player, {
            ref: `fileVideo${$props.message._id}`,
            class: "video-player",
            controls: "",
            playsinline: "",
            width: $options.fileWidth,
            height: $options.fileHeight,
            portrait: $options.fileWidth <= $options.fileHeight,
            src: $props.file.url,
            "video-init": ""
          }, null, 8, ["width", "height", "portrait", "src"])
        ]),
        _: 1
      }, 8, ["value"])
    ])) : createCommentVNode("", true)
  ]);
}
var MessageFile = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
const _sfc_main$9 = {
  name: "MessageFiles",
  components: { SvgIcon, FormatMessage, ProgressBar, MessageFile },
  props: {
    currentUserId: { type: [String, Number], required: true },
    message: { type: Object, required: true },
    roomUsers: { type: Array, required: true },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true },
    messageSelectionEnabled: { type: Boolean, required: true }
  },
  emits: ["open-file", "open-user-tag"],
  computed: {
    imageVideoFiles() {
      return this.message.files.filter((file) => isImageVideoFile(file));
    },
    otherFiles() {
      return this.message.files.filter((file) => !isImageVideoFile(file));
    }
  },
  methods: {
    openFile(event, file, action) {
      if (!this.messageSelectionEnabled) {
        event.stopPropagation();
        this.$emit("open-file", { file, action });
      }
    }
  }
};
const _hoisted_1$8 = { class: "vac-message-files-container" };
const _hoisted_2$6 = ["onClick"];
const _hoisted_3$5 = { class: "vac-svg-button" };
const _hoisted_4$5 = { class: "vac-text-ellipsis" };
const _hoisted_5$5 = {
  key: 0,
  class: "vac-text-ellipsis vac-text-extension"
};
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_message_file = resolveComponent("message-file");
  const _component_progress_bar = resolveComponent("progress-bar");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_format_message = resolveComponent("format-message");
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($options.imageVideoFiles, (file, i) => {
      return openBlock(), createElementBlock("div", {
        key: i + "iv"
      }, [
        createVNode(_component_message_file, {
          file,
          "current-user-id": $props.currentUserId,
          message: $props.message,
          index: i,
          "message-selection-enabled": $props.messageSelectionEnabled,
          onOpenFile: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("open-file", $event))
        }, createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (idx, name) => {
            return {
              name,
              fn: withCtx((data) => [
                renderSlot(_ctx.$slots, name, mergeProps({ ref_for: true }, data))
              ])
            };
          })
        ]), 1032, ["file", "current-user-id", "message", "index", "message-selection-enabled"])
      ]);
    }), 128)),
    (openBlock(true), createElementBlock(Fragment, null, renderList($options.otherFiles, (file, i) => {
      return openBlock(), createElementBlock("div", {
        key: i + "a",
        class: "vac-file-wrapper"
      }, [
        file.progress >= 0 ? (openBlock(), createBlock(_component_progress_bar, {
          key: 0,
          progress: file.progress,
          style: { top: "44px" }
        }, null, 8, ["progress"])) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(["vac-file-container", { "vac-file-container-progress": file.progress >= 0 }]),
          onClick: ($event) => $options.openFile($event, file, "download")
        }, [
          createElementVNode("div", _hoisted_3$5, [
            renderSlot(_ctx.$slots, "document-icon", {}, () => [
              createVNode(_component_svg_icon, { name: "document" })
            ])
          ]),
          createElementVNode("div", _hoisted_4$5, toDisplayString(file.name), 1),
          file.extension ? (openBlock(), createElementBlock("div", _hoisted_5$5, toDisplayString(file.extension), 1)) : createCommentVNode("", true)
        ], 10, _hoisted_2$6)
      ]);
    }), 128)),
    createVNode(_component_format_message, {
      "message-id": $props.message._id,
      content: $props.message.content,
      users: $props.roomUsers,
      "text-formatting": $props.textFormatting,
      "link-options": $props.linkOptions,
      onOpenUserTag: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("open-user-tag", $event))
    }, null, 8, ["message-id", "content", "users", "text-formatting", "link-options"])
  ]);
}
var MessageFiles = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
function findParentBySelector(node, selector) {
  while (node && !node.querySelector(selector)) {
    node = node.parentNode;
    const element2 = node.querySelector(selector);
    if (element2)
      return element2;
  }
  return null;
}
const _sfc_main$8 = {
  name: "MobileMessageActions",
  components: { SvgIcon, EmojiPickerContainer, ShareTwo, Translate },
  directives: {
    clickOutside: vClickOutside
  },
  props: {
    currentUserId: { type: [String, Number], required: true },
    message: { type: Object, required: true },
    messageActions: { type: Array, required: true },
    showReactionEmojis: { type: Boolean, required: true },
    messageHover: { type: Boolean, required: true },
    hoverMessageId: { type: [String, Number], default: null },
    hoverAudioProgress: { type: Boolean, required: true },
    emojiDataSource: { type: String, default: void 0 },
    isVideo: { type: Boolean, required: false }
  },
  emits: [
    "update-emoji-opened",
    "update-options-opened",
    "update-message-hover",
    "message-action-handler",
    "send-message-reaction"
  ],
  data() {
    return {
      menuOptionsTop: 0,
      optionsOpened: false,
      optionsClosing: false,
      emojiOpened: false
    };
  },
  computed: {
    isMessageActions() {
      return this.messageHover && !this.message.deleted && !this.hoverAudioProgress;
    },
    filteredMessageActions() {
      return this.messageActions.filter((message) => {
        if (message.onlyMe) {
          return this.message.senderId !== this.currentUserId;
        } else if (message.isVideo) {
          return this.isVideo;
        } else {
          return true;
        }
      });
    }
  },
  watch: {
    emojiOpened(val) {
      this.$emit("update-emoji-opened", val);
      if (val)
        this.optionsOpened = false;
    },
    optionsOpened(val) {
      this.$emit("update-options-opened", val);
    }
  },
  methods: {
    openOptions() {
      if (this.optionsClosing)
        return;
      this.optionsOpened = !this.optionsOpened;
      if (!this.optionsOpened)
        return;
      setTimeout(() => {
        const roomFooterRef = findParentBySelector(this.$el, "#room-footer");
        if (!roomFooterRef || !this.$refs.menuOptions || !this.$refs.actionIcon) {
          return;
        }
        const menuOptionsTop = this.$refs.menuOptions.getBoundingClientRect().height;
        const actionIconTop = this.$refs.actionIcon.getBoundingClientRect().top;
        const roomFooterTop = roomFooterRef.getBoundingClientRect().top;
        const optionsTopPosition = roomFooterTop - actionIconTop > menuOptionsTop + 50;
        if (optionsTopPosition)
          this.menuOptionsTop = 30;
        else
          this.menuOptionsTop = -menuOptionsTop;
      });
    },
    closeOptions() {
      this.optionsOpened = false;
      this.optionsClosing = true;
      this.updateMessageHover();
      setTimeout(() => this.optionsClosing = false, 100);
    },
    openEmoji() {
      this.emojiOpened = !this.emojiOpened;
    },
    closeEmoji() {
      this.emojiOpened = false;
      this.updateMessageHover();
    },
    updateMessageHover() {
      if (this.hoverMessageId !== this.message._id) {
        this.$emit("update-message-hover", false);
      }
    },
    messageActionHandler(action) {
      this.closeOptions();
      this.$emit("message-action-handler", action);
    },
    sendMessageReaction(emoji, reaction) {
      this.$emit("send-message-reaction", { emoji, reaction });
      this.closeEmoji();
    }
  }
};
const _hoisted_1$7 = { class: "vac-message-actions-wrapper" };
const _hoisted_2$5 = {
  key: "1",
  class: "vac-action"
};
const _hoisted_3$4 = {
  key: "2",
  class: "vac-action"
};
const _hoisted_4$4 = {
  key: "3",
  class: "vac-action"
};
const _hoisted_5$4 = { class: "vac-svg-button" };
const _hoisted_6$2 = { class: "vac-menu-list" };
const _hoisted_7$2 = ["onClick"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ShareTwo = resolveComponent("ShareTwo");
  const _component_emoji_picker_container = resolveComponent("emoji-picker-container");
  const _component_Translate = resolveComponent("Translate");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createElementBlock("div", _hoisted_1$7, [
    $options.isMessageActions ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["vac-options-container", [
        $props.message.senderId === $props.currentUserId ? "vac-options-container-left" : "vac-options-container-right"
      ]]),
      style: normalizeStyle({ display: $props.hoverAudioProgress ? "none" : "initial" })
    }, [
      createVNode(TransitionGroup, {
        name: $props.message.senderId === $props.currentUserId ? "vac-slide-left" : "vac-slide-right",
        tag: "div",
        class: "vac-action-list"
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_2$5, [
            renderSlot(_ctx.$slots, "reply-icon_" + $props.message._id, {}, () => [
              createVNode(_component_ShareTwo, {
                size: "18",
                fill: "#9e9e9e",
                onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("message-action-handler", { name: "replyMessage" }))
              })
            ])
          ]),
          $props.showReactionEmojis && !$props.message.disableReactions ? withDirectives((openBlock(), createElementBlock("div", _hoisted_3$4, [
            renderSlot(_ctx.$slots, "emoji-picker", mergeProps({ emojiOpened: $data.emojiOpened }, { addEmoji: $options.sendMessageReaction }), () => [
              createVNode(_component_emoji_picker_container, {
                class: "vac-message-emojis",
                "emoji-reaction": "",
                "emoji-opened": $data.emojiOpened,
                "position-right": $props.message.senderId === $props.currentUserId,
                "message-id": $props.message._id,
                "emoji-data-source": $props.emojiDataSource,
                onAddEmoji: $options.sendMessageReaction,
                onOpenEmoji: $options.openEmoji
              }, createSlots({ _: 2 }, [
                renderList(_ctx.$slots, (idx, name) => {
                  return {
                    name,
                    fn: withCtx((data) => [
                      renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                    ])
                  };
                })
              ]), 1032, ["emoji-opened", "position-right", "message-id", "emoji-data-source", "onAddEmoji", "onOpenEmoji"])
            ])
          ])), [
            [_directive_click_outside, $options.closeEmoji]
          ]) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_4$4, [
            renderSlot(_ctx.$slots, "translate-icon_" + $props.message._id, {}, () => [
              createVNode(_component_Translate, {
                size: "18",
                fill: "#9e9e9e",
                onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("message-action-handler", { name: "translateMessage" }))
              })
            ])
          ]),
          $options.filteredMessageActions.length && !$props.message.disableActions ? (openBlock(), createElementBlock("div", {
            ref: "actionIcon",
            key: "4",
            class: "vac-message-options",
            onClick: _cache[2] || (_cache[2] = (...args) => $options.openOptions && $options.openOptions(...args))
          }, [
            renderSlot(_ctx.$slots, "dropdown-icon_" + $props.message._id, {}, () => [
              createElementVNode("div", _hoisted_5$4, [
                createVNode(_component_svg_icon, {
                  name: "dropdown",
                  param: "message"
                })
              ])
            ]),
            $options.filteredMessageActions.length ? (openBlock(), createBlock(Transition, {
              key: 0,
              name: $props.message.senderId === $props.currentUserId ? "vac-slide-left" : "vac-slide-right"
            }, {
              default: withCtx(() => [
                $data.optionsOpened ? withDirectives((openBlock(), createElementBlock("div", {
                  key: 0,
                  ref: "menuOptions",
                  class: normalizeClass(["vac-menu-options", {}]),
                  style: normalizeStyle({ top: `${$data.menuOptionsTop}px` })
                }, [
                  createElementVNode("div", _hoisted_6$2, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList($options.filteredMessageActions, (action) => {
                      return openBlock(), createElementBlock("div", {
                        key: action.name
                      }, [
                        createElementVNode("div", {
                          class: "vac-menu-item",
                          onClick: ($event) => $options.messageActionHandler(action)
                        }, toDisplayString(action.title), 9, _hoisted_7$2)
                      ]);
                    }), 128))
                  ])
                ], 4)), [
                  [_directive_click_outside, $options.closeOptions]
                ]) : createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["name"])) : createCommentVNode("", true)
          ], 512)) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["name"])
    ], 6)) : createCommentVNode("", true)
  ]);
}
var MessageActions = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8]]);
var replySvg = "data:image/svg+xml;base64,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";
var stickersPng = "data:image/png;base64,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";
const _sfc_main$7 = {
  name: "MessageActions",
  components: { MobileEmojiPickerContainer },
  directives: {
    clickOutside: vClickOutside
  },
  props: {
    messageLongpress: { type: Boolean, required: true },
    emojiDataSource: { type: String, default: void 0 }
  },
  emits: [
    "update-emoji-opened",
    "update-options-opened",
    "update-message-longpress",
    "message-action-handler",
    "send-message-reaction"
  ],
  data() {
    return {
      replySvg,
      stickersPng,
      containerStyle: { top: "10px" },
      optionsOpened: false,
      emojiOpened: false
    };
  },
  watch: {
    messageLongpress(val) {
      const { y } = this.$refs.messageActions.getBoundingClientRect();
      if (window.innerHeight - y < 350) {
        this.containerStyle = {
          bottom: `${this.$refs.messageActions.offsetTop + 10}px`
        };
      } else {
        this.containerStyle = { top: "10px" };
      }
      console.log();
    },
    emojiOpened(val) {
      this.$emit("update-emoji-opened", val);
      if (val)
        this.optionsOpened = false;
    },
    optionsOpened(val) {
      this.$emit("update-options-opened", val);
    }
  },
  methods: {
    onReply() {
      this.emojiOpened = false;
      this.$emit("message-action-handler", { name: "replyMessage" });
      this.$emit("update-message-longpress", false);
    },
    closeOptions() {
      this.emojiOpened = false;
      this.$emit("update-message-longpress", false);
    },
    sendMessageReaction(emoji, reaction) {
      this.$emit("send-message-reaction", { emoji, reaction });
      this.closeOptions();
    }
  }
};
const _hoisted_1$6 = {
  ref: "messageActions",
  class: "vac-mobile-message-actions-wrapper"
};
const _hoisted_2$4 = { class: "vac-tabs" };
const _hoisted_3$3 = ["src"];
const _hoisted_4$3 = ["src"];
const _hoisted_5$3 = {
  key: "2",
  class: "vac-emoji-picker"
};
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mobile_emoji_picker_container = resolveComponent("mobile-emoji-picker-container");
  const _directive_click_outside = resolveDirective("click-outside");
  return openBlock(), createBlock(Transition, { name: "vac-slide-up" }, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$6, [
        withDirectives((openBlock(), createElementBlock("div", {
          class: "vac-options-container",
          style: normalizeStyle({
            display: $props.messageLongpress ? "initial" : "none",
            width: $data.emojiOpened ? "100%" : "",
            ...$data.containerStyle
          })
        }, [
          createElementVNode("div", {
            class: normalizeClass(["vac-triangle", [
              $data.containerStyle.top ? "vac-top-triangle" : "vac-bottom-triangle"
            ]])
          }, null, 2),
          createElementVNode("div", _hoisted_2$4, [
            createElementVNode("div", {
              class: "vac-tab",
              onClick: _cache[0] || (_cache[0] = (...args) => $options.onReply && $options.onReply(...args)),
              onMousedown: _cache[1] || (_cache[1] = withModifiers(() => {
              }, ["prevent"]))
            }, [
              createElementVNode("img", { src: $data.replySvg }, null, 8, _hoisted_3$3)
            ], 32),
            createElementVNode("div", {
              class: normalizeClass(["vac-tab", { selected: $data.emojiOpened }]),
              onClick: _cache[2] || (_cache[2] = ($event) => $data.emojiOpened = true)
            }, [
              createElementVNode("img", { src: $data.stickersPng }, null, 8, _hoisted_4$3)
            ], 2)
          ]),
          createVNode(TransitionGroup, {
            name: "vac-slide-left",
            tag: "div"
          }, {
            default: withCtx(() => [
              $data.emojiOpened ? (openBlock(), createElementBlock("div", _hoisted_5$3, [
                renderSlot(_ctx.$slots, "emoji-picker", mergeProps({ emojiOpened: $data.emojiOpened }, { addEmoji: $options.sendMessageReaction }), () => [
                  createVNode(_component_mobile_emoji_picker_container, {
                    class: "vac-message-emojis",
                    "emoji-opened": $data.emojiOpened,
                    "emoji-data-source": $props.emojiDataSource,
                    onAddEmoji: $options.sendMessageReaction
                  }, createSlots({ _: 2 }, [
                    renderList(_ctx.$slots, (idx, name) => {
                      return {
                        name,
                        fn: withCtx((data) => [
                          renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                        ])
                      };
                    })
                  ]), 1032, ["emoji-opened", "emoji-data-source", "onAddEmoji"])
                ])
              ])) : createCommentVNode("", true)
            ]),
            _: 3
          })
        ], 4)), [
          [_directive_click_outside, $options.closeOptions]
        ])
      ], 512)
    ]),
    _: 3
  });
}
var MobileMessageActions = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
const _sfc_main$6 = {
  name: "MessageReactions",
  props: {
    currentUserId: { type: [String, Number], required: true },
    message: { type: Object, required: true }
  },
  emits: ["send-message-reaction"],
  methods: {
    sendMessageReaction(emoji, reaction) {
      this.$emit("send-message-reaction", { emoji, reaction });
    }
  }
};
const _hoisted_1$5 = ["onClick"];
const _hoisted_2$3 = { key: 0 };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return !$props.message.deleted ? (openBlock(), createBlock(TransitionGroup, {
    key: 0,
    name: "vac-slide-left",
    tag: "span"
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.message.reactions, (reaction, key) => {
        return withDirectives((openBlock(), createElementBlock("button", {
          key: key + 0,
          class: normalizeClass(["vac-button-reaction", {
            "vac-reaction-me": reaction.indexOf($props.currentUserId) !== -1
          }]),
          onClick: ($event) => $options.sendMessageReaction({ unicode: key }, reaction)
        }, [
          createElementVNode("span", null, toDisplayString(key), 1),
          (openBlock(true), createElementBlock(Fragment, null, renderList(reaction, (m, n) => {
            return openBlock(), createElementBlock("span", { key: n }, [
              n !== 0 ? (openBlock(), createElementBlock("span", _hoisted_2$3, ",")) : createCommentVNode("", true),
              createTextVNode(toDisplayString(m), 1)
            ]);
          }), 128))
        ], 10, _hoisted_1$5)), [
          [vShow, reaction.length]
        ]);
      }), 128))
    ]),
    _: 1
  })) : createCommentVNode("", true);
}
var MessageReactions = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
function roomsValidation(obj) {
  const roomsValidate = [
    { key: "roomId", type: ["string", "number"] },
    { key: "roomName", type: ["string"] },
    { key: "users", type: ["array"] }
  ];
  const validate = (obj2, props) => {
    return props.every((prop) => {
      let validType = false;
      if (prop.type[0] === "array" && Array.isArray(obj2[prop.key])) {
        validType = true;
      } else if (prop.type.find((t) => t === typeof obj2[prop.key])) {
        validType = true;
      }
      return validType && checkObjectValid(obj2, prop.key);
    });
  };
  if (!validate(obj, roomsValidate)) {
    throw new Error(
      "Rooms object is not valid! Must contain at least roomId[String, Number], roomName[String] and users[Array]"
    );
  }
}
function partcipantsValidation(obj) {
  const participantsValidate = [
    { key: "_id", type: ["string", "number"] },
    { key: "username", type: ["string"] }
  ];
  const validate = (obj2, props) => {
    return props.every((prop) => {
      const validType = prop.type.find((t) => t === typeof obj2[prop.key]);
      return validType && checkObjectValid(obj2, prop.key);
    });
  };
  if (!validate(obj, participantsValidate)) {
    throw new Error(
      "Participants object is not valid! Must contain at least _id[String, Number] and username[String]"
    );
  }
}
function messagesValidation(obj) {
  const messagesValidate = [
    { key: "_id", type: ["string", "number"] },
    { key: "senderId", type: ["string", "number"] }
  ];
  const validate = (obj2, props) => {
    return props.every((prop) => {
      const validType = prop.type.find((t) => t === typeof obj2[prop.key]);
      return validType && checkObjectValid(obj2, prop.key);
    });
  };
  if (!validate(obj, messagesValidate)) {
    throw new Error(
      "Messages object is not valid! Must contain at least _id[String, Number] and senderId[String, Number]"
    );
  }
}
function checkObjectValid(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== null && obj[key] !== void 0;
}
const _sfc_main$5 = {
  name: "RoomMessage",
  components: {
    SvgIcon,
    FormatMessage,
    AudioPlayer,
    MessageReply,
    MessageFiles,
    MessageActions,
    MobileMessageActions,
    MessageReactions,
    CustomSendCard
  },
  props: {
    platform: { type: String, required: true },
    currentUserId: { type: [String, Number], required: true },
    pcMode: { type: Boolean, required: false },
    textMessages: { type: Object, required: true },
    index: { type: Number, required: true },
    message: { type: Object, required: true },
    messages: { type: Array, required: true },
    editedMessageId: { type: [String, Number], default: null },
    roomUsers: { type: Array, default: () => [] },
    messageActions: { type: Array, required: true },
    newMessages: { type: Array, default: () => [] },
    showReactionEmojis: { type: Boolean, required: true },
    showNewMessagesDivider: { type: Boolean, required: true },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true },
    usernameOptions: { type: Object, required: true },
    messageSelectionEnabled: { type: Boolean, required: true },
    selectedMessages: { type: Array, default: () => [] },
    emojiDataSource: { type: String, default: void 0 }
  },
  emits: [
    "message-added",
    "open-file",
    "open-user-tag",
    "open-failed-message",
    "message-action-handler",
    "send-message-reaction",
    "select-message",
    "unselect-message",
    "send-custom-card",
    "trigger-custom-card"
  ],
  data() {
    return {
      isMobileDevice,
      hoverMessageId: null,
      messageHover: false,
      optionsOpened: false,
      emojiOpened: false,
      newMessage: {},
      progressTime: "- : -",
      hoverAudioProgress: false,
      messageLongpress: false,
      longPressTimer: null
    };
  },
  computed: {
    isBusiness() {
      return this.platform === "business";
    },
    showUsername() {
      if (!this.usernameOptions.currentUser && this.message.senderId === this.currentUserId) {
        return false;
      } else {
        return this.roomUsers.length >= this.usernameOptions.minUsers;
      }
    },
    showDate() {
      return this.index > 0 && this.message.date !== this.messages[this.index - 1].date;
    },
    messageOffset() {
      return this.index > 0 && this.message.senderId !== this.messages[this.index - 1].senderId;
    },
    isMessageHover() {
      return this.editedMessageId === this.message._id || this.hoverMessageId === this.message._id;
    },
    isAudio() {
      var _a;
      return (_a = this.message.files) == null ? void 0 : _a.some((file) => isAudioFile(file));
    },
    isVideo() {
      var _a;
      return (_a = this.message.files) == null ? void 0 : _a.some((file) => isVideoFile(file));
    },
    isCheckmarkVisible() {
      return this.message.senderId === this.currentUserId && !this.message.deleted && (this.message.saved || this.message.distributed || this.message.seen);
    },
    isMessageSelected() {
      return this.messageSelectionEnabled && !!this.selectedMessages.find(
        (message) => message._id === this.message._id
      );
    }
  },
  watch: {
    newMessages: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val.length || !this.showNewMessagesDivider) {
          this.newMessage = {};
          return;
        }
        this.newMessage = val.reduce(
          (res, obj) => obj.index < res.index ? obj : res
        );
      }
    },
    messageSelectionEnabled() {
      this.resetMessageHover();
    }
  },
  mounted() {
    messagesValidation(this.message);
    this.$emit("message-added", {
      message: this.message,
      index: this.index,
      ref: this.$refs.message
    });
  },
  methods: {
    startLongPress() {
      this.longPressTimer = setTimeout(() => {
        this.messageLongpress = true;
      }, 500);
    },
    endLongPress(event) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    },
    cancelLongPress(event) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    },
    onHoverMessage() {
      if (!this.messageSelectionEnabled) {
        this.messageHover = true;
        if (this.canEditMessage())
          this.hoverMessageId = this.message._id;
      }
    },
    canEditMessage() {
      return !this.message.deleted;
    },
    onLeaveMessage() {
      if (!this.messageSelectionEnabled) {
        if (!this.optionsOpened && !this.emojiOpened)
          this.messageHover = false;
        this.hoverMessageId = null;
      }
    },
    resetMessageHover() {
      this.messageHover = false;
      this.hoverMessageId = null;
    },
    openFile(file) {
      this.$emit("open-file", { message: this.message, file });
    },
    openUserTag(user) {
      this.$emit("open-user-tag", { user, message: this.message });
    },
    messageActionHandler(action) {
      this.resetMessageHover();
      setTimeout(() => {
        this.$emit("message-action-handler", { action, message: this.message });
      }, 300);
    },
    sendMessageReaction({ emoji, reaction }) {
      this.$emit("send-message-reaction", {
        messageId: this.message._id,
        reaction: emoji,
        remove: reaction && reaction.indexOf(this.currentUserId) !== -1
      });
      this.messageHover = false;
    },
    selectMessage() {
      if (this.messageSelectionEnabled) {
        if (this.isMessageSelected) {
          this.$emit("unselect-message", this.message._id);
        } else {
          this.$emit("select-message", this.message);
        }
      }
    }
  }
};
const _hoisted_1$4 = ["id", "data-msgid"];
const _hoisted_2$2 = {
  key: 0,
  class: "vac-card-info vac-card-date"
};
const _hoisted_3$2 = {
  key: 1,
  class: "vac-line-new"
};
const _hoisted_4$2 = {
  key: 0,
  class: "system-time"
};
const _hoisted_5$2 = {
  key: 1,
  class: "system-summary"
};
const _hoisted_6$1 = { class: "system-summary-box" };
const _hoisted_7$1 = /* @__PURE__ */ createElementVNode("span", null, "\u5C0F\u7ED3\uFF1A", -1);
const _hoisted_8$1 = /* @__PURE__ */ createElementVNode("span", null, "\u5907\u6CE8\uFF1A", -1);
const _hoisted_9$1 = {
  key: 3,
  class: "custom-message"
};
const _hoisted_10 = {
  key: 1,
  class: "vac-username"
};
const _hoisted_11 = {
  key: 0,
  style: { "border-top": "1px solid #999" }
};
const _hoisted_12 = {
  key: 0,
  class: "vac-progress-time"
};
const _hoisted_13 = { class: "vac-text-timestamp" };
const _hoisted_14 = {
  key: 0,
  class: "vac-icon-edited"
};
const _hoisted_15 = { key: 1 };
const _hoisted_16 = /* @__PURE__ */ createElementVNode("div", { id: "vac-circle" }, null, -1);
const _hoisted_17 = [
  _hoisted_16
];
const _hoisted_18 = /* @__PURE__ */ createElementVNode("div", { class: "vac-failure-text" }, "!", -1);
const _hoisted_19 = [
  _hoisted_18
];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_format_message = resolveComponent("format-message");
  const _component_message_reply = resolveComponent("message-reply");
  const _component_custom_send_card = resolveComponent("custom-send-card");
  const _component_message_files = resolveComponent("message-files");
  const _component_audio_player = resolveComponent("audio-player");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_message_actions = resolveComponent("message-actions");
  const _component_mobile_message_actions = resolveComponent("mobile-message-actions");
  const _component_message_reactions = resolveComponent("message-reactions");
  return openBlock(), createElementBlock("div", {
    id: $props.message._id,
    ref: "message",
    "data-msgid": $props.message._id,
    class: "vac-message-wrapper"
  }, [
    $options.showDate ? (openBlock(), createElementBlock("div", _hoisted_2$2, toDisplayString($props.message.date), 1)) : createCommentVNode("", true),
    $data.newMessage._id === $props.message._id ? (openBlock(), createElementBlock("div", _hoisted_3$2, toDisplayString($props.textMessages.NEW_MESSAGES), 1)) : createCommentVNode("", true),
    $props.message.system ? (openBlock(), createElementBlock("div", {
      key: 2,
      class: normalizeClass(["vac-card-info", { "vac-card-system": !$props.message.noClass }])
    }, [
      renderSlot(_ctx.$slots, "message_" + $props.message._id, {}, () => [
        createVNode(_component_format_message, {
          "message-id": $props.message._id,
          content: $props.message.content,
          deleted: !!$props.message.deleted,
          users: $props.roomUsers,
          "text-messages": $props.textMessages,
          "text-formatting": $props.textFormatting,
          "link-options": $props.linkOptions,
          onOpenUserTag: $options.openUserTag
        }, createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (idx, name) => {
            return {
              name,
              fn: withCtx((data) => [
                renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
              ])
            };
          })
        ]), 1032, ["message-id", "content", "deleted", "users", "text-messages", "text-formatting", "link-options", "onOpenUserTag"]),
        $options.isBusiness ? (openBlock(), createElementBlock("div", _hoisted_4$2, toDisplayString($props.message.date + " " + $props.message.timestamp), 1)) : createCommentVNode("", true),
        $props.message.summaryConversation ? (openBlock(), createElementBlock("div", _hoisted_5$2, [
          createElementVNode("div", _hoisted_6$1, [
            createElementVNode("div", null, [
              _hoisted_7$1,
              createElementVNode("span", null, toDisplayString($props.message.summaryConversation.categoryName), 1)
            ]),
            createElementVNode("div", null, [
              _hoisted_8$1,
              createElementVNode("span", null, toDisplayString($props.message.summaryConversation.remarks), 1)
            ])
          ])
        ])) : createCommentVNode("", true)
      ])
    ], 2)) : $props.message.custom ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
      renderSlot(_ctx.$slots, "message_" + $props.message._id)
    ])) : (openBlock(), createElementBlock("div", {
      key: 4,
      class: normalizeClass(["vac-message-box", { "vac-offset-current": $props.message.senderId === $props.currentUserId }]),
      onClick: _cache[17] || (_cache[17] = (...args) => $options.selectMessage && $options.selectMessage(...args))
    }, [
      renderSlot(_ctx.$slots, "message_" + $props.message._id, {}, () => [
        renderSlot(_ctx.$slots, "message-avatar_" + $props.message._id, {}, () => [
          createElementVNode("div", {
            class: normalizeClass(["vac-user", [
              $props.message.senderId === $props.currentUserId ? "vac-user-right" : "vac-user-left"
            ]])
          }, [
            $props.message.avatar ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "vac-avatar",
              style: normalizeStyle({ "background-image": `url('${$props.message.avatar}')` })
            }, null, 4)) : createCommentVNode("", true),
            $props.message.username ? (openBlock(), createElementBlock("div", _hoisted_10, toDisplayString($props.message.username), 1)) : createCommentVNode("", true)
          ], 2)
        ]),
        createElementVNode("div", {
          class: normalizeClass(["vac-message-container", {
            "vac-message-container-offset": $options.messageOffset
          }])
        }, [
          createElementVNode("div", {
            class: normalizeClass(["vac-message-card", {
              "vac-message-highlight": $options.isMessageHover,
              "vac-message-current": $props.message.senderId === $props.currentUserId && !$props.message.card,
              "vac-message-deleted": $props.message.deleted,
              "vac-item-clickable": $props.messageSelectionEnabled,
              "vac-message-selected": $options.isMessageSelected,
              "vac-custom-card": $props.message.card
            }]),
            onMouseover: _cache[8] || (_cache[8] = (...args) => $options.onHoverMessage && $options.onHoverMessage(...args)),
            onMouseleave: _cache[9] || (_cache[9] = (...args) => $options.onLeaveMessage && $options.onLeaveMessage(...args)),
            onTouchstart: _cache[10] || (_cache[10] = (...args) => $options.startLongPress && $options.startLongPress(...args)),
            onTouchendCapture: _cache[11] || (_cache[11] = (...args) => $options.endLongPress && $options.endLongPress(...args)),
            onTouchcancelCapture: _cache[12] || (_cache[12] = (...args) => $options.cancelLongPress && $options.cancelLongPress(...args))
          }, [
            $options.showUsername ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(["vac-text-username", {
                "vac-username-reply": !$props.message.deleted && $props.message.replyMessage
              }])
            }, [
              createElementVNode("span", null, toDisplayString($props.message.username), 1)
            ], 2)) : createCommentVNode("", true),
            !$props.message.deleted && $props.message.replyMessage ? (openBlock(), createBlock(_component_message_reply, {
              key: 1,
              message: $props.message,
              "room-users": $props.roomUsers,
              "text-formatting": $props.textFormatting,
              "link-options": $props.linkOptions
            }, createSlots({ _: 2 }, [
              renderList(_ctx.$slots, (i, name) => {
                return {
                  name,
                  fn: withCtx((data) => [
                    renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                  ])
                };
              })
            ]), 1032, ["message", "room-users", "text-formatting", "link-options"])) : createCommentVNode("", true),
            $props.message.card ? (openBlock(), createBlock(_component_custom_send_card, {
              key: 2,
              "card-info": $props.message.card,
              "is-self": $props.currentUserId.toString() === $props.message.senderId.toString(),
              onSendCustomCard: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("send-custom-card", { message: $props.message })),
              onTriggerCustomCard: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("trigger-custom-card", { message: $props.message }))
            }, null, 8, ["card-info", "is-self"])) : !!$props.message.deleted || !$props.message.files || !$props.message.files.length ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
              createVNode(_component_format_message, {
                "message-id": $props.message._id,
                content: $props.message.content,
                deleted: !!$props.message.deleted,
                users: $props.roomUsers,
                "text-formatting": $props.textFormatting,
                "text-messages": $props.textMessages,
                "link-options": $props.linkOptions,
                onOpenUserTag: $options.openUserTag
              }, createSlots({ _: 2 }, [
                renderList(_ctx.$slots, (idx, name) => {
                  return {
                    name,
                    fn: withCtx((data) => [
                      renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                    ])
                  };
                })
              ]), 1032, ["message-id", "content", "deleted", "users", "text-formatting", "text-messages", "link-options", "onOpenUserTag"]),
              !$data.isMobileDevice && $props.message.originalText ? (openBlock(), createElementBlock("div", _hoisted_11, [
                createVNode(_component_format_message, {
                  "message-id": $props.message._id,
                  content: $props.message.originalContent,
                  deleted: !!$props.message.deleted,
                  users: $props.roomUsers,
                  "text-formatting": $props.textFormatting,
                  "text-messages": $props.textMessages,
                  "link-options": $props.linkOptions,
                  onOpenUserTag: $options.openUserTag
                }, createSlots({ _: 2 }, [
                  renderList(_ctx.$slots, (idx, name) => {
                    return {
                      name,
                      fn: withCtx((data) => [
                        renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                      ])
                    };
                  })
                ]), 1032, ["message-id", "content", "deleted", "users", "text-formatting", "text-messages", "link-options", "onOpenUserTag"]),
                createElementVNode("div", {
                  style: { "font-size": "12px", "color": "#409eff", "cursor": "pointer" },
                  onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("message-action-handler", {
                    action: { name: "translateMessage" },
                    message: $props.message
                  }))
                }, " \u53D6\u6D88\u5C55\u793A\u539F\u6587 ")
              ])) : createCommentVNode("", true)
            ], 64)) : !$options.isAudio || $props.message.files.length > 1 ? (openBlock(), createBlock(_component_message_files, {
              key: 4,
              "current-user-id": $props.currentUserId,
              message: $props.message,
              "room-users": $props.roomUsers,
              "text-formatting": $props.textFormatting,
              "link-options": $props.linkOptions,
              "message-selection-enabled": $props.messageSelectionEnabled,
              onOpenFile: $options.openFile,
              onOpenUserTag: $options.openUserTag
            }, createSlots({ _: 2 }, [
              renderList(_ctx.$slots, (i, name) => {
                return {
                  name,
                  fn: withCtx((data) => [
                    renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                  ])
                };
              })
            ]), 1032, ["current-user-id", "message", "room-users", "text-formatting", "link-options", "message-selection-enabled", "onOpenFile", "onOpenUserTag"])) : (openBlock(), createElementBlock(Fragment, { key: 5 }, [
              createVNode(_component_audio_player, {
                "message-id": $props.message._id,
                src: $props.message.files[0].url,
                "message-selection-enabled": $props.messageSelectionEnabled,
                onUpdateProgressTime: _cache[3] || (_cache[3] = ($event) => $data.progressTime = $event),
                onHoverAudioProgress: _cache[4] || (_cache[4] = ($event) => $data.hoverAudioProgress = $event)
              }, createSlots({ _: 2 }, [
                renderList(_ctx.$slots, (i, name) => {
                  return {
                    name,
                    fn: withCtx((data) => [
                      renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                    ])
                  };
                })
              ]), 1032, ["message-id", "src", "message-selection-enabled"]),
              !$props.message.deleted ? (openBlock(), createElementBlock("div", _hoisted_12, toDisplayString($data.progressTime), 1)) : createCommentVNode("", true)
            ], 64)),
            createElementVNode("div", _hoisted_13, [
              $props.message.edited && !$props.message.deleted ? (openBlock(), createElementBlock("div", _hoisted_14, [
                renderSlot(_ctx.$slots, "pencil-icon_" + $props.message._id, {}, () => [
                  createVNode(_component_svg_icon, { name: "pencil" })
                ])
              ])) : createCommentVNode("", true),
              createElementVNode("span", null, toDisplayString($props.message.timestamp), 1),
              $options.isCheckmarkVisible ? (openBlock(), createElementBlock("span", _hoisted_15, [
                renderSlot(_ctx.$slots, "checkmark-icon_" + $props.message._id, {}, () => [
                  createVNode(_component_svg_icon, {
                    name: $props.message.distributed ? "double-checkmark" : "checkmark",
                    param: $props.message.seen ? "seen" : "",
                    class: "vac-icon-check"
                  }, null, 8, ["name", "param"])
                ])
              ])) : createCommentVNode("", true)
            ]),
            !$data.isMobileDevice && !$props.pcMode ? (openBlock(), createBlock(_component_message_actions, {
              key: 6,
              "current-user-id": $props.currentUserId,
              message: $props.message,
              "message-actions": $props.messageActions,
              "show-reaction-emojis": $props.showReactionEmojis,
              "message-hover": $data.messageHover,
              "hover-message-id": $data.hoverMessageId,
              "hover-audio-progress": $data.hoverAudioProgress,
              "emoji-data-source": $props.emojiDataSource,
              "is-video": $options.isVideo,
              onUpdateMessageHover: _cache[5] || (_cache[5] = ($event) => $data.messageHover = $event),
              onUpdateOptionsOpened: _cache[6] || (_cache[6] = ($event) => $data.optionsOpened = $event),
              onUpdateEmojiOpened: _cache[7] || (_cache[7] = ($event) => $data.emojiOpened = $event),
              onMessageActionHandler: $options.messageActionHandler,
              onSendMessageReaction: $options.sendMessageReaction
            }, createSlots({ _: 2 }, [
              renderList(_ctx.$slots, (i, name) => {
                return {
                  name,
                  fn: withCtx((data) => [
                    renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                  ])
                };
              })
            ]), 1032, ["current-user-id", "message", "message-actions", "show-reaction-emojis", "message-hover", "hover-message-id", "hover-audio-progress", "emoji-data-source", "is-video", "onMessageActionHandler", "onSendMessageReaction"])) : createCommentVNode("", true)
          ], 34),
          $data.isMobileDevice ? (openBlock(), createBlock(_component_mobile_message_actions, {
            key: 0,
            "message-longpress": $data.messageLongpress && !$props.message.loading,
            "emoji-data-source": $props.emojiDataSource,
            onUpdateMessageLongpress: _cache[13] || (_cache[13] = ($event) => $data.messageLongpress = $event),
            onUpdateOptionsOpened: _cache[14] || (_cache[14] = ($event) => $data.optionsOpened = $event),
            onUpdateEmojiOpened: _cache[15] || (_cache[15] = ($event) => $data.emojiOpened = $event),
            onMessageActionHandler: $options.messageActionHandler,
            onSendMessageReaction: $options.sendMessageReaction
          }, createSlots({ _: 2 }, [
            renderList(_ctx.$slots, (i, name) => {
              return {
                name,
                fn: withCtx((data) => [
                  renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                ])
              };
            })
          ]), 1032, ["message-longpress", "emoji-data-source", "onMessageActionHandler", "onSendMessageReaction"])) : createCommentVNode("", true),
          createVNode(_component_message_reactions, {
            "current-user-id": $props.currentUserId,
            message: $props.message,
            onSendMessageReaction: $options.sendMessageReaction
          }, null, 8, ["current-user-id", "message", "onSendMessageReaction"])
        ], 2),
        renderSlot(_ctx.$slots, "message-loading_" + $props.message._id, {}, () => [
          $props.message.loading && $props.message.senderId === $props.currentUserId ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["vac-loading-container vac-svg-button", {
              "vac-loading-container-avatar": $props.message.avatar && $props.message.senderId === $props.currentUserId
            }])
          }, _hoisted_17, 2)) : createCommentVNode("", true)
        ]),
        renderSlot(_ctx.$slots, "message-failure_" + $props.message._id, {}, () => [
          !$props.message.loading && $props.message.failure && $props.message.senderId === $props.currentUserId ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["vac-failure-container vac-svg-button", {
              "vac-failure-container-avatar": $props.message.avatar && $props.message.senderId === $props.currentUserId
            }]),
            onClick: _cache[16] || (_cache[16] = ($event) => _ctx.$emit("open-failed-message", { message: $props.message }))
          }, _hoisted_19, 2)) : createCommentVNode("", true)
        ])
      ])
    ], 2))
  ], 8, _hoisted_1$4);
}
var RoomMessage = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
const _sfc_main$4 = {
  name: "RoomBottom",
  components: {},
  props: {
    platform: { type: String, required: true },
    pcMode: { type: Boolean, required: false }
  },
  emits: [],
  data() {
    return {
      keyboardVisible: false,
      removeKeyboardHandler: null,
      keyboardHeight: 0,
      animateDuration: 250,
      timingFunction: "ease-in-out",
      documentVisible: true
    };
  },
  computed: {
    isCustomer() {
      return this.platform === "customer";
    },
    finalMobile() {
      return this.isCustomer && !this.pcMode;
    },
    needSafeArea() {
      return this.finalMobile;
    },
    finalStyle() {
      const transitionDuration = this.keyboardVisible ? this.animateDuration : this.animateDuration;
      const style = {
        height: `${this.keyboardVisible ? this.keyboardHeight : 0}px`,
        transitionDuration: `${transitionDuration / 1e3}s`,
        transitionTimingFunction: this.timingFunction
      };
      return style;
    }
  },
  watch: {},
  mounted() {
    document.addEventListener("visibilitychange", this.visibilityChange);
    customKeyboardEvent({
      onRectChange: (res) => {
        if (!this.documentVisible) {
          return;
        }
        this.keyboardVisible = res.visible;
        if (res.visible) {
          this.keyboardHeight = res.endRect.height;
        }
        this.animateDuration = res.duration;
        this.timingFunction = res.timingFunction;
      }
    }).then((res) => {
      if (!res.error) {
        this.removeKeyboardHandler = res.data.removeEventListener;
      }
    });
  },
  beforeUnmount() {
    if (this.removeKeyboardHandler) {
      this.removeKeyboardHandler();
      this.removeKeyboardHandler = null;
    }
    document.removeEventListener("visibilitychange", this.visibilityChange);
  },
  methods: {
    handleInputBlur(detail) {
      this.keyboardVisible = false;
      this.keyboardHeight = 0;
      if (detail && detail.noAnimate) {
        this.animateDuration = 0;
      }
    },
    visibilityChange() {
      this.documentVisible = document.visibilityState === "visible";
      if (!this.documentVisible) {
        this.keyboardVisible = false;
      }
    }
  }
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["vac-room-bottom", {
      "vac-room-bottom-safe-area": $options.needSafeArea
    }]),
    style: normalizeStyle($options.finalStyle)
  }, null, 6);
}
var RoomBottom = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
const _sfc_main$3 = {
  name: "ChatRoom",
  components: {
    Loader,
    SvgIcon,
    RoomHeader,
    RoomFooter,
    RoomMessage,
    RoomBottom
  },
  props: {
    disabledEnterKeySend: { type: Boolean, required: true },
    platform: { type: String, required: true },
    pcMode: { type: Boolean, required: false },
    currentUserId: { type: [String, Number], required: true },
    textMessages: { type: Object, required: true },
    singleRoom: { type: Boolean, required: true },
    showRoomsList: { type: Boolean, required: true },
    isMobile: { type: Boolean, required: true },
    rooms: { type: Array, required: true },
    roomId: { type: [String, Number], required: true },
    loadFirstRoom: { type: Boolean, required: true },
    messages: { type: Array, required: true },
    roomMessage: { type: String, default: null },
    messagesLoaded: { type: Boolean, required: true },
    menuActions: { type: Array, required: true },
    messageActions: { type: Array, required: true },
    messageSelectionActions: { type: Array, required: true },
    autoScroll: { type: Object, required: true },
    showSendIcon: { type: Boolean, required: true },
    showFiles: { type: Boolean, required: true },
    showMenu: { type: Boolean, default: true },
    showAudio: { type: Boolean, required: true },
    audioBitRate: { type: Number, required: true },
    audioSampleRate: { type: Number, required: true },
    showEmojis: { type: Boolean, required: true },
    showReactionEmojis: { type: Boolean, required: true },
    showNewMessagesDivider: { type: Boolean, required: true },
    showFooter: { type: Boolean, required: true },
    acceptedFiles: { type: String, required: true },
    captureFiles: { type: String, required: true },
    multipleFiles: { type: Boolean, default: true },
    textFormatting: { type: Object, required: true },
    linkOptions: { type: Object, required: true },
    loadingRooms: { type: Boolean, required: true },
    roomInfoEnabled: { type: Boolean, required: true },
    textareaActionEnabled: { type: Boolean, required: true },
    textareaAutoFocus: { type: Boolean, required: true },
    userTagsEnabled: { type: Boolean, required: true },
    emojisSuggestionEnabled: { type: Boolean, required: true },
    scrollDistance: { type: Number, required: true },
    templatesText: { type: Array, default: null },
    usernameOptions: { type: Object, required: true },
    emojiDataSource: { type: String, default: void 0 },
    roomTopTips: { type: String, default: "" },
    networkException: { type: [Boolean, String], default: false },
    onlyView: { type: Boolean, default: false }
  },
  emits: [
    "toggle-rooms-list",
    "room-info",
    "menu-action-handler",
    "message-selection-action-handler",
    "edit-message",
    "send-message",
    "delete-message",
    "message-action-handler",
    "fetch-messages",
    "send-message-reaction",
    "typing-message",
    "open-file",
    "open-user-tag",
    "open-failed-message",
    "textarea-action-handler",
    "send-custom-card",
    "trigger-custom-card",
    "message-custom-view",
    "toggle-room-chat"
  ],
  data() {
    return {
      editedMessageId: null,
      initReplyMessage: null,
      initEditMessage: null,
      loadingMessages: false,
      observer: null,
      messagesObserver: null,
      showLoader: true,
      loadingMoreMessages: false,
      scrollIcon: false,
      scrollMessagesCount: 0,
      newMessages: [],
      messageSelectionEnabled: false,
      selectedMessages: [],
      droppedFiles: []
    };
  },
  computed: {
    room() {
      return this.rooms.find((room) => room.roomId === this.roomId) || {};
    },
    showNoMessages() {
      return this.roomId && !this.messages.length && !this.loadingMessages && !this.loadingRooms;
    },
    showNoRoom() {
      const noRoomSelected = !this.rooms.length && !this.loadingRooms || !this.roomId && !this.loadFirstRoom;
      if (noRoomSelected) {
        this.updateLoadingMessages(false);
      }
      return noRoomSelected;
    },
    showMessagesStarted() {
      return this.messages.length && this.messagesLoaded;
    },
    showRoomChat() {
      return this.isMobile && !this.showRoomsList || !this.isMobile || this.singleRoom;
    }
  },
  watch: {
    roomId: {
      immediate: true,
      handler() {
        this.onRoomChanged();
      }
    },
    messages: {
      deep: true,
      handler(newVal, oldVal) {
        newVal.forEach((message, i) => {
          if (this.showNewMessagesDivider && message && message.senderId !== this.currentUserId) {
            const oldIndex = this.newMessages.findIndex(
              (r) => r._id === message._id
            );
            if (oldIndex >= 0) {
              this.newMessages.splice(oldIndex, 1);
            }
            if (!message.seen) {
              this.newMessages.push({
                _id: message._id,
                index: i
              });
            }
          }
        });
        if ((oldVal == null ? void 0 : oldVal.length) === (newVal == null ? void 0 : newVal.length) - 1) {
          this.newMessages = [];
        }
        setTimeout(() => this.loadingMoreMessages = false);
        const oldMsgIds = oldVal.map((e) => e._id) || [];
        const updateVal = newVal.filter((msg) => !oldMsgIds.includes(msg._id));
        setTimeout(() => this.initMsgIntersectionObserver(updateVal));
      }
    },
    messagesLoaded(val) {
      if (val)
        this.updateLoadingMessages(false);
    },
    showRoomChat: {
      immediate: true,
      handler(newVal) {
        this.$emit("toggle-room-chat", { opened: newVal });
      }
    }
  },
  mounted() {
    this.newMessages = [];
  },
  methods: {
    updateLoadingMessages(val) {
      this.loadingMessages = val;
      if (!val) {
        setTimeout(() => this.initIntersectionObserver());
      }
    },
    initMsgIntersectionObserver(newMessages) {
      const messagesContain = this.$el.querySelector("#messages-list");
      if (messagesContain) {
        if (!this.messagesObserver) {
          const options = {
            root: messagesContain,
            rootMargin: `${this.scrollDistance}px`,
            threshold: 0
          };
          this.messagesObserver = new IntersectionObserver((entries) => {
            entries.forEach((item) => {
              if (item.isIntersecting) {
                const messageId = item.target.getAttribute("data-msgid");
                const roomId = this.roomId;
                this.$emit("message-custom-view", { messageId, roomId });
                this.messagesObserver.unobserve(item.target);
              }
            });
          }, options);
        }
        for (const message of newMessages) {
          if (!message.seen) {
            const element2 = messagesContain.querySelector(
              '[data-msgid="' + message._id + '"]'
            );
            element2 && this.messagesObserver.observe(element2);
          }
        }
      }
    },
    initIntersectionObserver() {
      if (this.observer) {
        this.showLoader = true;
        this.observer.disconnect();
      }
      const loader = this.$el.querySelector("#infinite-loader-messages");
      if (loader) {
        const options = {
          root: this.$el.querySelector("#messages-list"),
          rootMargin: `${this.scrollDistance}px`,
          threshold: 0
        };
        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.loadMoreMessages();
          }
        }, options);
        this.observer.observe(loader);
      }
    },
    preventTopScroll() {
      const container = this.$refs.scrollContainer;
      const prevScrollHeight = container.scrollHeight;
      const observer = new ResizeObserver((_) => {
        if (container.scrollHeight !== prevScrollHeight) {
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.scrollTo({
              top: container.scrollHeight - prevScrollHeight
            });
            observer.disconnect();
          }
        }
      });
      for (var i = 0; i < container.children.length; i++) {
        observer.observe(container.children[i]);
      }
    },
    touchStart(touchEvent) {
      if (this.singleRoom)
        return;
      if (touchEvent.changedTouches.length === 1) {
        const posXStart = touchEvent.changedTouches[0].clientX;
        const posYStart = touchEvent.changedTouches[0].clientY;
        addEventListener(
          "touchend",
          (touchEvent2) => this.touchEnd(touchEvent2, posXStart, posYStart),
          { once: true }
        );
      }
    },
    touchEnd(touchEvent, posXStart, posYStart) {
      if (touchEvent.changedTouches.length === 1) {
        const posXEnd = touchEvent.changedTouches[0].clientX;
        const posYEnd = touchEvent.changedTouches[0].clientY;
        const swippedRight = posXEnd - posXStart > 100;
        const swippedVertically = Math.abs(posYEnd - posYStart) > 50;
        if (swippedRight && !swippedVertically) {
          this.$emit("toggle-rooms-list");
        }
      }
    },
    onRoomChanged() {
      this.updateLoadingMessages(true);
      this.scrollIcon = false;
      this.scrollMessagesCount = 0;
      this.resetMessageSelection();
      const unwatch = this.$watch(
        () => this.messages,
        (val) => {
          if (!val || !val.length)
            return;
          const element2 = this.$refs.scrollContainer;
          if (!element2)
            return;
          unwatch();
          setTimeout(() => {
            element2.scrollTo({ top: element2.scrollHeight });
            this.updateLoadingMessages(false);
          });
        }
      );
    },
    resetMessageSelection() {
      this.messageSelectionEnabled = false;
      this.selectedMessages = [];
    },
    selectMessage(message) {
      this.selectedMessages.push(message);
    },
    unselectMessage(messageId) {
      this.selectedMessages = this.selectedMessages.filter(
        (message) => message._id !== messageId
      );
    },
    onMessageAdded({ message, index, ref }) {
      if (index !== this.messages.length - 1)
        return;
      const autoScrollOffset = ref.offsetHeight + 60;
      setTimeout(() => {
        const scrollContainer = this.$refs.scrollContainer;
        let scrolledUp = false;
        if (scrollContainer) {
          scrolledUp = this.getBottomScroll(scrollContainer) > autoScrollOffset;
        }
        if (message.senderId === this.currentUserId) {
          if (scrolledUp) {
            if (this.autoScroll.send.newAfterScrollUp) {
              this.scrollToBottom();
            }
          } else {
            if (this.autoScroll.send.new) {
              this.scrollToBottom();
            }
          }
        } else {
          if (scrolledUp) {
            if (this.autoScroll.receive.newAfterScrollUp) {
              this.scrollToBottom();
            } else {
              this.scrollIcon = true;
              this.scrollMessagesCount++;
            }
          } else {
            if (this.autoScroll.receive.new) {
              this.scrollToBottom();
            } else {
              this.scrollIcon = true;
              this.scrollMessagesCount++;
            }
          }
        }
      });
    },
    onContainerScroll(e) {
      if (!e.target)
        return;
      const bottomScroll = this.getBottomScroll(e.target);
      if (bottomScroll < 60)
        this.scrollMessagesCount = 0;
      this.scrollIcon = bottomScroll > 500 || this.scrollMessagesCount;
    },
    loadMoreMessages() {
      if (this.loadingMessages)
        return;
      setTimeout(
        () => {
          if (this.loadingMoreMessages)
            return;
          if (this.messagesLoaded || !this.roomId) {
            this.loadingMoreMessages = false;
            this.showLoader = false;
            return;
          }
          this.preventTopScroll();
          this.$emit("fetch-messages");
          this.loadingMoreMessages = true;
        },
        500
      );
    },
    messageActionHandler({ action, message }) {
      switch (action.name) {
        case "replyMessage":
          this.initReplyMessage = message;
          setTimeout(() => {
            this.initReplyMessage = null;
          });
          return;
        case "editMessage":
          this.initEditMessage = message;
          setTimeout(() => {
            this.initEditMessage = null;
          });
          return;
        case "deleteMessage":
          return this.$emit("delete-message", message);
        case "selectMessages":
          this.selectedMessages = [message];
          this.messageSelectionEnabled = true;
          return;
        case "download":
          window.open(message.files[0].url, "_blank");
          return;
        default:
          return this.$emit("message-action-handler", { action, message });
      }
    },
    messageSelectionActionHandler(action) {
      this.$emit("message-selection-action-handler", {
        action,
        messages: this.selectedMessages
      });
      this.resetMessageSelection();
    },
    sendMessageReaction(messageReaction) {
      this.$emit("send-message-reaction", messageReaction);
    },
    getBottomScroll(element2) {
      const { scrollHeight, clientHeight, scrollTop } = element2;
      return scrollHeight - clientHeight - scrollTop;
    },
    scrollToBottom(delay = 50) {
      setTimeout(() => {
        const element2 = this.$refs.scrollContainer;
        if (element2) {
          element2.classList.add("vac-scroll-smooth");
          element2.scrollTo({ top: element2.scrollHeight, behavior: "smooth" });
          setTimeout(() => element2.classList.remove("vac-scroll-smooth"));
        }
      }, delay);
    },
    openFile({ message, file }) {
      this.$emit("open-file", { message, file });
    },
    openUserTag(user) {
      this.$emit("open-user-tag", user);
    },
    onDropFiles(event) {
      if (this.showFiles) {
        this.droppedFiles = event.dataTransfer.files;
      }
    },
    previewImage(file) {
      this.$emit("open-file", {
        message: null,
        file: {
          action: "preview",
          file
        }
      });
    },
    handleInputBlur(detail) {
      if (this.$refs.roomBottom) {
        this.$refs.roomBottom.handleInputBlur(detail);
      }
    },
    handleClickScrollToBottomBtn() {
      this.scrollToBottom();
      if (this.$refs.roomFooter) {
        this.$refs.roomFooter.preventKeyboardFromClosing();
      }
    }
  }
};
const _hoisted_1$3 = { class: "vac-container-center vac-room-empty" };
const _hoisted_2$1 = { class: "vac-container-wrapper" };
const _hoisted_3$1 = { class: "vac-messages-container" };
const _hoisted_4$1 = {
  key: 0,
  class: "chat-top-bar"
};
const _hoisted_5$1 = {
  key: 0,
  class: "vac-text-started"
};
const _hoisted_6 = {
  key: 1,
  class: "vac-text-started"
};
const _hoisted_7 = {
  key: 0,
  id: "infinite-loader-messages"
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = {
  key: 0,
  class: "vac-badge-counter vac-messages-count"
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_room_header = resolveComponent("room-header");
  const _component_loader = resolveComponent("loader");
  const _component_room_message = resolveComponent("room-message");
  const _component_svg_icon = resolveComponent("svg-icon");
  const _component_room_footer = resolveComponent("room-footer");
  const _component_room_bottom = resolveComponent("room-bottom");
  return withDirectives((openBlock(), createElementBlock("div", {
    class: "vac-col-messages",
    onDrop: _cache[15] || (_cache[15] = withModifiers((...args) => $options.onDropFiles && $options.onDropFiles(...args), ["prevent"])),
    onDragenter: _cache[16] || (_cache[16] = withModifiers(() => {
    }, ["prevent"])),
    onDragover: _cache[17] || (_cache[17] = withModifiers(() => {
    }, ["prevent"])),
    onDragleave: _cache[18] || (_cache[18] = withModifiers(() => {
    }, ["prevent"])),
    onTouchstart: _cache[19] || (_cache[19] = (...args) => $options.touchStart && $options.touchStart(...args))
  }, [
    $options.showNoRoom ? renderSlot(_ctx.$slots, "no-room-selected", { key: 0 }, () => [
      createElementVNode("div", _hoisted_1$3, [
        createElementVNode("div", null, toDisplayString($props.textMessages.ROOM_EMPTY), 1)
      ])
    ]) : (openBlock(), createBlock(_component_room_header, {
      key: 1,
      "current-user-id": $props.currentUserId,
      "text-messages": $props.textMessages,
      "single-room": $props.singleRoom,
      "show-rooms-list": $props.showRoomsList,
      "is-mobile": $props.isMobile,
      "room-info-enabled": $props.roomInfoEnabled,
      "menu-actions": $props.menuActions,
      room: $options.room,
      "message-selection-enabled": $data.messageSelectionEnabled,
      "message-selection-actions": $props.messageSelectionActions,
      "selected-messages-total": $data.selectedMessages.length,
      onToggleRoomsList: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("toggle-rooms-list")),
      onRoomInfo: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("room-info")),
      onMenuActionHandler: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("menu-action-handler", $event)),
      onMessageSelectionActionHandler: $options.messageSelectionActionHandler,
      onCancelMessageSelection: _cache[3] || (_cache[3] = ($event) => $data.messageSelectionEnabled = false)
    }, createSlots({ _: 2 }, [
      renderList(_ctx.$slots, (i, name) => {
        return {
          name,
          fn: withCtx((data) => [
            renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
          ])
        };
      })
    ]), 1032, ["current-user-id", "text-messages", "single-room", "show-rooms-list", "is-mobile", "room-info-enabled", "menu-actions", "room", "message-selection-enabled", "message-selection-actions", "selected-messages-total", "onMessageSelectionActionHandler"])),
    createElementVNode("div", _hoisted_2$1, [
      createElementVNode("div", {
        id: "messages-list",
        ref: "scrollContainer",
        class: "vac-container-scroll",
        onScroll: _cache[7] || (_cache[7] = (...args) => $options.onContainerScroll && $options.onContainerScroll(...args))
      }, [
        createVNode(_component_loader, {
          show: $data.loadingMessages,
          type: "messages"
        }, createSlots({ _: 2 }, [
          renderList(_ctx.$slots, (idx, name) => {
            return {
              name,
              fn: withCtx((data) => [
                renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
              ])
            };
          })
        ]), 1032, ["show"]),
        createElementVNode("div", _hoisted_3$1, [
          createElementVNode("div", {
            class: normalizeClass({ "vac-messages-hidden": $data.loadingMessages })
          }, [
            createVNode(Transition, { name: "vac-fade-message" }, {
              default: withCtx(() => [
                JSON.parse($props.networkException) ? renderSlot(_ctx.$slots, "network-exception-room", { key: 0 }) : createCommentVNode("", true)
              ]),
              _: 3
            }),
            createVNode(Transition, { name: "vac-fade-message" }, {
              default: withCtx(() => [
                $props.roomTopTips ? (openBlock(), createElementBlock("div", _hoisted_4$1, toDisplayString($props.roomTopTips), 1)) : createCommentVNode("", true)
              ]),
              _: 1
            }),
            createVNode(Transition, { name: "vac-fade-message" }, {
              default: withCtx(() => [
                createElementVNode("div", null, [
                  $options.showNoMessages ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
                    renderSlot(_ctx.$slots, "messages-empty", {}, () => [
                      createTextVNode(toDisplayString($props.textMessages.MESSAGES_EMPTY), 1)
                    ])
                  ])) : createCommentVNode("", true),
                  $options.showMessagesStarted ? (openBlock(), createElementBlock("div", _hoisted_6, toDisplayString($props.textMessages.CONVERSATION_STARTED) + " " + toDisplayString($props.messages[0].date), 1)) : createCommentVNode("", true)
                ])
              ]),
              _: 3
            }),
            $props.messages.length && !$props.messagesLoaded ? (openBlock(), createElementBlock("div", _hoisted_7, [
              createVNode(_component_loader, {
                show: true,
                infinite: true,
                type: "infinite-messages"
              }, createSlots({ _: 2 }, [
                renderList(_ctx.$slots, (idx, name) => {
                  return {
                    name,
                    fn: withCtx((data) => [
                      renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
                    ])
                  };
                })
              ]), 1024)
            ])) : createCommentVNode("", true),
            (openBlock(), createBlock(TransitionGroup, {
              key: $props.roomId,
              name: "vac-fade-message",
              tag: "div"
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.messages, (m, i) => {
                  return openBlock(), createBlock(_component_room_message, {
                    key: m.indexId || m._id,
                    "current-user-id": $props.currentUserId,
                    message: m,
                    index: i,
                    platform: $props.platform,
                    "pc-mode": $props.pcMode,
                    messages: $props.messages,
                    "edited-message-id": $data.editedMessageId,
                    "message-actions": $props.messageActions,
                    "room-users": $options.room.users,
                    "text-messages": $props.textMessages,
                    "new-messages": $data.newMessages,
                    "show-reaction-emojis": $props.showReactionEmojis,
                    "show-new-messages-divider": $props.showNewMessagesDivider,
                    "text-formatting": $props.textFormatting,
                    "link-options": $props.linkOptions,
                    "username-options": $props.usernameOptions,
                    "message-selection-enabled": $data.messageSelectionEnabled,
                    "selected-messages": $data.selectedMessages,
                    "emoji-data-source": $props.emojiDataSource,
                    onMessageAdded: $options.onMessageAdded,
                    onMessageActionHandler: $options.messageActionHandler,
                    onOpenFile: $options.openFile,
                    onOpenUserTag: ($event) => $options.openUserTag($event, m),
                    onOpenFailedMessage: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("open-failed-message", $event)),
                    onSendMessageReaction: $options.sendMessageReaction,
                    onSelectMessage: $options.selectMessage,
                    onUnselectMessage: $options.unselectMessage,
                    onSendCustomCard: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("send-custom-card", $event)),
                    onTriggerCustomCard: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("trigger-custom-card", $event))
                  }, createSlots({ _: 2 }, [
                    renderList(_ctx.$slots, (idx, name) => {
                      return {
                        name,
                        fn: withCtx((data) => [
                          renderSlot(_ctx.$slots, name, mergeProps({ ref_for: true }, data))
                        ])
                      };
                    })
                  ]), 1032, ["current-user-id", "message", "index", "platform", "pc-mode", "messages", "edited-message-id", "message-actions", "room-users", "text-messages", "new-messages", "show-reaction-emojis", "show-new-messages-divider", "text-formatting", "link-options", "username-options", "message-selection-enabled", "selected-messages", "emoji-data-source", "onMessageAdded", "onMessageActionHandler", "onOpenFile", "onOpenUserTag", "onSendMessageReaction", "onSelectMessage", "onUnselectMessage"]);
                }), 128))
              ]),
              _: 3
            }))
          ], 2)
        ])
      ], 544),
      !$data.loadingMessages ? (openBlock(), createElementBlock("div", _hoisted_8, [
        createVNode(Transition, { name: "vac-bounce" }, {
          default: withCtx(() => [
            $data.scrollIcon ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "vac-icon-scroll",
              onClick: _cache[8] || (_cache[8] = withModifiers((...args) => $options.handleClickScrollToBottomBtn && $options.handleClickScrollToBottomBtn(...args), ["stop"]))
            }, [
              createVNode(Transition, { name: "vac-bounce" }, {
                default: withCtx(() => [
                  $data.scrollMessagesCount ? (openBlock(), createElementBlock("div", _hoisted_9, toDisplayString($data.scrollMessagesCount), 1)) : createCommentVNode("", true)
                ]),
                _: 1
              }),
              renderSlot(_ctx.$slots, "scroll-icon", {}, () => [
                createVNode(_component_svg_icon, {
                  name: "dropdown",
                  param: "scroll"
                })
              ])
            ])) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ])) : createCommentVNode("", true)
    ]),
    !$props.onlyView ? (openBlock(), createBlock(_component_room_footer, {
      key: 2,
      ref: "roomFooter",
      room: $options.room,
      platform: $props.platform,
      "pc-mode": $props.pcMode,
      "room-id": $props.roomId,
      "room-message": $props.roomMessage,
      "text-messages": $props.textMessages,
      "show-send-icon": $props.showSendIcon,
      "show-files": $props.showFiles,
      "show-menu": $props.showMenu,
      "show-audio": $props.showAudio,
      "show-emojis": $props.showEmojis,
      "show-footer": $props.showFooter,
      "accepted-files": $props.acceptedFiles,
      "capture-files": $props.captureFiles,
      "multiple-files": $props.multipleFiles,
      "textarea-action-enabled": $props.textareaActionEnabled,
      "textarea-auto-focus": $props.textareaAutoFocus,
      "user-tags-enabled": $props.userTagsEnabled,
      "emojis-suggestion-enabled": $props.emojisSuggestionEnabled,
      "templates-text": $props.templatesText,
      "text-formatting": $props.textFormatting,
      "link-options": $props.linkOptions,
      "audio-bit-rate": $props.audioBitRate,
      "audio-sample-rate": $props.audioSampleRate,
      "init-reply-message": $data.initReplyMessage,
      "init-edit-message": $data.initEditMessage,
      "dropped-files": $data.droppedFiles,
      "emoji-data-source": $props.emojiDataSource,
      "disabled-enter-key-send": $props.disabledEnterKeySend,
      onUpdateEditedMessageId: _cache[9] || (_cache[9] = ($event) => $data.editedMessageId = $event),
      onEditMessage: _cache[10] || (_cache[10] = ($event) => _ctx.$emit("edit-message", $event)),
      onSendMessage: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("send-message", $event)),
      onTypingMessage: _cache[12] || (_cache[12] = ($event) => _ctx.$emit("typing-message", $event)),
      onPreviewImage: $options.previewImage,
      onTextareaActionHandler: _cache[13] || (_cache[13] = ($event) => _ctx.$emit("textarea-action-handler", $event)),
      onBlur: $options.handleInputBlur,
      onScrollToBottom: _cache[14] || (_cache[14] = (delay) => $options.scrollToBottom(delay))
    }, createSlots({ _: 2 }, [
      renderList(_ctx.$slots, (idx, name) => {
        return {
          name,
          fn: withCtx((data) => [
            renderSlot(_ctx.$slots, name, normalizeProps(guardReactiveProps(data)))
          ])
        };
      })
    ]), 1032, ["room", "platform", "pc-mode", "room-id", "room-message", "text-messages", "show-send-icon", "show-files", "show-menu", "show-audio", "show-emojis", "show-footer", "accepted-files", "capture-files", "multiple-files", "textarea-action-enabled", "textarea-auto-focus", "user-tags-enabled", "emojis-suggestion-enabled", "templates-text", "text-formatting", "link-options", "audio-bit-rate", "audio-sample-rate", "init-reply-message", "init-edit-message", "dropped-files", "emoji-data-source", "disabled-enter-key-send", "onPreviewImage", "onBlur"])) : createCommentVNode("", true),
    createVNode(_component_room_bottom, {
      ref: "roomBottom",
      platform: $props.platform,
      "pc-mode": $props.pcMode
    }, null, 8, ["platform", "pc-mode"])
  ], 544)), [
    [vShow, $options.showRoomChat]
  ]);
}
var Room = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const _sfc_main$2 = {
  name: "ImagePreviewCustom",
  props: {
    imageUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      fullWidth: 0,
      fullHeight: 0,
      originHeight: 0,
      widthAdaptFullHeight: 0,
      imageRatio: 1,
      containerRatio: 1
    };
  },
  computed: {
    finalImageUrl() {
      return resizeImage(this.imageUrl);
    }
  },
  mounted() {
    this.doSortHeight();
  },
  methods: {
    doSortHeight() {
      const img = new Image();
      img.src = this.finalImageUrl;
      img.onload = () => {
        const containerSize = this.getContainerSize();
        const imageRatio = img.height / img.width;
        const containerRatio = containerSize.height / containerSize.width;
        if (this.$refs.bgImageContainerBox) {
          const bgImageContainerBoxHeight = this.$refs.bgImageContainerBox.clientHeight;
          const bgImageContainerBoxWidth = this.$refs.bgImageContainerBox.clientWidth;
          const containerHeight = bgImageContainerBoxWidth * imageRatio;
          this.originHeight = containerHeight;
          this.fullWidth = bgImageContainerBoxWidth;
          this.fullHeight = bgImageContainerBoxHeight;
          this.widthAdaptFullHeight = bgImageContainerBoxHeight / imageRatio;
          this.imageRatio = imageRatio;
          this.containerRatio = containerRatio;
          if (imageRatio < containerRatio) {
            this.width = this.fullWidth;
            this.height = this.originHeight;
          } else {
            this.width = this.widthAdaptFullHeight;
            this.height = this.fullHeight;
            this.$refs.bgImageContainerBox.style.height = "auto";
          }
        }
      };
    },
    getContainerSize() {
      const parent = this.$parent;
      if (!parent) {
        return {
          width: 300,
          height: 300
        };
      }
      const style = window.getComputedStyle(parent.$el);
      return {
        width: parseInt(style.width.replace("px", "")),
        height: parseInt(style.height.replace("px", ""))
      };
    },
    toogleImage(e) {
      e.stopPropagation();
      if (this.width === this.fullWidth) {
        this.width = this.widthAdaptFullHeight;
        this.height = this.fullHeight;
      } else {
        this.width = this.fullWidth;
        this.height = this.originHeight;
      }
    }
  }
};
const _hoisted_1$2 = {
  ref: "bgImageContainerBox",
  class: "vac-image-preview-custom-container"
};
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, [
    createElementVNode("div", {
      ref: "bgImageContainer",
      class: "vac-image-preview-custom",
      style: normalizeStyle({
        "background-image": `url('${$options.finalImageUrl}')`,
        width: `${$data.width}px`,
        height: `${$data.height}px`,
        margin: "0 auto"
      }),
      onDblclick: _cache[0] || (_cache[0] = (...args) => $options.toogleImage && $options.toogleImage(...args)),
      onClick: _cache[1] || (_cache[1] = (...args) => $options.toogleImage && $options.toogleImage(...args))
    }, null, 36)
  ], 512);
}
var ImagePreviewCustom = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const _sfc_main$1 = {
  name: "MediaPreview",
  components: {
    SvgIcon,
    ImagePreviewCustom
  },
  props: {
    file: { type: Object, required: true },
    isMobile: { type: Boolean, required: false, default: false }
  },
  emits: ["close-media-preview"],
  data() {
    return {
      removeCustomBack: null
    };
  },
  computed: {
    isImage() {
      return isImageFile(this.file);
    },
    isVideo() {
      return isVideoFile(this.file);
    }
  },
  mounted() {
    this.$refs.modal.focus();
    customBack({
      enable: true,
      handler: this.closeModal
    }).then((res) => {
      if (!res.error) {
        this.removeCustomBack = res.data.removeHandler;
      }
    });
  },
  methods: {
    closeModal() {
      this.$emit("close-media-preview");
      if (this.removeCustomBack) {
        this.removeCustomBack();
        this.removeCustomBack = null;
      }
    }
  }
};
const _hoisted_1$1 = {
  key: 0,
  style: { "overflow-y": "auto" },
  class: "vac-media-preview-container"
};
const _hoisted_2 = {
  key: 1,
  class: "vac-media-preview-container"
};
const _hoisted_3 = {
  controls: "",
  autoplay: ""
};
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "vac-svg-button" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ImagePreviewCustom = resolveComponent("ImagePreviewCustom");
  const _component_svg_icon = resolveComponent("svg-icon");
  return openBlock(), createElementBlock("div", {
    ref: "modal",
    tabindex: "0",
    class: "vac-media-preview",
    onClick: _cache[0] || (_cache[0] = withModifiers((...args) => $options.closeModal && $options.closeModal(...args), ["stop"])),
    onKeydown: _cache[1] || (_cache[1] = withKeys((...args) => $options.closeModal && $options.closeModal(...args), ["esc"]))
  }, [
    createVNode(Transition, {
      name: "vac-bounce-preview",
      appear: ""
    }, {
      default: withCtx(() => [
        $options.isImage ? (openBlock(), createElementBlock("div", _hoisted_1$1, [
          $props.file.url ? (openBlock(), createBlock(_component_ImagePreviewCustom, {
            key: 0,
            "image-url": $props.file.url,
            "is-mobile": $props.isMobile
          }, null, 8, ["image-url", "is-mobile"])) : createCommentVNode("", true)
        ])) : $options.isVideo ? (openBlock(), createElementBlock("div", _hoisted_2, [
          createElementVNode("video", _hoisted_3, [
            createElementVNode("source", {
              src: $props.file.url
            }, null, 8, _hoisted_4)
          ])
        ])) : createCommentVNode("", true)
      ]),
      _: 1
    }),
    createElementVNode("div", _hoisted_5, [
      renderSlot(_ctx.$slots, "preview-close-icon", {}, () => [
        createVNode(_component_svg_icon, {
          name: "close-outline",
          param: "preview"
        })
      ])
    ])
  ], 544);
}
var MediaPreview = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
var locales = {
  ROOMS_EMPTY: "No rooms",
  ROOM_EMPTY: "No room selected",
  NEW_MESSAGES: "New Messages",
  MESSAGE_DELETED: "This message was deleted",
  MESSAGES_EMPTY: "No messages",
  CONVERSATION_STARTED: "Conversation started on:",
  TYPE_MESSAGE: "Type message",
  SEARCH: "Search",
  IS_ONLINE: "is online",
  LAST_SEEN: "last seen ",
  IS_TYPING: "is writing...",
  CANCEL_SELECT_MESSAGE: "Cancel"
};
const defaultThemeStyles = {
  light: {
    general: {
      color: "#0a0a0a",
      colorButtonClear: "#1976d2",
      colorButton: "#fff",
      backgroundColorButton: "#1976d2",
      backgroundInput: "#fff",
      colorPlaceholder: "#9ca6af",
      colorCaret: "#1976d2",
      colorSpinner: "#333",
      borderStyle: "1px solid #e1e4e8",
      backgroundScrollIcon: "#fff"
    },
    container: {
      border: "none",
      borderRadius: "4px",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)"
    },
    header: {
      background: "#fff",
      colorRoomName: "#0a0a0a",
      colorRoomInfo: "#9ca6af"
    },
    footer: {
      background: "#f8f9fa",
      borderStyleInput: "1px solid #e1e4e8",
      borderInputSelected: "#1976d2",
      backgroundReply: "#e5e5e6",
      backgroundTagActive: "#e5e5e6",
      backgroundTag: "#f8f9fa"
    },
    content: {
      background: "#f8f9fa"
    },
    sidemenu: {
      background: "#fff",
      backgroundHover: "#f6f6f6",
      backgroundActive: "#e5effa",
      colorActive: "#1976d2",
      borderColorSearch: "#e1e5e8"
    },
    dropdown: {
      background: "#fff",
      backgroundHover: "#f6f6f6"
    },
    message: {
      background: "#fff",
      backgroundMe: "#ffedc1",
      color: "#0a0a0a",
      colorStarted: "#9ca6af",
      backgroundDeleted: "#dadfe2",
      backgroundSelected: "#c2dcf2",
      colorDeleted: "#757e85",
      colorUsername: "#9ca6af",
      colorTimestamp: "#828c94",
      backgroundDate: "#e5effa",
      colorDate: "#505a62",
      backgroundSystem: "#e5effa",
      colorSystem: "#505a62",
      backgroundMedia: "rgba(0, 0, 0, 0.15)",
      backgroundReply: "rgba(0, 0, 0, 0.08)",
      colorReplyUsername: "#0a0a0a",
      colorReply: "#6e6e6e",
      colorTag: "#0d579c",
      backgroundImage: "#ddd",
      colorNewMessages: "#1976d2",
      backgroundScrollCounter: "#0696c7",
      colorScrollCounter: "#fff",
      backgroundReaction: "#eee",
      borderStyleReaction: "1px solid #eee",
      backgroundReactionHover: "#fff",
      borderStyleReactionHover: "1px solid #ddd",
      colorReactionCounter: "#0a0a0a",
      backgroundReactionMe: "#cfecf5",
      borderStyleReactionMe: "1px solid #3b98b8",
      backgroundReactionHoverMe: "#cfecf5",
      borderStyleReactionHoverMe: "1px solid #3b98b8",
      colorReactionCounterMe: "#0b59b3",
      backgroundAudioRecord: "#eb4034",
      backgroundAudioLine: "rgba(0, 0, 0, 0.15)",
      backgroundAudioProgress: "#455247",
      backgroundAudioProgressSelector: "#455247",
      colorFileExtension: "#757e85"
    },
    markdown: {
      background: "rgba(239, 239, 239, 0.7)",
      border: "rgba(212, 212, 212, 0.9)",
      color: "#e01e5a",
      colorMulti: "#0a0a0a"
    },
    room: {
      colorUsername: "#0a0a0a",
      colorMessage: "#67717a",
      colorTimestamp: "#a2aeb8",
      colorStateOnline: "#4caf50",
      colorStateOffline: "#9ca6af",
      backgroundCounterBadge: "#FF5656",
      colorCounterBadge: "#fff"
    },
    emoji: {
      background: "#fff"
    },
    icons: {
      search: "#9ca6af",
      add: "#1976d2",
      toggle: "#0a0a0a",
      menu: "#0a0a0a",
      close: "#9ca6af",
      closeImage: "#fff",
      file: "#1976d2",
      paperclip: "#1976d2",
      closeOutline: "#000",
      closePreview: "#fff",
      send: "#1976d2",
      sendDisabled: "#9ca6af",
      emoji: "#1976d2",
      emojiReaction: "rgba(0, 0, 0, 0.3)",
      document: "#1976d2",
      pencil: "#9e9e9e",
      checkmark: "#9e9e9e",
      checkmarkSeen: "#0696c7",
      eye: "#fff",
      dropdownMessage: "#fff",
      dropdownMessageBackground: "rgba(0, 0, 0, 0.25)",
      dropdownRoom: "#9e9e9e",
      dropdownScroll: "#0a0a0a",
      microphone: "#1976d2",
      audioPlay: "#455247",
      audioPause: "#455247",
      audioCancel: "#eb4034",
      audioConfirm: "#1ba65b"
    }
  },
  dark: {
    general: {
      color: "#fff",
      colorButtonClear: "#fff",
      colorButton: "#fff",
      backgroundColorButton: "#1976d2",
      backgroundInput: "#202223",
      colorPlaceholder: "#596269",
      colorCaret: "#fff",
      colorSpinner: "#fff",
      borderStyle: "none",
      backgroundScrollIcon: "#fff"
    },
    container: {
      border: "none",
      borderRadius: "4px",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)"
    },
    header: {
      background: "#181a1b",
      colorRoomName: "#fff",
      colorRoomInfo: "#9ca6af"
    },
    footer: {
      background: "#131415",
      borderStyleInput: "none",
      borderInputSelected: "#1976d2",
      backgroundReply: "#1b1c1c",
      backgroundTagActive: "#1b1c1c",
      backgroundTag: "#131415"
    },
    content: {
      background: "#131415"
    },
    sidemenu: {
      background: "#181a1b",
      backgroundHover: "#202224",
      backgroundActive: "#151617",
      colorActive: "#fff",
      borderColorSearch: "#181a1b"
    },
    dropdown: {
      background: "#2a2c33",
      backgroundHover: "#26282e"
    },
    message: {
      background: "#22242a",
      backgroundMe: "#1f7e80",
      color: "#fff",
      colorStarted: "#9ca6af",
      backgroundDeleted: "#1b1c21",
      backgroundSelected: "#c2dcf2",
      colorDeleted: "#a2a5a8",
      colorUsername: "#b3bac9",
      colorTimestamp: "#ebedf2",
      backgroundDate: "rgba(0, 0, 0, 0.3)",
      colorDate: "#bec5cc",
      backgroundSystem: "rgba(0, 0, 0, 0.3)",
      colorSystem: "#bec5cc",
      backgroundMedia: "rgba(0, 0, 0, 0.18)",
      backgroundReply: "rgba(0, 0, 0, 0.18)",
      colorReplyUsername: "#fff",
      colorReply: "#d6d6d6",
      colorTag: "#f0c60a",
      backgroundImage: "#ddd",
      colorNewMessages: "#fff",
      backgroundScrollCounter: "#1976d2",
      colorScrollCounter: "#fff",
      backgroundReaction: "none",
      borderStyleReaction: "none",
      backgroundReactionHover: "#202223",
      borderStyleReactionHover: "none",
      colorReactionCounter: "#fff",
      backgroundReactionMe: "#4e9ad1",
      borderStyleReactionMe: "none",
      backgroundReactionHoverMe: "#4e9ad1",
      borderStyleReactionHoverMe: "none",
      colorReactionCounterMe: "#fff",
      backgroundAudioRecord: "#eb4034",
      backgroundAudioLine: "rgba(255, 255, 255, 0.15)",
      backgroundAudioProgress: "#b7d4d3",
      backgroundAudioProgressSelector: "#b7d4d3",
      colorFileExtension: "#a2a5a8"
    },
    markdown: {
      background: "rgba(239, 239, 239, 0.7)",
      border: "rgba(212, 212, 212, 0.9)",
      color: "#e01e5a",
      colorMulti: "#0a0a0a"
    },
    room: {
      colorUsername: "#fff",
      colorMessage: "#6c7278",
      colorTimestamp: "#6c7278",
      colorStateOnline: "#4caf50",
      colorStateOffline: "#596269",
      backgroundCounterBadge: "#1976d2",
      colorCounterBadge: "#fff"
    },
    emoji: {
      background: "#343740"
    },
    icons: {
      search: "#596269",
      add: "#fff",
      toggle: "#fff",
      menu: "#fff",
      close: "#9ca6af",
      closeImage: "#fff",
      file: "#1976d2",
      paperclip: "#fff",
      closeOutline: "#fff",
      closePreview: "#fff",
      send: "#fff",
      sendDisabled: "#646a70",
      emoji: "#fff",
      emojiReaction: "#fff",
      document: "#1976d2",
      pencil: "#ebedf2",
      checkmark: "#ebedf2",
      checkmarkSeen: "#f0d90a",
      eye: "#fff",
      dropdownMessage: "#fff",
      dropdownMessageBackground: "rgba(0, 0, 0, 0.25)",
      dropdownRoom: "#fff",
      dropdownScroll: "#0a0a0a",
      microphone: "#fff",
      audioPlay: "#b7d4d3",
      audioPause: "#b7d4d3",
      audioCancel: "#eb4034",
      audioConfirm: "#1ba65b"
    }
  }
};
const cssThemeVars = ({
  general,
  container,
  header,
  footer,
  sidemenu,
  content: content2,
  dropdown,
  message,
  markdown: markdown2,
  room,
  emoji,
  icons
}) => {
  return {
    "--chat-color": general.color,
    "--chat-color-button-clear": general.colorButtonClear,
    "--chat-color-button": general.colorButton,
    "--chat-bg-color-button": general.backgroundColorButton,
    "--chat-bg-color-input": general.backgroundInput,
    "--chat-color-spinner": general.colorSpinner,
    "--chat-color-placeholder": general.colorPlaceholder,
    "--chat-color-caret": general.colorCaret,
    "--chat-border-style": general.borderStyle,
    "--chat-bg-scroll-icon": general.backgroundScrollIcon,
    "--chat-container-border": container.border,
    "--chat-container-border-radius": container.borderRadius,
    "--chat-container-box-shadow": container.boxShadow,
    "--chat-header-bg-color": header.background,
    "--chat-header-color-name": header.colorRoomName,
    "--chat-header-color-info": header.colorRoomInfo,
    "--chat-footer-bg-color": footer.background,
    "--chat-border-style-input": footer.borderStyleInput,
    "--chat-border-color-input-selected": footer.borderInputSelected,
    "--chat-footer-bg-color-reply": footer.backgroundReply,
    "--chat-footer-bg-color-tag-active": footer.backgroundTagActive,
    "--chat-footer-bg-color-tag": footer.backgroundTag,
    "--chat-content-bg-color": content2.background,
    "--chat-sidemenu-bg-color": sidemenu.background,
    "--chat-sidemenu-bg-color-hover": sidemenu.backgroundHover,
    "--chat-sidemenu-bg-color-active": sidemenu.backgroundActive,
    "--chat-sidemenu-color-active": sidemenu.colorActive,
    "--chat-sidemenu-border-color-search": sidemenu.borderColorSearch,
    "--chat-dropdown-bg-color": dropdown.background,
    "--chat-dropdown-bg-color-hover": dropdown.backgroundHover,
    "--chat-message-bg-color": message.background,
    "--chat-message-bg-color-me": message.backgroundMe,
    "--chat-message-color-started": message.colorStarted,
    "--chat-message-bg-color-deleted": message.backgroundDeleted,
    "--chat-message-bg-color-selected": message.backgroundSelected,
    "--chat-message-color-deleted": message.colorDeleted,
    "--chat-message-color-username": message.colorUsername,
    "--chat-message-color-timestamp": message.colorTimestamp,
    "--chat-message-bg-color-date": message.backgroundDate,
    "--chat-message-color-date": message.colorDate,
    "--chat-message-bg-color-system": message.backgroundSystem,
    "--chat-message-color-system": message.colorSystem,
    "--chat-message-color": message.color,
    "--chat-message-bg-color-media": message.backgroundMedia,
    "--chat-message-bg-color-reply": message.backgroundReply,
    "--chat-message-color-reply-username": message.colorReplyUsername,
    "--chat-message-color-reply-content": message.colorReply,
    "--chat-message-color-tag": message.colorTag,
    "--chat-message-bg-color-image": message.backgroundImage,
    "--chat-message-color-new-messages": message.colorNewMessages,
    "--chat-message-bg-color-scroll-counter": message.backgroundScrollCounter,
    "--chat-message-color-scroll-counter": message.colorScrollCounter,
    "--chat-message-bg-color-reaction": message.backgroundReaction,
    "--chat-message-border-style-reaction": message.borderStyleReaction,
    "--chat-message-bg-color-reaction-hover": message.backgroundReactionHover,
    "--chat-message-border-style-reaction-hover": message.borderStyleReactionHover,
    "--chat-message-color-reaction-counter": message.colorReactionCounter,
    "--chat-message-bg-color-reaction-me": message.backgroundReactionMe,
    "--chat-message-border-style-reaction-me": message.borderStyleReactionMe,
    "--chat-message-bg-color-reaction-hover-me": message.backgroundReactionHoverMe,
    "--chat-message-border-style-reaction-hover-me": message.borderStyleReactionHoverMe,
    "--chat-message-color-reaction-counter-me": message.colorReactionCounterMe,
    "--chat-message-bg-color-audio-record": message.backgroundAudioRecord,
    "--chat-message-bg-color-audio-line": message.backgroundAudioLine,
    "--chat-message-bg-color-audio-progress": message.backgroundAudioProgress,
    "--chat-message-bg-color-audio-progress-selector": message.backgroundAudioProgressSelector,
    "--chat-message-color-file-extension": message.colorFileExtension,
    "--chat-markdown-bg": markdown2.background,
    "--chat-markdown-border": markdown2.border,
    "--chat-markdown-color": markdown2.color,
    "--chat-markdown-color-multi": markdown2.colorMulti,
    "--chat-room-color-username": room.colorUsername,
    "--chat-room-color-message": room.colorMessage,
    "--chat-room-color-timestamp": room.colorTimestamp,
    "--chat-room-color-online": room.colorStateOnline,
    "--chat-room-color-offline": room.colorStateOffline,
    "--chat-room-bg-color-badge": room.backgroundCounterBadge,
    "--chat-room-color-badge": room.colorCounterBadge,
    "--chat-emoji-bg-color": emoji.background,
    "--chat-icon-color-search": icons.search,
    "--chat-icon-color-add": icons.add,
    "--chat-icon-color-toggle": icons.toggle,
    "--chat-icon-color-menu": icons.menu,
    "--chat-icon-color-close": icons.close,
    "--chat-icon-color-close-image": icons.closeImage,
    "--chat-icon-color-file": icons.file,
    "--chat-icon-color-paperclip": icons.paperclip,
    "--chat-icon-color-close-outline": icons.closeOutline,
    "--chat-icon-color-close-preview": icons.closePreview,
    "--chat-icon-color-send": icons.send,
    "--chat-icon-color-send-disabled": icons.sendDisabled,
    "--chat-icon-color-emoji": icons.emoji,
    "--chat-icon-color-emoji-reaction": icons.emojiReaction,
    "--chat-icon-color-document": icons.document,
    "--chat-icon-color-pencil": icons.pencil,
    "--chat-icon-color-checkmark": icons.checkmark,
    "--chat-icon-color-checkmark-seen": icons.checkmarkSeen,
    "--chat-icon-color-eye": icons.eye,
    "--chat-icon-color-dropdown-message": icons.dropdownMessage,
    "--chat-icon-bg-dropdown-message": icons.dropdownMessageBackground,
    "--chat-icon-color-dropdown-room": icons.dropdownRoom,
    "--chat-icon-color-dropdown-scroll": icons.dropdownScroll,
    "--chat-icon-color-microphone": icons.microphone,
    "--chat-icon-color-audio-play": icons.audioPlay,
    "--chat-icon-color-audio-pause": icons.audioPause,
    "--chat-icon-color-audio-cancel": icons.audioCancel,
    "--chat-icon-color-audio-confirm": icons.audioConfirm
  };
};
var _style_0 = '@charset "UTF-8";.xgplayer-skin-default .xgplayer-placeholder{flex:0;order:3;display:block}.xgplayer-skin-default .xgplayer-cssfullscreen,.xgplayer-skin-default .xgplayer-cssfullscreen-img{position:relative;order:12;display:block;cursor:pointer}.xgplayer-skin-default .xgplayer-cssfullscreen-img .xgplayer-icon,.xgplayer-skin-default .xgplayer-cssfullscreen .xgplayer-icon{width:32px;margin-top:5px}.xgplayer-skin-default .xgplayer-cssfullscreen-img .xgplayer-icon div,.xgplayer-skin-default .xgplayer-cssfullscreen .xgplayer-icon div{position:absolute}.xgplayer-skin-default .xgplayer-cssfullscreen-img .xgplayer-icon .xgplayer-icon-requestfull,.xgplayer-skin-default .xgplayer-cssfullscreen .xgplayer-icon .xgplayer-icon-requestfull{display:block}.xgplayer-skin-default .xgplayer-cssfullscreen-img .xgplayer-icon .xgplayer-icon-exitfull,.xgplayer-skin-default .xgplayer-cssfullscreen .xgplayer-icon .xgplayer-icon-exitfull{display:none}.xgplayer-skin-default .xgplayer-cssfullscreen-img .xgplayer-tips,.xgplayer-skin-default .xgplayer-cssfullscreen .xgplayer-tips{margin-left:-40px}.xgplayer-skin-default .xgplayer-cssfullscreen-img .xgplayer-tips .xgplayer-tip-requestfull,.xgplayer-skin-default .xgplayer-cssfullscreen .xgplayer-tips .xgplayer-tip-requestfull{display:block}.xgplayer-skin-default .xgplayer-cssfullscreen-img .xgplayer-tips .xgplayer-tip-exitfull,.xgplayer-skin-default .xgplayer-cssfullscreen .xgplayer-tips .xgplayer-tip-exitfull{display:none}.xgplayer-skin-default .xgplayer-cssfullscreen-img:hover,.xgplayer-skin-default .xgplayer-cssfullscreen:hover{opacity:.85}.xgplayer-skin-default .xgplayer-cssfullscreen-img:hover .xgplayer-tips,.xgplayer-skin-default .xgplayer-cssfullscreen:hover .xgplayer-tips{display:block}.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen-img .xgplayer-icon .xgplayer-icon-requestfull,.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen .xgplayer-icon .xgplayer-icon-requestfull{display:none}.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen-img .xgplayer-icon .xgplayer-icon-exitfull,.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen .xgplayer-icon .xgplayer-icon-exitfull{display:block}.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen-img .xgplayer-tips,.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen .xgplayer-tips{margin-left:-47px}.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen-img .xgplayer-tips .xgplayer-tip-requestfull,.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen .xgplayer-tips .xgplayer-tip-requestfull{display:none}.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen-img .xgplayer-tips .xgplayer-tip-exitfull,.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen .xgplayer-tips .xgplayer-tip-exitfull{display:block}.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-cssfullscreen,.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-cssfullscreen-img{display:none}.xgplayer-skin-default.xgplayer-is-cssfullscreen{position:fixed!important;left:0!important;top:0!important;width:100%!important;height:100%!important;z-index:99999!important}.xgplayer-lang-is-en .xgplayer-cssfullscreen-img .xgplayer-tips,.xgplayer-lang-is-en .xgplayer-cssfullscreen .xgplayer-tips,.xgplayer-lang-is-en.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen-img .xgplayer-tips,.xgplayer-lang-is-en.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen .xgplayer-tips{margin-left:-46px}.lang-is-jp .xgplayer-cssfullscreen-img .xgplayer-tips,.lang-is-jp .xgplayer-cssfullscreen .xgplayer-tips{margin-left:-120px}.lang-is-jp.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen-img .xgplayer-tips,.lang-is-jp.xgplayer-is-cssfullscreen .xgplayer-cssfullscreen .xgplayer-tips{margin-left:-60px}.xgplayer-skin-default .xgplayer-fullscreen,.xgplayer-skin-default .xgplayer-fullscreen-img{position:relative;order:13;display:block;cursor:pointer;margin-right:8px}.xgplayer-skin-default .xgplayer-fullscreen-img .xgplayer-icon div,.xgplayer-skin-default .xgplayer-fullscreen .xgplayer-icon div{position:absolute}.xgplayer-skin-default .xgplayer-fullscreen-img .xgplayer-icon .xgplayer-icon-requestfull,.xgplayer-skin-default .xgplayer-fullscreen .xgplayer-icon .xgplayer-icon-requestfull{display:block}.xgplayer-skin-default .xgplayer-fullscreen-img .xgplayer-icon .xgplayer-icon-exitfull,.xgplayer-skin-default .xgplayer-fullscreen .xgplayer-icon .xgplayer-icon-exitfull{display:none}.xgplayer-skin-default .xgplayer-fullscreen-img .xgplayer-tips,.xgplayer-skin-default .xgplayer-fullscreen .xgplayer-tips{position:absolute;right:0;left:auto}.xgplayer-skin-default .xgplayer-fullscreen-img .xgplayer-tips .xgplayer-tip-requestfull,.xgplayer-skin-default .xgplayer-fullscreen .xgplayer-tips .xgplayer-tip-requestfull{display:block}.xgplayer-skin-default .xgplayer-fullscreen-img .xgplayer-tips .xgplayer-tip-exitfull,.xgplayer-skin-default .xgplayer-fullscreen .xgplayer-tips .xgplayer-tip-exitfull{display:none}.xgplayer-skin-default .xgplayer-fullscreen-img:hover,.xgplayer-skin-default .xgplayer-fullscreen:hover{opacity:.85}.xgplayer-skin-default .xgplayer-fullscreen-img:hover .xgplayer-tips,.xgplayer-skin-default .xgplayer-fullscreen:hover .xgplayer-tips{display:block}.xgplayer-skin-default .xgplayer-back{position:absolute;top:20px;left:16px;padding-left:constant(safe-area-inset-top);padding-left:env(safe-area-inset-top)}.xgplayer-skin-default .xgplayer-back .xgplayer-icon,.xgplayer-skin-default.xgplayer-inactive .xgplayer-back{display:none}.xgplayer-skin-default.xgplayer-is-fullscreen,.xgplayer-skin-default.xgplayer-rotate-fullscreen{overflow:initial}.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen-img .xgplayer-icon .xgplayer-icon-requestfull,.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen .xgplayer-icon .xgplayer-icon-requestfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen-img .xgplayer-icon .xgplayer-icon-requestfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen .xgplayer-icon .xgplayer-icon-requestfull{display:none}.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen-img .xgplayer-icon .xgplayer-icon-exitfull,.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen .xgplayer-icon .xgplayer-icon-exitfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen-img .xgplayer-icon .xgplayer-icon-exitfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen .xgplayer-icon .xgplayer-icon-exitfull{display:block}.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen-img .xgplayer-tips .xgplayer-tip-requestfull,.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen .xgplayer-tips .xgplayer-tip-requestfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen-img .xgplayer-tips .xgplayer-tip-requestfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen .xgplayer-tips .xgplayer-tip-requestfull{display:none}.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-back .xgplayer-icon,.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen-img .xgplayer-tips .xgplayer-tip-exitfull,.xgplayer-skin-default.xgplayer-is-fullscreen .xgplayer-fullscreen .xgplayer-tips .xgplayer-tip-exitfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-back .xgplayer-icon,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen-img .xgplayer-tips .xgplayer-tip-exitfull,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-fullscreen .xgplayer-tips .xgplayer-tip-exitfull{display:block}.xgplayer-skin-default .xgplayer-loading{display:none;width:28px;height:28px;overflow:hidden;position:absolute;left:50%;top:50%;margin:-14px auto auto -14px}.xgplayer-skin-default .xgplayer-loading div{width:8%;height:26%;background-color:#fff;position:absolute;left:44%;top:37%;opacity:0;border-radius:30px;animation:fade 1s linear infinite}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar1{transform:rotate(0) translateY(-142%);animation-delay:0s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar2{transform:rotate(30deg) translateY(-142%);animation-delay:-.9163s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar3{transform:rotate(60deg) translateY(-142%);animation-delay:-.833s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar4{transform:rotate(90deg) translateY(-142%);animation-delay:-.7497s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar5{transform:rotate(120deg) translateY(-142%);animation-delay:-.6664s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar6{transform:rotate(150deg) translateY(-142%);animation-delay:-.5831s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar7{transform:rotate(180deg) translateY(-142%);animation-delay:-.4998s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar8{transform:rotate(210deg) translateY(-142%);animation-delay:-.4165s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar9{transform:rotate(240deg) translateY(-142%);animation-delay:-.3332s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar10{transform:rotate(270deg) translateY(-142%);animation-delay:-.2499s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar11{transform:rotate(300deg) translateY(-142%);animation-delay:-.1666s}.xgplayer-skin-default .xgplayer-loading div.xgplayer-loading-bar12{transform:rotate(330deg) translateY(-142%);animation-delay:-.0833s}@keyframes fade{0%{opacity:1}to{opacity:.25}}.xgplayer-skin-default.xgplayer-nostart .xgplayer-loading{display:none}.xgplayer-skin-default.xgplayer-pause .xgplayer-loading{display:none!important}.xgplayer-skin-default.xgplayer-isloading .xgplayer-loading{display:block}.xgplayer-skin-default.xgplayer-is-enter .xgplayer-loading,.xgplayer-skin-default.xgplayer-will-play .xgplayer-loading{display:none!important}.xgplayer-skin-default .xgplayer-play,.xgplayer-skin-default .xgplayer-play-img{width:40px;position:relative;order:0;display:none;cursor:pointer;margin-left:3px}.xgplayer-skin-default .xgplayer-play-img .xgplayer-icon,.xgplayer-skin-default .xgplayer-play .xgplayer-icon{margin-top:3px;width:32px}.xgplayer-skin-default .xgplayer-play-img .xgplayer-icon div,.xgplayer-skin-default .xgplayer-play .xgplayer-icon div{position:absolute}.xgplayer-skin-default .xgplayer-play-img .xgplayer-icon .xgplayer-icon-play,.xgplayer-skin-default .xgplayer-play .xgplayer-icon .xgplayer-icon-play{display:block}.xgplayer-skin-default .xgplayer-play-img .xgplayer-icon .xgplayer-icon-pause,.xgplayer-skin-default .xgplayer-play .xgplayer-icon .xgplayer-icon-pause{display:none}.xgplayer-skin-default .xgplayer-play-img .xgplayer-tips .xgplayer-tip-play,.xgplayer-skin-default .xgplayer-play .xgplayer-tips .xgplayer-tip-play{display:block}.xgplayer-skin-default .xgplayer-play-img .xgplayer-tips .xgplayer-tip-pause,.xgplayer-skin-default .xgplayer-play .xgplayer-tips .xgplayer-tip-pause{display:none}.xgplayer-skin-default .xgplayer-play-img:hover,.xgplayer-skin-default .xgplayer-play:hover{opacity:.85}.xgplayer-skin-default .xgplayer-play-img:hover .xgplayer-tips,.xgplayer-skin-default .xgplayer-play:hover .xgplayer-tips{display:block}.xgplayer-skin-default.xgplayer-playing .xgplayer-play-img .xgplayer-icon .xgplayer-icon-play,.xgplayer-skin-default.xgplayer-playing .xgplayer-play .xgplayer-icon .xgplayer-icon-play{display:none}.xgplayer-skin-default.xgplayer-playing .xgplayer-play-img .xgplayer-icon .xgplayer-icon-pause,.xgplayer-skin-default.xgplayer-playing .xgplayer-play .xgplayer-icon .xgplayer-icon-pause{display:block}.xgplayer-skin-default.xgplayer-playing .xgplayer-play-img .xgplayer-tips .xgplayer-tip-play,.xgplayer-skin-default.xgplayer-playing .xgplayer-play .xgplayer-tips .xgplayer-tip-play{display:none}.xgplayer-skin-default.xgplayer-pause .xgplayer-play-img .xgplayer-icon .xgplayer-icon-play,.xgplayer-skin-default.xgplayer-pause .xgplayer-play .xgplayer-icon .xgplayer-icon-play,.xgplayer-skin-default.xgplayer-playing .xgplayer-play-img .xgplayer-tips .xgplayer-tip-pause,.xgplayer-skin-default.xgplayer-playing .xgplayer-play .xgplayer-tips .xgplayer-tip-pause{display:block}.xgplayer-skin-default.xgplayer-pause .xgplayer-play-img .xgplayer-icon .xgplayer-icon-pause,.xgplayer-skin-default.xgplayer-pause .xgplayer-play .xgplayer-icon .xgplayer-icon-pause{display:none}.xgplayer-skin-default.xgplayer-pause .xgplayer-play-img .xgplayer-tips .xgplayer-tip-play,.xgplayer-skin-default.xgplayer-pause .xgplayer-play .xgplayer-tips .xgplayer-tip-play{display:block}.xgplayer-skin-default.xgplayer-pause .xgplayer-play-img .xgplayer-tips .xgplayer-tip-pause,.xgplayer-skin-default.xgplayer-pause .xgplayer-play .xgplayer-tips .xgplayer-tip-pause,.xgplayer-skin-default.xgplayer-show-control .xgplayer-play-img .xgplayer-icon .xgplayer-icon-play,.xgplayer-skin-default.xgplayer-show-control .xgplayer-play .xgplayer-icon .xgplayer-icon-play{display:none}.xgplayer-skin-default.xgplayer-show-control .xgplayer-play-img .xgplayer-icon .xgplayer-icon-pause,.xgplayer-skin-default.xgplayer-show-control .xgplayer-play-img .xgplayer-tips .xgplayer-tip-play,.xgplayer-skin-default.xgplayer-show-control .xgplayer-play .xgplayer-icon .xgplayer-icon-pause,.xgplayer-skin-default.xgplayer-show-control .xgplayer-play .xgplayer-tips .xgplayer-tip-play{display:block}.xgplayer-skin-default.xgplayer-show-control .xgplayer-play-img .xgplayer-tips .xgplayer-tip-pause,.xgplayer-skin-default.xgplayer-show-control .xgplayer-play .xgplayer-tips .xgplayer-tip-pause{display:none}.xgplayer-skin-default .xgplayer-volume{outline:none;order:1;width:36px;height:40px;display:flex;align-items:center;z-index:18;margin-left:8px;padding-left:8px}.xgplayer-skin-default .xgplayer-volume .xgplayer-icon{width:24px;height:22px}.xgplayer-skin-default .xgplayer-volume .xgplayer-icon .xgplayer-icon-large{display:block}.xgplayer-skin-default .xgplayer-volume .xgplayer-icon .xgplayer-icon-muted,.xgplayer-skin-default .xgplayer-volume .xgplayer-icon .xgplayer-icon-small{display:none}.xgplayer-skin-default .xgplayer-slider{display:none;position:absolute;width:28px;height:92px;background:rgba(0,0,0,.54);border-radius:1px;bottom:42px;outline:none}.xgplayer-skin-default .xgplayer-slider:after{content:" ";display:block;height:15px;width:28px;position:absolute;bottom:-15px;left:0;z-index:20}.xgplayer-skin-default .xgplayer-bar,.xgplayer-skin-default .xgplayer-drag{display:block;position:absolute;bottom:6px;left:12px;background:hsla(0,0%,100%,.3);border-radius:100px;width:5px;height:76px;outline:none;cursor:pointer}.xgplayer-skin-default .xgplayer-drag{bottom:0;left:0;background:#fa1f41;max-height:76px}.xgplayer-skin-default .xgplayer-drag:after{content:" ";display:inline-block;width:8px;height:8px;background:#fff;box-shadow:0 0 5px #00000042;position:absolute;border-radius:50%;left:-2px;top:-6px}.xgplayer-skin-default.xgplayer-volume-active .xgplayer-slider,.xgplayer-skin-default.xgplayer-volume-large .xgplayer-volume .xgplayer-icon .xgplayer-icon-large{display:block}.xgplayer-skin-default.xgplayer-volume-large .xgplayer-volume .xgplayer-icon .xgplayer-icon-muted,.xgplayer-skin-default.xgplayer-volume-large .xgplayer-volume .xgplayer-icon .xgplayer-icon-small,.xgplayer-skin-default.xgplayer-volume-small .xgplayer-volume .xgplayer-icon .xgplayer-icon-large{display:none}.xgplayer-skin-default.xgplayer-volume-small .xgplayer-volume .xgplayer-icon .xgplayer-icon-small{display:block}.xgplayer-skin-default.xgplayer-volume-muted .xgplayer-volume .xgplayer-icon .xgplayer-icon-large,.xgplayer-skin-default.xgplayer-volume-muted .xgplayer-volume .xgplayer-icon .xgplayer-icon-small,.xgplayer-skin-default.xgplayer-volume-small .xgplayer-volume .xgplayer-icon .xgplayer-icon-muted{display:none}.xgplayer-skin-default.xgplayer-volume-muted .xgplayer-volume .xgplayer-icon .xgplayer-icon-muted{display:block}.xgplayer-skin-default.xgplayer-mobile .xgplayer-volume .xgplayer-slider{display:none}.xgplayer-skin-default .xgplayer-progress{flex:1;height:20px;line-height:20px;left:12px;right:12px;outline:none;top:-15px;z-index:35;order:3;display:flex;align-items:center}.xgplayer-skin-default .xgplayer-progress-outer{background:hsla(0,0%,100%,.3);display:block;height:2px;line-height:2px;width:100%;position:relative;cursor:pointer}.xgplayer-skin-default .xgplayer-progress-cache,.xgplayer-skin-default .xgplayer-progress-played{display:block;height:100%;line-height:1;position:absolute;left:0;top:0}.xgplayer-skin-default .xgplayer-progress-cache{width:0;background:hsla(0,0%,100%,.5)}.xgplayer-skin-default .xgplayer-progress-played{display:block;width:0;background:#fff;border-radius:0 1.5px 1.5px 0}.xgplayer-skin-default .xgplayer-progress-btn{display:none;position:absolute;left:0;top:-5px;width:13px;height:13px;border-radius:30px;background:#fff;box-shadow:0 0 2px #00000042;left:100%;transform:translate(-50%);z-index:36}.xgplayer-skin-default .xgplayer-progress-btn:after{content:"";position:absolute;top:-16px;left:-16px;right:-16px;bottom:-16px}.xgplayer-skin-default .xgplayer-progress-point{position:absolute}.xgplayer-skin-default .xgplayer-progress-point.xgplayer-tips{margin-left:0;top:-25px;display:none;z-index:100}.xgplayer-skin-default .xgplayer-progress-dot{display:inline-block;position:absolute;height:3px;width:5px;top:0;background:#fff;border-radius:6px;z-index:16}.xgplayer-skin-default .xgplayer-progress-dot .xgplayer-progress-tip{position:absolute;bottom:200%;right:50%;transform:translate(50%);height:auto;line-height:30px;width:auto;background:rgba(0,0,0,.3);border-radius:6px;border:1px solid rgba(0,0,0,.8);cursor:default;white-space:nowrap;display:none}.xgplayer-skin-default .xgplayer-progress-dot-show .xgplayer-progress-tip{display:block}.xgplayer-skin-default .xgplayer-progress-thumbnail{position:absolute;box-sizing:border-box}.xgplayer-skin-default .xgplayer-progress-thumbnail.xgplayer-tips{margin-left:0;display:none;z-index:99}.xgplayer-skin-default .xgplayer-coverpreview{position:absolute;width:100%;height:100%;top:0;left:0;display:none}.xgplayer-skin-default .xgplayer-coverpreview .xgplayer-coverpreview-outer{position:absolute;display:block;top:50%;left:50%;transform:translate(-50%,-50%)}.xgplayer-skin-default .xgplayer-coverpreview .xgplayer-coverpreview-outer .xgplayer-coverpreview-thumbnail{display:block}.xgplayer-skin-default .xgplayer-coverpreview .xgplayer-coverpreview-outer .xgplayer-coverpreview-point{display:block;text-align:center;font-family:PingFangSC-Regular;font-size:11px;color:#ccc;padding:2px 4px;position:relative}.xgplayer-skin-default .xgplayer-coverpreview .xgplayer-coverpreview-outer .xgplayer-coverpreview-point span{color:#fff}.xgplayer-skin-default .xgplayer-progress:focus .xgplayer-progress-dot,.xgplayer-skin-default .xgplayer-progress:focus .xgplayer-progress-outer,.xgplayer-skin-default .xgplayer-progress:hover .xgplayer-progress-dot,.xgplayer-skin-default .xgplayer-progress:hover .xgplayer-progress-outer{height:6px}.xgplayer-skin-default .xgplayer-progress:focus .xgplayer-progress-btn,.xgplayer-skin-default .xgplayer-progress:hover .xgplayer-progress-btn{display:block;top:-3px}.xgplayer-skin-default.xgplayer-definition-active .xgplayer-progress,.xgplayer-skin-default.xgplayer-playbackrate-active .xgplayer-progress,.xgplayer-skin-default.xgplayer-texttrack-active .xgplayer-progress,.xgplayer-skin-default.xgplayer-volume-active .xgplayer-progress{z-index:15}.xgplayer-skin-default.xgplayer-mobile .xgplayer-progress-btn{display:block!important}.xgplayer-skin-default.xgplayer-mobile .xgplayer-progress:focus .xgplayer-progress-outer,.xgplayer-skin-default.xgplayer-mobile .xgplayer-progress:hover .xgplayer-progress-outer{height:3px!important;margin-top:1px}.xgplayer-skin-default.xgplayer-mobile .xgplayer-progress:focus .xgplayer-progress-btn,.xgplayer-skin-default.xgplayer-mobile .xgplayer-progress:hover .xgplayer-progress-btn{display:block!important;top:-5px!important}.xgplayer-skin-default .xgplayer-poster{position:absolute;left:0;top:0;width:100%;height:100%;z-index:100;background-size:contain;background-position:50%;background-repeat:no-repeat;background-color:#000;opacity:0;pointer-events:none}.xgplayer-skin-default.xgplayer-is-enter .xgplayer-poster,.xgplayer-skin-default.xgplayer-nostart .xgplayer-poster,.xgplayer-skin-default.xgplayer-will-play .xgplayer-poster{opacity:1}.xgplayer-skin-default .xgplayer-time{order:2;color:#fff;height:40px;margin:0 6px 0 0;min-width:52px;display:flex;align-items:center;justify-content:flex-end}.xgplayer-skin-default .xgplayer-time span{font-size:15px;line-height:normal;transform:scale(.8)}.xgplayer-skin-default .xgplayer-duration{order:4;color:#ffffff80;height:40px;text-align:center;margin:0 6px;min-width:36px;display:flex;align-items:center}.xgplayer-skin-default .xgplayer-duration span{font-size:15px;line-height:normal;transform:scale(.8)}.xgplayer-skin-default .xgplayer-playbackrate{order:8;z-index:18;position:relative;display:inline-block;cursor:default}.xgplayer-skin-default .xgplayer-playbackrate ul{display:none;list-style:none;width:78px;background:rgba(0,0,0,.54);border-radius:1px;position:absolute;bottom:30px;left:50%;transform:translate(-50%);text-align:left;white-space:nowrap;z-index:26;cursor:pointer}.xgplayer-skin-default .xgplayer-playbackrate ul li{opacity:.7;font-family:PingFangSC-Regular;font-size:11px;color:#fffc;position:relative;padding:4px 0;text-align:center}.xgplayer-skin-default .xgplayer-playbackrate ul li.selected,.xgplayer-skin-default .xgplayer-playbackrate ul li:hover{color:#fff;opacity:1}.xgplayer-skin-default .xgplayer-playbackrate ul li:first-child{position:relative;margin-top:12px}.xgplayer-skin-default .xgplayer-playbackrate ul li:last-child{position:relative;margin-bottom:12px}.xgplayer-skin-default .xgplayer-playbackrate .name{order:2;height:28px;font-family:ArialMT;font-size:14px;color:#fff;text-align:center;display:inline-block;margin:auto 8px;display:flex;align-items:center;justify-content:center;background-color:transparent}.xgplayer-skin-default .xgplayer-playbackrate span{position:relative;top:19px;font-weight:700;text-shadow:0 0 4px rgba(0,0,0,.6)}.xgplayer-skin-default .xgplayer-playbackrate:hover{opacity:1}.xgplayer-skin-default .xgplayer-playbackrate-list{display:none;position:absolute;bottom:30px;left:50%;transform:translate(-50%);padding:10px 25px;background:rgba(0,0,0,.65);border-radius:12px}.xgplayer-skin-default .xgplayer-playbackrate-list ul{display:flex}.xgplayer-skin-default .xgplayer-playbackrate-list ul li{font-family:PingFangSC-Regular;font-size:14px;color:#ffffffa6;display:flex;align-items:center;justify-content:center;margin-right:27px}.xgplayer-skin-default .xgplayer-playbackrate-list ul li:last-child{margin-right:0}.xgplayer-skin-default .xgplayer-playbackrate-list ul li.selected{color:#fff;opacity:1;font-size:16px}.xgplayer-skin-default .xgplayer-playbackrate-list ul li:hover{color:#fff;opacity:1}.xgplayer-skin-default .xgplayer-playbackrate-list:hover{opacity:1}.xgplayer-skin-default.xgplayer-playbackrate-active .xgplayer-playbackrate-list,.xgplayer-skin-default.xgplayer-playbackrate-active .xgplayer-playbackrate ul{display:block}.xgplayer-skin-default.xgplayer-rotate-fullscreen.xgplayer-landscape .xgplayer-playbackrate-list{width:200px;left:auto;right:34px;transform:none;padding:0 12px}.xgplayer-skin-default.xgplayer-rotate-fullscreen.xgplayer-landscape .xgplayer-playbackrate-list ul{justify-content:center;flex-direction:column}.xgplayer-skin-default.xgplayer-rotate-fullscreen.xgplayer-landscape .xgplayer-playbackrate-list ul li{margin-right:0;display:flex;align-items:center;height:56px;font-size:14px}.xgplayer-skin-default.xgplayer-rotate-fullscreen.xgplayer-landscape .xgplayer-playbackrate-list ul li.selected{color:#fff;opacity:1;font-size:20px}.xgplayer-skin-default .xgplayer-replay{position:absolute;left:0;top:0;width:100%;height:100%;z-index:105;display:none;justify-content:center;align-items:center;flex-direction:column;background:rgba(0,0,0,.7);padding-bottom:10px}.xgplayer-skin-default .xgplayer-replay svg{border-radius:100%;cursor:pointer}.xgplayer-skin-default .xgplayer-replay svg path{transform:translate(20px,21px);fill:#fff}.xgplayer-skin-default .xgplayer-replay svg:hover path{fill:#fff}.xgplayer-skin-default .xgplayer-replay .xgplayer-replay-txt{display:inline-block;font-family:PingFangSC-Regular;font-size:14px;color:#ffffffb3;line-height:16px}.xgplayer-skin-default.xgplayer.xgplayer-ended .xgplayer-controls{display:none}.xgplayer-skin-default.xgplayer.xgplayer-ended .xgplayer-replay{display:flex}.xgplayer-skin-default.xgplayer.xgplayer-no-controls:not(.xgplayer-rotate-fullscreen) .xgplayer-replay{display:none}.xgplayer-skin-default .xgplayer-start{border-radius:50%;display:inline-block;width:70px;height:70px;background:transparent;overflow:hidden;text-align:center;line-height:70px;vertical-align:middle;position:absolute;left:50%;top:50%;z-index:115;margin:-35px auto auto -35px;cursor:pointer;display:none;transform-origin:center;transform:scale(.8)}.xgplayer-skin-default .xgplayer-start div{position:absolute}.xgplayer-skin-default .xgplayer-start div svg{background-color:#000000b3;fill:#fff}.xgplayer-skin-default .xgplayer-start .xgplayer-icon-play{display:block}.xgplayer-skin-default .xgplayer-start .xgplayer-icon-pause{display:none}.xgplayer-skin-default .xgplayer-start:hover{opacity:.85}.xgplayer-skin-default .xgplayer-shade{display:none;position:absolute;top:0;left:0;width:100%;height:100%;z-index:101;background:rgba(0,0,0,.2);pointer-events:none}.xgplayer-skin-default.xgplayer-playing .xgplayer-start,.xgplayer-skin-default.xgplayer-playing .xgplayer-start .xgplayer-icon-play{display:none}.xgplayer-skin-default.xgplayer-is-enter .xgplayer-shade,.xgplayer-skin-default.xgplayer-nostart .xgplayer-shade,.xgplayer-skin-default.xgplayer-nostart .xgplayer-start,.xgplayer-skin-default.xgplayer-playing .xgplayer-start .xgplayer-icon-pause{display:block}.xgplayer-skin-default.xgplayer-is-enter .xgplayer-start{display:none}.xgplayer-skin-default.xgplayer-show-control .xgplayer-start{display:inline-block}.xgplayer-skin-default.xgplayer-show-control .xgplayer-start .xgplayer-icon-play{display:none}.xgplayer-skin-default.xgplayer-show-control .xgplayer-start .xgplayer-icon-pause{display:block}.xgplayer-skin-default.xgplayer-pause .xgplayer-shade{display:block;z-index:9}.xgplayer-skin-default.xgplayer-pause .xgplayer-start{display:inline-block}.xgplayer-skin-default.xgplayer-pause .xgplayer-start .xgplayer-icon-play{display:block}.xgplayer-skin-default.xgplayer-is-replay .xgplayer-start,.xgplayer-skin-default.xgplayer-pause .xgplayer-start .xgplayer-icon-pause{display:none}.xgplayer-skin-default.xgplayer-is-replay .xgplayer-start .xgplayer-icon-play{display:block}.xgplayer-skin-default.xgplayer-is-replay .xgplayer-start .xgplayer-icon-pause,.xgplayer-skin-default.xgplayer-no-controls:not(.xgplayer-rotate-fullscreen) .xgplayer-shade,.xgplayer-skin-default.xgplayer-no-controls:not(.xgplayer-rotate-fullscreen) .xgplayer-start{display:none}.xgplayer-skin-default.xgplayer-is-enter .xgplayer-start,.xgplayer-skin-default.xgplayer-will-play .xgplayer-start{display:none!important}.xgplayer-skin-default .xgplayer-enter{display:none;position:absolute;left:0;top:0;width:100%;height:100%;z-index:120}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner{display:block;position:absolute;left:50%;top:50%;height:28px;width:28px;position:relative;transform:translate(-50%,-50%)}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div{width:8%;height:26%;background-color:#fff;position:absolute;left:44%;top:37%;opacity:0;border-radius:30px;animation:fade 1s linear infinite}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar1{transform:rotate(0) translateY(-142%);animation-delay:0s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar2{transform:rotate(30deg) translateY(-142%);animation-delay:-.9163s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar3{transform:rotate(60deg) translateY(-142%);animation-delay:-.833s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar4{transform:rotate(90deg) translateY(-142%);animation-delay:-.7497s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar5{transform:rotate(120deg) translateY(-142%);animation-delay:-.6664s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar6{transform:rotate(150deg) translateY(-142%);animation-delay:-.5831s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar7{transform:rotate(180deg) translateY(-142%);animation-delay:-.4998s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar8{transform:rotate(210deg) translateY(-142%);animation-delay:-.4165s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar9{transform:rotate(240deg) translateY(-142%);animation-delay:-.3332s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar10{transform:rotate(270deg) translateY(-142%);animation-delay:-.2499s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar11{transform:rotate(300deg) translateY(-142%);animation-delay:-.1666s}.xgplayer-skin-default .xgplayer-enter .xgplayer-enter-spinner div.xgplayer-enter-bar12{transform:rotate(330deg) translateY(-142%);animation-delay:-.0833s}@keyframes fade{0%{opacity:1}to{opacity:.25}}.xgplayer-skin-default.xgplayer-is-enter .xgplayer-enter,.xgplayer-skin-default.xgplayer-will-play .xgplayer-enter{transition:opacity 0s ease;transition-delay:.5s;display:block}.xgplayer-nav,.xgplayer-nav-fullscreen{position:absolute;top:0;left:0;right:0;height:44px;z-index:199;background:linear-gradient(0,transparent,rgba(0,0,0,.4));display:flex;justify-content:space-between}.xgplayer-nav-fullscreen .xgplayer-icon-nav-left,.xgplayer-nav .xgplayer-icon-nav-left{width:100%;height:100%;display:flex;align-items:center;padding-left:16px}.xgplayer-nav-fullscreen .xgplayer-icon-nav-right,.xgplayer-nav .xgplayer-icon-nav-right{width:100%;height:100%;display:flex;justify-content:flex-end;align-items:center;padding-right:16px}.xgplayer-nav:not(.xgplayer-nav-inline){display:none}.xgplayer-skin-default.xgplayer-inactive .xgplayer-nav:not(.xgplayer-nav-inline-lock),.xgplayer-skin-default.xgplayer.xgplayer-ended .xgplayer-nav:not(.xgplayer-nav-inline){transform:translateY(-100%);transition:all .5s linear;display:flex}.xgplayer-skin-default.xgplayer-ended.xgplayer-no-controls .xgplayer-nav:not(.xgplayer-nav-inline),.xgplayer-skin-default .xgplayer-nav-fullscreen,.xgplayer-skin-default.xgplayer-no-controls .xgplayer-nav:not(.xgplayer-nav-inline){display:none}.xgplayer-landscape .xgplayer-nav-fullscreen{padding-top:10px;padding-left:20px;padding-right:20px;padding-left:constant(safe-area-inset-top);padding-left:env(safe-area-inset-top);padding-right:constant(safe-area-inset-bottom);padding-right:env(safe-area-inset-bottom)}.xgplayer-portrait .xgplayer-nav-fullscreen{padding-top:20px;padding-top:constant(safe-area-inset-top);padding-top:env(safe-area-inset-top)}.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-nav{display:none}.xgplayer-skin-default.xgplayer-is-cssfullscreen .xgplayer-nav-fullscreen,.xgplayer-skin-default.xgplayer-rotate-fullscreen .xgplayer-nav-fullscreen{display:block}.xgplayer-skin-default.xgplayer-is-cssfullscreen.xgplayer-inactive .xgplayer-nav-fullscreen,.xgplayer-skin-default.xgplayer-rotate-fullscreen.xgplayer-inactive .xgplayer-nav-fullscreen{transform:translateY(-100%);transition:all .5s linear;transition-delay:1s;display:flex}.xgplayer-skin-default .xgplayer-error{background:#000;display:none;position:absolute;left:0;top:0;width:100%;height:100%;z-index:125;font-family:PingFangSC-Regular;font-size:14px;color:#fff;text-align:center;line-height:100%;justify-content:center;align-items:center}.xgplayer-skin-default .xgplayer-error .xgplayer-error-refresh{color:#fa1f41;padding:0 3px;cursor:pointer}.xgplayer-skin-default .xgplayer-error .xgplayer-error-text{line-height:18px;margin:auto 6px}.xgplayer-skin-default.xgplayer-is-error .xgplayer-error{display:flex}.xgplayer-skin-default{overflow:hidden;width:100%;height:100%;position:relative;-webkit-user-select:none;user-select:none;-ms-user-select:none;background:#000}.xgplayer-skin-default *{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}.xgplayer-skin-default .xg-shade{display:none;position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.2);z-index:1}.xgplayer-skin-default.xgplayer-nostart .xg-shade{display:block}.xgplayer-skin-default.xgplayer-rotate-fullscreen{position:fixed;top:0;left:100%;bottom:0;right:0;height:100vw!important;width:100vh!important;transform-origin:top left;transform:rotate(90deg);bottom:constant(safe-area-inset-bottom);bottom:env(safe-area-inset-bottom)}.xgplayer-skin-default.xgplayer-is-fullscreen{width:100%!important;height:100%!important;padding-top:0!important;z-index:9999}.xgplayer-skin-default.xgplayer-is-fullscreen.xgplayer-inactive{cursor:none}.xgplayer-skin-default video{width:100%;height:100%;outline:none}.xgplayer-skin-default .xgplayer-none{display:none}@keyframes loadingRotate{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes loadingDashOffset{0%{stroke-dashoffset:236}to{stroke-dashoffset:0}}.xgplayer-skin-default .xgplayer-controls{display:flex;position:absolute;bottom:0;left:0;right:0;height:56px;padding-top:8px;background:linear-gradient(180deg,transparent,rgba(0,0,0,.2));z-index:10;align-items:center}.xgplayer-skin-default.xgplayer-inactive .xgplayer-controls{transform:translateY(100%);transition:all .5s linear;transition-delay:1s;display:flex}.xgplayer-skin-default.xgplayer-nostart .xgplayer-controls{display:none}.xgplayer-skin-default.xgplayer-no-controls.xgplayer-rotate-fullscreen .xgplayer-controls{display:flex}.xgplayer-skin-default.xgplayer-is-live .xgplayer-controls .xgplayer-progress,.xgplayer-skin-default.xgplayer-is-live .xgplayer-controls .xgplayer-time{display:none}.xgplayer-skin-default.xgplayer-is-live .xgplayer-controls .xgplayer-live{display:block}.xgplayer-landscape.xgplayer-rotate-fullscreen .xgplayer-controls{padding-left:20px;padding-right:20px;padding-left:constant(safe-area-inset-top);padding-left:env(safe-area-inset-top);padding-right:constant(safe-area-inset-bottom);padding-right:env(safe-area-inset-bottom)}.xgplayer-portrait.xgplayer-rotate-fullscreen .xgplayer-controls{box-sizing:content-box;padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}.xgplayer-skin-default .xgplayer-live{display:block;font-size:12px;color:#fff;line-height:40px;order:1}.xgplayer-skin-default .xgplayer-icon{display:block;width:40px;height:40px;overflow:hidden;fill:#fff}.xgplayer-skin-default .xgplayer-icon svg{position:relative}.xgplayer-skin-default .xgplayer-tips{background:rgba(0,0,0,.54);border-radius:1px;display:none;position:absolute;font-family:PingFangSC-Regular;font-size:11px;color:#fff;padding:2px 4px;text-align:center;top:-30px;left:50%;margin-left:-16px;width:auto;white-space:nowrap}.xgplayer-skin-default.xgplayer-mobile .xgplayer-tips{display:none!important}.xgplayer-skin-default .xgplayer-screen-container,.xgplayer-skin-default .xgplayer-screen-container .xgplayer-screen-canvas{width:100%;height:100%}.vac-fade-spinner-enter-from{opacity:0}.vac-fade-spinner-enter-active{transition:opacity .8s}.vac-fade-spinner-leave-active{transition:opacity .2s;opacity:0}.vac-fade-image-enter-from{opacity:0}.vac-fade-image-enter-active{transition:opacity 1s}.vac-fade-image-leave-active{transition:opacity .5s;opacity:0}.vac-fade-message-enter-from{opacity:0}.vac-fade-message-enter-active{transition:opacity .5s}.vac-fade-message-leave-active{transition:opacity .2s;opacity:0}.vac-slide-left-enter-active,.vac-slide-right-enter-active{transition:all .3s ease;transition-property:transform,opacity}.vac-slide-left-leave-active,.vac-slide-right-leave-active{transition:all .2s cubic-bezier(1,.5,.8,1)!important;transition-property:transform,opacity}.vac-slide-left-enter-from,.vac-slide-left-leave-to{transform:translate(10px);opacity:0}.vac-slide-right-enter-from,.vac-slide-right-leave-to{transform:translate(-10px);opacity:0}.vac-slide-up-enter-active{transition:all .3s ease}.vac-slide-up-leave-active{transition:all .2s cubic-bezier(1,.5,.8,1)}.vac-slide-up-enter-from,.vac-slide-up-leave-to{transform:translateY(10px);opacity:0}.vac-bounce-enter-active{animation:vac-bounce-in .5s}.vac-bounce-leave-active{animation:vac-bounce-in .3s reverse}@keyframes vac-bounce-in{0%{transform:scale(0)}50%{transform:scale(1.05)}to{transform:scale(1)}}.vac-fade-preview-enter{opacity:0}.vac-fade-preview-enter-active{transition:opacity .1s}.vac-fade-preview-leave-active{transition:opacity .2s;opacity:0}.vac-bounce-preview-enter-active{animation:vac-bounce-image-in .4s}.vac-bounce-preview-leave-active{animation:vac-bounce-image-in .3s reverse}@keyframes vac-bounce-image-in{0%{transform:scale(.6)}to{transform:scale(1)}}.vac-menu-list{border-radius:4px;display:block;cursor:pointer;background:var(--chat-dropdown-bg-color);padding:6px 0}.vac-menu-list :hover{background:var(--chat-dropdown-bg-color-hover);transition:background-color .3s cubic-bezier(.25,.8,.5,1)}.vac-menu-list :not(:hover){transition:background-color .3s cubic-bezier(.25,.8,.5,1)}.vac-menu-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;min-height:30px;padding:5px 16px;position:relative;white-space:nowrap;line-height:30px}.vac-menu-options{position:absolute;right:10px;top:20px;z-index:9999;min-width:150px;display:inline-block;border-radius:4px;font-size:14px;color:var(--chat-color);overflow-y:auto;overflow-x:hidden;contain:content;box-shadow:0 2px 2px -4px #0000001a,0 2px 2px 1px #0000001f,0 1px 8px 1px #0000001f}.vac-app-border{border:var(--chat-border-style)}.vac-app-border-t{border-top:var(--chat-border-style)}.vac-app-border-r{border-right:var(--chat-border-style)}.vac-app-border-b{border-bottom:var(--chat-border-style)}.vac-app-box-shadow{transition:all .5s;box-shadow:0 2px 2px -4px #0000001a,0 2px 2px 1px #0000001f,0 1px 8px 1px #0000001f}.vac-item-clickable{cursor:pointer}.vac-vertical-center{display:flex;align-items:center;height:100%}.vac-vertical-center .vac-vertical-container{width:100%;text-align:center}.vac-svg-button{max-height:30px;display:flex;cursor:pointer;transition:all .2s}.vac-svg-button:hover{transform:scale(1.1);opacity:.7}.vac-avatar{background-size:cover;background-position:center center;background-repeat:no-repeat;background-color:#ddd;height:42px;width:42px;min-height:42px;min-width:42px;margin-right:15px;border-radius:50%}.vac-blur-loading{filter:blur(3px)}.vac-badge-counter{height:13px;width:auto;min-width:13px;border-radius:50%;display:flex;align-items:center;justify-content:center;padding:3px;font-size:11px;font-weight:500}.vac-text-ellipsis{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vac-text-tag{color:var(--chat-message-color-tag);cursor:pointer}.vac-file-container{display:flex;align-content:center;justify-content:center;flex-wrap:wrap;text-align:center;background:var(--chat-bg-color-input);border:var(--chat-border-style-input);border-radius:4px;padding:10px}.vac-file-container svg{height:28px;width:28px}.vac-file-container .vac-text-extension{font-size:12px;color:var(--chat-message-color-file-extension);margin-top:-2px}.markdown p{margin:0}.markdown ol{display:flex;flex-direction:column;list-style-position:inside}.markdown ul{display:flex;flex-direction:column}.markdown code{display:block;font-size:12px;color:var(--chat-markdown-color-multi);background:var(--chat-markdown-bg);border:1px solid var(--chat-markdown-border);border-radius:3px;margin:4px 0;padding:7px}.markdown p code{display:inline-block;font-size:12px;color:var(--chat-markdown-color);background:var(--chat-markdown-bg);border:1px solid var(--chat-markdown-border);border-radius:3px;margin:2px 0;padding:2px 3px}.vac-card-window{width:100%;display:block;max-width:100%;background:var(--chat-content-bg-color);color:var(--chat-color);overflow-wrap:break-word;white-space:normal;border:var(--chat-container-border);border-radius:var(--chat-container-border-radius);box-shadow:var(--chat-container-box-shadow);-webkit-tap-highlight-color:transparent}.vac-card-window.vac-card-window-customer{box-shadow:none}.vac-card-window *{font-family:inherit}.vac-card-window a{color:#0d579c;font-weight:500}.vac-card-window .vac-chat-container{height:100%;display:flex}.vac-card-window .vac-chat-container input{min-width:10px}.vac-card-window .vac-chat-container textarea,.vac-card-window .vac-chat-container input[type=text],.vac-card-window .vac-chat-container input[type=search]{-webkit-appearance:none}.vac-media-preview{position:fixed;top:0;left:0;z-index:2000;width:100vw;height:100vh;display:flex;align-items:center;background-color:#000c;outline:none}.vac-media-preview .vac-media-preview-container{height:calc(100% - 140px);width:calc(100% - 80px);padding:70px 40px;margin:0 auto}.vac-media-preview .vac-media-preview-container::webkit-scrollbar{display:none}.vac-media-preview .vac-image-preview-custom-container{height:100%;width:100%;margin:0 auto;display:flex;align-items:center;justify-content:center;flex-direction:column;overflow:scroll}.vac-media-preview .vac-image-preview-custom-container .vac-image-preview-custom{width:100%;background-size:cover;background-position:center center;background-repeat:no-repeat}.vac-media-preview .vac-image-preview{width:100%;height:100%;background-size:contain;background-repeat:no-repeat;background-position:center}.vac-media-preview video{width:100%;height:100%}.vac-media-preview .vac-svg-button{position:absolute;top:30px;right:30px;transform:scale(1.4)}@media only screen and (max-width: 768px){.vac-media-preview .vac-svg-button{top:40px;right:20px;transform:scale(1.2)}.vac-media-preview .vac-media-preview-container{width:calc(100% - 40px);padding:70px 20px}}.vac-col-messages{position:relative;height:100%;flex:1;overflow:hidden;display:flex;flex-flow:column}.vac-col-messages .vac-container-center{height:100%;width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center}.vac-col-messages .vac-room-empty{font-size:14px;color:#9ca6af;font-style:italic;line-height:20px;white-space:pre-line}.vac-col-messages .vac-room-empty div{padding:0 10%}.vac-col-messages .vac-container-wrapper{position:relative;background:var(--chat-content-bg-color);flex:1;display:flex;flex-direction:column;min-height:0}.vac-col-messages .vac-container-scroll{flex:1;overflow-y:auto;margin-right:1px;margin-top:65px;-webkit-overflow-scrolling:touch}.vac-col-messages .vac-container-scroll.vac-scroll-smooth{scroll-behavior:smooth}.vac-col-messages .vac-messages-container{padding:0 5px 5px}.vac-col-messages .vac-text-started{font-size:14px;color:var(--chat-message-color-started);font-style:italic;text-align:center;margin-top:25px;margin-bottom:20px}.vac-col-messages .vac-icon-scroll{position:absolute;bottom:20px;right:20px;padding:8px;background:var(--chat-bg-scroll-icon);border-radius:50%;box-shadow:0 1px 1px -1px #0003,0 1px 1px #00000024,0 1px 2px #0000001f;display:flex;cursor:pointer;z-index:220}.vac-col-messages .vac-icon-scroll svg{height:25px;width:25px}.vac-col-messages .vac-messages-count{position:absolute;top:-8px;left:11px;background-color:var(--chat-message-bg-color-scroll-counter);color:var(--chat-message-color-scroll-counter)}.vac-col-messages .vac-messages-hidden{opacity:0}.vac-col-messages .chat-top-bar{width:80%;text-align:center;position:sticky;top:6px;background-color:#f6e3cb;color:#333;margin:6px auto 0;z-index:210;font-size:12px;padding-top:3px;padding-bottom:3px}@media only screen and (max-width: 768px){.vac-col-messages .vac-container-scroll{margin-top:50px}.vac-col-messages .vac-text-started{margin-top:20px}}.vac-room-header{position:absolute;display:flex;align-items:center;height:64px;width:100%;z-index:10;margin-right:1px;background:var(--chat-header-bg-color);border-top-right-radius:var(--chat-container-border-radius)}.vac-room-header .vac-room-wrapper{display:flex;align-items:center;min-width:0;height:100%;width:100%;padding:0 16px}.vac-room-header .vac-toggle-button{margin-right:15px}.vac-room-header .vac-toggle-button svg{height:26px;width:26px}.vac-room-header .vac-rotate-icon{transform:rotate(180deg)!important}.vac-room-header .vac-rotate-icon-init{transform:rotate(360deg)}.vac-room-header .vac-info-wrapper,.vac-room-header .vac-room-selection{display:flex;align-items:center;min-width:0;width:100%;height:100%}.vac-room-header .vac-room-selection .vac-selection-button{padding:8px 16px;color:var(--chat-color-button);background-color:var(--chat-bg-color-button);border-radius:4px;margin-right:10px;cursor:pointer;transition:all .2s}.vac-room-header .vac-room-selection .vac-selection-button:hover{opacity:.7}.vac-room-header .vac-room-selection .vac-selection-button:active{opacity:.9}.vac-room-header .vac-room-selection .vac-selection-button .vac-selection-button-count{margin-left:6px;opacity:.9}.vac-room-header .vac-room-selection .vac-selection-cancel{display:flex;align-items:center;margin-left:auto;white-space:nowrap;color:var(--chat-color-button-clear);transition:all .2s}.vac-room-header .vac-room-selection .vac-selection-cancel:hover{opacity:.7}.vac-room-header .vac-room-name{font-size:17px;font-weight:500;line-height:22px;color:var(--chat-header-color-name)}.vac-room-header .vac-room-info{font-size:13px;line-height:18px;color:var(--chat-header-color-info)}.vac-room-header .vac-room-options{margin-left:auto}@media only screen and (max-width: 768px){.vac-room-header{height:50px}.vac-room-header .vac-room-wrapper{padding:0 10px}.vac-room-header .vac-room-name{font-size:16px;line-height:22px}.vac-room-header .vac-room-info{font-size:12px;line-height:16px}.vac-room-header .vac-avatar{height:37px;width:37px;min-height:37px;min-width:37px}}.vac-card-window-customer .vac-room-header{border-radius:0}.vac-card-window-customer .vac-info-wrapper{display:none}.vac-room-footer{width:100%;border-bottom-right-radius:4px;z-index:10}.vac-room-footer-fullscreen{z-index:2000}.vac-box-footer{display:flex;position:relative;background:var(--chat-footer-bg-color);padding:10px 8px}.vac-textarea{max-height:300px;overflow-y:auto;height:20px;width:100%;line-height:20px;outline:0;resize:none;border-radius:8px;padding:12px 16px;box-sizing:content-box;font-size:16px;background:var(--chat-bg-color-input);color:var(--chat-color);caret-color:var(--chat-color-caret);border:var(--chat-border-style-input)}.vac-textarea::placeholder{color:var(--chat-color-placeholder);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.vac-textarea-outline{border:1px solid var(--chat-border-color-input-selected);box-shadow:inset 0 0 0 1px var(--chat-border-color-input-selected)}.vac-icon-textarea,.vac-icon-textarea-left{display:flex;align-items:center}.vac-icon-textarea .custom-menu-icon,.vac-icon-textarea-left .custom-menu-icon{width:32px;height:32px;background:linear-gradient(180deg,#FDA732 0%,#FE6E43 100%);border-radius:50%;display:inline-flex;align-items:center;justify-content:center;transition:transform .3s ease}.vac-icon-textarea .rotate-45,.vac-icon-textarea-left .rotate-45{transform:rotate(45deg)}.vac-icon-textarea svg,.vac-icon-textarea .vac-wrapper,.vac-icon-textarea-left svg,.vac-icon-textarea-left .vac-wrapper{margin:0 7px}.vac-icon-textarea{margin-left:5px}.vac-icon-textarea-left{display:flex;align-items:center;margin-right:5px}.vac-icon-textarea-left svg,.vac-icon-textarea-left .vac-wrapper{margin:0 7px}.vac-icon-textarea-left .vac-icon-microphone{fill:var(--chat-icon-color-microphone);margin:0 7px}.vac-icon-textarea-left .vac-dot-audio-record{height:15px;width:15px;border-radius:50%;background-color:var(--chat-message-bg-color-audio-record);animation:vac-scaling .8s ease-in-out infinite alternate}@keyframes vac-scaling{0%{transform:scale(1);opacity:.4}to{transform:scale(1.1);opacity:1}}.vac-icon-textarea-left .vac-dot-audio-record-time{font-size:16px;color:var(--chat-color);margin-left:8px;width:45px}.vac-icon-textarea-left .vac-icon-audio-stop,.vac-icon-textarea-left .vac-icon-audio-confirm{min-height:28px;min-width:28px}.vac-icon-textarea-left .vac-icon-audio-stop svg,.vac-icon-textarea-left .vac-icon-audio-confirm svg{min-height:28px;min-width:28px}.vac-icon-textarea-left .vac-icon-audio-stop{margin-right:20px}.vac-icon-textarea-left .vac-icon-audio-stop #vac-icon-close-outline{fill:var(--chat-icon-color-audio-cancel)}.vac-icon-textarea-left .vac-icon-audio-confirm{margin-right:3px;margin-left:12px}.vac-icon-textarea-left .vac-icon-audio-confirm #vac-icon-checkmark{fill:var(--chat-icon-color-audio-confirm)}.vac-emoji-btn-mobile{position:relative;cursor:pointer}.vac-emoji-btn-mobile:after{content:"";position:absolute;top:-5px;bottom:-5px;left:0px;right:0px}.vac-send-disabled,.vac-send-disabled svg{cursor:none!important;pointer-events:none!important;transform:none!important}.send-icon{width:32px;height:32px}.opt-icon{position:relative;transition:transform .3s ease;margin-right:3px}.opt-icon:after{content:"";position:absolute;top:-5px;bottom:-5px;right:-5px;left:0}.upload-pic-icon{margin-right:5px}.upload-pic-icon img{width:100%}.send-btn{padding:0 16px;height:30px;background:#FDBB2B;border-radius:16px;font-weight:500;font-size:14px;color:#333;line-height:30px;margin-right:8px;position:relative}.send-btn.disabled{background:#9EA7B5;color:#ffffffb3}.send-btn:after{content:"";position:absolute;top:-6px;bottom:-6px;right:0;left:0}@media only screen and (max-width: 768px){.vac-room-footer{width:100%}.vac-box-footer{padding:7px 2px 7px 7px}.vac-box-footer.vac-box-footer-border{border-top:var(--chat-border-style-input)}.vac-textarea{padding:5px;line-height:24px;max-height:120px}.vac-textarea::placeholder{color:transparent}.vac-icon-textarea svg,.vac-icon-textarea .vac-wrapper,.vac-icon-textarea-left svg,.vac-icon-textarea-left .vac-wrapper{margin:0 3px!important}}.vac-emojis-container{width:calc(100% - 16px);padding:10px 8px;background:var(--chat-footer-bg-color);display:flex;align-items:center;overflow:auto}.vac-emojis-container .vac-emoji-element{padding:0 8px;font-size:30px;border-radius:4px;cursor:pointer;background:var(--chat-footer-bg-color-tag);transition:background-color .3s cubic-bezier(.25,.8,.5,1)}.vac-emojis-container .vac-emoji-element-active{background:var(--chat-footer-bg-color-tag-active)}@media only screen and (max-width: 768px){.vac-emojis-container{width:calc(100% - 10px);padding:7px 5px}.vac-emojis-container .vac-emoji-element{padding:0 7px;font-size:26px}}.vac-reply-container{display:flex;padding:10px 10px 0;background:var(--chat-footer-bg-color);align-items:center;width:calc(100% - 20px)}.vac-reply-container .vac-reply-box{width:100%;overflow:hidden;background:var(--chat-footer-bg-color-reply);border-radius:4px;padding:8px 10px}.vac-reply-container .vac-reply-info{overflow:hidden}.vac-reply-container .vac-reply-username{color:var(--chat-message-color-reply-username);font-size:12px;line-height:15px;margin-bottom:2px}.vac-reply-container .vac-reply-content{font-size:12px;color:var(--chat-message-color-reply-content);white-space:pre-line}.vac-reply-container .vac-icon-reply{margin-left:10px}.vac-reply-container .vac-icon-reply svg{height:20px;width:20px}.vac-reply-container .vac-image-reply{max-height:100px;max-width:200px;margin:4px 10px 0 0;border-radius:4px}.vac-reply-container .video-player{width:100px;height:100px}.vac-reply-container .vac-audio-reply{margin-right:10px}.vac-reply-container .vac-file-container{max-width:80px}@media only screen and (max-width: 768px){.vac-reply-container{padding:5px 8px;width:calc(100% - 16px)}}.vac-room-files-container{display:flex;align-items:center;padding:10px 6px 0;background:var(--chat-footer-bg-color)}.vac-room-files-container .vac-files-box{display:flex;overflow:auto;width:calc(100% - 30px)}.vac-room-files-container .video-player{width:100px;height:100px;border:var(--chat-border-style-input);border-radius:4px}.vac-room-files-container .vac-icon-close{margin-left:auto}.vac-room-files-container .vac-icon-close svg{height:20px;width:20px}@media only screen and (max-width: 768px){.vac-files-container{padding:6px 4px 4px 2px}}.vac-room-file-container{display:flex;position:relative;margin:0 4px}.vac-room-file-container .vac-message-image{position:relative;background-color:var(--chat-message-bg-color-image)!important;background-size:cover!important;background-position:center center!important;background-repeat:no-repeat!important;height:100px;width:100px;border:var(--chat-border-style-input);border-radius:4px;cursor:pointer}.vac-room-file-container .vac-file-container{height:80px;width:80px}.vac-room-file-container .vac-icon-remove{position:absolute;top:6px;left:6px;z-index:10}.vac-room-file-container .vac-icon-remove svg{height:20px;width:20px;border-radius:50%}.vac-room-file-container .vac-icon-remove:before{content:" ";position:absolute;width:100%;height:100%;background:rgba(0,0,0,.5);border-radius:50%;z-index:-1}.vac-tags-container{display:flex;flex-direction:column;align-items:center;width:100%}.vac-tags-container .vac-tags-box{display:flex;width:100%;height:54px;overflow:hidden;cursor:pointer;background:var(--chat-footer-bg-color-tag);transition:background-color .3s cubic-bezier(.25,.8,.5,1)}.vac-tags-container .vac-tags-box-active{background:var(--chat-footer-bg-color-tag-active)}.vac-tags-container .vac-tags-info{display:flex;overflow:hidden;padding:0 20px;align-items:center}.vac-tags-container .vac-tags-avatar{height:34px;width:34px;min-height:34px;min-width:34px}.vac-tags-container .vac-tags-username{font-size:14px}@media only screen and (max-width: 768px){.vac-tags-container .vac-tags-box{height:50px}.vac-tags-container .vac-tags-info{padding:0 12px}}.vac-template-container{display:flex;flex-direction:column;align-items:center;width:100%}.vac-template-container .vac-template-box{display:flex;width:100%;height:54px;overflow:hidden;cursor:pointer;background:var(--chat-footer-bg-color-tag);transition:background-color .3s cubic-bezier(.25,.8,.5,1)}.vac-template-container .vac-template-active{background:var(--chat-footer-bg-color-tag-active)}.vac-template-container .vac-template-info{display:flex;overflow:hidden;padding:0 20px;align-items:center}.vac-template-container .vac-template-tag{font-size:14px;font-weight:700;margin-right:10px}.vac-template-container .vac-template-text{font-size:14px}@media only screen and (max-width: 768px){.vac-template-container .vac-template-box{height:50px}.vac-template-container .vac-template-info{padding:0 12px}}.vac-room-bottom{transition-property:height;background:var(--chat-footer-bg-color)}.vac-room-bottom-safe-area{min-height:calc(env(safe-area-inset-top) * 2 / 3)}.send-menu-list{background:var(--chat-footer-bg-color);display:flex;flex-flow:row wrap;justify-content:space-around;padding:26px 0}.send-menu-item{display:inline-block}.send-menu-item .send-menu-item-card{width:64px;height:64px;background-color:#fff;display:inline-flex;justify-content:center;align-items:center;border-radius:10px;flex-flow:column nowrap;margin-bottom:10px}.send-menu-item .send-menu-item-card .menu-icon{width:32px}.send-menu-item .send-menu-item-title{text-align:center;font-weight:400;font-size:14px}.vac-rooms-container{display:flex;flex-flow:column;flex:0 0 25%;min-width:260px;max-width:500px;position:relative;background:var(--chat-sidemenu-bg-color);height:100%;border-top-left-radius:var(--chat-container-border-radius);border-bottom-left-radius:var(--chat-container-border-radius)}.vac-rooms-container.vac-rooms-container-full{flex:0 0 100%;max-width:100%}.vac-rooms-container .vac-rooms-empty{font-size:14px;color:#9ca6af;font-style:italic;text-align:center;margin:40px 0;line-height:20px;white-space:pre-line}.vac-rooms-container .vac-room-list{flex:1;position:relative;max-width:100%;padding:0 10px 5px;overflow-y:auto}.vac-rooms-container .network-exception{color:#ff4926;background-color:#ffeae5;padding:8px 4px;display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;border-radius:3px;font-size:12px}.vac-rooms-container .network-exception .warn-icon{display:inline-block;width:16px;height:16px;line-height:16px;text-align:center;background-color:#ff4926;color:#fff;border-radius:50%;margin:0 6px}.vac-rooms-container .network-exception .reconnect-btn{background-color:#fff;border:1px solid #ddd;border-radius:3px;margin-left:10px}.vac-rooms-container .vac-room-item{border-radius:8px;align-items:center;display:flex;flex:1 1 100%;margin-bottom:5px;padding:0 14px;position:relative;min-height:71px;transition:background-color .3s cubic-bezier(.25,.8,.5,1)}.vac-rooms-container .vac-room-item:hover{background:var(--chat-sidemenu-bg-color-hover)}.vac-rooms-container .vac-room-item:not(.vac-room-selected){cursor:pointer}.vac-rooms-container .vac-room-selected{color:var(--chat-sidemenu-color-active)!important;background:var(--chat-sidemenu-bg-color-active)!important}.vac-rooms-container .vac-room-selected:hover{background:var(--chat-sidemenu-bg-color-active)!important}@media only screen and (max-width: 768px){.vac-rooms-container .vac-room-list{padding:0 7px 5px}.vac-rooms-container .vac-room-item{min-height:60px;padding:0 8px}}.vac-card-window-customer .vac-rooms-container{border-radius:0}.vac-room-container{display:flex;flex:1;align-items:center;width:100%}.vac-room-container .vac-name-container{flex:1;padding:17px 0;border-bottom:.5px solid #F5F5F5}.vac-room-container .vac-title-container{display:flex;align-items:center;line-height:25px}.vac-room-container .vac-state-circle{width:9px;height:9px;border-radius:50%;background-color:var(--chat-room-color-offline);margin-right:6px;transition:.3s}.vac-room-container .vac-state-online{background-color:var(--chat-room-color-online)}.vac-room-container .vac-room-name{flex:1;color:var(--chat-room-color-username);font-weight:500}.vac-room-container .vac-text-date{margin-left:5px;font-size:11px;color:var(--chat-room-color-timestamp)}.vac-room-container .vac-text-last{display:flex;align-items:center;font-size:12px;line-height:19px;color:var(--chat-room-color-message)}.vac-room-container .vac-custom-icon{margin-left:5px}.vac-room-container .vac-message-new{color:var(--chat-room-color-username);font-weight:500}.vac-room-container .vac-icon-check{display:flex;vertical-align:middle;height:14px;width:14px;margin-top:-2px;margin-right:2px}.vac-room-container .vac-icon-microphone{height:15px;width:15px;vertical-align:middle;margin:-3px 1px 0 -2px;fill:var(--chat-room-color-message)}.vac-room-container .vac-room-options-container{display:flex;margin-left:auto}.vac-room-container .vac-room-badge{background-color:var(--chat-room-bg-color-badge);color:var(--chat-room-color-badge);margin-left:5px}.vac-room-container .vac-room-dot{width:5px;height:5px;min-width:5px}.vac-room-container .vac-list-room-options{height:19px;width:19px;align-items:center;margin-left:5px}.vac-box-empty{margin-top:10px}@media only screen and (max-width: 768px){.vac-box-empty{margin-top:7px}}.vac-box-search{position:sticky;display:flex;align-items:center;height:64px;padding:0 15px}.vac-box-search .vac-icon-search{display:flex;position:absolute;left:30px}.vac-box-search .vac-icon-search svg{width:18px;height:18px}.vac-box-search .vac-input{height:38px;width:100%;background:var(--chat-bg-color-input);color:var(--chat-color);font-size:15px;outline:0;caret-color:var(--chat-color-caret);padding:10px 10px 10px 40px;border:1px solid var(--chat-sidemenu-border-color-search);border-radius:20px}.vac-box-search .vac-input::placeholder{color:var(--chat-color-placeholder)}.vac-box-search .vac-add-icon{margin-left:auto;padding-left:10px}@media only screen and (max-width: 768px){.vac-box-search{height:58px}}.vac-message-wrapper .vac-card-info{border-radius:4px;text-align:center;margin:10px auto;font-size:12px;padding:4px;display:block;overflow-wrap:break-word;position:relative;white-space:normal}.vac-message-wrapper .vac-card-date{max-width:150px;font-weight:500;text-transform:uppercase;color:var(--chat-message-color-date);background-color:var(--chat-message-bg-color-date)}.vac-message-wrapper .vac-card-system{max-width:250px;padding:8px 4px;color:var(--chat-message-color-system);background-color:var(--chat-message-bg-color-system)}.vac-message-wrapper .vac-line-new{color:var(--chat-message-color-new-messages);position:relative;text-align:center;font-size:13px;padding:10px 0}.vac-message-wrapper .vac-line-new:after,.vac-message-wrapper .vac-line-new:before{border-top:1px solid var(--chat-message-color-new-messages);content:"";left:0;position:absolute;top:50%;width:calc(50% - 60px)}.vac-message-wrapper .vac-line-new:before{left:auto;right:0}.vac-message-wrapper .vac-message-box{max-width:50%;line-height:1.4;margin:10px 0}.vac-message-wrapper .vac-user{position:relative}.vac-message-wrapper .vac-avatar{position:absolute;height:28px;width:28px;min-height:28px;min-width:28px;margin:0}.vac-message-wrapper .vac-username{font-size:12px;color:#999;padding:0 10px}.vac-message-wrapper .vac-user-left .vac-avatar{left:-28px}.vac-message-wrapper .vac-user-right .vac-avatar{right:-28px}.vac-message-wrapper .vac-user-right .vac-username{text-align:right}.vac-message-wrapper #vac-circle{margin:auto;height:10px;width:10px;border:3px rgba(0,0,0,.25) solid;border-top:3px var(--chat-color-spinner) solid;border-right:3px var(--chat-color-spinner) solid;border-bottom:3px var(--chat-color-spinner) solid;border-radius:50%;-webkit-animation:vac-spin 1s infinite linear;animation:vac-spin 1s infinite linear}.vac-message-wrapper .vac-loading-container{position:relative;align-self:flex-end;height:20px;width:20px}.vac-message-wrapper .vac-loading-container.vac-loading-container-avatar{margin-right:6px}.vac-message-wrapper .vac-failure-container{position:relative;align-self:flex-end;height:20px;width:20px;margin:0 0 2px -4px;border-radius:50%;background-color:#f44336}.vac-message-wrapper .vac-failure-container.vac-failure-container-avatar{margin-right:6px}.vac-message-wrapper .vac-failure-container .vac-failure-text{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#fff;font-size:15px;font-weight:700}.vac-message-wrapper .vac-message-container{position:relative;padding:2px 10px;align-items:end;min-width:100px;box-sizing:content-box}.vac-message-wrapper .vac-message-container-offset{margin-bottom:10px}.vac-message-wrapper .vac-offset-current{margin-left:50%;justify-content:flex-end}.vac-message-wrapper .vac-message-card{background-color:var(--chat-message-bg-color);color:var(--chat-message-color);font-size:14px;padding:6px 9px 3px;white-space:pre-line;max-width:100%;-webkit-transition-property:box-shadow,opacity;transition-property:box-shadow,opacity;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);will-change:box-shadow;border-radius:0 8px 8px;box-shadow:0 1px 1px -1px #0000001a,0 1px 1px -1px #0000001c,0 1px 2px -1px #0000001c}.vac-message-wrapper .vac-message-highlight{box-shadow:0 1px 2px -1px #0000001a,0 1px 2px -1px #0000001c,0 1px 5px -1px #0000001c}.vac-message-wrapper .vac-message-current{background-color:var(--chat-message-bg-color-me)!important;border-radius:8px 0 8px 8px}.vac-message-wrapper .vac-message-deleted{color:var(--chat-message-color-deleted)!important;font-size:13px!important;font-style:italic!important;background-color:var(--chat-message-bg-color-deleted)!important}.vac-message-wrapper .vac-message-selected{background-color:var(--chat-message-bg-color-selected)!important;transition:background-color .2s}.vac-message-wrapper .vac-custom-card{padding:0}.vac-message-wrapper .vac-custom-card .vac-text-timestamp,.vac-message-wrapper .vac-custom-card .vac-text-username{padding:3px 9px}.vac-message-wrapper .vac-message-image{position:relative;background-color:var(--chat-message-bg-color-image)!important;background-size:cover!important;background-position:center center!important;background-repeat:no-repeat!important;height:250px;width:250px;max-width:100%;border-radius:4px;margin:4px auto 5px;transition:.4s filter linear}.vac-message-wrapper .vac-text-username{font-size:13px;color:var(--chat-message-color-username);margin-bottom:2px}.vac-message-wrapper .vac-username-reply{margin-bottom:5px}.vac-message-wrapper .vac-text-timestamp{font-size:10px;color:var(--chat-message-color-timestamp);text-align:right}.vac-message-wrapper .vac-progress-time{float:left;margin:-2px 0 0 40px;color:var(--chat-color);font-size:12px}.vac-message-wrapper .vac-icon-edited{-webkit-box-align:center;align-items:center;display:-webkit-inline-box;display:inline-flex;justify-content:center;letter-spacing:normal;line-height:1;text-indent:0;vertical-align:middle;margin:0 4px 2px}.vac-message-wrapper .vac-icon-edited svg{height:12px;width:12px}.vac-message-wrapper .vac-icon-check{height:14px;width:14px;vertical-align:middle;margin:-3px -3px 0 3px}.vac-message-wrapper .custom-card{display:flex}.vac-message-wrapper .system-time{margin-top:5px}.vac-message-wrapper .system-summary{display:flex;margin-top:5px}.vac-message-wrapper .system-summary .system-summary-box{margin:0 auto;text-align:left;word-wrap:break-word}@media (any-hover: none){.vac-message-wrapper .vac-message-card{user-select:none}}@media only screen and (max-width: 768px){.vac-message-wrapper .vac-message-container{padding:2px 3px 1px}.vac-message-wrapper .vac-message-box{max-width:80%}.vac-message-wrapper .vac-avatar{height:25px;width:25px;min-height:25px;min-width:25px}.vac-message-wrapper .vac-username{display:none}.vac-message-wrapper .vac-user-left .vac-avatar{left:-25px}.vac-message-wrapper .vac-user-right .vac-avatar{right:-25px}.vac-message-wrapper .vac-failure-container{margin-left:2px}.vac-message-wrapper .vac-failure-container.vac-failure-container-avatar{margin-right:0}.vac-message-wrapper .vac-offset-current{margin-left:20%}.vac-message-wrapper .vac-progress-time{margin-left:37px}}.vac-card-window-business .vac-message-wrapper{padding:0 28px}.vac-audio-player{display:flex;margin:8px 0 5px}.vac-audio-player .vac-svg-button{max-width:18px;margin-left:7px}@media only screen and (max-width: 768px){.vac-audio-player{margin:4px 0 0}.vac-audio-player .vac-svg-button{max-width:16px;margin-left:5px}}.vac-player-bar{display:flex;align-items:center;max-width:calc(100% - 18px);margin-right:7px;margin-left:20px}.vac-player-bar .vac-player-progress{width:190px}.vac-player-bar .vac-player-progress .vac-line-container{position:relative;height:4px;border-radius:5px;background-color:var(--chat-message-bg-color-audio-line)}.vac-player-bar .vac-player-progress .vac-line-container .vac-line-progress{position:absolute;height:inherit;background-color:var(--chat-message-bg-color-audio-progress);border-radius:inherit}.vac-player-bar .vac-player-progress .vac-line-container .vac-line-dot{position:absolute;top:-5px;margin-left:-7px;height:14px;width:14px;border-radius:50%;background-color:var(--chat-message-bg-color-audio-progress-selector);transition:transform .25s}.vac-player-bar .vac-player-progress .vac-line-container .vac-line-dot__active{transform:scale(1.2)}@media only screen and (max-width: 768px){.vac-player-bar{margin-right:5px}.vac-player-bar .vac-player-progress .vac-line-container{height:3px}.vac-player-bar .vac-player-progress .vac-line-container .vac-line-dot{height:12px;width:12px;top:-5px;margin-left:-5px}}.vac-message-actions-wrapper{position:relative}.vac-message-actions-wrapper .vac-options-container{position:absolute;bottom:-3px;z-index:200}.vac-message-actions-wrapper .vac-options-container .vac-action-list{display:flex;align-items:center;padding:0 8px;border-radius:4px;background-color:#fff}.vac-message-actions-wrapper .vac-options-container .vac-action{display:flex;align-items:center;height:32px;margin-right:6px}.vac-message-actions-wrapper .vac-options-container .vac-action .i-icon{display:inline-flex;align-items:center;cursor:pointer}.vac-message-actions-wrapper .vac-options-container-left{right:100%;padding-right:12px}.vac-message-actions-wrapper .vac-options-container-left .vac-menu-options{right:15px}.vac-message-actions-wrapper .vac-options-container-right{left:100%;padding-left:12px}.vac-message-actions-wrapper .vac-options-container-right .vac-menu-options{right:15px}.vac-message-actions-wrapper .vac-message-options{position:relative;padding:2px}.vac-message-actions-wrapper .vac-message-options .vac-svg-button{width:17px;height:17px;background:var(--chat-icon-bg-dropdown-message);border-radius:50%}.vac-message-actions-wrapper .vac-message-options .vac-svg-button svg{height:17px;width:17px;padding:5px;margin:-5px}.vac-mobile-message-actions-wrapper{position:relative}.vac-mobile-message-actions-wrapper .vac-triangle{position:absolute;z-index:-1;left:40px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent}.vac-mobile-message-actions-wrapper .vac-top-triangle{top:-10px;border-bottom:10px solid rgba(0,0,0,.7)}.vac-mobile-message-actions-wrapper .vac-bottom-triangle{bottom:-10px;border-top:10px solid rgba(0,0,0,.7)}.vac-mobile-message-actions-wrapper .vac-options-container{position:absolute;left:0;background-color:#000000b3;border-radius:8px;z-index:200}.vac-mobile-message-actions-wrapper .vac-options-container .vac-tabs{display:flex;padding:0 10px}.vac-mobile-message-actions-wrapper .vac-options-container .vac-tabs .vac-tab{display:flex;justify-content:center;align-items:center;width:40px;height:40px;position:relative}.vac-mobile-message-actions-wrapper .vac-options-container .vac-tabs .vac-tab img{display:block;width:20px;height:20px}.vac-mobile-message-actions-wrapper .vac-options-container .vac-tabs .vac-tab:after{content:"";position:absolute;top:-5px;bottom:-5px;left:-3px;right:-3px}.vac-mobile-message-actions-wrapper .vac-options-container .vac-tabs .selected{background-color:#000}.vac-message-files-container .vac-file-wrapper{position:relative;width:fit-content}.vac-message-files-container .vac-file-wrapper .vac-file-container{height:60px;width:60px;margin:3px 0 5px;cursor:pointer;transition:all .6s}.vac-message-files-container .vac-file-wrapper .vac-file-container:hover{opacity:.85}.vac-message-files-container .vac-file-wrapper .vac-file-container svg{height:30px;width:30px}.vac-message-files-container .vac-file-wrapper .vac-file-container.vac-file-container-progress{background-color:#0000004d}.vac-message-file-container{position:relative}.vac-message-file-container .vac-message-image-container{cursor:pointer}.vac-message-file-container .vac-image-buttons{position:absolute;width:100%;height:100%;border-radius:4px;background:linear-gradient(to bottom,rgba(0,0,0,0) 55%,rgba(0,0,0,.02) 60%,rgba(0,0,0,.05) 65%,rgba(0,0,0,.1) 70%,rgba(0,0,0,.2) 75%,rgba(0,0,0,.3) 80%,rgba(0,0,0,.5) 85%,rgba(0,0,0,.6) 90%,rgba(0,0,0,.7) 95%,rgba(0,0,0,.8) 100%)}.vac-message-file-container .vac-image-buttons svg{height:26px;width:26px}.vac-message-file-container .vac-image-buttons .vac-button-view,.vac-message-file-container .vac-image-buttons .vac-button-download{position:absolute;bottom:6px;left:7px}.vac-message-file-container .vac-image-buttons :first-child{left:40px}.vac-message-file-container .vac-image-buttons .vac-button-view{max-width:18px;bottom:8px}.vac-message-file-container .vac-video-container{width:350px;max-width:100%;margin:4px auto 5px;cursor:pointer}.vac-message-file-container .vac-video-container .video-player{width:100%;height:100%}.vac-message-file-container .vac-video-container .video-container,.vac-message-file-container .vac-video-container video{border-radius:4px;width:100%;height:100%}.vac-button-reaction{display:inline-flex;align-items:center;border:var(--chat-message-border-style-reaction);outline:none;background:var(--chat-message-bg-color-reaction);border-radius:4px;margin:4px 2px 0;transition:.3s;padding:0 5px;font-size:18px;line-height:23px}.vac-button-reaction span{font-size:11px;font-weight:500;min-width:7px;color:var(--chat-message-color-reaction-counter)}.vac-button-reaction:hover{border:var(--chat-message-border-style-reaction-hover);background:var(--chat-message-bg-color-reaction-hover);cursor:pointer}.vac-button-reaction.vac-reaction-me{border:var(--chat-message-border-style-reaction-me);background:var(--chat-message-bg-color-reaction-me)}.vac-button-reaction.vac-reaction-me span{color:var(--chat-message-color-reaction-counter-me)}.vac-button-reaction.vac-reaction-me:hover{border:var(--chat-message-border-style-reaction-hover-me);background:var(--chat-message-bg-color-reaction-hover-me)}.vac-reply-message{background:var(--chat-message-bg-color-reply);border-radius:4px;margin:-1px -5px 8px;padding:8px 10px}.vac-reply-message .vac-reply-username{color:var(--chat-message-color-reply-username);font-size:12px;line-height:15px;margin-bottom:2px}.vac-reply-message .vac-image-reply-container{width:70px}.vac-reply-message .vac-image-reply-container .vac-message-image-reply{height:70px;width:70px;margin:4px auto 3px}.vac-reply-message .vac-video-reply-container{width:200px;max-width:100%}.vac-reply-message .vac-video-reply-container .video-player{width:100%;height:100%}.vac-reply-message .vac-video-reply-container .video-container,.vac-reply-message .vac-video-reply-container video{border-radius:4px}.vac-reply-message .vac-reply-content{font-size:12px;color:var(--chat-message-color-reply-content)}.vac-reply-message .vac-file-container{height:60px;width:60px}.vac-emoji-wrapper{position:relative;display:flex}.vac-emoji-wrapper .vac-emoji-reaction svg{height:19px;width:19px}.vac-emoji-wrapper .vac-emoji-picker{position:absolute;z-index:9999;right:20px;width:300px;padding-top:4px;overflow:scroll;box-sizing:border-box;border-radius:.5rem;background:var(--chat-emoji-bg-color);box-shadow:0 1px 2px -2px #0000001a,0 1px 2px -1px #0000001a,0 1px 2px 1px #0000001a;scrollbar-width:none}.vac-emoji-wrapper .vac-emoji-picker.vac-picker-pc{right:-50px;width:min(100vw - 78px,300px)}.vac-emoji-wrapper .vac-emoji-picker::-webkit-scrollbar{display:none}.vac-emoji-wrapper .vac-emoji-picker emoji-picker{height:100%;width:100%;--emoji-size: 24px;--emoji-padding: 4px;--background: var(--chat-emoji-bg-color);--border-color: var(--chat-sidemenu-border-color-search);--button-hover-background: var(--chat-sidemenu-bg-color-hover);--button-active-background: var(--chat-sidemenu-bg-color-hover)}@media screen and (max-width: 350px){.vac-emoji-wrapper .vac-emoji-picker emoji-picker{--num-columns: 6}}.vac-mobile-emoji-wrapper{height:300px;overflow:hidden}.vac-mobile-emoji-wrapper.vac-message-emojis{height:300px}.vac-mobile-emoji-wrapper.vac-message-emojis .vac-mobile-emoji-picker emoji-picker{--num-columns: 6;--emoji-padding: 8px;--background: transparent;--border-color: #000;--button-hover-background: #000;--button-active-background: #000;--input-font-color: #fff}.vac-mobile-emoji-wrapper .vac-mobile-emoji-picker{height:100%;width:100%;overflow:scroll;box-sizing:border-box;scrollbar-width:none}.vac-mobile-emoji-wrapper .vac-mobile-emoji-picker::-webkit-scrollbar{display:none}.vac-mobile-emoji-wrapper .vac-mobile-emoji-picker emoji-picker{--num-columns: 7;height:100%;width:100%;--emoji-size: 28px;--emoji-padding: 8px;--category-emoji-padding: 4px;--input-border-radius: 8px;--input-font-size: 16px;--input-padding: 4px;--skintone-border-radius: 16px;--category-font-size: 16px;--background: var(--chat-footer-bg-color);--border-color: var(--chat-sidemenu-border-color-search);--button-hover-background: var(--chat-sidemenu-bg-color-hover);--button-active-background: var(--chat-sidemenu-bg-color-hover)}.vac-format-message-wrapper .vac-format-container{display:inline}.vac-format-message-wrapper .vac-icon-deleted{height:14px;width:14px;vertical-align:middle;margin:-2px 2px 0 0;fill:var(--chat-message-color-deleted)}.vac-format-message-wrapper .vac-icon-deleted.vac-icon-deleted-room{margin:-3px 1px 0 0;fill:var(--chat-room-color-message)}.vac-format-message-wrapper .vac-image-link-container{background-color:var(--chat-message-bg-color-media);padding:8px;margin:2px auto;border-radius:4px}.vac-format-message-wrapper .vac-image-link{position:relative;background-color:var(--chat-message-bg-color-image)!important;background-size:contain;background-position:center center!important;background-repeat:no-repeat!important;height:150px;width:150px;max-width:100%;border-radius:4px;margin:0 auto}.vac-format-message-wrapper .vac-image-link-message{max-width:166px;font-size:12px}.vac-loader-wrapper.vac-container-center{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:9}.vac-loader-wrapper.vac-container-top{padding:21px}.vac-loader-wrapper.vac-container-top #vac-circle{height:20px;width:20px}.vac-loader-wrapper #vac-circle{margin:auto;height:28px;width:28px;border:3px rgba(0,0,0,.25) solid;border-top:3px var(--chat-color-spinner) solid;border-right:3px var(--chat-color-spinner) solid;border-bottom:3px var(--chat-color-spinner) solid;border-radius:50%;-webkit-animation:vac-spin 1s infinite linear;animation:vac-spin 1s infinite linear}@media only screen and (max-width: 768px){.vac-loader-wrapper #vac-circle{height:24px;width:24px}.vac-loader-wrapper.vac-container-top{padding:18px}.vac-loader-wrapper.vac-container-top #vac-circle{height:16px;width:16px}}@-webkit-keyframes vac-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes vac-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}#vac-icon-search{fill:var(--chat-icon-color-search)}#vac-icon-add{fill:var(--chat-icon-color-add)}#vac-icon-toggle{fill:var(--chat-icon-color-toggle)}#vac-icon-menu{fill:var(--chat-icon-color-menu)}#vac-icon-close{fill:var(--chat-icon-color-close)}#vac-icon-close-image{fill:var(--chat-icon-color-close-image)}#vac-icon-file{fill:var(--chat-icon-color-file)}#vac-icon-paperclip{fill:var(--chat-icon-color-paperclip)}#vac-icon-close-outline{fill:var(--chat-icon-color-close-outline)}#vac-icon-close-outline-preview{fill:var(--chat-icon-color-close-preview)}#vac-icon-send{fill:var(--chat-icon-color-send)}#vac-icon-send-disabled{fill:var(--chat-icon-color-send-disabled)}#vac-icon-emoji{fill:var(--chat-icon-color-emoji)}#vac-icon-emoji-reaction{fill:var(--chat-icon-color-emoji-reaction)}#vac-icon-document{fill:var(--chat-icon-color-document)}#vac-icon-pencil{fill:var(--chat-icon-color-pencil)}#vac-icon-checkmark,#vac-icon-double-checkmark{fill:var(--chat-icon-color-checkmark)}#vac-icon-checkmark-seen,#vac-icon-double-checkmark-seen{fill:var(--chat-icon-color-checkmark-seen)}#vac-icon-eye{fill:var(--chat-icon-color-eye)}#vac-icon-dropdown-message{fill:var(--chat-icon-color-dropdown-message)}#vac-icon-dropdown-room{fill:var(--chat-icon-color-dropdown-room)}#vac-icon-dropdown-scroll{fill:var(--chat-icon-color-dropdown-scroll)}#vac-icon-audio-play{fill:var(--chat-icon-color-audio-play)}#vac-icon-audio-pause{fill:var(--chat-icon-color-audio-pause)}.vac-progress-wrapper{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:9}.vac-progress-wrapper circle{transition:stroke-dashoffset .35s;transform:rotate(-90deg);transform-origin:50% 50%}.vac-progress-wrapper .vac-progress-content{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:-1;margin-top:-2px;background-color:#000000b3;border-radius:50%}.vac-progress-wrapper .vac-progress-content .vac-progress-text{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);font-weight:700;color:#fff}.vac-progress-wrapper .vac-progress-content .vac-progress-text .vac-progress-pourcent{font-size:9px;font-weight:400}.video-wrapper{white-space:normal}.video-wrapper .video-container.xgplayer-is-cssfullscreen{position:fixed!important;z-index:2000!important;border-radius:0!important}.video-wrapper .video-container.xgplayer-is-cssfullscreen ::v-deep video{border-radius:0!important}.video-wrapper .video-container.xgplayer-rotate-fullscreen{position:fixed!important;z-index:2000!important;border-radius:0!important}.video-wrapper .video-container.xgplayer-rotate-fullscreen ::v-deep video{border-radius:0!important}.video-wrapper .video-container.auto-height{padding-top:0!important}.video-wrapper.no-control-inline .video-container:not(.xgplayer-rotate-fullscreen,.xgplayer-is-cssfullscreen) .xgplayer-controls{display:none}.video-wrapper.portrait .xgplayer-rotate-fullscreen{transform:rotate(0)!important;transform-origin:0!important;width:100vw!important;height:100vh!important;max-width:100vw!important;padding-top:0!important;top:0;left:0;right:0;bottom:0}.video-wrapper.landscape .xgplayer-rotate-fullscreen{transform:rotate(90deg);transform-origin:50vw;width:100vh!important;height:100vw!important;max-width:100vh!important;padding-top:0!important;right:auto;bottom:auto;left:0}.video-wrapper.cover .video-container:not(.xgplayer-rotate-fullscreen,.xgplayer-is-cssfullscreen) ::v-deep video{object-fit:cover}.video-wrapper.cover .video-container:not(.xgplayer-rotate-fullscreen,.xgplayer-is-cssfullscreen) ::v-deep .xgplayer-poster{background-size:cover}.ar-container{display:block;overflow:hidden;position:relative;width:100%;min-height:40px;height:100%;height:min(200px,100%)}.ar-container .ar-inner{display:block;width:100%;max-height:100%}.ar-container .ar-limit{position:absolute;top:0;left:0;width:100%;height:100%;display:block}.two-line{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.three-line{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}.one-line{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical}.one-line-label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.custom-card-contain{flex:1;margin:0;padding-left:12px;padding-right:12px;border-radius:6px;background-color:#fff}.custom-card-contain .merchant-head{border-bottom:1px dashed #ddd;padding-bottom:6px;margin-bottom:10px;color:#999;font-size:12px}.custom-card-contain .card-footer{text-align:right}.custom-card-contain .card-footer .btn{padding:8px 16px;border-radius:40px;font-weight:500;border:none;color:#d34f25;background-color:#fdf7f0}.order-card{padding-top:12px;width:100%}.order-card .card-header{color:#333;font-size:12px;display:flex;justify-content:space-between;align-items:center;margin-bottom:10px}.order-card .card-header .order-status{color:#f3b847}.order-card .card-content{display:flex;cursor:pointer}.order-card .card-content .card-img{border-radius:6px;overflow:hidden;margin-right:10px;width:72px;height:72px}.order-card .card-content .card-img img{display:block;width:100%;height:100%;object-fit:cover}.order-card .card-content .card-info{flex:1;display:inline-flex;width:100%;flex-flow:column nowrap;justify-content:space-between}.order-card .card-content .card-info .card-title{font-size:12px;font-weight:400;line-height:14px}.order-card .card-content .card-info .card-quantity{display:inline-flex;width:100%;justify-content:space-between;color:#999;font-size:12px;margin-bottom:3px}.order-card .card-content .card-info .card-info-data{display:inline-flex;width:100%;justify-content:space-between;align-items:center}.order-card .card-content .card-info .card-info-data .card-price{font-size:14px;font-weight:700}.order-card .card-bottom-line{margin-top:8px;border-top:1px solid #ECECEC;padding:6px 0;font-size:12px;color:#999}.goods-card{padding-top:12px;padding-bottom:5px;width:100%}.goods-card .goods-content{display:flex;padding-bottom:10px;border-bottom:1px border #ECECEC;cursor:pointer}.goods-card .goods-card-img{width:72px;height:72px;border-radius:6px;overflow:hidden}.goods-card .goods-card-img img{display:block;width:100%;height:100%;object-fit:cover}.goods-card .goods-card-info{margin-left:10px;display:inline-flex;flex-flow:column nowrap;justify-content:space-between;flex:1}.goods-card .goods-card-info .goods-card-title{font-size:12px;font-weight:500;line-height:14px}.goods-card .goods-card-info .goods-card-bottom{display:inline-flex;width:100%;align-items:center;justify-content:space-between}.goods-card .goods-card-info .goods-card-bottom .goods-card-price{font-size:14px;font-weight:700}.guide-book-card .card-header{padding-bottom:10px;font-size:16px;font-weight:600;color:#333}.guide-book-card .card-content{display:flex;cursor:pointer}.guide-book-card .card-content .card-img{width:72px;height:72px;margin-right:10px;border-radius:6px;overflow:hidden}.guide-book-card .card-content .card-img img{display:block;width:100%;height:100%;object-fit:cover}.guide-book-card .card-content .goods-card-info{flex:1;margin-left:10px}.guide-book-card .card-content .goods-card-info .goods-card-title{font-size:12px;font-weight:500;line-height:14px}.points-card .card-content{padding-top:10px}.points-card .card-content .card-balance{padding-bottom:5px;color:#333;border-bottom:.5px solid #F5F5F5}.points-card .card-content .card-balance .title{font-size:14px}.points-card .card-content .card-balance .text{font-size:24px;font-weight:500}.points-card .card-content .card-points,.points-card .card-content .card-frozenPoints{padding-top:10px}.points-card .card-content .card-points .title,.points-card .card-content .card-frozenPoints .title{font-size:12px;color:#666}.points-card .card-content .card-points .text,.points-card .card-content .card-frozenPoints .text{font-size:20px;font-weight:500;color:#333}.points-card .card-content .card-currency{margin-top:10px;font-size:12px;color:#333}.card-send .card-send-btn{width:74px;height:33px;background:linear-gradient(90deg,#FFDF56 0%,#FDBB2B 100%);border-radius:16px;color:#333;font-size:14px;text-align:center;line-height:33px;font-weight:700}.card-send-time{text-align:right;margin-top:5px;color:#999;font-size:12px;padding:5px 0}@media only screen and (max-width: 768px){.card-send-time{padding:0}}\n';
const _sfc_main = {
  name: "ChatContainer",
  components: {
    RoomsList,
    Room,
    MediaPreview
  },
  props: {
    disabledEnterKeySend: { type: Boolean, default: false },
    platform: { type: String, default: "business" },
    pcMode: { type: Boolean, default: false },
    height: { type: String, default: "600px" },
    theme: { type: String, default: "light" },
    styles: { type: [Object, String], default: () => ({}) },
    responsiveBreakpoint: { type: Number, default: 900 },
    singleRoom: { type: [Boolean, String], default: false },
    roomsListOpened: { type: [Boolean, String], default: true },
    textMessages: { type: [Object, String], default: () => ({}) },
    currentUserId: { type: String, default: "" },
    rooms: { type: [Array, String], default: () => [] },
    roomsOrder: { type: String, default: "desc" },
    loadingRooms: { type: [Boolean, String], default: false },
    roomsLoaded: { type: [Boolean, String], default: false },
    roomId: { type: [String, Number], default: null },
    loadFirstRoom: { type: [Boolean, String], default: true },
    messages: { type: [Array, String], default: () => [] },
    messagesLoaded: { type: [Boolean, String], default: false },
    roomActions: { type: [Array, String], default: () => [] },
    menuActions: { type: [Array, String], default: () => [] },
    networkException: { type: [Boolean, String], required: true },
    messageActions: {
      type: [Array, String],
      default: () => [
        { name: "editMessage", title: "Edit Message", onlyMe: true },
        { name: "deleteMessage", title: "Delete Message", onlyMe: true },
        { name: "download", title: "Download", isVideo: true }
      ]
    },
    messageSelectionActions: { type: [Array, String], default: () => [] },
    autoScroll: {
      type: [Object, String],
      default: () => {
        return {
          send: {
            new: true,
            newAfterScrollUp: true
          },
          receive: {
            new: true,
            newAfterScrollUp: false
          }
        };
      }
    },
    customSearchRoomEnabled: { type: [Boolean, String], default: false },
    showSearch: { type: [Boolean, String], default: true },
    showAddRoom: { type: [Boolean, String], default: true },
    showSendIcon: { type: [Boolean, String], default: true },
    showFiles: { type: [Boolean, String], default: true },
    showMenu: { type: [Boolean, String], default: true },
    showAudio: { type: [Boolean, String], default: true },
    audioBitRate: { type: Number, default: 128 },
    audioSampleRate: { type: Number, default: new (window.AudioContext || window.webkitAudioContext)().sampleRate },
    showEmojis: { type: [Boolean, String], default: true },
    showReactionEmojis: { type: [Boolean, String], default: true },
    showNewMessagesDivider: { type: [Boolean, String], default: true },
    showFooter: { type: [Boolean, String], default: true },
    textFormatting: {
      type: [Object, String],
      default: () => ({
        disabled: false
      })
    },
    linkOptions: {
      type: [Object, String],
      default: () => ({ disabled: false, target: "_blank", rel: null })
    },
    roomInfoEnabled: { type: [Boolean, String], default: false },
    textareaActionEnabled: { type: [Boolean, String], default: false },
    textareaAutoFocus: { type: [Boolean, String], default: true },
    userTagsEnabled: { type: [Boolean, String], default: true },
    emojisSuggestionEnabled: { type: [Boolean, String], default: true },
    roomMessage: { type: String, default: "" },
    scrollDistance: { type: Number, default: 60 },
    acceptedFiles: { type: String, default: "*" },
    captureFiles: { type: String, default: "" },
    multipleFiles: { type: [Boolean, String], default: true },
    templatesText: { type: [Array, String], default: () => [] },
    mediaPreviewEnabled: { type: [Boolean, String], default: true },
    usernameOptions: {
      type: [Object, String],
      default: () => ({ minUsers: 3, currentUser: false })
    },
    emojiDataSource: { type: String, default: void 0 },
    roomTopTips: { type: String, default: "" },
    roomHref: { type: [Boolean, String], default: false },
    onlyView: { type: [Boolean, String], default: false }
  },
  emits: [
    "toggle-rooms-list",
    "toggle-room-chat",
    "room-info",
    "fetch-messages",
    "send-message",
    "edit-message",
    "delete-message",
    "open-file",
    "open-user-tag",
    "open-failed-message",
    "menu-action-handler",
    "message-action-handler",
    "send-message-reaction",
    "typing-message",
    "textarea-action-handler",
    "fetch-more-rooms",
    "add-room",
    "search-room",
    "room-action-handler",
    "message-selection-action-handler",
    "send-custom-card",
    "trigger-custom-card",
    "message-custom-view",
    "trigger-custom-room-select",
    "room-select",
    "before-fetch-rooms"
  ],
  data() {
    return {
      slots: [],
      room: {},
      loadingMoreRooms: false,
      showRoomsList: true,
      isMobile: false,
      showMediaPreview: false,
      previewFile: {}
    };
  },
  computed: {
    t() {
      return {
        ...locales,
        ...this.textMessagesCasted
      };
    },
    cssVars() {
      const defaultStyles = defaultThemeStyles[this.theme];
      const customStyles = {};
      Object.keys(defaultStyles).map((key) => {
        customStyles[key] = {
          ...defaultStyles[key],
          ...this.stylesCasted[key] || {}
        };
      });
      return cssThemeVars(customStyles);
    },
    orderedRooms() {
      return this.roomsCasted.slice().sort((a, b) => {
        const aVal = a.index || 0;
        const bVal = b.index || 0;
        if (this.roomsOrder === "asc") {
          return aVal < bVal ? -1 : bVal < aVal ? 1 : 0;
        }
        return aVal > bVal ? -1 : bVal > aVal ? 1 : 0;
      });
    },
    singleRoomCasted() {
      return this.castBoolean(this.singleRoom);
    },
    roomsListOpenedCasted() {
      return this.castBoolean(this.roomsListOpened);
    },
    loadingRoomsCasted() {
      return this.castBoolean(this.loadingRooms);
    },
    roomsLoadedCasted() {
      return this.castBoolean(this.roomsLoaded);
    },
    loadFirstRoomCasted() {
      return this.castBoolean(this.loadFirstRoom);
    },
    messagesLoadedCasted() {
      return this.castBoolean(this.messagesLoaded);
    },
    multipleFilesCasted() {
      return this.castBoolean(this.multipleFiles);
    },
    showSearchCasted() {
      return this.castBoolean(this.showSearch);
    },
    showAddRoomCasted() {
      return this.castBoolean(this.showAddRoom);
    },
    showSendIconCasted() {
      return this.castBoolean(this.showSendIcon);
    },
    showFilesCasted() {
      return this.castBoolean(this.showFiles);
    },
    showMenuCasted() {
      return this.castBoolean(this.showMenu);
    },
    showAudioCasted() {
      return this.castBoolean(this.showAudio);
    },
    showEmojisCasted() {
      return this.castBoolean(this.showEmojis);
    },
    showReactionEmojisCasted() {
      return this.castBoolean(this.showReactionEmojis);
    },
    showNewMessagesDividerCasted() {
      return this.castBoolean(this.showNewMessagesDivider);
    },
    showFooterCasted() {
      return this.castBoolean(this.showFooter);
    },
    roomInfoEnabledCasted() {
      return this.castBoolean(this.roomInfoEnabled);
    },
    textareaActionEnabledCasted() {
      return this.castBoolean(this.textareaActionEnabled);
    },
    textareaAutoFocusCasted() {
      return this.castBoolean(this.textareaAutoFocus);
    },
    userTagsEnabledCasted() {
      return this.castBoolean(this.userTagsEnabled);
    },
    emojisSuggestionEnabledCasted() {
      return this.castBoolean(this.emojisSuggestionEnabled);
    },
    mediaPreviewEnabledCasted() {
      return this.castBoolean(this.mediaPreviewEnabled);
    },
    roomsCasted() {
      return this.castArray(this.rooms);
    },
    messagesCasted() {
      return this.castArray(this.messages);
    },
    roomActionsCasted() {
      return this.castArray(this.roomActions);
    },
    menuActionsCasted() {
      return this.castArray(this.menuActions);
    },
    messageActionsCasted() {
      return this.castArray(this.messageActions);
    },
    messageSelectionActionsCasted() {
      return this.castArray(this.messageSelectionActions);
    },
    templatesTextCasted() {
      return this.castArray(this.templatesText);
    },
    stylesCasted() {
      return this.castObject(this.styles);
    },
    textMessagesCasted() {
      return this.castObject(this.textMessages);
    },
    autoScrollCasted() {
      return this.castObject(this.autoScroll);
    },
    textFormattingCasted() {
      return this.castObject(this.textFormatting);
    },
    linkOptionsCasted() {
      return this.castObject(this.linkOptions);
    },
    usernameOptionsCasted() {
      return this.castObject(this.usernameOptions);
    },
    roomHrefCasted() {
      return this.castBoolean(this.roomHref);
    },
    onlyViewCasted() {
      return this.castBoolean(this.onlyView);
    },
    pcModeCasted() {
      return this.castBoolean(this.pcMode);
    }
  },
  watch: {
    roomsCasted: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal[0] || !newVal.find((room) => room.roomId === this.room.roomId)) {
          this.showRoomsList = true;
        }
        this.updateResponsive();
        if (!this.loadingMoreRooms && this.loadFirstRoomCasted && newVal[0] && (!oldVal || newVal.length !== oldVal.length)) {
          if (this.roomId) {
            const room = newVal.find((r) => r.roomId === this.roomId) || {};
            this.fetchRoom({ room });
          } else if (!this.isMobile || this.singleRoomCasted) {
            this.fetchRoom({ room: this.orderedRooms[0] });
          } else {
            this.showRoomsList = true;
          }
        }
      }
    },
    loadingRoomsCasted(val) {
      if (val)
        this.room = {};
    },
    roomId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && !this.loadingRoomsCasted && this.roomsCasted.length) {
          const room = this.roomsCasted.find((r) => r.roomId === newVal);
          this.fetchRoom({ room });
        } else if (oldVal && !newVal) {
          this.room = {};
        }
      }
    },
    room(val) {
      if (!val || Object.entries(val).length === 0)
        return;
      roomsValidation(val);
      val.users.forEach((user) => {
        partcipantsValidation(user);
      });
    },
    roomsListOpenedCasted: {
      immediate: true,
      handler(val) {
        this.showRoomsList = val;
      }
    },
    showRoomsList: {
      immediate: true,
      handler(val) {
        this.$emit("toggle-rooms-list", { opened: val });
      }
    }
  },
  created() {
    this.updateResponsive();
    window.addEventListener("resize", this.windowResizeHandler);
  },
  updated() {
    const slots = document.querySelectorAll("[slot]");
    if (this.slots.length !== slots.length) {
      this.slots = slots;
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.windowResizeHandler);
  },
  methods: {
    windowResizeHandler(ev) {
      if (ev.isTrusted)
        this.updateResponsive();
    },
    castBoolean(val) {
      return val === "true" || val === true;
    },
    castArray(val) {
      return !val ? [] : Array.isArray(val) ? val : JSON.parse(val);
    },
    castObject(val) {
      return !val ? {} : typeof val === "object" ? val : JSON.parse(val);
    },
    updateResponsive() {
      this.isMobile = window.innerWidth < Number(this.responsiveBreakpoint);
    },
    toggleRoomsList() {
      this.showRoomsList = !this.showRoomsList;
      if (this.isMobile)
        this.room = {};
    },
    toggleRoomChat({ opened }) {
      this.$emit("toggle-room-chat", { opened });
    },
    fetchRoom({ room }) {
      this.$emit("before-fetch-rooms");
      this.room = room;
      this.fetchMessages({ reset: true });
      if (this.isMobile)
        this.showRoomsList = false;
    },
    fetchMoreRooms() {
      this.$emit("fetch-more-rooms");
    },
    roomInfo() {
      this.$emit("room-info", this.room);
    },
    addRoom() {
      this.$emit("add-room");
    },
    searchRoom(val) {
      this.$emit("search-room", { value: val, roomId: this.room.roomId });
    },
    fetchMessages(options) {
      this.$emit("fetch-messages", { room: this.room, options });
    },
    sendMessage(message) {
      this.$emit("send-message", { ...message, roomId: this.room.roomId });
    },
    editMessage(message) {
      this.$emit("edit-message", { ...message, roomId: this.room.roomId });
    },
    deleteMessage(message) {
      this.$emit("delete-message", { message, roomId: this.room.roomId });
    },
    openFile({ message, file }) {
      if (this.mediaPreviewEnabledCasted && file.action === "preview") {
        this.previewFile = file.file;
        this.showMediaPreview = true;
      } else {
        this.$emit("open-file", { message, file });
      }
    },
    openUserTag({ user, message }) {
      this.$emit("open-user-tag", { user, message });
    },
    openFailedMessage({ message }) {
      this.$emit("open-failed-message", {
        message,
        roomId: this.room.roomId
      });
    },
    menuActionHandler(ev) {
      this.$emit("menu-action-handler", {
        action: ev,
        roomId: this.room.roomId
      });
    },
    roomActionHandler({ action, roomId }) {
      this.$emit("room-action-handler", {
        action,
        roomId
      });
    },
    messageActionHandler(ev) {
      this.$emit("message-action-handler", {
        ...ev,
        roomId: this.room.roomId
      });
    },
    messageSelectionActionHandler(ev) {
      this.$emit("message-selection-action-handler", {
        ...ev,
        roomId: this.room.roomId
      });
    },
    sendMessageReaction(messageReaction) {
      this.$emit("send-message-reaction", {
        ...messageReaction,
        roomId: this.room.roomId
      });
    },
    typingMessage(message) {
      this.$emit("typing-message", {
        message,
        roomId: this.room.roomId
      });
    },
    textareaActionHandler(message) {
      this.$emit("textarea-action-handler", {
        message,
        roomId: this.room.roomId
      });
    }
  }
};
const _hoisted_1 = { class: "vac-chat-container" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_rooms_list = resolveComponent("rooms-list");
  const _component_room = resolveComponent("room");
  const _component_media_preview = resolveComponent("media-preview");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["vac-card-window", {
      "vac-card-window-customer": $props.platform === "customer",
      "vac-card-window-business": $props.platform === "business"
    }]),
    style: normalizeStyle([{ height: $props.height }, $options.cssVars])
  }, [
    createElementVNode("div", _hoisted_1, [
      !$options.singleRoomCasted ? (openBlock(), createBlock(_component_rooms_list, {
        key: 0,
        "current-user-id": $props.currentUserId,
        rooms: $options.orderedRooms,
        "loading-rooms": $options.loadingRoomsCasted,
        "rooms-loaded": $options.roomsLoadedCasted,
        room: $data.room,
        "room-actions": $options.roomActionsCasted,
        "custom-search-room-enabled": $props.customSearchRoomEnabled,
        "text-messages": $options.t,
        "show-search": $options.showSearchCasted,
        "show-add-room": $options.showAddRoomCasted,
        "show-rooms-list": $data.showRoomsList && $options.roomsListOpenedCasted,
        "text-formatting": $options.textFormattingCasted,
        "link-options": $options.linkOptionsCasted,
        "is-mobile": $data.isMobile,
        "scroll-distance": $props.scrollDistance,
        "network-exception": $props.networkException,
        "room-href": $options.roomHrefCasted,
        onFetchRoom: $options.fetchRoom,
        onFetchMoreRooms: $options.fetchMoreRooms,
        onLoadingMoreRooms: _cache[0] || (_cache[0] = ($event) => $data.loadingMoreRooms = $event),
        onAddRoom: $options.addRoom,
        onSearchRoom: $options.searchRoom,
        onRoomActionHandler: $options.roomActionHandler,
        onTriggerCustomRoomSelect: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("trigger-custom-room-select", $event)),
        onRoomSelect: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("room-select", $event))
      }, createSlots({ _: 2 }, [
        renderList($data.slots, (el) => {
          return {
            name: el.slot,
            fn: withCtx((data) => [
              renderSlot(_ctx.$slots, el.slot, normalizeProps(guardReactiveProps(data)))
            ])
          };
        })
      ]), 1032, ["current-user-id", "rooms", "loading-rooms", "rooms-loaded", "room", "room-actions", "custom-search-room-enabled", "text-messages", "show-search", "show-add-room", "show-rooms-list", "text-formatting", "link-options", "is-mobile", "scroll-distance", "network-exception", "room-href", "onFetchRoom", "onFetchMoreRooms", "onAddRoom", "onSearchRoom", "onRoomActionHandler"])) : createCommentVNode("", true),
      createVNode(_component_room, {
        "disabled-enter-key-send": $props.disabledEnterKeySend,
        platform: $props.platform,
        "pc-mode": $options.pcModeCasted,
        "current-user-id": $props.currentUserId,
        rooms: $options.roomsCasted,
        "room-id": $data.room.roomId || "",
        "load-first-room": $options.loadFirstRoomCasted,
        messages: $options.messagesCasted,
        "room-message": $props.roomMessage,
        "messages-loaded": $options.messagesLoadedCasted,
        "menu-actions": $options.menuActionsCasted,
        "message-actions": $options.messageActionsCasted,
        "message-selection-actions": $options.messageSelectionActionsCasted,
        "auto-scroll": $options.autoScrollCasted,
        "show-send-icon": $options.showSendIconCasted,
        "show-files": $options.showFilesCasted,
        "show-menu": $options.showMenuCasted,
        "show-audio": $options.showAudioCasted,
        "audio-bit-rate": $props.audioBitRate,
        "audio-sample-rate": $props.audioSampleRate,
        "show-emojis": $options.showEmojisCasted,
        "show-reaction-emojis": $options.showReactionEmojisCasted,
        "show-new-messages-divider": $options.showNewMessagesDividerCasted,
        "show-footer": $options.showFooterCasted,
        "text-messages": $options.t,
        "single-room": $options.singleRoomCasted,
        "show-rooms-list": $data.showRoomsList && $options.roomsListOpenedCasted,
        "text-formatting": $options.textFormattingCasted,
        "link-options": $options.linkOptionsCasted,
        "is-mobile": $data.isMobile,
        "loading-rooms": $options.loadingRoomsCasted,
        "room-info-enabled": $options.roomInfoEnabledCasted,
        "textarea-action-enabled": $options.textareaActionEnabledCasted,
        "textarea-auto-focus": $options.textareaAutoFocusCasted,
        "user-tags-enabled": $options.userTagsEnabledCasted,
        "emojis-suggestion-enabled": $options.emojisSuggestionEnabledCasted,
        "scroll-distance": $props.scrollDistance,
        "accepted-files": $props.acceptedFiles,
        "capture-files": $props.captureFiles,
        "multiple-files": $options.multipleFilesCasted,
        "templates-text": $options.templatesTextCasted,
        "username-options": $options.usernameOptionsCasted,
        "emoji-data-source": $props.emojiDataSource,
        "room-top-tips": $props.roomTopTips,
        "only-view": $options.onlyViewCasted,
        "network-exception": $props.networkException,
        onToggleRoomsList: $options.toggleRoomsList,
        onToggleRoomChat: $options.toggleRoomChat,
        onRoomInfo: $options.roomInfo,
        onFetchMessages: $options.fetchMessages,
        onSendMessage: $options.sendMessage,
        onEditMessage: $options.editMessage,
        onDeleteMessage: $options.deleteMessage,
        onOpenFile: $options.openFile,
        onOpenUserTag: $options.openUserTag,
        onOpenFailedMessage: $options.openFailedMessage,
        onMenuActionHandler: $options.menuActionHandler,
        onMessageActionHandler: $options.messageActionHandler,
        onMessageSelectionActionHandler: $options.messageSelectionActionHandler,
        onSendMessageReaction: $options.sendMessageReaction,
        onTypingMessage: $options.typingMessage,
        onTextareaActionHandler: $options.textareaActionHandler,
        onSendCustomCard: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("send-custom-card", $event)),
        onTriggerCustomCard: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("trigger-custom-card", $event)),
        onMessageCustomView: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("message-custom-view", $event))
      }, createSlots({ _: 2 }, [
        renderList($data.slots, (el) => {
          return {
            name: el.slot,
            fn: withCtx((data) => [
              renderSlot(_ctx.$slots, el.slot, normalizeProps(guardReactiveProps(data)))
            ])
          };
        })
      ]), 1032, ["disabled-enter-key-send", "platform", "pc-mode", "current-user-id", "rooms", "room-id", "load-first-room", "messages", "room-message", "messages-loaded", "menu-actions", "message-actions", "message-selection-actions", "auto-scroll", "show-send-icon", "show-files", "show-menu", "show-audio", "audio-bit-rate", "audio-sample-rate", "show-emojis", "show-reaction-emojis", "show-new-messages-divider", "show-footer", "text-messages", "single-room", "show-rooms-list", "text-formatting", "link-options", "is-mobile", "loading-rooms", "room-info-enabled", "textarea-action-enabled", "textarea-auto-focus", "user-tags-enabled", "emojis-suggestion-enabled", "scroll-distance", "accepted-files", "capture-files", "multiple-files", "templates-text", "username-options", "emoji-data-source", "room-top-tips", "only-view", "network-exception", "onToggleRoomsList", "onToggleRoomChat", "onRoomInfo", "onFetchMessages", "onSendMessage", "onEditMessage", "onDeleteMessage", "onOpenFile", "onOpenUserTag", "onOpenFailedMessage", "onMenuActionHandler", "onMessageActionHandler", "onMessageSelectionActionHandler", "onSendMessageReaction", "onTypingMessage", "onTextareaActionHandler"])
    ]),
    createVNode(Transition, {
      name: "vac-fade-preview",
      appear: ""
    }, {
      default: withCtx(() => [
        $data.showMediaPreview ? (openBlock(), createBlock(_component_media_preview, {
          key: 0,
          file: $data.previewFile,
          "is-mobile": $data.isMobile,
          onCloseMediaPreview: _cache[6] || (_cache[6] = ($event) => $data.showMediaPreview = false)
        }, createSlots({ _: 2 }, [
          renderList($data.slots, (el) => {
            return {
              name: el.slot,
              fn: withCtx((data) => [
                renderSlot(_ctx.$slots, el.slot, normalizeProps(guardReactiveProps(data)))
              ])
            };
          })
        ]), 1032, ["file", "is-mobile"])) : createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 6);
}
var ChatWindow = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["styles", [_style_0]]]);
(function() {
  if (typeof window === "undefined") {
    return;
  }
  var eventTarget;
  var supportTouch = "ontouchstart" in window;
  if (!document.createTouch) {
    document.createTouch = function(view, target, identifier, pageX, pageY, screenX, screenY) {
      return new Touch(
        target,
        identifier,
        {
          pageX,
          pageY,
          screenX,
          screenY,
          clientX: pageX - window.pageXOffset,
          clientY: pageY - window.pageYOffset
        },
        0,
        0
      );
    };
  }
  if (!document.createTouchList) {
    document.createTouchList = function() {
      var touchList = TouchList();
      for (var i = 0; i < arguments.length; i++) {
        touchList[i] = arguments[i];
      }
      touchList.length = arguments.length;
      return touchList;
    };
  }
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
      do {
        if (el.matches(s))
          return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
  var Touch = function Touch2(target, identifier, pos, deltaX, deltaY) {
    deltaX = deltaX || 0;
    deltaY = deltaY || 0;
    this.identifier = identifier;
    this.target = target;
    this.clientX = pos.clientX + deltaX;
    this.clientY = pos.clientY + deltaY;
    this.screenX = pos.screenX + deltaX;
    this.screenY = pos.screenY + deltaY;
    this.pageX = pos.pageX + deltaX;
    this.pageY = pos.pageY + deltaY;
  };
  function TouchList() {
    var touchList = [];
    touchList["item"] = function(index) {
      return this[index] || null;
    };
    touchList["identifiedTouch"] = function(id) {
      return this[id + 1] || null;
    };
    return touchList;
  }
  var initiated = false;
  function onMouse(touchType) {
    return function(ev) {
      if (ev.type === "mousedown") {
        initiated = true;
      }
      if (ev.type === "mouseup") {
        initiated = false;
      }
      if (ev.type === "mousemove" && !initiated) {
        return;
      }
      if (ev.type === "mousedown" || !eventTarget || eventTarget && !eventTarget.dispatchEvent) {
        eventTarget = ev.target;
      }
      if (eventTarget.closest("[data-no-touch-simulate]") == null) {
        triggerTouch(touchType, ev);
      }
      if (ev.type === "mouseup") {
        eventTarget = null;
      }
    };
  }
  function triggerTouch(eventName, mouseEv) {
    var touchEvent = document.createEvent("Event");
    touchEvent.initEvent(eventName, true, true);
    touchEvent.altKey = mouseEv.altKey;
    touchEvent.ctrlKey = mouseEv.ctrlKey;
    touchEvent.metaKey = mouseEv.metaKey;
    touchEvent.shiftKey = mouseEv.shiftKey;
    touchEvent.touches = getActiveTouches(mouseEv);
    touchEvent.targetTouches = getActiveTouches(mouseEv);
    touchEvent.changedTouches = createTouchList(mouseEv);
    eventTarget.dispatchEvent(touchEvent);
  }
  function createTouchList(mouseEv) {
    var touchList = TouchList();
    touchList.push(new Touch(eventTarget, 1, mouseEv, 0, 0));
    return touchList;
  }
  function getActiveTouches(mouseEv) {
    if (mouseEv.type === "mouseup") {
      return TouchList();
    }
    return createTouchList(mouseEv);
  }
  function TouchEmulator() {
    window.addEventListener("mousedown", onMouse("touchstart"), true);
    window.addEventListener("mousemove", onMouse("touchmove"), true);
    window.addEventListener("mouseup", onMouse("touchend"), true);
  }
  TouchEmulator["multiTouchOffset"] = 75;
  if (!supportTouch) {
    new TouchEmulator();
  }
})();
const VueAdvancedChat = defineCustomElement(ChatWindow);
const PACKAGE_NAME = "vue-advanced-chat";
function register() {
  if (!customElements.get(PACKAGE_NAME)) {
    customElements.define(PACKAGE_NAME, VueAdvancedChat);
  }
}
export { VueAdvancedChat, register };
